import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions =  {}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** The `Byte` scalar type represents non-fractional whole numeric values. Byte can represent values between 0 and 255. */
  Byte: number;
  ByteArray: number[];
  /** The `DateTime` scalar represents an ISO-8601 compliant date time type. */
  DateTime: string;
  /** The built-in `Decimal` scalar type. */
  Decimal: number;
  /** The `Long` scalar type represents non-fractional signed whole 64-bit numeric values. Long can represent values between -(2^63) and 2^63 - 1. */
  Long: number;
  /** The `Short` scalar type represents non-fractional signed whole 16-bit numeric values. Short can represent values between -(2^15) and 2^15 - 1. */
  Short: number;
  /** The `TimeSpan` scalar represents an ISO-8601 compliant duration type. */
  TimeSpan: string;
  UUID: any;
  /** The `Upload` scalar type represents a file upload. */
  Upload: File;
};

export type Activity = {
  __typename?: 'Activity';
  activityAttendees: Array<ActivityAttendee>;
  activityBusinessLevelRates: Array<ActivityBusinessLevelRate>;
  activityComments: Array<ActivityComment>;
  activityDocumentMaps: Array<ActivityDocumentMap>;
  activityDueDates: Array<ActivityDueDate>;
  activityEmailComms: Array<ActivityEmailComm>;
  activityLabels: Array<ActivityLabel>;
  activityMeetings: Array<ActivityMeeting>;
  assignedBusinessLevel?: Maybe<BusinessLevel>;
  assignedBusinessLevelId?: Maybe<Scalars['Int']>;
  assignedCustomerName?: Maybe<Scalars['String']>;
  assignedEmails?: Maybe<Scalars['String']>;
  assignedFirstName?: Maybe<Scalars['String']>;
  assignedLastName?: Maybe<Scalars['String']>;
  assignedUser?: Maybe<UserType>;
  assignedUserId?: Maybe<Scalars['Int']>;
  colour?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created: Scalars['DateTime'];
  customer: Customer;
  customerId: Scalars['Int'];
  dateFinished?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  emailGuid?: Maybe<Scalars['String']>;
  emailTrackedOpen: Scalars['Boolean'];
  endDate?: Maybe<Scalars['DateTime']>;
  followUpDate?: Maybe<Scalars['DateTime']>;
  followUpRequired: Scalars['Boolean'];
  id: Scalars['Int'];
  location?: Maybe<Scalars['String']>;
  meetingRequestSent: Scalars['Boolean'];
  modified: Scalars['DateTime'];
  name?: Maybe<Scalars['String']>;
  orderLines: Array<OrderLineType>;
  orders: Array<Order>;
  originalProjectStage?: Maybe<ProjectStage>;
  originalProjectStageId?: Maybe<Scalars['Int']>;
  postCode?: Maybe<Scalars['String']>;
  premierFundingServicesLoans: Array<PremierFundingServicesLoan>;
  projectStage: ProjectStage;
  projectStageId: Scalars['Int'];
  removed: Scalars['Boolean'];
  rowVersion: Array<Scalars['ByteArray']>;
  sendToCustomer: Scalars['Boolean'];
  sortOrder?: Maybe<Scalars['Int']>;
  startDate?: Maybe<Scalars['DateTime']>;
  state?: Maybe<Scalars['String']>;
  street1: Scalars['String'];
  street2?: Maybe<Scalars['String']>;
  street3?: Maybe<Scalars['String']>;
  street4?: Maybe<Scalars['String']>;
  subTasks: Array<SubTask>;
  suburb?: Maybe<Scalars['String']>;
  timeEstimate?: Maybe<Scalars['Decimal']>;
  timeSpent?: Maybe<Scalars['Decimal']>;
  type: ActivityType;
  typeId: Scalars['Int'];
  userCreatedId: Scalars['Int'];
  zeecapeJobDetailsv2s: Array<ZeecapeJobDetailsv2>;
};

export type ActivityAttendee = {
  __typename?: 'ActivityAttendee';
  activity: Activity;
  activityId: Scalars['Int'];
  attendeeType: Scalars['Int'];
  email: Scalars['String'];
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  user?: Maybe<UserType>;
  userId?: Maybe<Scalars['Int']>;
};

export type ActivityAttendeeFilterInput = {
  activity?: InputMaybe<ActivityFilterInput>;
  activityId?: InputMaybe<ComparableInt32OperationFilterInput>;
  and?: InputMaybe<Array<ActivityAttendeeFilterInput>>;
  attendeeType?: InputMaybe<ComparableInt32OperationFilterInput>;
  email?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ActivityAttendeeFilterInput>>;
  user?: InputMaybe<UserDetailFilterInput>;
  userId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
};

export type ActivityBusinessLevelRate = {
  __typename?: 'ActivityBusinessLevelRate';
  activity: Activity;
  activityId: Scalars['Int'];
  businessLevel: BusinessLevel;
  businessLevelId: Scalars['Int'];
  businessLevelRateId: Scalars['Int'];
  created: Scalars['DateTime'];
  modified: Scalars['DateTime'];
  rate: Scalars['Decimal'];
  rateCategory: RateCategory;
  rateCategoryId: Scalars['Int'];
  rowVersion: Array<Scalars['ByteArray']>;
  userCreatedId: Scalars['Int'];
  userModifiedId: Scalars['Int'];
};

export type ActivityBusinessLevelRateFilterInput = {
  activity?: InputMaybe<ActivityFilterInput>;
  activityId?: InputMaybe<ComparableInt32OperationFilterInput>;
  and?: InputMaybe<Array<ActivityBusinessLevelRateFilterInput>>;
  businessLevel?: InputMaybe<BusinessLevelFilterInput>;
  businessLevelId?: InputMaybe<ComparableInt32OperationFilterInput>;
  businessLevelRateId?: InputMaybe<ComparableInt32OperationFilterInput>;
  created?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  modified?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<ActivityBusinessLevelRateFilterInput>>;
  rate?: InputMaybe<ComparableDecimalOperationFilterInput>;
  rateCategory?: InputMaybe<RateCategoryFilterInput>;
  rateCategoryId?: InputMaybe<ComparableInt32OperationFilterInput>;
  rowVersion?: InputMaybe<ListComparableByteOperationFilterInput>;
  userCreatedId?: InputMaybe<ComparableInt32OperationFilterInput>;
  userModifiedId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type ActivityComment = {
  __typename?: 'ActivityComment';
  activity: Activity;
  activityId: Scalars['Int'];
  authorUserId: Scalars['Int'];
  created: Scalars['DateTime'];
  id: Scalars['Int'];
  isUrgent: Scalars['Boolean'];
  modified: Scalars['DateTime'];
  name: Scalars['String'];
  tagged?: Maybe<Scalars['String']>;
};

export type ActivityCommentFilterInput = {
  activity?: InputMaybe<ActivityFilterInput>;
  activityId?: InputMaybe<ComparableInt32OperationFilterInput>;
  and?: InputMaybe<Array<ActivityCommentFilterInput>>;
  authorUserId?: InputMaybe<ComparableInt32OperationFilterInput>;
  created?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  isUrgent?: InputMaybe<BooleanOperationFilterInput>;
  modified?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ActivityCommentFilterInput>>;
  tagged?: InputMaybe<StringOperationFilterInput>;
};

export type ActivityDocumentMap = {
  __typename?: 'ActivityDocumentMap';
  activity: Activity;
  activityId: Scalars['Int'];
  commentId?: Maybe<Scalars['Int']>;
  document: Document;
  documentId: Scalars['Int'];
  id: Scalars['Int'];
};

export type ActivityDocumentMapFilterInput = {
  activity?: InputMaybe<ActivityFilterInput>;
  activityId?: InputMaybe<ComparableInt32OperationFilterInput>;
  and?: InputMaybe<Array<ActivityDocumentMapFilterInput>>;
  commentId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  document?: InputMaybe<DocumentFilterInput>;
  documentId?: InputMaybe<ComparableInt32OperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<ActivityDocumentMapFilterInput>>;
};

export type ActivityDueDate = {
  __typename?: 'ActivityDueDate';
  activity: Activity;
  activityId: Scalars['Int'];
  created: Scalars['DateTime'];
  doneByUserId?: Maybe<Scalars['Int']>;
  doneDateTime?: Maybe<Scalars['DateTime']>;
  dueDate: Scalars['DateTime'];
  hasNotifyOverDue?: Maybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  modfied: Scalars['DateTime'];
  rowVersion: Array<Scalars['ByteArray']>;
  sortOrder?: Maybe<Scalars['Int']>;
  status: Scalars['Int'];
  targetProjectStage?: Maybe<ProjectStage>;
  targetProjectStageId?: Maybe<Scalars['Int']>;
};

export type ActivityDueDateFilterInput = {
  activity?: InputMaybe<ActivityFilterInput>;
  activityId?: InputMaybe<ComparableInt32OperationFilterInput>;
  and?: InputMaybe<Array<ActivityDueDateFilterInput>>;
  created?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  doneByUserId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  doneDateTime?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  dueDate?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  hasNotifyOverDue?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  modfied?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<ActivityDueDateFilterInput>>;
  rowVersion?: InputMaybe<ListComparableByteOperationFilterInput>;
  sortOrder?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  status?: InputMaybe<ComparableInt32OperationFilterInput>;
  targetProjectStage?: InputMaybe<ProjectStageFilterInput>;
  targetProjectStageId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
};

export type ActivityEmailComm = {
  __typename?: 'ActivityEmailComm';
  activity: Activity;
  activityEmailCommsDocumentMaps: Array<ActivityEmailCommsDocumentMap>;
  activityId: Scalars['Int'];
  body: Scalars['String'];
  created: Scalars['DateTime'];
  fromAddress?: Maybe<Scalars['String']>;
  fromName?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  inverseParent: Array<ActivityEmailComm>;
  messageId: Scalars['String'];
  parent?: Maybe<ActivityEmailComm>;
  parentId?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['String']>;
  repliedToMessageId?: Maybe<Scalars['String']>;
  subject: Scalars['String'];
  toAddresses?: Maybe<Scalars['String']>;
};

export type ActivityEmailCommFilterInput = {
  activity?: InputMaybe<ActivityFilterInput>;
  activityEmailCommsDocumentMaps?: InputMaybe<ListFilterInputTypeOfActivityEmailCommsDocumentMapFilterInput>;
  activityId?: InputMaybe<ComparableInt32OperationFilterInput>;
  and?: InputMaybe<Array<ActivityEmailCommFilterInput>>;
  body?: InputMaybe<StringOperationFilterInput>;
  created?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  fromAddress?: InputMaybe<StringOperationFilterInput>;
  fromName?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  inverseParent?: InputMaybe<ListFilterInputTypeOfActivityEmailCommFilterInput>;
  messageId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ActivityEmailCommFilterInput>>;
  parent?: InputMaybe<ActivityEmailCommFilterInput>;
  parentId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  preview?: InputMaybe<StringOperationFilterInput>;
  repliedToMessageId?: InputMaybe<StringOperationFilterInput>;
  subject?: InputMaybe<StringOperationFilterInput>;
  toAddresses?: InputMaybe<StringOperationFilterInput>;
};

export type ActivityEmailCommsDocumentMap = {
  __typename?: 'ActivityEmailCommsDocumentMap';
  activityEmailComms: ActivityEmailComm;
  activityEmailCommsId: Scalars['Int'];
  documentId: Scalars['Int'];
  documentMetaData: DocumentMetadata;
  documentMetaDataId: Scalars['Int'];
  id: Scalars['Int'];
};

export type ActivityEmailCommsDocumentMapFilterInput = {
  activityEmailComms?: InputMaybe<ActivityEmailCommFilterInput>;
  activityEmailCommsId?: InputMaybe<ComparableInt32OperationFilterInput>;
  and?: InputMaybe<Array<ActivityEmailCommsDocumentMapFilterInput>>;
  documentId?: InputMaybe<ComparableInt32OperationFilterInput>;
  documentMetaData?: InputMaybe<DocumentMetadataFilterInput>;
  documentMetaDataId?: InputMaybe<ComparableInt32OperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<ActivityEmailCommsDocumentMapFilterInput>>;
};

export type ActivityFilterInput = {
  activityAttendees?: InputMaybe<ListFilterInputTypeOfActivityAttendeeFilterInput>;
  activityBusinessLevelRates?: InputMaybe<ListFilterInputTypeOfActivityBusinessLevelRateFilterInput>;
  activityComments?: InputMaybe<ListFilterInputTypeOfActivityCommentFilterInput>;
  activityDocumentMaps?: InputMaybe<ListFilterInputTypeOfActivityDocumentMapFilterInput>;
  activityDueDates?: InputMaybe<ListFilterInputTypeOfActivityDueDateFilterInput>;
  activityEmailComms?: InputMaybe<ListFilterInputTypeOfActivityEmailCommFilterInput>;
  activityLabels?: InputMaybe<ListFilterInputTypeOfActivityLabelFilterInput>;
  activityMeetings?: InputMaybe<ListFilterInputTypeOfActivityMeetingFilterInput>;
  and?: InputMaybe<Array<ActivityFilterInput>>;
  assignedBusinessLevel?: InputMaybe<BusinessLevelFilterInput>;
  assignedBusinessLevelId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  assignedCustomerName?: InputMaybe<StringOperationFilterInput>;
  assignedEmails?: InputMaybe<StringOperationFilterInput>;
  assignedFirstName?: InputMaybe<StringOperationFilterInput>;
  assignedLastName?: InputMaybe<StringOperationFilterInput>;
  assignedUser?: InputMaybe<UserDetailFilterInput>;
  assignedUserId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  colour?: InputMaybe<StringOperationFilterInput>;
  country?: InputMaybe<StringOperationFilterInput>;
  created?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  customer?: InputMaybe<CustomerFilterInput>;
  customerId?: InputMaybe<ComparableInt32OperationFilterInput>;
  dateFinished?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  emailGuid?: InputMaybe<StringOperationFilterInput>;
  emailTrackedOpen?: InputMaybe<BooleanOperationFilterInput>;
  endDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  followUpDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  followUpRequired?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  location?: InputMaybe<StringOperationFilterInput>;
  meetingRequestSent?: InputMaybe<BooleanOperationFilterInput>;
  modified?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ActivityFilterInput>>;
  orderLines?: InputMaybe<ListFilterInputTypeOfOrderLineFilterInput>;
  orders?: InputMaybe<ListFilterInputTypeOfOrderFilterInput>;
  originalProjectStage?: InputMaybe<ProjectStageFilterInput>;
  originalProjectStageId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  postCode?: InputMaybe<StringOperationFilterInput>;
  premierFundingServicesLoans?: InputMaybe<ListFilterInputTypeOfPremierFundingServicesLoanFilterInput>;
  projectStage?: InputMaybe<ProjectStageFilterInput>;
  projectStageId?: InputMaybe<ComparableInt32OperationFilterInput>;
  removed?: InputMaybe<BooleanOperationFilterInput>;
  rowVersion?: InputMaybe<ListComparableByteOperationFilterInput>;
  sendToCustomer?: InputMaybe<BooleanOperationFilterInput>;
  sortOrder?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  startDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  state?: InputMaybe<StringOperationFilterInput>;
  street1?: InputMaybe<StringOperationFilterInput>;
  street2?: InputMaybe<StringOperationFilterInput>;
  street3?: InputMaybe<StringOperationFilterInput>;
  street4?: InputMaybe<StringOperationFilterInput>;
  subTasks?: InputMaybe<ListFilterInputTypeOfSubTaskFilterInput>;
  suburb?: InputMaybe<StringOperationFilterInput>;
  timeEstimate?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  timeSpent?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  type?: InputMaybe<ActivityTypeFilterInput>;
  typeId?: InputMaybe<ComparableInt32OperationFilterInput>;
  userCreatedId?: InputMaybe<ComparableInt32OperationFilterInput>;
  zeecapeJobDetailsv2s?: InputMaybe<ListFilterInputTypeOfZeecapeJobDetailsv2FilterInput>;
};

export type ActivityLabel = {
  __typename?: 'ActivityLabel';
  activity: Activity;
  activityId: Scalars['Int'];
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type ActivityLabelFilterInput = {
  activity?: InputMaybe<ActivityFilterInput>;
  activityId?: InputMaybe<ComparableInt32OperationFilterInput>;
  and?: InputMaybe<Array<ActivityLabelFilterInput>>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ActivityLabelFilterInput>>;
};

export type ActivityMeeting = {
  __typename?: 'ActivityMeeting';
  activity: Activity;
  activityId: Scalars['Int'];
  alarmTimeSpan?: Maybe<Scalars['Long']>;
  created: Scalars['DateTime'];
  description: Scalars['String'];
  endTime: Scalars['DateTime'];
  location: Scalars['String'];
  meetingGuid: Scalars['UUID'];
  meetingId: Scalars['Int'];
  organizerEmail: Scalars['String'];
  organizerId: Scalars['Int'];
  organizerName: Scalars['String'];
  startTime: Scalars['DateTime'];
};

export type ActivityMeetingFilterInput = {
  activity?: InputMaybe<ActivityFilterInput>;
  activityId?: InputMaybe<ComparableInt32OperationFilterInput>;
  alarmTimeSpan?: InputMaybe<ComparableNullableOfInt64OperationFilterInput>;
  and?: InputMaybe<Array<ActivityMeetingFilterInput>>;
  created?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  endTime?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  location?: InputMaybe<StringOperationFilterInput>;
  meetingGuid?: InputMaybe<ComparableGuidOperationFilterInput>;
  meetingId?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<ActivityMeetingFilterInput>>;
  organizerEmail?: InputMaybe<StringOperationFilterInput>;
  organizerId?: InputMaybe<ComparableInt32OperationFilterInput>;
  organizerName?: InputMaybe<StringOperationFilterInput>;
  startTime?: InputMaybe<ComparableDateTimeOperationFilterInput>;
};

export type ActivitySortInput = {
  assignedBusinessLevel?: InputMaybe<BusinessLevelSortInput>;
  assignedBusinessLevelId?: InputMaybe<SortEnumType>;
  assignedCustomerName?: InputMaybe<SortEnumType>;
  assignedEmails?: InputMaybe<SortEnumType>;
  assignedFirstName?: InputMaybe<SortEnumType>;
  assignedLastName?: InputMaybe<SortEnumType>;
  assignedUser?: InputMaybe<UserDetailSortInput>;
  assignedUserId?: InputMaybe<SortEnumType>;
  colour?: InputMaybe<SortEnumType>;
  country?: InputMaybe<SortEnumType>;
  created?: InputMaybe<SortEnumType>;
  customer?: InputMaybe<CustomerSortInput>;
  customerId?: InputMaybe<SortEnumType>;
  dateFinished?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  emailGuid?: InputMaybe<SortEnumType>;
  emailTrackedOpen?: InputMaybe<SortEnumType>;
  endDate?: InputMaybe<SortEnumType>;
  followUpDate?: InputMaybe<SortEnumType>;
  followUpRequired?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  location?: InputMaybe<SortEnumType>;
  meetingRequestSent?: InputMaybe<SortEnumType>;
  modified?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  originalProjectStage?: InputMaybe<ProjectStageSortInput>;
  originalProjectStageId?: InputMaybe<SortEnumType>;
  postCode?: InputMaybe<SortEnumType>;
  projectStage?: InputMaybe<ProjectStageSortInput>;
  projectStageId?: InputMaybe<SortEnumType>;
  removed?: InputMaybe<SortEnumType>;
  sendToCustomer?: InputMaybe<SortEnumType>;
  sortOrder?: InputMaybe<SortEnumType>;
  startDate?: InputMaybe<SortEnumType>;
  state?: InputMaybe<SortEnumType>;
  street1?: InputMaybe<SortEnumType>;
  street2?: InputMaybe<SortEnumType>;
  street3?: InputMaybe<SortEnumType>;
  street4?: InputMaybe<SortEnumType>;
  suburb?: InputMaybe<SortEnumType>;
  timeEstimate?: InputMaybe<SortEnumType>;
  timeSpent?: InputMaybe<SortEnumType>;
  type?: InputMaybe<ActivityTypeSortInput>;
  typeId?: InputMaybe<SortEnumType>;
  userCreatedId?: InputMaybe<SortEnumType>;
};

export type ActivityType = {
  __typename?: 'ActivityType';
  activities: Array<Activity>;
  activityTypeRoleVisibilities: Array<ActivityTypeRoleVisibility>;
  customerId?: Maybe<Scalars['Int']>;
  defaultTabs?: Maybe<Scalars['String']>;
  iconClass?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  isEndDateMandatiory: Scalars['Boolean'];
  isEndDatePrefilled: Scalars['Boolean'];
  isLocationVisible: Scalars['Boolean'];
  isStartDateMandatory: Scalars['Boolean'];
  isStartDatePrefilled: Scalars['Boolean'];
  isTimeEstimateVisible: Scalars['Boolean'];
  isTimeSpentVisible: Scalars['Boolean'];
  name: Scalars['String'];
};

export type ActivityTypeFilterInput = {
  activities?: InputMaybe<ListFilterInputTypeOfActivityFilterInput>;
  activityTypeRoleVisibilities?: InputMaybe<ListFilterInputTypeOfActivityTypeRoleVisibilityFilterInput>;
  and?: InputMaybe<Array<ActivityTypeFilterInput>>;
  customerId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  defaultTabs?: InputMaybe<StringOperationFilterInput>;
  iconClass?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  isEndDateMandatiory?: InputMaybe<BooleanOperationFilterInput>;
  isEndDatePrefilled?: InputMaybe<BooleanOperationFilterInput>;
  isLocationVisible?: InputMaybe<BooleanOperationFilterInput>;
  isStartDateMandatory?: InputMaybe<BooleanOperationFilterInput>;
  isStartDatePrefilled?: InputMaybe<BooleanOperationFilterInput>;
  isTimeEstimateVisible?: InputMaybe<BooleanOperationFilterInput>;
  isTimeSpentVisible?: InputMaybe<BooleanOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ActivityTypeFilterInput>>;
};

export type ActivityTypeRoleVisibility = {
  __typename?: 'ActivityTypeRoleVisibility';
  activityType: ActivityType;
  activityTypeId: Scalars['Int'];
  created: Scalars['DateTime'];
  modified: Scalars['DateTime'];
  role: RoleType;
  roleId: Scalars['Int'];
  userModifiedId: Scalars['Int'];
  visibilityId: Scalars['Int'];
};

export type ActivityTypeRoleVisibilityFilterInput = {
  activityType?: InputMaybe<ActivityTypeFilterInput>;
  activityTypeId?: InputMaybe<ComparableInt32OperationFilterInput>;
  and?: InputMaybe<Array<ActivityTypeRoleVisibilityFilterInput>>;
  created?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  modified?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<ActivityTypeRoleVisibilityFilterInput>>;
  role?: InputMaybe<RoleFilterInput>;
  roleId?: InputMaybe<ComparableInt32OperationFilterInput>;
  userModifiedId?: InputMaybe<ComparableInt32OperationFilterInput>;
  visibilityId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type ActivityTypeSortInput = {
  customerId?: InputMaybe<SortEnumType>;
  defaultTabs?: InputMaybe<SortEnumType>;
  iconClass?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isEndDateMandatiory?: InputMaybe<SortEnumType>;
  isEndDatePrefilled?: InputMaybe<SortEnumType>;
  isLocationVisible?: InputMaybe<SortEnumType>;
  isStartDateMandatory?: InputMaybe<SortEnumType>;
  isStartDatePrefilled?: InputMaybe<SortEnumType>;
  isTimeEstimateVisible?: InputMaybe<SortEnumType>;
  isTimeSpentVisible?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
};

export type AddFeatureInput = {
  description: Scalars['String'];
  name: Scalars['String'];
};

export type Address = {
  __typename?: 'Address';
  active: Scalars['Boolean'];
  additionalAddress: Scalars['Boolean'];
  addressId: Scalars['Int'];
  addressOptData: Array<AddressOptDatum>;
  addressOptHeads: Array<AddressOptHead>;
  businessLevelBillingAddresses: Array<BusinessLevel>;
  businessLevelDeliveryAddresses: Array<BusinessLevel>;
  cityId?: Maybe<Scalars['Int']>;
  companyName?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  countryId?: Maybe<Scalars['Int']>;
  created: Scalars['DateTime'];
  customerBillingAddresses: Array<Customer>;
  customerDeliveryAddresses: Array<Customer>;
  customerId: Scalars['Int'];
  email?: Maybe<Scalars['String']>;
  email2?: Maybe<Scalars['String']>;
  fax?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  ifsreceiverAccount?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  mobile?: Maybe<Scalars['String']>;
  modified: Scalars['DateTime'];
  name: Scalars['String'];
  notes?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  postcode: Scalars['String'];
  postcodeId?: Maybe<Scalars['Int']>;
  procurementSupplier: Scalars['Boolean'];
  purgeDate?: Maybe<Scalars['DateTime']>;
  recordTimestamp: Array<Scalars['ByteArray']>;
  regionId?: Maybe<Scalars['Int']>;
  remapped?: Maybe<Scalars['Boolean']>;
  removed: Scalars['Boolean'];
  state?: Maybe<Scalars['String']>;
  street1: Scalars['String'];
  street2?: Maybe<Scalars['String']>;
  street3?: Maybe<Scalars['String']>;
  street4?: Maybe<Scalars['String']>;
  suburb?: Maybe<Scalars['String']>;
  supplier: Scalars['Boolean'];
  userCreatedId: Scalars['Int'];
  userDetailBillingAddresses: Array<UserType>;
  userDetailDeliveryAddresses: Array<UserType>;
  userModifiedId: Scalars['Int'];
  wmsRgas: Array<WmsRga>;
};

export type AddressFilterInput = {
  active?: InputMaybe<BooleanOperationFilterInput>;
  additionalAddress?: InputMaybe<BooleanOperationFilterInput>;
  addressId?: InputMaybe<ComparableInt32OperationFilterInput>;
  addressOptData?: InputMaybe<ListFilterInputTypeOfAddressOptDatumFilterInput>;
  addressOptHeads?: InputMaybe<ListFilterInputTypeOfAddressOptHeadFilterInput>;
  and?: InputMaybe<Array<AddressFilterInput>>;
  businessLevelBillingAddresses?: InputMaybe<ListFilterInputTypeOfBusinessLevelFilterInput>;
  businessLevelDeliveryAddresses?: InputMaybe<ListFilterInputTypeOfBusinessLevelFilterInput>;
  cityId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  companyName?: InputMaybe<StringOperationFilterInput>;
  country?: InputMaybe<StringOperationFilterInput>;
  countryId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  created?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  customerBillingAddresses?: InputMaybe<ListFilterInputTypeOfCustomerFilterInput>;
  customerDeliveryAddresses?: InputMaybe<ListFilterInputTypeOfCustomerFilterInput>;
  customerId?: InputMaybe<ComparableInt32OperationFilterInput>;
  email?: InputMaybe<StringOperationFilterInput>;
  email2?: InputMaybe<StringOperationFilterInput>;
  fax?: InputMaybe<StringOperationFilterInput>;
  firstName?: InputMaybe<StringOperationFilterInput>;
  ifsreceiverAccount?: InputMaybe<StringOperationFilterInput>;
  lastName?: InputMaybe<StringOperationFilterInput>;
  mobile?: InputMaybe<StringOperationFilterInput>;
  modified?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  notes?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<AddressFilterInput>>;
  phone?: InputMaybe<StringOperationFilterInput>;
  postcode?: InputMaybe<StringOperationFilterInput>;
  postcodeId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  procurementSupplier?: InputMaybe<BooleanOperationFilterInput>;
  purgeDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  recordTimestamp?: InputMaybe<ListComparableByteOperationFilterInput>;
  regionId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  remapped?: InputMaybe<BooleanOperationFilterInput>;
  removed?: InputMaybe<BooleanOperationFilterInput>;
  state?: InputMaybe<StringOperationFilterInput>;
  street1?: InputMaybe<StringOperationFilterInput>;
  street2?: InputMaybe<StringOperationFilterInput>;
  street3?: InputMaybe<StringOperationFilterInput>;
  street4?: InputMaybe<StringOperationFilterInput>;
  suburb?: InputMaybe<StringOperationFilterInput>;
  supplier?: InputMaybe<BooleanOperationFilterInput>;
  userCreatedId?: InputMaybe<ComparableInt32OperationFilterInput>;
  userDetailBillingAddresses?: InputMaybe<ListFilterInputTypeOfUserDetailFilterInput>;
  userDetailDeliveryAddresses?: InputMaybe<ListFilterInputTypeOfUserDetailFilterInput>;
  userModifiedId?: InputMaybe<ComparableInt32OperationFilterInput>;
  wmsRgas?: InputMaybe<ListFilterInputTypeOfWmsRgaFilterInput>;
};

/** Represents the input to create a new address. */
export type AddressInputType = {
  /** Represents the address' country. */
  country: Scalars['String'];
  /** Represents the address' customer ID. */
  customerId?: InputMaybe<Scalars['Int']>;
  /** Represents the address' name. */
  name: Scalars['String'];
  /** Represents the address' postcode. */
  postcode: Scalars['String'];
  /** Represents the address' state. */
  state: Scalars['String'];
  /** Represents the address' street 1. */
  street1: Scalars['String'];
  /** Represnets the address' street 2. */
  street2?: InputMaybe<Scalars['String']>;
  /** Represents the address' street 3. */
  street3?: InputMaybe<Scalars['String']>;
  /** Represents the address' street 4. */
  street4?: InputMaybe<Scalars['String']>;
  /** Represents the address' suburb. */
  suburb: Scalars['String'];
};

export type AddressOptDatum = {
  __typename?: 'AddressOptDatum';
  address: Address;
  addressId: Scalars['Int'];
  binary?: Maybe<Array<Scalars['ByteArray']>>;
  dataId: Scalars['Int'];
  dateTime?: Maybe<Scalars['DateTime']>;
  decimal?: Maybe<Scalars['Decimal']>;
  int?: Maybe<Scalars['Int']>;
  nvarchar50?: Maybe<Scalars['String']>;
  nvarcharMax?: Maybe<Scalars['String']>;
};

export type AddressOptDatumFilterInput = {
  address?: InputMaybe<AddressFilterInput>;
  addressId?: InputMaybe<ComparableInt32OperationFilterInput>;
  and?: InputMaybe<Array<AddressOptDatumFilterInput>>;
  binary?: InputMaybe<ListComparableByteOperationFilterInput>;
  dataId?: InputMaybe<ComparableInt32OperationFilterInput>;
  dateTime?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  decimal?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  int?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  nvarchar50?: InputMaybe<StringOperationFilterInput>;
  nvarcharMax?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<AddressOptDatumFilterInput>>;
};

export type AddressOptEnum = {
  __typename?: 'AddressOptEnum';
  enumId: Scalars['Int'];
  name: Scalars['String'];
  optHead: AddressOptHead;
  optHeadId: Scalars['Int'];
};

export type AddressOptEnumFilterInput = {
  and?: InputMaybe<Array<AddressOptEnumFilterInput>>;
  enumId?: InputMaybe<ComparableInt32OperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  optHead?: InputMaybe<AddressOptHeadFilterInput>;
  optHeadId?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<AddressOptEnumFilterInput>>;
};

export type AddressOptHead = {
  __typename?: 'AddressOptHead';
  address: Address;
  addressId: Scalars['Int'];
  addressOptEnums: Array<AddressOptEnum>;
  dataType: Scalars['String'];
  name: Scalars['String'];
  optHeadId: Scalars['Int'];
};

export type AddressOptHeadFilterInput = {
  address?: InputMaybe<AddressFilterInput>;
  addressId?: InputMaybe<ComparableInt32OperationFilterInput>;
  addressOptEnums?: InputMaybe<ListFilterInputTypeOfAddressOptEnumFilterInput>;
  and?: InputMaybe<Array<AddressOptHeadFilterInput>>;
  dataType?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  optHeadId?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<AddressOptHeadFilterInput>>;
};

export type AddressSortInput = {
  active?: InputMaybe<SortEnumType>;
  additionalAddress?: InputMaybe<SortEnumType>;
  addressId?: InputMaybe<SortEnumType>;
  cityId?: InputMaybe<SortEnumType>;
  companyName?: InputMaybe<SortEnumType>;
  country?: InputMaybe<SortEnumType>;
  countryId?: InputMaybe<SortEnumType>;
  created?: InputMaybe<SortEnumType>;
  customerId?: InputMaybe<SortEnumType>;
  email?: InputMaybe<SortEnumType>;
  email2?: InputMaybe<SortEnumType>;
  fax?: InputMaybe<SortEnumType>;
  firstName?: InputMaybe<SortEnumType>;
  ifsreceiverAccount?: InputMaybe<SortEnumType>;
  lastName?: InputMaybe<SortEnumType>;
  mobile?: InputMaybe<SortEnumType>;
  modified?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  notes?: InputMaybe<SortEnumType>;
  phone?: InputMaybe<SortEnumType>;
  postcode?: InputMaybe<SortEnumType>;
  postcodeId?: InputMaybe<SortEnumType>;
  procurementSupplier?: InputMaybe<SortEnumType>;
  purgeDate?: InputMaybe<SortEnumType>;
  regionId?: InputMaybe<SortEnumType>;
  remapped?: InputMaybe<SortEnumType>;
  removed?: InputMaybe<SortEnumType>;
  state?: InputMaybe<SortEnumType>;
  street1?: InputMaybe<SortEnumType>;
  street2?: InputMaybe<SortEnumType>;
  street3?: InputMaybe<SortEnumType>;
  street4?: InputMaybe<SortEnumType>;
  suburb?: InputMaybe<SortEnumType>;
  supplier?: InputMaybe<SortEnumType>;
  userCreatedId?: InputMaybe<SortEnumType>;
  userModifiedId?: InputMaybe<SortEnumType>;
};

export type AdvertisementBlock = {
  __typename?: 'AdvertisementBlock';
  active: Scalars['Boolean'];
  advertisementBlockData: Array<AdvertisementBlockData>;
  advertisementBlockId: Scalars['Int'];
  advertisementBlockPlaceholder?: Maybe<AdvertisementBlock>;
  advertisementBlockPlaceholderId?: Maybe<Scalars['Int']>;
  advertisementMasterPage?: Maybe<AdvertisementMasterPage>;
  advertisementMasterPageId?: Maybe<Scalars['Int']>;
  advertisementPage?: Maybe<AdvertisementPage>;
  advertisementPageId?: Maybe<Scalars['Int']>;
  blockClassType: Scalars['String'];
  canPageOverwriteData: Scalars['Boolean'];
  endDate?: Maybe<Scalars['DateTime']>;
  height?: Maybe<Scalars['Int']>;
  htmlRawContent?: Maybe<Scalars['String']>;
  inverseAdvertisementBlockPlaceholder: Array<AdvertisementBlock>;
  isPlaceholder: Scalars['Boolean'];
  isRequired: Scalars['Boolean'];
  modifiedDate: Scalars['DateTime'];
  name: Scalars['String'];
  orderOfDisplay: Scalars['Int'];
  removed: Scalars['Boolean'];
  rowVersion: Array<Scalars['ByteArray']>;
  serializedExtraData?: Maybe<Array<Scalars['ByteArray']>>;
  startDate?: Maybe<Scalars['DateTime']>;
  width?: Maybe<Scalars['Int']>;
};

export type AdvertisementBlockData = {
  __typename?: 'AdvertisementBlockData';
  active: Scalars['Boolean'];
  advertisementBlock: AdvertisementBlock;
  advertisementBlockDataId: Scalars['Int'];
  advertisementBlockId: Scalars['Int'];
  advertisementMasterPage?: Maybe<AdvertisementMasterPage>;
  advertisementMasterPageId?: Maybe<Scalars['Int']>;
  advertisementPage?: Maybe<AdvertisementPage>;
  advertisementPageId?: Maybe<Scalars['Int']>;
  htmlRawContent?: Maybe<Scalars['String']>;
  removed: Scalars['Boolean'];
  rowVersion: Array<Scalars['ByteArray']>;
  serializedExtraData?: Maybe<Array<Scalars['ByteArray']>>;
};

export type AdvertisementBlockDataFilterInput = {
  active?: InputMaybe<BooleanOperationFilterInput>;
  advertisementBlock?: InputMaybe<AdvertisementBlockFilterInput>;
  advertisementBlockDataId?: InputMaybe<ComparableInt32OperationFilterInput>;
  advertisementBlockId?: InputMaybe<ComparableInt32OperationFilterInput>;
  advertisementMasterPage?: InputMaybe<AdvertisementMasterPageFilterInput>;
  advertisementMasterPageId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  advertisementPage?: InputMaybe<AdvertisementPageFilterInput>;
  advertisementPageId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<AdvertisementBlockDataFilterInput>>;
  htmlRawContent?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<AdvertisementBlockDataFilterInput>>;
  removed?: InputMaybe<BooleanOperationFilterInput>;
  rowVersion?: InputMaybe<ListComparableByteOperationFilterInput>;
  serializedExtraData?: InputMaybe<ListComparableByteOperationFilterInput>;
};

export type AdvertisementBlockFilterInput = {
  active?: InputMaybe<BooleanOperationFilterInput>;
  advertisementBlockData?: InputMaybe<ListFilterInputTypeOfAdvertisementBlockDataFilterInput>;
  advertisementBlockId?: InputMaybe<ComparableInt32OperationFilterInput>;
  advertisementBlockPlaceholder?: InputMaybe<AdvertisementBlockFilterInput>;
  advertisementBlockPlaceholderId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  advertisementMasterPage?: InputMaybe<AdvertisementMasterPageFilterInput>;
  advertisementMasterPageId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  advertisementPage?: InputMaybe<AdvertisementPageFilterInput>;
  advertisementPageId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<AdvertisementBlockFilterInput>>;
  blockClassType?: InputMaybe<StringOperationFilterInput>;
  canPageOverwriteData?: InputMaybe<BooleanOperationFilterInput>;
  endDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  height?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  htmlRawContent?: InputMaybe<StringOperationFilterInput>;
  inverseAdvertisementBlockPlaceholder?: InputMaybe<ListFilterInputTypeOfAdvertisementBlockFilterInput>;
  isPlaceholder?: InputMaybe<BooleanOperationFilterInput>;
  isRequired?: InputMaybe<BooleanOperationFilterInput>;
  modifiedDate?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<AdvertisementBlockFilterInput>>;
  orderOfDisplay?: InputMaybe<ComparableInt32OperationFilterInput>;
  removed?: InputMaybe<BooleanOperationFilterInput>;
  rowVersion?: InputMaybe<ListComparableByteOperationFilterInput>;
  serializedExtraData?: InputMaybe<ListComparableByteOperationFilterInput>;
  startDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  width?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
};

export type AdvertisementMasterPage = {
  __typename?: 'AdvertisementMasterPage';
  active: Scalars['Boolean'];
  activeDate: Scalars['DateTime'];
  advertisementBlockData: Array<AdvertisementBlockData>;
  advertisementBlocks: Array<AdvertisementBlock>;
  advertisementMasterPageId: Scalars['Int'];
  advertisementPages: Array<AdvertisementPage>;
  businessLevel: BusinessLevel;
  businessLevelId: Scalars['Int'];
  created: Scalars['DateTime'];
  customer: Customer;
  customerId: Scalars['Int'];
  expiryDate?: Maybe<Scalars['DateTime']>;
  generatedUrl?: Maybe<Scalars['String']>;
  inverseParentMasterPage: Array<AdvertisementMasterPage>;
  linkTrackingEnabled: Scalars['Boolean'];
  locationTrackingEnabled: Scalars['Boolean'];
  maxWidth?: Maybe<Scalars['Int']>;
  modified: Scalars['DateTime'];
  name: Scalars['String'];
  parentMasterPage?: Maybe<AdvertisementMasterPage>;
  parentMasterPageId?: Maybe<Scalars['Int']>;
  removed: Scalars['Boolean'];
  rowVersion: Array<Scalars['ByteArray']>;
  securitySettingEdit: Scalars['Int'];
  securitySettingImplement: Scalars['Int'];
  termsAndConditionTemplate?: Maybe<Scalars['String']>;
  userCreated: UserType;
  userCreatedId: Scalars['Int'];
  userModified: UserType;
  userModifiedId: Scalars['Int'];
  viewTrackingEnabled: Scalars['Boolean'];
};

export type AdvertisementMasterPageFilterInput = {
  active?: InputMaybe<BooleanOperationFilterInput>;
  activeDate?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  advertisementBlockData?: InputMaybe<ListFilterInputTypeOfAdvertisementBlockDataFilterInput>;
  advertisementBlocks?: InputMaybe<ListFilterInputTypeOfAdvertisementBlockFilterInput>;
  advertisementMasterPageId?: InputMaybe<ComparableInt32OperationFilterInput>;
  advertisementPages?: InputMaybe<ListFilterInputTypeOfAdvertisementPageFilterInput>;
  and?: InputMaybe<Array<AdvertisementMasterPageFilterInput>>;
  businessLevel?: InputMaybe<BusinessLevelFilterInput>;
  businessLevelId?: InputMaybe<ComparableInt32OperationFilterInput>;
  created?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  customer?: InputMaybe<CustomerFilterInput>;
  customerId?: InputMaybe<ComparableInt32OperationFilterInput>;
  expiryDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  generatedUrl?: InputMaybe<StringOperationFilterInput>;
  inverseParentMasterPage?: InputMaybe<ListFilterInputTypeOfAdvertisementMasterPageFilterInput>;
  linkTrackingEnabled?: InputMaybe<BooleanOperationFilterInput>;
  locationTrackingEnabled?: InputMaybe<BooleanOperationFilterInput>;
  maxWidth?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  modified?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<AdvertisementMasterPageFilterInput>>;
  parentMasterPage?: InputMaybe<AdvertisementMasterPageFilterInput>;
  parentMasterPageId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  removed?: InputMaybe<BooleanOperationFilterInput>;
  rowVersion?: InputMaybe<ListComparableByteOperationFilterInput>;
  securitySettingEdit?: InputMaybe<ComparableInt32OperationFilterInput>;
  securitySettingImplement?: InputMaybe<ComparableInt32OperationFilterInput>;
  termsAndConditionTemplate?: InputMaybe<StringOperationFilterInput>;
  userCreated?: InputMaybe<UserDetailFilterInput>;
  userCreatedId?: InputMaybe<ComparableInt32OperationFilterInput>;
  userModified?: InputMaybe<UserDetailFilterInput>;
  userModifiedId?: InputMaybe<ComparableInt32OperationFilterInput>;
  viewTrackingEnabled?: InputMaybe<BooleanOperationFilterInput>;
};

export type AdvertisementPage = {
  __typename?: 'AdvertisementPage';
  active: Scalars['Boolean'];
  advertisementBlockData: Array<AdvertisementBlockData>;
  advertisementBlocks: Array<AdvertisementBlock>;
  advertisementMasterPage: AdvertisementMasterPage;
  advertisementMasterPageId: Scalars['Int'];
  advertisementPageId: Scalars['Int'];
  businessLevel: BusinessLevel;
  businessLevelId: Scalars['Int'];
  created: Scalars['DateTime'];
  customer: Customer;
  customerId: Scalars['Int'];
  endDate?: Maybe<Scalars['DateTime']>;
  generatedUrl: Scalars['String'];
  modified: Scalars['DateTime'];
  name: Scalars['String'];
  removed: Scalars['Boolean'];
  rowVersion: Array<Scalars['ByteArray']>;
  securitySettingEdit: Scalars['Int'];
  startDate?: Maybe<Scalars['DateTime']>;
  userCreated: UserType;
  userCreatedId: Scalars['Int'];
  userModified: UserType;
  userModifiedId: Scalars['Int'];
};

export type AdvertisementPageFilterInput = {
  active?: InputMaybe<BooleanOperationFilterInput>;
  advertisementBlockData?: InputMaybe<ListFilterInputTypeOfAdvertisementBlockDataFilterInput>;
  advertisementBlocks?: InputMaybe<ListFilterInputTypeOfAdvertisementBlockFilterInput>;
  advertisementMasterPage?: InputMaybe<AdvertisementMasterPageFilterInput>;
  advertisementMasterPageId?: InputMaybe<ComparableInt32OperationFilterInput>;
  advertisementPageId?: InputMaybe<ComparableInt32OperationFilterInput>;
  and?: InputMaybe<Array<AdvertisementPageFilterInput>>;
  businessLevel?: InputMaybe<BusinessLevelFilterInput>;
  businessLevelId?: InputMaybe<ComparableInt32OperationFilterInput>;
  created?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  customer?: InputMaybe<CustomerFilterInput>;
  customerId?: InputMaybe<ComparableInt32OperationFilterInput>;
  endDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  generatedUrl?: InputMaybe<StringOperationFilterInput>;
  modified?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<AdvertisementPageFilterInput>>;
  removed?: InputMaybe<BooleanOperationFilterInput>;
  rowVersion?: InputMaybe<ListComparableByteOperationFilterInput>;
  securitySettingEdit?: InputMaybe<ComparableInt32OperationFilterInput>;
  startDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  userCreated?: InputMaybe<UserDetailFilterInput>;
  userCreatedId?: InputMaybe<ComparableInt32OperationFilterInput>;
  userModified?: InputMaybe<UserDetailFilterInput>;
  userModifiedId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type AgreementFilterInput = {
  agreementId?: InputMaybe<ComparableInt32OperationFilterInput>;
  and?: InputMaybe<Array<AgreementFilterInput>>;
  businessName?: InputMaybe<StringOperationFilterInput>;
  franchiseeStores?: InputMaybe<ListFilterInputTypeOfFranchiseeStoreFilterInput>;
  guarantors?: InputMaybe<ListFilterInputTypeOfGuarantorFilterInput>;
  initialTerm?: InputMaybe<ComparableInt32OperationFilterInput>;
  minimumPerformances?: InputMaybe<ListFilterInputTypeOfMinimumPerformanceFilterInput>;
  oneOffFees?: InputMaybe<ListFilterInputTypeOfOneOffFeeFilterInput>;
  or?: InputMaybe<Array<AgreementFilterInput>>;
  recruitment?: InputMaybe<RecruitmentFilterInput>;
  recruitmentId?: InputMaybe<ComparableInt32OperationFilterInput>;
  recurringFees?: InputMaybe<ListFilterInputTypeOfRecurringFeeFilterInput>;
  removed?: InputMaybe<BooleanOperationFilterInput>;
  renewalNoticeDueMax?: InputMaybe<ComparableInt32OperationFilterInput>;
  renewalNoticeDueMin?: InputMaybe<ComparableInt32OperationFilterInput>;
  rowVersion?: InputMaybe<ListComparableByteOperationFilterInput>;
  specialConditions?: InputMaybe<ListFilterInputTypeOfSpecialConditionFilterInput>;
  territoryDescription?: InputMaybe<StringOperationFilterInput>;
  territoryMapId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
};

export enum ApplyPolicy {
  AfterResolver = 'AFTER_RESOLVER',
  BeforeResolver = 'BEFORE_RESOLVER'
}

/** Represents the input for approving multiple OrderShipping's. */
export type ApproveMultipleOrderShippingsInput = {
  /** Optional comments */
  comments?: InputMaybe<Scalars['String']>;
  /** Order Shipping IDs */
  orderShippingIds: Array<Scalars['Int']>;
};

/** Represents the input for approving an OrderShipping. */
export type ApproveOrderShippingInput = {
  /** Optional comment */
  comments?: InputMaybe<Scalars['String']>;
  /** The Order Shipping ID */
  orderShippingId: Scalars['Int'];
};

/** Represents the input for updating an OrderShipping's fee. */
export type UpdateOrderShippingFeeInput = {
  /** The Order Shipping ID */
  orderShippingId: Scalars['Int'];
  /** The new total fee of the order shipping */
  feeTotal: Scalars['Decimal'];
};

export type AttributeDataRecord = {
  __typename?: 'AttributeDataRecord';
  abbreviation?: Maybe<Scalars['String']>;
  attribDataId: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
};

export type AttributeRecord = {
  __typename?: 'AttributeRecord';
  attributeData: Array<AttributeDataRecord>;
  attributeId: Scalars['Int'];
  name: Scalars['String'];
};

export type AttributeSetRecord = {
  __typename?: 'AttributeSetRecord';
  attributeSetId: Scalars['Int'];
  attributes: Array<AttributeRecord>;
  name: Scalars['String'];
};

export type AttributeViewModel = {
  __typename?: 'AttributeViewModel';
  attributeName: Scalars['String'];
  productCode: Scalars['String'];
  productId: Scalars['Int'];
  stockAvailable: Scalars['Int'];
};

export type AutoPopulateCustomerFeaturesPayload = {
  __typename?: 'AutoPopulateCustomerFeaturesPayload';
  success: Scalars['Boolean'];
};

export type BankDetail = {
  __typename?: 'BankDetail';
  accountName: Scalars['String'];
  accountNumber: Scalars['String'];
  bankName: Scalars['String'];
  bsb: Scalars['String'];
  businessLevels: Array<BusinessLevel>;
  companyAbn?: Maybe<Scalars['String']>;
  companyName: Scalars['String'];
  customers: Array<Customer>;
  id: Scalars['Int'];
};

export type BankDetailFilterInput = {
  accountName?: InputMaybe<StringOperationFilterInput>;
  accountNumber?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<BankDetailFilterInput>>;
  bankName?: InputMaybe<StringOperationFilterInput>;
  bsb?: InputMaybe<StringOperationFilterInput>;
  businessLevels?: InputMaybe<ListFilterInputTypeOfBusinessLevelFilterInput>;
  companyAbn?: InputMaybe<StringOperationFilterInput>;
  companyName?: InputMaybe<StringOperationFilterInput>;
  customers?: InputMaybe<ListFilterInputTypeOfCustomerFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<BankDetailFilterInput>>;
};

export type BankDetailSortInput = {
  accountName?: InputMaybe<SortEnumType>;
  accountNumber?: InputMaybe<SortEnumType>;
  bankName?: InputMaybe<SortEnumType>;
  bsb?: InputMaybe<SortEnumType>;
  companyAbn?: InputMaybe<SortEnumType>;
  companyName?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
};

export type BaseRoleType = {
  __typename?: 'BaseRoleType';
  active: Scalars['Boolean'];
  activityTypeRoleVisibilities: Array<ActivityTypeRoleVisibility>;
  additionalRole: Scalars['Boolean'];
  adminRole: Scalars['Boolean'];
  bodyContent?: Maybe<Scalars['String']>;
  created: Scalars['DateTime'];
  customer: Customer;
  customerDefault: Scalars['Boolean'];
  customerEmailSettings: Array<CustomerEmailSetting>;
  customerId: Scalars['Int'];
  defaultCategoryId?: Maybe<Scalars['Int']>;
  defaultRole: Scalars['Boolean'];
  defaultWarehouse?: Maybe<Scalars['String']>;
  discount?: Maybe<Scalars['Decimal']>;
  discountIsPercentage?: Maybe<Scalars['Boolean']>;
  exchangeRateCode?: Maybe<Scalars['String']>;
  headerContent?: Maybe<Scalars['String']>;
  liveChatPriority?: Maybe<Scalars['Int']>;
  maxOrderQuantity?: Maybe<Scalars['Int']>;
  maxSpendByDays?: Maybe<Scalars['Decimal']>;
  maxSpendDays?: Maybe<Scalars['Int']>;
  minOrderTotal?: Maybe<Scalars['Decimal']>;
  modified: Scalars['DateTime'];
  name: Scalars['String'];
  orderBy: Scalars['Int'];
  orderPlacedForwardText?: Maybe<Scalars['String']>;
  orderPlacedForwardUrl?: Maybe<Scalars['String']>;
  productCategoryOrderLimitByRoles: Array<ProductCategoryOrderLimitByRole>;
  productOrderLimitByRoles: Array<ProductOrderLimitByRole>;
  purgeDate?: Maybe<Scalars['DateTime']>;
  removed: Scalars['Boolean'];
  reportRoleTableListVisibilities: Array<ReportRoleTableListVisibility>;
  reportRoleVisibilities: Array<ReportRoleVisibility>;
  roleCategoryDiscounts: Array<RoleCategoryDiscount>;
  roleCategoryVisibilities: Array<RoleCategoryVisibility>;
  roleCss?: Maybe<Scalars['String']>;
  roleFreightMaps: Array<RoleFreightMap>;
  roleId: Scalars['Int'];
  roleOrderTypes: Array<RoleOrderType>;
  rolePermissions: Array<RolePermission>;
  roleProductDiscounts: Array<RoleProductDiscount>;
  rowVersion: Scalars['Int'];
  siteMaps: Array<SiteMap>;
  userDetails: Array<UserType>;
  userModifiedId: Scalars['Int'];
  zeroFreightOrderAmount?: Maybe<Scalars['Decimal']>;
};

export type Bmwcampaign = {
  __typename?: 'Bmwcampaign';
  active: Scalars['Boolean'];
  bmwcampaignId: Scalars['Int'];
  bmwcampaignSubmissions: Array<BmwcampaignSubmission>;
  campaignMessage: Scalars['String'];
  rowVersion: Array<Scalars['ByteArray']>;
};

export type BmwcampaignFilterInput = {
  active?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<BmwcampaignFilterInput>>;
  bmwcampaignId?: InputMaybe<ComparableInt32OperationFilterInput>;
  bmwcampaignSubmissions?: InputMaybe<ListFilterInputTypeOfBmwcampaignSubmissionFilterInput>;
  campaignMessage?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<BmwcampaignFilterInput>>;
  rowVersion?: InputMaybe<ListComparableByteOperationFilterInput>;
};

export type BmwcampaignSubmission = {
  __typename?: 'BmwcampaignSubmission';
  bmwcampaign: Bmwcampaign;
  bmwcampaignId: Scalars['Int'];
  bmwcampaignSubmissionId: Scalars['Int'];
  businessLevel: BusinessLevel;
  businessLevelId: Scalars['Int'];
  feedback?: Maybe<Scalars['String']>;
  qbit1?: Maybe<Scalars['Boolean']>;
  qbit2?: Maybe<Scalars['Boolean']>;
  qbit3?: Maybe<Scalars['Boolean']>;
  qint1?: Maybe<Scalars['Int']>;
  qint2?: Maybe<Scalars['Int']>;
  qint3?: Maybe<Scalars['Int']>;
  qstring1?: Maybe<Scalars['String']>;
  qstring2?: Maybe<Scalars['String']>;
  qstring3?: Maybe<Scalars['String']>;
  removed: Scalars['Boolean'];
  rowVersion: Array<Scalars['ByteArray']>;
  submissionDateTime: Scalars['DateTime'];
  submitUser: UserType;
  submitUserId: Scalars['Int'];
};

export type BmwcampaignSubmissionFilterInput = {
  and?: InputMaybe<Array<BmwcampaignSubmissionFilterInput>>;
  bmwcampaign?: InputMaybe<BmwcampaignFilterInput>;
  bmwcampaignId?: InputMaybe<ComparableInt32OperationFilterInput>;
  bmwcampaignSubmissionId?: InputMaybe<ComparableInt32OperationFilterInput>;
  businessLevel?: InputMaybe<BusinessLevelFilterInput>;
  businessLevelId?: InputMaybe<ComparableInt32OperationFilterInput>;
  feedback?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<BmwcampaignSubmissionFilterInput>>;
  qbit1?: InputMaybe<BooleanOperationFilterInput>;
  qbit2?: InputMaybe<BooleanOperationFilterInput>;
  qbit3?: InputMaybe<BooleanOperationFilterInput>;
  qint1?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  qint2?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  qint3?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  qstring1?: InputMaybe<StringOperationFilterInput>;
  qstring2?: InputMaybe<StringOperationFilterInput>;
  qstring3?: InputMaybe<StringOperationFilterInput>;
  removed?: InputMaybe<BooleanOperationFilterInput>;
  rowVersion?: InputMaybe<ListComparableByteOperationFilterInput>;
  submissionDateTime?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  submitUser?: InputMaybe<UserDetailFilterInput>;
  submitUserId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type BmwcommunicationBriefFilterInput = {
  activityId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<BmwcommunicationBriefFilterInput>>;
  approverId?: InputMaybe<ComparableInt32OperationFilterInput>;
  bmwcommunicationFiles?: InputMaybe<ListFilterInputTypeOfBmwcommunicationFileFilterInput>;
  briefTitle?: InputMaybe<StringOperationFilterInput>;
  businessLevelId?: InputMaybe<ComparableInt32OperationFilterInput>;
  campaignName?: InputMaybe<StringOperationFilterInput>;
  comments?: InputMaybe<StringOperationFilterInput>;
  created?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  isPart2Adhoc?: InputMaybe<BooleanOperationFilterInput>;
  modified?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<BmwcommunicationBriefFilterInput>>;
  part1AppearanceDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  part1ArtworkProof?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  part1BriefDate?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  part1BriefSummary?: InputMaybe<StringOperationFilterInput>;
  part1ContactName?: InputMaybe<StringOperationFilterInput>;
  part1DealershipName?: InputMaybe<StringOperationFilterInput>;
  part1Email?: InputMaybe<StringOperationFilterInput>;
  part1Material?: InputMaybe<StringOperationFilterInput>;
  part1MaterialDeadLine?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  part1Other?: InputMaybe<StringOperationFilterInput>;
  part2AdhocAdditionalInformation?: InputMaybe<StringOperationFilterInput>;
  part2AdhocBleed?: InputMaybe<StringOperationFilterInput>;
  part2AdhocBookingNumber?: InputMaybe<StringOperationFilterInput>;
  part2AdhocContact?: InputMaybe<StringOperationFilterInput>;
  part2AdhocDispatchMethod?: InputMaybe<StringOperationFilterInput>;
  part2AdhocMaterial?: InputMaybe<StringOperationFilterInput>;
  part2AdhocOutput?: InputMaybe<StringOperationFilterInput>;
  part2AdhocPublication?: InputMaybe<StringOperationFilterInput>;
  part2AdhocSafeArea?: InputMaybe<StringOperationFilterInput>;
  part2AdhocSection?: InputMaybe<StringOperationFilterInput>;
  part2AdhocTrim?: InputMaybe<StringOperationFilterInput>;
  part2DigitalAdditionalInformation?: InputMaybe<StringOperationFilterInput>;
  part2DigitalClickThroughUrl?: InputMaybe<StringOperationFilterInput>;
  part2DigitalCreativeDimensions?: InputMaybe<StringOperationFilterInput>;
  part2DigitalCreativeFormat?: InputMaybe<StringOperationFilterInput>;
  part2DigitalFileSize?: InputMaybe<StringOperationFilterInput>;
  part2DigitalFileType?: InputMaybe<StringOperationFilterInput>;
  part2DigitalMaterial?: InputMaybe<StringOperationFilterInput>;
  part2DigitalPublicationName?: InputMaybe<StringOperationFilterInput>;
  part3BodyCopy?: InputMaybe<StringOperationFilterInput>;
  part3CallToAction?: InputMaybe<StringOperationFilterInput>;
  part3Disclaimer?: InputMaybe<StringOperationFilterInput>;
  part3Headline?: InputMaybe<StringOperationFilterInput>;
  part3Other?: InputMaybe<StringOperationFilterInput>;
  part3Pricing?: InputMaybe<StringOperationFilterInput>;
  part3Subhead?: InputMaybe<StringOperationFilterInput>;
  part4DeliveryDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  part4QuantityRequired?: InputMaybe<StringOperationFilterInput>;
  part4StockType?: InputMaybe<StringOperationFilterInput>;
  part4useWaratah?: InputMaybe<BooleanOperationFilterInput>;
  status?: InputMaybe<StringOperationFilterInput>;
  userCreated?: InputMaybe<UserDetailFilterInput>;
  userCreatedId?: InputMaybe<ComparableInt32OperationFilterInput>;
  userModifiedId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type BmwcommunicationFileFilterInput = {
  and?: InputMaybe<Array<BmwcommunicationFileFilterInput>>;
  brief?: InputMaybe<BmwcommunicationBriefFilterInput>;
  briefId?: InputMaybe<ComparableInt32OperationFilterInput>;
  created?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  fileGuid?: InputMaybe<StringOperationFilterInput>;
  filename?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  modified?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<BmwcommunicationFileFilterInput>>;
  type?: InputMaybe<StringOperationFilterInput>;
};

export type BooleanOperationFilterInput = {
  eq?: InputMaybe<Scalars['Boolean']>;
  neq?: InputMaybe<Scalars['Boolean']>;
};

export type BusinessLevel = {
  __typename?: 'BusinessLevel';
  abn?: Maybe<Scalars['String']>;
  accpacAccount?: Maybe<Scalars['String']>;
  active: Scalars['Boolean'];
  activities: Array<Activity>;
  activityBusinessLevelRates: Array<ActivityBusinessLevelRate>;
  advertisementMasterPages: Array<AdvertisementMasterPage>;
  advertisementPages: Array<AdvertisementPage>;
  approverFirstOrderValue?: Maybe<Scalars['Decimal']>;
  approverSecondOrderValue?: Maybe<Scalars['Decimal']>;
  bankDetails?: Maybe<BankDetail>;
  bankDetailsId?: Maybe<Scalars['Int']>;
  billingAddress?: Maybe<Address>;
  billingAddressId?: Maybe<Scalars['Int']>;
  blnote?: Maybe<Scalars['String']>;
  bmwcampaignSubmissions: Array<BmwcampaignSubmission>;
  budgetAmount?: Maybe<Scalars['Decimal']>;
  budgetExpiryDate?: Maybe<Scalars['DateTime']>;
  budgetReOccurance?: Maybe<Scalars['Int']>;
  businessLevelComments: Array<BusinessLevelComment>;
  businessLevelId: Scalars['Int'];
  businessLevelOptData: Array<BusinessLevelOptDatum>;
  businessLevelOptHeads: Array<BusinessLevelOptHead>;
  cachedVersion: Scalars['Int'];
  campaigns: Array<Campaign>;
  categoryPromoterVisibilities: Array<CategoryPromoterVisibility>;
  categoryVisibilities: Array<CategoryVisibility>;
  cmsBlockStatuses: Array<CmsBlockStatus>;
  created: Scalars['DateTime'];
  crmid?: Maybe<Scalars['String']>;
  customer: Customer;
  customerBlid?: Maybe<Scalars['String']>;
  customerId: Scalars['Int'];
  customisedCss?: Maybe<Scalars['String']>;
  deliveryAddress?: Maybe<Address>;
  deliveryAddressId?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  documentCategories: Array<DocumentCategory>;
  documentCategoryCustomVisibilities: Array<DocumentCategoryCustomVisibility>;
  documentCustomVisibilities: Array<DocumentCustomVisibility>;
  documents: Array<Document>;
  emailDetails: Array<EmailDetail>;
  emailTemplates: Array<EmailTemplate>;
  etemplateDataBusinessLevelMaps: Array<EtemplateDataBusinessLevelMap>;
  exchangeRate?: Maybe<CustomerExchangeRate>;
  exchangeRateId?: Maybe<Scalars['Int']>;
  fordTransactions: Array<FordTransaction>;
  fordTransactionsRctis: Array<FordTransactionsRcti>;
  hideFromBilling: Scalars['Boolean'];
  hideFromDelivery: Scalars['Boolean'];
  hierarchy?: Maybe<Scalars['String']>;
  icon?: Maybe<Scalars['String']>;
  inverseParent: Array<BusinessLevel>;
  isSelectableForBilling: Scalars['Boolean'];
  keywords?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  modified: Scalars['DateTime'];
  name: Scalars['String'];
  noCustomerEmailNotification: Scalars['Boolean'];
  orderCredit?: Maybe<Scalars['Decimal']>;
  orderNotifyEmail?: Maybe<Scalars['String']>;
  parent?: Maybe<BusinessLevel>;
  parentId?: Maybe<Scalars['Int']>;
  primaryApprover2ndPassId?: Maybe<Scalars['Int']>;
  primaryApproverId?: Maybe<Scalars['Int']>;
  primaryColour?: Maybe<Scalars['String']>;
  primaryDarkColour?: Maybe<Scalars['String']>;
  projectVisibilities: Array<ProjectVisibility>;
  projects: Array<Project>;
  purgeDate?: Maybe<Scalars['DateTime']>;
  reasonForVisibility?: Maybe<Scalars['String']>;
  recipientData: Array<RecipientData>;
  recordTimestamp: Array<Scalars['ByteArray']>;
  removed: Scalars['Boolean'];
  reportBusinessLevelVisibilities: Array<ReportBusinessLevelVisibility>;
  responsiblePerson1?: Maybe<Scalars['Int']>;
  responsiblePerson1Navigation?: Maybe<UserType>;
  responsiblePerson2?: Maybe<Scalars['Int']>;
  responsiblePerson2Navigation?: Maybe<UserType>;
  restrictUserCreation: Scalars['Boolean'];
  salesForceId?: Maybe<Scalars['String']>;
  salesForceSettings: Array<SalesForceSetting>;
  secondaryApprover2ndPassId?: Maybe<Scalars['Int']>;
  secondaryApproverId?: Maybe<Scalars['Int']>;
  secondaryColour?: Maybe<Scalars['String']>;
  smsTemplates: Array<SmsTemplate>;
  stihlbaseOrderSubmissions: Array<StihlbaseOrderSubmission>;
  surveySubmissionHeaders: Array<SurveySubmissionHeader>;
  taxLiable: Scalars['Boolean'];
  type?: Maybe<BusinessLevelType>;
  typeId?: Maybe<Scalars['Int']>;
  userCreatedId: Scalars['Int'];
  userDetails: Array<UserType>;
  userModifiedId: Scalars['Int'];
  visible: Scalars['Boolean'];
  webAddress?: Maybe<Scalars['String']>;
  wn2id?: Maybe<Scalars['Int']>;
  workFlowColour?: Maybe<Scalars['String']>;
};

export type BusinessLevelComment = {
  __typename?: 'BusinessLevelComment';
  businessLevel: BusinessLevel;
  businessLevelId: Scalars['Int'];
  created: Scalars['DateTime'];
  id: Scalars['Int'];
  modified: Scalars['DateTime'];
  name: Scalars['String'];
  userCreatedId: Scalars['Int'];
  userModifiedId: Scalars['Int'];
};

export type BusinessLevelCommentFilterInput = {
  and?: InputMaybe<Array<BusinessLevelCommentFilterInput>>;
  businessLevel?: InputMaybe<BusinessLevelFilterInput>;
  businessLevelId?: InputMaybe<ComparableInt32OperationFilterInput>;
  created?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  modified?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<BusinessLevelCommentFilterInput>>;
  userCreatedId?: InputMaybe<ComparableInt32OperationFilterInput>;
  userModifiedId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type BusinessLevelFilterInput = {
  abn?: InputMaybe<StringOperationFilterInput>;
  accpacAccount?: InputMaybe<StringOperationFilterInput>;
  active?: InputMaybe<BooleanOperationFilterInput>;
  activities?: InputMaybe<ListFilterInputTypeOfActivityFilterInput>;
  activityBusinessLevelRates?: InputMaybe<ListFilterInputTypeOfActivityBusinessLevelRateFilterInput>;
  advertisementMasterPages?: InputMaybe<ListFilterInputTypeOfAdvertisementMasterPageFilterInput>;
  advertisementPages?: InputMaybe<ListFilterInputTypeOfAdvertisementPageFilterInput>;
  and?: InputMaybe<Array<BusinessLevelFilterInput>>;
  approverFirstOrderValue?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  approverSecondOrderValue?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  bankDetails?: InputMaybe<BankDetailFilterInput>;
  bankDetailsId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  billingAddress?: InputMaybe<AddressFilterInput>;
  billingAddressId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  blnote?: InputMaybe<StringOperationFilterInput>;
  bmwcampaignSubmissions?: InputMaybe<ListFilterInputTypeOfBmwcampaignSubmissionFilterInput>;
  budgetAmount?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  budgetExpiryDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  budgetReOccurance?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  businessLevelComments?: InputMaybe<ListFilterInputTypeOfBusinessLevelCommentFilterInput>;
  businessLevelId?: InputMaybe<ComparableInt32OperationFilterInput>;
  businessLevelOptData?: InputMaybe<ListFilterInputTypeOfBusinessLevelOptDatumFilterInput>;
  businessLevelOptHeads?: InputMaybe<ListFilterInputTypeOfBusinessLevelOptHeadFilterInput>;
  cachedVersion?: InputMaybe<ComparableInt32OperationFilterInput>;
  campaigns?: InputMaybe<ListFilterInputTypeOfCampaignFilterInput>;
  categoryPromoterVisibilities?: InputMaybe<ListFilterInputTypeOfCategoryPromoterVisibilityFilterInput>;
  categoryVisibilities?: InputMaybe<ListFilterInputTypeOfCategoryVisibilityFilterInput>;
  cmsBlockStatuses?: InputMaybe<ListFilterInputTypeOfCmsBlockStatusFilterInput>;
  created?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  crmid?: InputMaybe<StringOperationFilterInput>;
  customer?: InputMaybe<CustomerFilterInput>;
  customerBlid?: InputMaybe<StringOperationFilterInput>;
  customerId?: InputMaybe<ComparableInt32OperationFilterInput>;
  customisedCss?: InputMaybe<StringOperationFilterInput>;
  deliveryAddress?: InputMaybe<AddressFilterInput>;
  deliveryAddressId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  documentCategories?: InputMaybe<ListFilterInputTypeOfDocumentCategoryFilterInput>;
  documentCategoryCustomVisibilities?: InputMaybe<ListFilterInputTypeOfDocumentCategoryCustomVisibilityFilterInput>;
  documentCustomVisibilities?: InputMaybe<ListFilterInputTypeOfDocumentCustomVisibilityFilterInput>;
  documents?: InputMaybe<ListFilterInputTypeOfDocumentFilterInput>;
  emailDetails?: InputMaybe<ListFilterInputTypeOfEmailDetailFilterInput>;
  emailTemplates?: InputMaybe<ListFilterInputTypeOfEmailTemplateFilterInput>;
  etemplateDataBusinessLevelMaps?: InputMaybe<ListFilterInputTypeOfEtemplateDataBusinessLevelMapFilterInput>;
  exchangeRate?: InputMaybe<CustomerExchangeRateFilterInput>;
  exchangeRateId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  fordTransactions?: InputMaybe<ListFilterInputTypeOfFordTransactionFilterInput>;
  fordTransactionsRctis?: InputMaybe<ListFilterInputTypeOfFordTransactionsRctiFilterInput>;
  hideFromBilling?: InputMaybe<BooleanOperationFilterInput>;
  hideFromDelivery?: InputMaybe<BooleanOperationFilterInput>;
  hierarchy?: InputMaybe<StringOperationFilterInput>;
  icon?: InputMaybe<StringOperationFilterInput>;
  inverseParent?: InputMaybe<ListFilterInputTypeOfBusinessLevelFilterInput>;
  isSelectableForBilling?: InputMaybe<BooleanOperationFilterInput>;
  keywords?: InputMaybe<StringOperationFilterInput>;
  logo?: InputMaybe<StringOperationFilterInput>;
  modified?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  noCustomerEmailNotification?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<BusinessLevelFilterInput>>;
  orderCredit?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  orderNotifyEmail?: InputMaybe<StringOperationFilterInput>;
  parent?: InputMaybe<BusinessLevelFilterInput>;
  parentId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  primaryApprover2ndPassId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  primaryApproverId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  primaryColour?: InputMaybe<StringOperationFilterInput>;
  primaryDarkColour?: InputMaybe<StringOperationFilterInput>;
  projectVisibilities?: InputMaybe<ListFilterInputTypeOfProjectVisibilityFilterInput>;
  projects?: InputMaybe<ListFilterInputTypeOfProjectFilterInput>;
  purgeDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  reasonForVisibility?: InputMaybe<StringOperationFilterInput>;
  recipientData?: InputMaybe<ListFilterInputTypeOfRecipientDataFilterInput>;
  recordTimestamp?: InputMaybe<ListComparableByteOperationFilterInput>;
  removed?: InputMaybe<BooleanOperationFilterInput>;
  reportBusinessLevelVisibilities?: InputMaybe<ListFilterInputTypeOfReportBusinessLevelVisibilityFilterInput>;
  responsiblePerson1?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  responsiblePerson1Navigation?: InputMaybe<UserDetailFilterInput>;
  responsiblePerson2?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  responsiblePerson2Navigation?: InputMaybe<UserDetailFilterInput>;
  restrictUserCreation?: InputMaybe<BooleanOperationFilterInput>;
  salesForceId?: InputMaybe<StringOperationFilterInput>;
  salesForceSettings?: InputMaybe<ListFilterInputTypeOfSalesForceSettingFilterInput>;
  secondaryApprover2ndPassId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  secondaryApproverId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  secondaryColour?: InputMaybe<StringOperationFilterInput>;
  smsTemplates?: InputMaybe<ListFilterInputTypeOfSmsTemplateFilterInput>;
  stihlbaseOrderSubmissions?: InputMaybe<ListFilterInputTypeOfStihlbaseOrderSubmissionFilterInput>;
  surveySubmissionHeaders?: InputMaybe<ListFilterInputTypeOfSurveySubmissionHeaderFilterInput>;
  taxLiable?: InputMaybe<BooleanOperationFilterInput>;
  type?: InputMaybe<BusinessLevelTypeFilterInput>;
  typeId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  userCreatedId?: InputMaybe<ComparableInt32OperationFilterInput>;
  userDetails?: InputMaybe<ListFilterInputTypeOfUserDetailFilterInput>;
  userModifiedId?: InputMaybe<ComparableInt32OperationFilterInput>;
  visible?: InputMaybe<BooleanOperationFilterInput>;
  webAddress?: InputMaybe<StringOperationFilterInput>;
  wn2id?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  workFlowColour?: InputMaybe<StringOperationFilterInput>;
};

export type BusinessLevelOptDataType = {
  __typename?: 'BusinessLevelOptDataType';
  businessLevelOptHeads: Array<BusinessLevelOptHead>;
  dataType: Scalars['String'];
  filterable: Scalars['Boolean'];
  format?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type BusinessLevelOptDataTypeFilterInput = {
  and?: InputMaybe<Array<BusinessLevelOptDataTypeFilterInput>>;
  businessLevelOptHeads?: InputMaybe<ListFilterInputTypeOfBusinessLevelOptHeadFilterInput>;
  dataType?: InputMaybe<StringOperationFilterInput>;
  filterable?: InputMaybe<BooleanOperationFilterInput>;
  format?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<BusinessLevelOptDataTypeFilterInput>>;
};

export type BusinessLevelOptDatum = {
  __typename?: 'BusinessLevelOptDatum';
  binary?: Maybe<Array<Scalars['ByteArray']>>;
  businessLevel: BusinessLevel;
  businessLevelId: Scalars['Int'];
  dataId: Scalars['Int'];
  dateTime?: Maybe<Scalars['DateTime']>;
  decimal?: Maybe<Scalars['Decimal']>;
  int?: Maybe<Scalars['Int']>;
  nvarchar50?: Maybe<Scalars['String']>;
  nvarcharMax?: Maybe<Scalars['String']>;
  optHead: BusinessLevelOptHead;
  optHeadId: Scalars['Int'];
};

export type BusinessLevelOptDatumFilterInput = {
  and?: InputMaybe<Array<BusinessLevelOptDatumFilterInput>>;
  binary?: InputMaybe<ListComparableByteOperationFilterInput>;
  businessLevel?: InputMaybe<BusinessLevelFilterInput>;
  businessLevelId?: InputMaybe<ComparableInt32OperationFilterInput>;
  dataId?: InputMaybe<ComparableInt32OperationFilterInput>;
  dateTime?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  decimal?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  int?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  nvarchar50?: InputMaybe<StringOperationFilterInput>;
  nvarcharMax?: InputMaybe<StringOperationFilterInput>;
  optHead?: InputMaybe<BusinessLevelOptHeadFilterInput>;
  optHeadId?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<BusinessLevelOptDatumFilterInput>>;
};

export type BusinessLevelOptEnum = {
  __typename?: 'BusinessLevelOptEnum';
  enumId: Scalars['Int'];
  name: Scalars['String'];
  optHead: BusinessLevelOptHead;
  optHeadId: Scalars['Int'];
};

export type BusinessLevelOptEnumFilterInput = {
  and?: InputMaybe<Array<BusinessLevelOptEnumFilterInput>>;
  enumId?: InputMaybe<ComparableInt32OperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  optHead?: InputMaybe<BusinessLevelOptHeadFilterInput>;
  optHeadId?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<BusinessLevelOptEnumFilterInput>>;
};

export type BusinessLevelOptHead = {
  __typename?: 'BusinessLevelOptHead';
  active: Scalars['Boolean'];
  businessLevel?: Maybe<BusinessLevel>;
  businessLevelId?: Maybe<Scalars['Int']>;
  businessLevelOptData: Array<BusinessLevelOptDatum>;
  businessLevelOptEnums: Array<BusinessLevelOptEnum>;
  dataType: Scalars['String'];
  dataTypeId: Scalars['Int'];
  dataTypeNavigation: BusinessLevelOptDataType;
  dbcolumn?: Maybe<Scalars['String']>;
  isDbcolumn: Scalars['Boolean'];
  isMeta: Scalars['Boolean'];
  name: Scalars['String'];
  optHeadId: Scalars['Int'];
  removed: Scalars['Boolean'];
  user?: Maybe<UserType>;
  userId?: Maybe<Scalars['Int']>;
};

export type BusinessLevelOptHeadFilterInput = {
  active?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<BusinessLevelOptHeadFilterInput>>;
  businessLevel?: InputMaybe<BusinessLevelFilterInput>;
  businessLevelId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  businessLevelOptData?: InputMaybe<ListFilterInputTypeOfBusinessLevelOptDatumFilterInput>;
  businessLevelOptEnums?: InputMaybe<ListFilterInputTypeOfBusinessLevelOptEnumFilterInput>;
  dataType?: InputMaybe<StringOperationFilterInput>;
  dataTypeId?: InputMaybe<ComparableInt32OperationFilterInput>;
  dataTypeNavigation?: InputMaybe<BusinessLevelOptDataTypeFilterInput>;
  dbcolumn?: InputMaybe<StringOperationFilterInput>;
  isDbcolumn?: InputMaybe<BooleanOperationFilterInput>;
  isMeta?: InputMaybe<BooleanOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  optHeadId?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<BusinessLevelOptHeadFilterInput>>;
  removed?: InputMaybe<BooleanOperationFilterInput>;
  user?: InputMaybe<UserDetailFilterInput>;
  userId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
};

export type BusinessLevelSortInput = {
  abn?: InputMaybe<SortEnumType>;
  accpacAccount?: InputMaybe<SortEnumType>;
  active?: InputMaybe<SortEnumType>;
  approverFirstOrderValue?: InputMaybe<SortEnumType>;
  approverSecondOrderValue?: InputMaybe<SortEnumType>;
  bankDetails?: InputMaybe<BankDetailSortInput>;
  bankDetailsId?: InputMaybe<SortEnumType>;
  billingAddress?: InputMaybe<AddressSortInput>;
  billingAddressId?: InputMaybe<SortEnumType>;
  blnote?: InputMaybe<SortEnumType>;
  budgetAmount?: InputMaybe<SortEnumType>;
  budgetExpiryDate?: InputMaybe<SortEnumType>;
  budgetReOccurance?: InputMaybe<SortEnumType>;
  businessLevelId?: InputMaybe<SortEnumType>;
  cachedVersion?: InputMaybe<SortEnumType>;
  created?: InputMaybe<SortEnumType>;
  crmid?: InputMaybe<SortEnumType>;
  customer?: InputMaybe<CustomerSortInput>;
  customerBlid?: InputMaybe<SortEnumType>;
  customerId?: InputMaybe<SortEnumType>;
  customisedCss?: InputMaybe<SortEnumType>;
  deliveryAddress?: InputMaybe<AddressSortInput>;
  deliveryAddressId?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  exchangeRate?: InputMaybe<CustomerExchangeRateSortInput>;
  exchangeRateId?: InputMaybe<SortEnumType>;
  hideFromBilling?: InputMaybe<SortEnumType>;
  hideFromDelivery?: InputMaybe<SortEnumType>;
  hierarchy?: InputMaybe<SortEnumType>;
  icon?: InputMaybe<SortEnumType>;
  isSelectableForBilling?: InputMaybe<SortEnumType>;
  keywords?: InputMaybe<SortEnumType>;
  logo?: InputMaybe<SortEnumType>;
  modified?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  noCustomerEmailNotification?: InputMaybe<SortEnumType>;
  orderCredit?: InputMaybe<SortEnumType>;
  orderNotifyEmail?: InputMaybe<SortEnumType>;
  parent?: InputMaybe<BusinessLevelSortInput>;
  parentId?: InputMaybe<SortEnumType>;
  primaryApprover2ndPassId?: InputMaybe<SortEnumType>;
  primaryApproverId?: InputMaybe<SortEnumType>;
  primaryColour?: InputMaybe<SortEnumType>;
  primaryDarkColour?: InputMaybe<SortEnumType>;
  purgeDate?: InputMaybe<SortEnumType>;
  reasonForVisibility?: InputMaybe<SortEnumType>;
  removed?: InputMaybe<SortEnumType>;
  responsiblePerson1?: InputMaybe<SortEnumType>;
  responsiblePerson1Navigation?: InputMaybe<UserDetailSortInput>;
  responsiblePerson2?: InputMaybe<SortEnumType>;
  responsiblePerson2Navigation?: InputMaybe<UserDetailSortInput>;
  restrictUserCreation?: InputMaybe<SortEnumType>;
  salesForceId?: InputMaybe<SortEnumType>;
  secondaryApprover2ndPassId?: InputMaybe<SortEnumType>;
  secondaryApproverId?: InputMaybe<SortEnumType>;
  secondaryColour?: InputMaybe<SortEnumType>;
  taxLiable?: InputMaybe<SortEnumType>;
  type?: InputMaybe<BusinessLevelTypeSortInput>;
  typeId?: InputMaybe<SortEnumType>;
  userCreatedId?: InputMaybe<SortEnumType>;
  userModifiedId?: InputMaybe<SortEnumType>;
  visible?: InputMaybe<SortEnumType>;
  webAddress?: InputMaybe<SortEnumType>;
  wn2id?: InputMaybe<SortEnumType>;
  workFlowColour?: InputMaybe<SortEnumType>;
};

export type BusinessLevelType = {
  __typename?: 'BusinessLevelType';
  businessLevels: Array<BusinessLevel>;
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type BusinessLevelTypeFilterInput = {
  and?: InputMaybe<Array<BusinessLevelTypeFilterInput>>;
  businessLevels?: InputMaybe<ListFilterInputTypeOfBusinessLevelFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<BusinessLevelTypeFilterInput>>;
};

export type BusinessLevelTypeSortInput = {
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
};

export type Campaign = {
  __typename?: 'Campaign';
  active: Scalars['Boolean'];
  businessLevel: BusinessLevel;
  businessLevelId: Scalars['Int'];
  campaignId: Scalars['Int'];
  campaignStatus: CampaignStatus;
  campaignStatusId: Scalars['Int'];
  created: Scalars['DateTime'];
  customer?: Maybe<Customer>;
  customerId?: Maybe<Scalars['Int']>;
  emailAttachmentUploadedFile?: Maybe<UploadedFile>;
  emailAttachmentUploadedFileId?: Maybe<Scalars['Int']>;
  emailEtemplate?: Maybe<Etemplate>;
  emailEtemplateId?: Maybe<Scalars['Int']>;
  emailHeader?: Maybe<EmailHeader>;
  emailHeaderId?: Maybe<Scalars['Int']>;
  emailRecipientData?: Maybe<RecipientData>;
  emailRecipientDataId?: Maybe<Scalars['Int']>;
  emailTemplate?: Maybe<EmailTemplate>;
  emailTemplateId?: Maybe<Scalars['Int']>;
  isEmailEnabled: Scalars['Boolean'];
  isSmsenabled: Scalars['Boolean'];
  modified: Scalars['DateTime'];
  name: Scalars['String'];
  order?: Maybe<Order>;
  orderId?: Maybe<Scalars['Int']>;
  removed: Scalars['Boolean'];
  rowVersion: Array<Scalars['ByteArray']>;
  scheduled?: Maybe<Scalars['DateTime']>;
  smsrecipientData?: Maybe<RecipientData>;
  smsrecipientDataId?: Maybe<Scalars['Int']>;
  smsrequest?: Maybe<SmsRequest>;
  smsrequestId?: Maybe<Scalars['Int']>;
  smssender?: Maybe<Scalars['String']>;
  smstemplate?: Maybe<SmsTemplate>;
  smstemplateId?: Maybe<Scalars['Int']>;
  userCreated?: Maybe<UserType>;
  userCreatedId?: Maybe<Scalars['Int']>;
  userModified: UserType;
  userModifiedId: Scalars['Int'];
  version: Scalars['Int'];
};

export type CampaignFilterInput = {
  active?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<CampaignFilterInput>>;
  businessLevel?: InputMaybe<BusinessLevelFilterInput>;
  businessLevelId?: InputMaybe<ComparableInt32OperationFilterInput>;
  campaignId?: InputMaybe<ComparableInt32OperationFilterInput>;
  campaignStatus?: InputMaybe<CampaignStatusFilterInput>;
  campaignStatusId?: InputMaybe<ComparableInt32OperationFilterInput>;
  created?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  customer?: InputMaybe<CustomerFilterInput>;
  customerId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  emailAttachmentUploadedFile?: InputMaybe<UploadedFileFilterInput>;
  emailAttachmentUploadedFileId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  emailEtemplate?: InputMaybe<EtemplateFilterInput>;
  emailEtemplateId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  emailHeader?: InputMaybe<EmailHeaderFilterInput>;
  emailHeaderId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  emailRecipientData?: InputMaybe<RecipientDataFilterInput>;
  emailRecipientDataId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  emailTemplate?: InputMaybe<EmailTemplateFilterInput>;
  emailTemplateId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  isEmailEnabled?: InputMaybe<BooleanOperationFilterInput>;
  isSmsenabled?: InputMaybe<BooleanOperationFilterInput>;
  modified?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CampaignFilterInput>>;
  order?: InputMaybe<OrderFilterInput>;
  orderId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  removed?: InputMaybe<BooleanOperationFilterInput>;
  rowVersion?: InputMaybe<ListComparableByteOperationFilterInput>;
  scheduled?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  smsrecipientData?: InputMaybe<RecipientDataFilterInput>;
  smsrecipientDataId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  smsrequest?: InputMaybe<SmsRequestFilterInput>;
  smsrequestId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  smssender?: InputMaybe<StringOperationFilterInput>;
  smstemplate?: InputMaybe<SmsTemplateFilterInput>;
  smstemplateId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  userCreated?: InputMaybe<UserDetailFilterInput>;
  userCreatedId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  userModified?: InputMaybe<UserDetailFilterInput>;
  userModifiedId?: InputMaybe<ComparableInt32OperationFilterInput>;
  version?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type CampaignStatus = {
  __typename?: 'CampaignStatus';
  campaignStatusId: Scalars['Int'];
  campaigns: Array<Campaign>;
  description?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

export type CampaignStatusFilterInput = {
  and?: InputMaybe<Array<CampaignStatusFilterInput>>;
  campaignStatusId?: InputMaybe<ComparableInt32OperationFilterInput>;
  campaigns?: InputMaybe<ListFilterInputTypeOfCampaignFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CampaignStatusFilterInput>>;
};

export type CarrierService = {
  __typename?: 'CarrierService';
  carrierName: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  freightSettings: Array<CustomerFreightSettingType>;
  serviceCode: Scalars['String'];
  serviceId: Scalars['Int'];
};

export type CarrierServiceFilterInput = {
  and?: InputMaybe<Array<CarrierServiceFilterInput>>;
  carrierName?: InputMaybe<StringOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  freightSettings?: InputMaybe<ListFilterInputTypeOfCustomerFreightSettingFilterInput>;
  or?: InputMaybe<Array<CarrierServiceFilterInput>>;
  serviceCode?: InputMaybe<StringOperationFilterInput>;
  serviceId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

/** Represents a temporary cart */
export type Cart = {
  __typename?: 'Cart';
  /** Represents the cart's information */
  cartInformation: CartInformation;
  /** Represents the cart's creation DateTime */
  created?: Maybe<Scalars['DateTime']>;
  /** Represents the customer ID which the cart belongs to */
  customerId?: Maybe<Scalars['Int']>;
  /** Represents the cart's unique Object ID */
  id?: Maybe<Scalars['String']>;
  /** Represents the cart's last modified DateTime */
  modified?: Maybe<Scalars['DateTime']>;
  /** Represents the cart's estimated order costs */
  orderCosts?: Maybe<OrderCosts>;
  /** Represents the user's ID which the cart belongs to */
  userId?: Maybe<Scalars['Int']>;
};

/** Represents a cart's address details */
export type CartAddress = {
  __typename?: 'CartAddress';
  /** Represents the address' company name */
  company?: Maybe<Scalars['String']>;
  /** Represents the address' country */
  country: Scalars['String'];
  /** Represents the address' email */
  email: Scalars['String'];
  /** Represents the address' mobile number */
  mobile?: Maybe<Scalars['String']>;
  /** Represens the address' phone number */
  phone: Scalars['String'];
  /** Represents the address' postcode */
  postcode: Scalars['String'];
  /** Represents the address' state */
  state: Scalars['String'];
  /** Represents the address' street 1 */
  street1: Scalars['String'];
  /** Represents the address' street 2 */
  street2?: Maybe<Scalars['String']>;
  /** Represents the address' street 3 */
  street3?: Maybe<Scalars['String']>;
  /** Represents the address' street 4 */
  street4?: Maybe<Scalars['String']>;
  /** Represents the address' suburb */
  suburb: Scalars['String'];
};

/** Represents a cart's address details */
export type CartAddressInput = {
  /** Represents the address' company name */
  company?: InputMaybe<Scalars['String']>;
  /** Represents the address' country */
  country: Scalars['String'];
  /** Represents the address' email */
  email: Scalars['String'];
  /** Represents the address' mobile number */
  mobile?: InputMaybe<Scalars['String']>;
  /** Represens the address' phone number */
  phone: Scalars['String'];
  /** Represents the address' postcode */
  postcode: Scalars['String'];
  /** Represents the address' state */
  state: Scalars['String'];
  /** Represents the address' street 1 */
  street1: Scalars['String'];
  /** Represents the address' street 2 */
  street2?: InputMaybe<Scalars['String']>;
  /** Represents the address' street 3 */
  street3?: InputMaybe<Scalars['String']>;
  /** Represents the address' street 4 */
  street4?: InputMaybe<Scalars['String']>;
  /** Represents the address' suburb */
  suburb: Scalars['String'];
};

/** Represents a cart's information */
export type CartInformation = {
  __typename?: 'CartInformation';
  /** Represents the cart's billing address */
  billingAddress?: Maybe<CartAddress>;
  /** Represents the cart's order lines */
  cartLines: Array<CartLine>;
  /** Represents a cart's client order reference */
  clientOrderReference?: Maybe<Scalars['String']>;
  /** Represents if the cart will be collected */
  collect: Scalars['Boolean'];
  /** Represents the cart's delivery address */
  deliveryAddress: CartAddress;
  /** Represents a cart's delivery instructions */
  deliveryInstructions?: Maybe<Scalars['String']>;
  /** Represents a cart's selected delivery method ID */
  deliveryMethodId: Scalars['Int'];
  /** Represents a cart's selected delivery service code */
  deliveryServiceCode?: Maybe<Scalars['String']>;
  /** Represents the first name which a cart belongs to */
  firstName: Scalars['String'];
  /** Represents the last name which a cart belongs to */
  lastName: Scalars['String'];
  /** Represents if the cart will be charged a processing fee */
  manualOrder: Scalars['Boolean'];
  /** Represents if the cart is to be urgently picked */
  urgentPick: Scalars['Boolean'];
};

/** Represents a cart's information */
export type CartInformationInput = {
  /** Represents the cart's billing address */
  billingAddress?: InputMaybe<CartAddressInput>;
  /** Represents the cart's order lines */
  cartLines: Array<CartLineInput>;
  /** Represents a cart's client order reference */
  clientOrderReference?: InputMaybe<Scalars['String']>;
  /** Represents if the cart will be collected */
  collect: Scalars['Boolean'];
  /** Represents the cart's delivery address */
  deliveryAddress: CartAddressInput;
  /** Represents a cart's delivery instructions */
  deliveryInstructions?: InputMaybe<Scalars['String']>;
  /** Represents a cart's selected delivery method ID */
  deliveryMethodId: Scalars['Int'];
  /** Represents a cart's selected delivery service code */
  deliveryServiceCode?: InputMaybe<Scalars['String']>;
  /** Represents the first name which a cart belongs to */
  firstName: Scalars['String'];
  /** Represents the last name which a cart belongs to */
  lastName: Scalars['String'];
  /** Represents if the cart will be charged a processing fee */
  manualOrder: Scalars['Boolean'];
  /** Represents if the cart is to be urgently picked */
  urgentPick: Scalars['Boolean'];
};

/** Represents a cart's order line */
export type CartLine = {
  __typename?: 'CartLine';
  /** Represents the line's client product code */
  clientProductCode?: Maybe<Scalars['String']>;
  /** Represents the line's e-template ID (optional) */
  eTemplateId?: Maybe<Scalars['Int']>;
  /** Represents the line's product code */
  productCode: Scalars['String'];
  /** Represents the line's product ID */
  productId?: Maybe<Scalars['Int']>;
  /** Represents the line's quantity */
  quantity: Scalars['Int'];
};

/** Represents a cart's order line */
export type CartLineInput = {
  /** Represents the line's client product code */
  clientProductCode?: InputMaybe<Scalars['String']>;
  /** Represents the line's e-template ID (optional) */
  eTemplateId?: InputMaybe<Scalars['Int']>;
  /** Represents the line's product code */
  productCode: Scalars['String'];
  /** Represents the line's product ID */
  productId?: InputMaybe<Scalars['Int']>;
  /** Represents the line's quantity */
  quantity: Scalars['Int'];
};

export type Category = {
  __typename?: 'Category';
  active: Scalars['Boolean'];
  categoryHtml?: Maybe<Scalars['String']>;
  categoryId: Scalars['Int'];
  categoryPromoters: Array<CategoryPromoter>;
  categoryVisibilities: Array<CategoryVisibility>;
  created: Scalars['DateTime'];
  customCssClass?: Maybe<Scalars['String']>;
  customer: Customer;
  customerCategoryId?: Maybe<Scalars['String']>;
  customerId: Scalars['Int'];
  globalCategory: Scalars['Boolean'];
  imagePath?: Maybe<Scalars['String']>;
  inverseParent: Array<Category>;
  modified: Scalars['DateTime'];
  name?: Maybe<Scalars['String']>;
  orderType: OrderTypeGqlType;
  orderTypeId: Scalars['Int'];
  parent?: Maybe<Category>;
  parentId?: Maybe<Scalars['Int']>;
  productCategoryOrderLimitByRoles: Array<ProductCategoryOrderLimitByRole>;
  productNewTemporaries: Array<ProductNewTemporary>;
  productVisibilities: Array<ProductVisibility>;
  purgeDate?: Maybe<Scalars['DateTime']>;
  recordTimestamp: Array<Scalars['ByteArray']>;
  removed: Scalars['Boolean'];
  reorderInfoEmail?: Maybe<Scalars['String']>;
  roleCategoryDiscounts: Array<RoleCategoryDiscount>;
  roleCategoryVisibilities: Array<RoleCategoryVisibility>;
  secondaryApproverId?: Maybe<Scalars['Int']>;
  shopCategory: Scalars['Boolean'];
  showImage?: Maybe<Scalars['Boolean']>;
  showThumb?: Maybe<Scalars['Boolean']>;
  sortByIndicator: Scalars['Int'];
  sortIndex: Scalars['Int'];
  specialPickRateBase?: Maybe<Scalars['Decimal']>;
  specialPickRateScale?: Maybe<Scalars['Decimal']>;
  thirdPartyEmail?: Maybe<Scalars['String']>;
  thumbPath?: Maybe<Scalars['String']>;
  useSpecialPickRate: Scalars['Boolean'];
  useThirdPartySupplier: Scalars['Boolean'];
  userCreatedId: Scalars['Int'];
  userCreditByCategories: Array<UserCreditByCategory>;
  userModifiedId: Scalars['Int'];
  userSpendByCategories: Array<UserSpendByCategory>;
  wmsPickPdftype: WmsPickPdftype;
  wmsPickPdftypeId: Scalars['Int'];
  wn2id?: Maybe<Scalars['Int']>;
  zeroFreight: Scalars['Boolean'];
};

export type CategoryFilterInput = {
  active?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<CategoryFilterInput>>;
  categoryHtml?: InputMaybe<StringOperationFilterInput>;
  categoryId?: InputMaybe<ComparableInt32OperationFilterInput>;
  categoryPromoters?: InputMaybe<ListFilterInputTypeOfCategoryPromoterFilterInput>;
  categoryVisibilities?: InputMaybe<ListFilterInputTypeOfCategoryVisibilityFilterInput>;
  created?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  customCssClass?: InputMaybe<StringOperationFilterInput>;
  customer?: InputMaybe<CustomerFilterInput>;
  customerCategoryId?: InputMaybe<StringOperationFilterInput>;
  customerId?: InputMaybe<ComparableInt32OperationFilterInput>;
  globalCategory?: InputMaybe<BooleanOperationFilterInput>;
  imagePath?: InputMaybe<StringOperationFilterInput>;
  inverseParent?: InputMaybe<ListFilterInputTypeOfCategoryFilterInput>;
  modified?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CategoryFilterInput>>;
  orderType?: InputMaybe<OrderTypeFilterInput>;
  orderTypeId?: InputMaybe<ComparableInt32OperationFilterInput>;
  parent?: InputMaybe<CategoryFilterInput>;
  parentId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  productCategoryOrderLimitByRoles?: InputMaybe<ListFilterInputTypeOfProductCategoryOrderLimitByRoleFilterInput>;
  productNewTemporaries?: InputMaybe<ListFilterInputTypeOfProductNewTemporaryFilterInput>;
  productVisibilities?: InputMaybe<ListFilterInputTypeOfProductVisibilityFilterInput>;
  purgeDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  recordTimestamp?: InputMaybe<ListComparableByteOperationFilterInput>;
  removed?: InputMaybe<BooleanOperationFilterInput>;
  reorderInfoEmail?: InputMaybe<StringOperationFilterInput>;
  roleCategoryDiscounts?: InputMaybe<ListFilterInputTypeOfRoleCategoryDiscountFilterInput>;
  roleCategoryVisibilities?: InputMaybe<ListFilterInputTypeOfRoleCategoryVisibilityFilterInput>;
  secondaryApproverId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  shopCategory?: InputMaybe<BooleanOperationFilterInput>;
  showImage?: InputMaybe<BooleanOperationFilterInput>;
  showThumb?: InputMaybe<BooleanOperationFilterInput>;
  sortByIndicator?: InputMaybe<ComparableInt32OperationFilterInput>;
  sortIndex?: InputMaybe<ComparableInt32OperationFilterInput>;
  specialPickRateBase?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  specialPickRateScale?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  thirdPartyEmail?: InputMaybe<StringOperationFilterInput>;
  thumbPath?: InputMaybe<StringOperationFilterInput>;
  useSpecialPickRate?: InputMaybe<BooleanOperationFilterInput>;
  useThirdPartySupplier?: InputMaybe<BooleanOperationFilterInput>;
  userCreatedId?: InputMaybe<ComparableInt32OperationFilterInput>;
  userCreditByCategories?: InputMaybe<ListFilterInputTypeOfUserCreditByCategoryFilterInput>;
  userModifiedId?: InputMaybe<ComparableInt32OperationFilterInput>;
  userSpendByCategories?: InputMaybe<ListFilterInputTypeOfUserSpendByCategoryFilterInput>;
  wmsPickPdftype?: InputMaybe<WmsPickPdftypeFilterInput>;
  wmsPickPdftypeId?: InputMaybe<ComparableInt32OperationFilterInput>;
  wn2id?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  zeroFreight?: InputMaybe<BooleanOperationFilterInput>;
};

export type CategoryPromoter = {
  __typename?: 'CategoryPromoter';
  categoryNameList: Scalars['String'];
  categoryPromoterVisibilities: Array<CategoryPromoterVisibility>;
  created: Scalars['DateTime'];
  customer: Customer;
  customerId: Scalars['Int'];
  modified: Scalars['DateTime'];
  name: Scalars['String'];
  parent?: Maybe<Category>;
  /** self reference needs to be nullable so that we can have either a temp parent or a live parent */
  parentId?: Maybe<Scalars['Int']>;
  productNewTemporaries: Array<ProductNewTemporary>;
  promoterId: Scalars['Int'];
  purgeDate?: Maybe<Scalars['DateTime']>;
  removed: Scalars['Boolean'];
  rowVersion: Scalars['Int'];
  userCreatedId: Scalars['Int'];
  userModifiedId: Scalars['Int'];
};

export type CategoryPromoterFilterInput = {
  and?: InputMaybe<Array<CategoryPromoterFilterInput>>;
  categoryNameList?: InputMaybe<StringOperationFilterInput>;
  categoryPromoterVisibilities?: InputMaybe<ListFilterInputTypeOfCategoryPromoterVisibilityFilterInput>;
  created?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  customer?: InputMaybe<CustomerFilterInput>;
  customerId?: InputMaybe<ComparableInt32OperationFilterInput>;
  modified?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CategoryPromoterFilterInput>>;
  parent?: InputMaybe<CategoryFilterInput>;
  /** self reference needs to be nullable so that we can have either a temp parent or a live parent */
  parentId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  productNewTemporaries?: InputMaybe<ListFilterInputTypeOfProductNewTemporaryFilterInput>;
  promoterId?: InputMaybe<ComparableInt32OperationFilterInput>;
  purgeDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  removed?: InputMaybe<BooleanOperationFilterInput>;
  rowVersion?: InputMaybe<ComparableInt32OperationFilterInput>;
  userCreatedId?: InputMaybe<ComparableInt32OperationFilterInput>;
  userModifiedId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type CategoryPromoterVisibility = {
  __typename?: 'CategoryPromoterVisibility';
  businessLevel: BusinessLevel;
  businessLevelId: Scalars['Int'];
  promoter: CategoryPromoter;
  promoterId: Scalars['Int'];
  promoterVisId: Scalars['Int'];
  userModifiedId: Scalars['Int'];
};

export type CategoryPromoterVisibilityFilterInput = {
  and?: InputMaybe<Array<CategoryPromoterVisibilityFilterInput>>;
  businessLevel?: InputMaybe<BusinessLevelFilterInput>;
  businessLevelId?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<CategoryPromoterVisibilityFilterInput>>;
  promoter?: InputMaybe<CategoryPromoterFilterInput>;
  promoterId?: InputMaybe<ComparableInt32OperationFilterInput>;
  promoterVisId?: InputMaybe<ComparableInt32OperationFilterInput>;
  userModifiedId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type CategorySortInput = {
  active?: InputMaybe<SortEnumType>;
  categoryHtml?: InputMaybe<SortEnumType>;
  categoryId?: InputMaybe<SortEnumType>;
  created?: InputMaybe<SortEnumType>;
  customCssClass?: InputMaybe<SortEnumType>;
  customer?: InputMaybe<CustomerSortInput>;
  customerCategoryId?: InputMaybe<SortEnumType>;
  customerId?: InputMaybe<SortEnumType>;
  globalCategory?: InputMaybe<SortEnumType>;
  imagePath?: InputMaybe<SortEnumType>;
  modified?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  orderType?: InputMaybe<OrderTypeSortInput>;
  orderTypeId?: InputMaybe<SortEnumType>;
  parent?: InputMaybe<CategorySortInput>;
  parentId?: InputMaybe<SortEnumType>;
  purgeDate?: InputMaybe<SortEnumType>;
  removed?: InputMaybe<SortEnumType>;
  reorderInfoEmail?: InputMaybe<SortEnumType>;
  secondaryApproverId?: InputMaybe<SortEnumType>;
  shopCategory?: InputMaybe<SortEnumType>;
  showImage?: InputMaybe<SortEnumType>;
  showThumb?: InputMaybe<SortEnumType>;
  sortByIndicator?: InputMaybe<SortEnumType>;
  sortIndex?: InputMaybe<SortEnumType>;
  specialPickRateBase?: InputMaybe<SortEnumType>;
  specialPickRateScale?: InputMaybe<SortEnumType>;
  thirdPartyEmail?: InputMaybe<SortEnumType>;
  thumbPath?: InputMaybe<SortEnumType>;
  useSpecialPickRate?: InputMaybe<SortEnumType>;
  useThirdPartySupplier?: InputMaybe<SortEnumType>;
  userCreatedId?: InputMaybe<SortEnumType>;
  userModifiedId?: InputMaybe<SortEnumType>;
  wmsPickPdftype?: InputMaybe<WmsPickPdftypeSortInput>;
  wmsPickPdftypeId?: InputMaybe<SortEnumType>;
  wn2id?: InputMaybe<SortEnumType>;
  zeroFreight?: InputMaybe<SortEnumType>;
};

/** Represents a Category */
export type CategoryType = {
  __typename?: 'CategoryType';
  /** Represents the Category's ID */
  categoryId: Scalars['Int'];
  /** Represents the number of sub-categories under this Category */
  childCategoriesCount: Scalars['Int'];
  /** Represents the Category's Name */
  name?: Maybe<Scalars['String']>;
  /** Represents the Category's Order Type's ID */
  orderTypeId: Scalars['Int'];
  /** Represents the Parent Category's ID */
  parentId?: Maybe<Scalars['Int']>;
};

export type CategoryVisibility = {
  __typename?: 'CategoryVisibility';
  businessLevel: BusinessLevel;
  businessLevelId: Scalars['Int'];
  category: Category;
  categoryId: Scalars['Int'];
  created: Scalars['DateTime'];
  modified: Scalars['DateTime'];
  userModifiedId: Scalars['Int'];
  visibilityId: Scalars['Int'];
};

export type CategoryVisibilityFilterInput = {
  and?: InputMaybe<Array<CategoryVisibilityFilterInput>>;
  businessLevel?: InputMaybe<BusinessLevelFilterInput>;
  businessLevelId?: InputMaybe<ComparableInt32OperationFilterInput>;
  category?: InputMaybe<CategoryFilterInput>;
  categoryId?: InputMaybe<ComparableInt32OperationFilterInput>;
  created?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  modified?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<CategoryVisibilityFilterInput>>;
  userModifiedId?: InputMaybe<ComparableInt32OperationFilterInput>;
  visibilityId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

/** Represents the input to change customer. */
export type ChangeCustomerInputType = {
  /** Represnets the new customer ID. */
  custId: Scalars['Int'];
};

export type CmsAdvertisementBlock = {
  __typename?: 'CmsAdvertisementBlock';
  active: Scalars['Boolean'];
  adBlockId: Scalars['Int'];
  adContent?: Maybe<Scalars['String']>;
  adExpiryDate: Scalars['DateTime'];
  adImage?: Maybe<Scalars['String']>;
  blockStatus: CmsBlockStatus;
  blockStatusId: Scalars['Int'];
  created: Scalars['DateTime'];
  modified: Scalars['DateTime'];
  purgeDate?: Maybe<Scalars['DateTime']>;
  removed: Scalars['Boolean'];
  userCreatedId: Scalars['Int'];
  userModifiedId: Scalars['Int'];
};

export type CmsAdvertisementBlockFilterInput = {
  active?: InputMaybe<BooleanOperationFilterInput>;
  adBlockId?: InputMaybe<ComparableInt32OperationFilterInput>;
  adContent?: InputMaybe<StringOperationFilterInput>;
  adExpiryDate?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  adImage?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<CmsAdvertisementBlockFilterInput>>;
  blockStatus?: InputMaybe<CmsBlockStatusFilterInput>;
  blockStatusId?: InputMaybe<ComparableInt32OperationFilterInput>;
  created?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  modified?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<CmsAdvertisementBlockFilterInput>>;
  purgeDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  removed?: InputMaybe<BooleanOperationFilterInput>;
  userCreatedId?: InputMaybe<ComparableInt32OperationFilterInput>;
  userModifiedId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type CmsBlockMetum = {
  __typename?: 'CmsBlockMetum';
  cmsPageBlocks: Array<CmsPageBlock>;
  contentHtml: Scalars['String'];
  controlHtml?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  isSurveyBlock: Scalars['Boolean'];
  name: Scalars['String'];
  rowVersion: Array<Scalars['ByteArray']>;
};

export type CmsBlockMetumFilterInput = {
  and?: InputMaybe<Array<CmsBlockMetumFilterInput>>;
  cmsPageBlocks?: InputMaybe<ListFilterInputTypeOfCmsPageBlockFilterInput>;
  contentHtml?: InputMaybe<StringOperationFilterInput>;
  controlHtml?: InputMaybe<StringOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  isSurveyBlock?: InputMaybe<BooleanOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CmsBlockMetumFilterInput>>;
  rowVersion?: InputMaybe<ListComparableByteOperationFilterInput>;
};

export type CmsBlockPriority = {
  __typename?: 'CmsBlockPriority';
  blockId: Scalars['Int'];
  blockName: Scalars['String'];
  blockPriority: Scalars['Int'];
  blockZindex: Scalars['Int'];
  cmsBlockStatuses: Array<CmsBlockStatus>;
  userCreatedId: Scalars['Int'];
  userModifiedId: Scalars['Int'];
};

export type CmsBlockPriorityFilterInput = {
  and?: InputMaybe<Array<CmsBlockPriorityFilterInput>>;
  blockId?: InputMaybe<ComparableInt32OperationFilterInput>;
  blockName?: InputMaybe<StringOperationFilterInput>;
  blockPriority?: InputMaybe<ComparableInt32OperationFilterInput>;
  blockZindex?: InputMaybe<ComparableInt32OperationFilterInput>;
  cmsBlockStatuses?: InputMaybe<ListFilterInputTypeOfCmsBlockStatusFilterInput>;
  or?: InputMaybe<Array<CmsBlockPriorityFilterInput>>;
  userCreatedId?: InputMaybe<ComparableInt32OperationFilterInput>;
  userModifiedId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type CmsBlockStatus = {
  __typename?: 'CmsBlockStatus';
  block: CmsBlockPriority;
  blockId: Scalars['Int'];
  blockStatus: Scalars['Boolean'];
  blockStatusId: Scalars['Int'];
  businessLvl?: Maybe<BusinessLevel>;
  businessLvlId?: Maybe<Scalars['Int']>;
  cmsAdvertisementBlocks: Array<CmsAdvertisementBlock>;
  cmsChatBlocks: Array<CmsChatBlock>;
  cmsDashBoardBlocks: Array<CmsDashBoardBlock>;
  cmsFeaturedProdBlocks: Array<CmsFeaturedProdBlock>;
  cmsNewsBlocks: Array<CmsNewsBlock>;
  cmsPendingApprovalsBlocks: Array<CmsPendingApprovalsBlock>;
  cmsWelcomeBlock2s: Array<CmsWelcomeBlock2>;
  cmsWelcomeBlocks: Array<CmsWelcomeBlock>;
  customer: Customer;
  customerId: Scalars['Int'];
  userCreatedId: Scalars['Int'];
  userModifiedId: Scalars['Int'];
};

export type CmsBlockStatusFilterInput = {
  and?: InputMaybe<Array<CmsBlockStatusFilterInput>>;
  block?: InputMaybe<CmsBlockPriorityFilterInput>;
  blockId?: InputMaybe<ComparableInt32OperationFilterInput>;
  blockStatus?: InputMaybe<BooleanOperationFilterInput>;
  blockStatusId?: InputMaybe<ComparableInt32OperationFilterInput>;
  businessLvl?: InputMaybe<BusinessLevelFilterInput>;
  businessLvlId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  cmsAdvertisementBlocks?: InputMaybe<ListFilterInputTypeOfCmsAdvertisementBlockFilterInput>;
  cmsChatBlocks?: InputMaybe<ListFilterInputTypeOfCmsChatBlockFilterInput>;
  cmsDashBoardBlocks?: InputMaybe<ListFilterInputTypeOfCmsDashBoardBlockFilterInput>;
  cmsFeaturedProdBlocks?: InputMaybe<ListFilterInputTypeOfCmsFeaturedProdBlockFilterInput>;
  cmsNewsBlocks?: InputMaybe<ListFilterInputTypeOfCmsNewsBlockFilterInput>;
  cmsPendingApprovalsBlocks?: InputMaybe<ListFilterInputTypeOfCmsPendingApprovalsBlockFilterInput>;
  cmsWelcomeBlock2s?: InputMaybe<ListFilterInputTypeOfCmsWelcomeBlock2FilterInput>;
  cmsWelcomeBlocks?: InputMaybe<ListFilterInputTypeOfCmsWelcomeBlockFilterInput>;
  customer?: InputMaybe<CustomerFilterInput>;
  customerId?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<CmsBlockStatusFilterInput>>;
  userCreatedId?: InputMaybe<ComparableInt32OperationFilterInput>;
  userModifiedId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type CmsChatBlock = {
  __typename?: 'CmsChatBlock';
  active: Scalars['Boolean'];
  blockStatus: CmsBlockStatus;
  blockStatusId: Scalars['Int'];
  chatBlockId: Scalars['Int'];
  chatContent: Scalars['String'];
  created: Scalars['DateTime'];
  modified: Scalars['DateTime'];
  purgeDate?: Maybe<Scalars['DateTime']>;
  removed: Scalars['Boolean'];
  userCreatedId: Scalars['Int'];
  userModifiedId: Scalars['Int'];
};

export type CmsChatBlockFilterInput = {
  active?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<CmsChatBlockFilterInput>>;
  blockStatus?: InputMaybe<CmsBlockStatusFilterInput>;
  blockStatusId?: InputMaybe<ComparableInt32OperationFilterInput>;
  chatBlockId?: InputMaybe<ComparableInt32OperationFilterInput>;
  chatContent?: InputMaybe<StringOperationFilterInput>;
  created?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  modified?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<CmsChatBlockFilterInput>>;
  purgeDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  removed?: InputMaybe<BooleanOperationFilterInput>;
  userCreatedId?: InputMaybe<ComparableInt32OperationFilterInput>;
  userModifiedId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type CmsDashBoardBlock = {
  __typename?: 'CmsDashBoardBlock';
  blockStatus: CmsBlockStatus;
  blockStatusId: Scalars['Int'];
  dashBoardBlockId: Scalars['Int'];
  dashBoardContent?: Maybe<Scalars['String']>;
  userCreatedId: Scalars['Int'];
  userModifiedId: Scalars['Int'];
};

export type CmsDashBoardBlockFilterInput = {
  and?: InputMaybe<Array<CmsDashBoardBlockFilterInput>>;
  blockStatus?: InputMaybe<CmsBlockStatusFilterInput>;
  blockStatusId?: InputMaybe<ComparableInt32OperationFilterInput>;
  dashBoardBlockId?: InputMaybe<ComparableInt32OperationFilterInput>;
  dashBoardContent?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CmsDashBoardBlockFilterInput>>;
  userCreatedId?: InputMaybe<ComparableInt32OperationFilterInput>;
  userModifiedId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type CmsFeaturedProdBlock = {
  __typename?: 'CmsFeaturedProdBlock';
  active: Scalars['Boolean'];
  blockStatus: CmsBlockStatus;
  blockStatusId: Scalars['Int'];
  featuredProdBlockId: Scalars['Int'];
  featuredProdContent?: Maybe<Scalars['String']>;
  prodExpiryDate: Scalars['DateTime'];
  productId: Scalars['Int'];
  purgeDate?: Maybe<Scalars['DateTime']>;
  removed: Scalars['Boolean'];
  userCreatedId: Scalars['Int'];
  userModifiedId: Scalars['Int'];
};

export type CmsFeaturedProdBlockFilterInput = {
  active?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<CmsFeaturedProdBlockFilterInput>>;
  blockStatus?: InputMaybe<CmsBlockStatusFilterInput>;
  blockStatusId?: InputMaybe<ComparableInt32OperationFilterInput>;
  featuredProdBlockId?: InputMaybe<ComparableInt32OperationFilterInput>;
  featuredProdContent?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CmsFeaturedProdBlockFilterInput>>;
  prodExpiryDate?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  productId?: InputMaybe<ComparableInt32OperationFilterInput>;
  purgeDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  removed?: InputMaybe<BooleanOperationFilterInput>;
  userCreatedId?: InputMaybe<ComparableInt32OperationFilterInput>;
  userModifiedId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type CmsNewsBlock = {
  __typename?: 'CmsNewsBlock';
  active: Scalars['Boolean'];
  blockStatus: CmsBlockStatus;
  blockStatusId: Scalars['Int'];
  created: Scalars['DateTime'];
  modified: Scalars['DateTime'];
  newsBlockId: Scalars['Int'];
  newsContent: Scalars['String'];
  newsExpiryDate: Scalars['DateTime'];
  purgeDate?: Maybe<Scalars['DateTime']>;
  removed: Scalars['Boolean'];
  userCreatedId: Scalars['Int'];
  userModifiedId: Scalars['Int'];
};

export type CmsNewsBlockFilterInput = {
  active?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<CmsNewsBlockFilterInput>>;
  blockStatus?: InputMaybe<CmsBlockStatusFilterInput>;
  blockStatusId?: InputMaybe<ComparableInt32OperationFilterInput>;
  created?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  modified?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  newsBlockId?: InputMaybe<ComparableInt32OperationFilterInput>;
  newsContent?: InputMaybe<StringOperationFilterInput>;
  newsExpiryDate?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<CmsNewsBlockFilterInput>>;
  purgeDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  removed?: InputMaybe<BooleanOperationFilterInput>;
  userCreatedId?: InputMaybe<ComparableInt32OperationFilterInput>;
  userModifiedId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type CmsPage = {
  __typename?: 'CmsPage';
  active: Scalars['Boolean'];
  cmsPageBlocks: Array<CmsPageBlock>;
  collaboratorId?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  inverseParent: Array<CmsPage>;
  name: Scalars['String'];
  parent?: Maybe<CmsPage>;
  parentId?: Maybe<Scalars['Int']>;
  published: Scalars['Boolean'];
  reviewerId?: Maybe<Scalars['Int']>;
  rowVersion: Array<Scalars['ByteArray']>;
  siteMapPageMaps: Array<SiteMapPageMap>;
};

export type CmsPageBlock = {
  __typename?: 'CmsPageBlock';
  blockMeta: CmsBlockMetum;
  blockMetaId: Scalars['Int'];
  contentHtml: Scalars['String'];
  controlHtml?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  inverseParent: Array<CmsPageBlock>;
  isLayoutBlock: Scalars['Boolean'];
  name?: Maybe<Scalars['String']>;
  page?: Maybe<CmsPage>;
  pageId?: Maybe<Scalars['Int']>;
  parent?: Maybe<CmsPageBlock>;
  parentId?: Maybe<Scalars['Int']>;
  rowVersion: Array<Scalars['ByteArray']>;
  surveyDescriptor?: Maybe<SurveyDescriptor>;
  surveyDescriptorId?: Maybe<Scalars['Int']>;
};

export type CmsPageBlockFilterInput = {
  and?: InputMaybe<Array<CmsPageBlockFilterInput>>;
  blockMeta?: InputMaybe<CmsBlockMetumFilterInput>;
  blockMetaId?: InputMaybe<ComparableInt32OperationFilterInput>;
  contentHtml?: InputMaybe<StringOperationFilterInput>;
  controlHtml?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  inverseParent?: InputMaybe<ListFilterInputTypeOfCmsPageBlockFilterInput>;
  isLayoutBlock?: InputMaybe<BooleanOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CmsPageBlockFilterInput>>;
  page?: InputMaybe<CmsPageFilterInput>;
  pageId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  parent?: InputMaybe<CmsPageBlockFilterInput>;
  parentId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  rowVersion?: InputMaybe<ListComparableByteOperationFilterInput>;
  surveyDescriptor?: InputMaybe<SurveyDescriptorFilterInput>;
  surveyDescriptorId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
};

export type CmsPageFilterInput = {
  active?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<CmsPageFilterInput>>;
  cmsPageBlocks?: InputMaybe<ListFilterInputTypeOfCmsPageBlockFilterInput>;
  collaboratorId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  inverseParent?: InputMaybe<ListFilterInputTypeOfCmsPageFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CmsPageFilterInput>>;
  parent?: InputMaybe<CmsPageFilterInput>;
  parentId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  published?: InputMaybe<BooleanOperationFilterInput>;
  reviewerId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  rowVersion?: InputMaybe<ListComparableByteOperationFilterInput>;
  siteMapPageMaps?: InputMaybe<ListFilterInputTypeOfSiteMapPageMapFilterInput>;
};

export type CmsPendingApprovalsBlock = {
  __typename?: 'CmsPendingApprovalsBlock';
  active: Scalars['Boolean'];
  approvalBlockId: Scalars['Int'];
  blockStatus: CmsBlockStatus;
  blockStatusId: Scalars['Int'];
  created: Scalars['DateTime'];
  modified: Scalars['DateTime'];
  removed: Scalars['Boolean'];
  userCreatedId: Scalars['Int'];
  userModifiedId: Scalars['Int'];
};

export type CmsPendingApprovalsBlockFilterInput = {
  active?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<CmsPendingApprovalsBlockFilterInput>>;
  approvalBlockId?: InputMaybe<ComparableInt32OperationFilterInput>;
  blockStatus?: InputMaybe<CmsBlockStatusFilterInput>;
  blockStatusId?: InputMaybe<ComparableInt32OperationFilterInput>;
  created?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  modified?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<CmsPendingApprovalsBlockFilterInput>>;
  removed?: InputMaybe<BooleanOperationFilterInput>;
  userCreatedId?: InputMaybe<ComparableInt32OperationFilterInput>;
  userModifiedId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type CmsWelcomeBlock = {
  __typename?: 'CmsWelcomeBlock';
  blockStatus: CmsBlockStatus;
  blockStatusId: Scalars['Int'];
  userCreatedId: Scalars['Int'];
  userModifiedId: Scalars['Int'];
  welcomeBlockId: Scalars['Int'];
  welcomeContent: Scalars['String'];
};

export type CmsWelcomeBlock2 = {
  __typename?: 'CmsWelcomeBlock2';
  blockStatus: CmsBlockStatus;
  blockStatusId: Scalars['Int'];
  userCreatedId: Scalars['Int'];
  userModifiedId: Scalars['Int'];
  welcomeBlockId: Scalars['Int'];
  welcomeContent: Scalars['String'];
};

export type CmsWelcomeBlock2FilterInput = {
  and?: InputMaybe<Array<CmsWelcomeBlock2FilterInput>>;
  blockStatus?: InputMaybe<CmsBlockStatusFilterInput>;
  blockStatusId?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<CmsWelcomeBlock2FilterInput>>;
  userCreatedId?: InputMaybe<ComparableInt32OperationFilterInput>;
  userModifiedId?: InputMaybe<ComparableInt32OperationFilterInput>;
  welcomeBlockId?: InputMaybe<ComparableInt32OperationFilterInput>;
  welcomeContent?: InputMaybe<StringOperationFilterInput>;
};

export type CmsWelcomeBlockFilterInput = {
  and?: InputMaybe<Array<CmsWelcomeBlockFilterInput>>;
  blockStatus?: InputMaybe<CmsBlockStatusFilterInput>;
  blockStatusId?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<CmsWelcomeBlockFilterInput>>;
  userCreatedId?: InputMaybe<ComparableInt32OperationFilterInput>;
  userModifiedId?: InputMaybe<ComparableInt32OperationFilterInput>;
  welcomeBlockId?: InputMaybe<ComparableInt32OperationFilterInput>;
  welcomeContent?: InputMaybe<StringOperationFilterInput>;
};

/** Information about the offset pagination. */
export type CollectionSegmentInfo = {
  __typename?: 'CollectionSegmentInfo';
  /** Indicates whether more items exist following the set defined by the clients arguments. */
  hasNextPage: Scalars['Boolean'];
  /** Indicates whether more items exist prior the set defined by the clients arguments. */
  hasPreviousPage: Scalars['Boolean'];
};

export type Color = {
  __typename?: 'Color';
  contrastText: Scalars['String'];
  dark: Scalars['String'];
  light: Scalars['String'];
  main: Scalars['String'];
};

export type ColorUpdatesInput = {
  contrastText?: InputMaybe<Scalars['String']>;
  dark?: InputMaybe<Scalars['String']>;
  light?: InputMaybe<Scalars['String']>;
  main?: InputMaybe<Scalars['String']>;
};

export type ComparableByteOperationFilterInput = {
  eq?: InputMaybe<Scalars['Byte']>;
  gt?: InputMaybe<Scalars['Byte']>;
  gte?: InputMaybe<Scalars['Byte']>;
  in?: InputMaybe<Array<Scalars['Byte']>>;
  lt?: InputMaybe<Scalars['Byte']>;
  lte?: InputMaybe<Scalars['Byte']>;
  neq?: InputMaybe<Scalars['Byte']>;
  ngt?: InputMaybe<Scalars['Byte']>;
  ngte?: InputMaybe<Scalars['Byte']>;
  nin?: InputMaybe<Array<Scalars['Byte']>>;
  nlt?: InputMaybe<Scalars['Byte']>;
  nlte?: InputMaybe<Scalars['Byte']>;
};

export type ComparableDateTimeOperationFilterInput = {
  eq?: InputMaybe<Scalars['DateTime']>;
  gt?: InputMaybe<Scalars['DateTime']>;
  gte?: InputMaybe<Scalars['DateTime']>;
  in?: InputMaybe<Array<Scalars['DateTime']>>;
  lt?: InputMaybe<Scalars['DateTime']>;
  lte?: InputMaybe<Scalars['DateTime']>;
  neq?: InputMaybe<Scalars['DateTime']>;
  ngt?: InputMaybe<Scalars['DateTime']>;
  ngte?: InputMaybe<Scalars['DateTime']>;
  nin?: InputMaybe<Array<Scalars['DateTime']>>;
  nlt?: InputMaybe<Scalars['DateTime']>;
  nlte?: InputMaybe<Scalars['DateTime']>;
};

export type ComparableDecimalOperationFilterInput = {
  eq?: InputMaybe<Scalars['Decimal']>;
  gt?: InputMaybe<Scalars['Decimal']>;
  gte?: InputMaybe<Scalars['Decimal']>;
  in?: InputMaybe<Array<Scalars['Decimal']>>;
  lt?: InputMaybe<Scalars['Decimal']>;
  lte?: InputMaybe<Scalars['Decimal']>;
  neq?: InputMaybe<Scalars['Decimal']>;
  ngt?: InputMaybe<Scalars['Decimal']>;
  ngte?: InputMaybe<Scalars['Decimal']>;
  nin?: InputMaybe<Array<Scalars['Decimal']>>;
  nlt?: InputMaybe<Scalars['Decimal']>;
  nlte?: InputMaybe<Scalars['Decimal']>;
};

export type ComparableGuidOperationFilterInput = {
  eq?: InputMaybe<Scalars['UUID']>;
  gt?: InputMaybe<Scalars['UUID']>;
  gte?: InputMaybe<Scalars['UUID']>;
  in?: InputMaybe<Array<Scalars['UUID']>>;
  lt?: InputMaybe<Scalars['UUID']>;
  lte?: InputMaybe<Scalars['UUID']>;
  neq?: InputMaybe<Scalars['UUID']>;
  ngt?: InputMaybe<Scalars['UUID']>;
  ngte?: InputMaybe<Scalars['UUID']>;
  nin?: InputMaybe<Array<Scalars['UUID']>>;
  nlt?: InputMaybe<Scalars['UUID']>;
  nlte?: InputMaybe<Scalars['UUID']>;
};

export type ComparableInt16OperationFilterInput = {
  eq?: InputMaybe<Scalars['Short']>;
  gt?: InputMaybe<Scalars['Short']>;
  gte?: InputMaybe<Scalars['Short']>;
  in?: InputMaybe<Array<Scalars['Short']>>;
  lt?: InputMaybe<Scalars['Short']>;
  lte?: InputMaybe<Scalars['Short']>;
  neq?: InputMaybe<Scalars['Short']>;
  ngt?: InputMaybe<Scalars['Short']>;
  ngte?: InputMaybe<Scalars['Short']>;
  nin?: InputMaybe<Array<Scalars['Short']>>;
  nlt?: InputMaybe<Scalars['Short']>;
  nlte?: InputMaybe<Scalars['Short']>;
};

export type ComparableInt32OperationFilterInput = {
  eq?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<Scalars['Int']>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  neq?: InputMaybe<Scalars['Int']>;
  ngt?: InputMaybe<Scalars['Int']>;
  ngte?: InputMaybe<Scalars['Int']>;
  nin?: InputMaybe<Array<Scalars['Int']>>;
  nlt?: InputMaybe<Scalars['Int']>;
  nlte?: InputMaybe<Scalars['Int']>;
};

export type ComparableInt64OperationFilterInput = {
  eq?: InputMaybe<Scalars['Long']>;
  gt?: InputMaybe<Scalars['Long']>;
  gte?: InputMaybe<Scalars['Long']>;
  in?: InputMaybe<Array<Scalars['Long']>>;
  lt?: InputMaybe<Scalars['Long']>;
  lte?: InputMaybe<Scalars['Long']>;
  neq?: InputMaybe<Scalars['Long']>;
  ngt?: InputMaybe<Scalars['Long']>;
  ngte?: InputMaybe<Scalars['Long']>;
  nin?: InputMaybe<Array<Scalars['Long']>>;
  nlt?: InputMaybe<Scalars['Long']>;
  nlte?: InputMaybe<Scalars['Long']>;
};

export type ComparableNullableOfDateTimeOperationFilterInput = {
  eq?: InputMaybe<Scalars['DateTime']>;
  gt?: InputMaybe<Scalars['DateTime']>;
  gte?: InputMaybe<Scalars['DateTime']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  lt?: InputMaybe<Scalars['DateTime']>;
  lte?: InputMaybe<Scalars['DateTime']>;
  neq?: InputMaybe<Scalars['DateTime']>;
  ngt?: InputMaybe<Scalars['DateTime']>;
  ngte?: InputMaybe<Scalars['DateTime']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  nlt?: InputMaybe<Scalars['DateTime']>;
  nlte?: InputMaybe<Scalars['DateTime']>;
};

export type ComparableNullableOfDecimalOperationFilterInput = {
  eq?: InputMaybe<Scalars['Decimal']>;
  gt?: InputMaybe<Scalars['Decimal']>;
  gte?: InputMaybe<Scalars['Decimal']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Decimal']>>>;
  lt?: InputMaybe<Scalars['Decimal']>;
  lte?: InputMaybe<Scalars['Decimal']>;
  neq?: InputMaybe<Scalars['Decimal']>;
  ngt?: InputMaybe<Scalars['Decimal']>;
  ngte?: InputMaybe<Scalars['Decimal']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Decimal']>>>;
  nlt?: InputMaybe<Scalars['Decimal']>;
  nlte?: InputMaybe<Scalars['Decimal']>;
};

export type ComparableNullableOfDoubleOperationFilterInput = {
  eq?: InputMaybe<Scalars['Float']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  neq?: InputMaybe<Scalars['Float']>;
  ngt?: InputMaybe<Scalars['Float']>;
  ngte?: InputMaybe<Scalars['Float']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  nlt?: InputMaybe<Scalars['Float']>;
  nlte?: InputMaybe<Scalars['Float']>;
};

export type ComparableNullableOfGuidOperationFilterInput = {
  eq?: InputMaybe<Scalars['UUID']>;
  gt?: InputMaybe<Scalars['UUID']>;
  gte?: InputMaybe<Scalars['UUID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  lt?: InputMaybe<Scalars['UUID']>;
  lte?: InputMaybe<Scalars['UUID']>;
  neq?: InputMaybe<Scalars['UUID']>;
  ngt?: InputMaybe<Scalars['UUID']>;
  ngte?: InputMaybe<Scalars['UUID']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  nlt?: InputMaybe<Scalars['UUID']>;
  nlte?: InputMaybe<Scalars['UUID']>;
};

export type ComparableNullableOfInt16OperationFilterInput = {
  eq?: InputMaybe<Scalars['Short']>;
  gt?: InputMaybe<Scalars['Short']>;
  gte?: InputMaybe<Scalars['Short']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Short']>>>;
  lt?: InputMaybe<Scalars['Short']>;
  lte?: InputMaybe<Scalars['Short']>;
  neq?: InputMaybe<Scalars['Short']>;
  ngt?: InputMaybe<Scalars['Short']>;
  ngte?: InputMaybe<Scalars['Short']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Short']>>>;
  nlt?: InputMaybe<Scalars['Short']>;
  nlte?: InputMaybe<Scalars['Short']>;
};

export type ComparableNullableOfInt32OperationFilterInput = {
  eq?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  neq?: InputMaybe<Scalars['Int']>;
  ngt?: InputMaybe<Scalars['Int']>;
  ngte?: InputMaybe<Scalars['Int']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  nlt?: InputMaybe<Scalars['Int']>;
  nlte?: InputMaybe<Scalars['Int']>;
};

export type ComparableNullableOfInt64OperationFilterInput = {
  eq?: InputMaybe<Scalars['Long']>;
  gt?: InputMaybe<Scalars['Long']>;
  gte?: InputMaybe<Scalars['Long']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Long']>>>;
  lt?: InputMaybe<Scalars['Long']>;
  lte?: InputMaybe<Scalars['Long']>;
  neq?: InputMaybe<Scalars['Long']>;
  ngt?: InputMaybe<Scalars['Long']>;
  ngte?: InputMaybe<Scalars['Long']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Long']>>>;
  nlt?: InputMaybe<Scalars['Long']>;
  nlte?: InputMaybe<Scalars['Long']>;
};

export type ComparableNullableOfTimeSpanOperationFilterInput = {
  eq?: InputMaybe<Scalars['TimeSpan']>;
  gt?: InputMaybe<Scalars['TimeSpan']>;
  gte?: InputMaybe<Scalars['TimeSpan']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['TimeSpan']>>>;
  lt?: InputMaybe<Scalars['TimeSpan']>;
  lte?: InputMaybe<Scalars['TimeSpan']>;
  neq?: InputMaybe<Scalars['TimeSpan']>;
  ngt?: InputMaybe<Scalars['TimeSpan']>;
  ngte?: InputMaybe<Scalars['TimeSpan']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['TimeSpan']>>>;
  nlt?: InputMaybe<Scalars['TimeSpan']>;
  nlte?: InputMaybe<Scalars['TimeSpan']>;
};

export type ConsolidationType = {
  __typename?: 'ConsolidationType';
  consolidationTypeId: Scalars['Int'];
  customerOrderOptions: Array<CustomerOrderOption>;
  name: Scalars['String'];
};

export type ConsolidationTypeFilterInput = {
  and?: InputMaybe<Array<ConsolidationTypeFilterInput>>;
  consolidationTypeId?: InputMaybe<ComparableInt32OperationFilterInput>;
  customerOrderOptions?: InputMaybe<ListFilterInputTypeOfCustomerOrderOptionFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ConsolidationTypeFilterInput>>;
};

export type ContactUsInput = {
  email: Scalars['String'];
  message: Scalars['String'];
  name: Scalars['String'];
};

export type ContactUsResponse = {
  __typename?: 'ContactUsResponse';
  message: Scalars['String'];
};

export type Courier = {
  __typename?: 'Courier';
  id: Scalars['Int'];
  name: Scalars['String'];
  orderShippings: Array<OrderShippingType>;
  trackingUrl: Scalars['String'];
};

export type CourierFilterInput = {
  and?: InputMaybe<Array<CourierFilterInput>>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CourierFilterInput>>;
  orderShippings?: InputMaybe<ListFilterInputTypeOfOrderShippingFilterInput>;
  trackingUrl?: InputMaybe<StringOperationFilterInput>;
};

export type CourierSortInput = {
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  trackingUrl?: InputMaybe<SortEnumType>;
};

export type CreateProductPayloadInput = {
  externalProductId?: InputMaybe<Scalars['String']>;
  gst: Scalars['Int'];
  isSpecialDelivery: Scalars['Boolean'];
  itemGroupId?: InputMaybe<Scalars['Int']>;
  maxOrderQuantityLimit?: InputMaybe<Scalars['Int']>;
  maxOrderQuantityLimitDays?: InputMaybe<Scalars['Int']>;
  maxQuantityPerOrder?: InputMaybe<Scalars['Int']>;
  maxStockLevel: Scalars['Int'];
  minQuantityPerOrder?: InputMaybe<Scalars['Int']>;
  processDays: Scalars['Int'];
  productCode: Scalars['String'];
  productDescription: Scalars['String'];
  productName: Scalars['String'];
  productTypeId?: InputMaybe<Scalars['Int']>;
  quantityTypeId: Scalars['Int'];
  reOrderLevel?: InputMaybe<Scalars['Int']>;
  statusId: Scalars['Int'];
  unitOfMeasure: Scalars['String'];
  zeroFreightOrderQuantity: Scalars['Int'];
};

export type CreateProductUomPayloadInput = {
  costPerUnit?: InputMaybe<Scalars['Int']>;
  description: Scalars['String'];
  descriptorId: Scalars['Int'];
  dimensionX?: InputMaybe<Scalars['Int']>;
  dimensionY?: InputMaybe<Scalars['Int']>;
  dimensionZ?: InputMaybe<Scalars['Int']>;
  multiplier: Scalars['Int'];
  pricePerUnit?: InputMaybe<Scalars['Int']>;
  stockingUom: Scalars['Boolean'];
  weightKg?: InputMaybe<Scalars['Int']>;
};

export type CreateReportScheduleInput = {
  dateFilters: DateFiltersInput;
  filtersApplied: Array<FilterInput>;
  frequencyInput: FrequencyInput;
  reportDetails: ReportDetailsInput;
};

/** Represents the input to create a new user. */
export type CreateUserInputType = {
  /** Represents the user's address. */
  address?: InputMaybe<AddressInputType>;
  /** Represents the user's customer ID. */
  customerId: Scalars['Int'];
  /** Represents the user's email address. */
  email: Scalars['String'];
  /** Represents the user's first name. */
  firstName: Scalars['String'];
  /** Represents the user's last name. */
  lastName: Scalars['String'];
  /** Represents the user's mobile number. */
  mobile: Scalars['String'];
  /** Represents the user's password. */
  password: Scalars['String'];
  phone: Scalars['String'];
};

export type CrmaddressFilterInput = {
  address?: InputMaybe<StringOperationFilterInput>;
  address2?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<CrmaddressFilterInput>>;
  crmaddressId?: InputMaybe<ComparableInt32OperationFilterInput>;
  crmcontacts?: InputMaybe<ListFilterInputTypeOfCrmcontactFilterInput>;
  crmemails?: InputMaybe<ListFilterInputTypeOfCrmemailFilterInput>;
  crmkeyDates?: InputMaybe<ListFilterInputTypeOfCrmkeyDateFilterInput>;
  crmphones?: InputMaybe<ListFilterInputTypeOfCrmphoneFilterInput>;
  franchiseeStores?: InputMaybe<ListFilterInputTypeOfFranchiseeStoreFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CrmaddressFilterInput>>;
  postcode?: InputMaybe<StringOperationFilterInput>;
  removed?: InputMaybe<BooleanOperationFilterInput>;
  rowVersion?: InputMaybe<ListComparableByteOperationFilterInput>;
  suburb?: InputMaybe<StringOperationFilterInput>;
};

export type CrmcontactCategoryFilterInput = {
  and?: InputMaybe<Array<CrmcontactCategoryFilterInput>>;
  contactCategoryId?: InputMaybe<ComparableInt32OperationFilterInput>;
  crmcontacts?: InputMaybe<ListFilterInputTypeOfCrmcontactFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CrmcontactCategoryFilterInput>>;
};

export type CrmcontactFilterInput = {
  and?: InputMaybe<Array<CrmcontactFilterInput>>;
  contactCategory?: InputMaybe<CrmcontactCategoryFilterInput>;
  contactCategoryId?: InputMaybe<ComparableInt32OperationFilterInput>;
  crmaddress?: InputMaybe<CrmaddressFilterInput>;
  crmaddressId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  crmcontactId?: InputMaybe<ComparableInt32OperationFilterInput>;
  firstName?: InputMaybe<StringOperationFilterInput>;
  franchiseeDirectors?: InputMaybe<ListFilterInputTypeOfFranchiseeDirectorFilterInput>;
  franchiseeStores?: InputMaybe<ListFilterInputTypeOfFranchiseeStoreFilterInput>;
  guarantors?: InputMaybe<ListFilterInputTypeOfGuarantorFilterInput>;
  isPublic?: InputMaybe<BooleanOperationFilterInput>;
  lastName?: InputMaybe<StringOperationFilterInput>;
  loginUser?: InputMaybe<UserDetailFilterInput>;
  loginUserId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  or?: InputMaybe<Array<CrmcontactFilterInput>>;
  recruitments?: InputMaybe<ListFilterInputTypeOfRecruitmentFilterInput>;
  removed?: InputMaybe<BooleanOperationFilterInput>;
  rowVersion?: InputMaybe<ListComparableByteOperationFilterInput>;
  surTitle?: InputMaybe<StringOperationFilterInput>;
  title?: InputMaybe<StringOperationFilterInput>;
  userCreated?: InputMaybe<UserDetailFilterInput>;
  userCreatedId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type CrmemailFilterInput = {
  and?: InputMaybe<Array<CrmemailFilterInput>>;
  crmaddress?: InputMaybe<CrmaddressFilterInput>;
  crmaddressId?: InputMaybe<ComparableInt32OperationFilterInput>;
  crmemailId?: InputMaybe<ComparableInt32OperationFilterInput>;
  email?: InputMaybe<StringOperationFilterInput>;
  emailCategory?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CrmemailFilterInput>>;
  removed?: InputMaybe<BooleanOperationFilterInput>;
  rowVersion?: InputMaybe<ListComparableByteOperationFilterInput>;
};

export type CrmkeyDateFilterInput = {
  and?: InputMaybe<Array<CrmkeyDateFilterInput>>;
  category?: InputMaybe<StringOperationFilterInput>;
  crmaddress?: InputMaybe<CrmaddressFilterInput>;
  crmaddressId?: InputMaybe<ComparableInt32OperationFilterInput>;
  date?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  keyDateId?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<CrmkeyDateFilterInput>>;
  removed?: InputMaybe<BooleanOperationFilterInput>;
  rowVersion?: InputMaybe<ListComparableByteOperationFilterInput>;
};

export type CrmphoneFilterInput = {
  and?: InputMaybe<Array<CrmphoneFilterInput>>;
  crmaddress?: InputMaybe<CrmaddressFilterInput>;
  crmaddressId?: InputMaybe<ComparableInt32OperationFilterInput>;
  crmphoneId?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<CrmphoneFilterInput>>;
  phone?: InputMaybe<StringOperationFilterInput>;
  phoneCategory?: InputMaybe<StringOperationFilterInput>;
  removed?: InputMaybe<BooleanOperationFilterInput>;
  rowVersion?: InputMaybe<ListComparableByteOperationFilterInput>;
};

export type CrossUpSaleItem = {
  __typename?: 'CrossUpSaleItem';
  productId: Scalars['Int'];
  productTitle?: Maybe<Scalars['String']>;
  saleType: Scalars['String'];
};

export type CrossUpSaleItemInput = {
  productId: Scalars['Int'];
  productTitle?: InputMaybe<Scalars['String']>;
  saleType: Scalars['String'];
};

export type CustomCategoryEntitySortInput = {
  active?: InputMaybe<SortEnumType>;
  categoryHtml?: InputMaybe<SortEnumType>;
  categoryId?: InputMaybe<SortEnumType>;
  childCategoriesCount?: InputMaybe<SortEnumType>;
  created?: InputMaybe<SortEnumType>;
  customCssClass?: InputMaybe<SortEnumType>;
  customer?: InputMaybe<CustomerSortInput>;
  customerCategoryId?: InputMaybe<SortEnumType>;
  customerId?: InputMaybe<SortEnumType>;
  globalCategory?: InputMaybe<SortEnumType>;
  imagePath?: InputMaybe<SortEnumType>;
  modified?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  orderType?: InputMaybe<OrderTypeSortInput>;
  orderTypeId?: InputMaybe<SortEnumType>;
  parent?: InputMaybe<CategorySortInput>;
  parentId?: InputMaybe<SortEnumType>;
  purgeDate?: InputMaybe<SortEnumType>;
  removed?: InputMaybe<SortEnumType>;
  reorderInfoEmail?: InputMaybe<SortEnumType>;
  secondaryApproverId?: InputMaybe<SortEnumType>;
  shopCategory?: InputMaybe<SortEnumType>;
  showImage?: InputMaybe<SortEnumType>;
  showThumb?: InputMaybe<SortEnumType>;
  sortByIndicator?: InputMaybe<SortEnumType>;
  sortIndex?: InputMaybe<SortEnumType>;
  specialPickRateBase?: InputMaybe<SortEnumType>;
  specialPickRateScale?: InputMaybe<SortEnumType>;
  thirdPartyEmail?: InputMaybe<SortEnumType>;
  thumbPath?: InputMaybe<SortEnumType>;
  useSpecialPickRate?: InputMaybe<SortEnumType>;
  useThirdPartySupplier?: InputMaybe<SortEnumType>;
  userCreatedId?: InputMaybe<SortEnumType>;
  userModifiedId?: InputMaybe<SortEnumType>;
  wmsPickPdftype?: InputMaybe<WmsPickPdftypeSortInput>;
  wmsPickPdftypeId?: InputMaybe<SortEnumType>;
  wn2id?: InputMaybe<SortEnumType>;
  zeroFreight?: InputMaybe<SortEnumType>;
};

export type CustomFreightSetting = {
  __typename?: 'CustomFreightSetting';
  active: Scalars['Boolean'];
  bypassPobox?: Maybe<Scalars['Boolean']>;
  created: Scalars['DateTime'];
  customer: Customer;
  customerFreightRates: Array<CustomerFreightRate>;
  customerFsmappingChildcfsses: Array<CustomerFsmapping>;
  customerFsmappingParentcfsses: Array<CustomerFsmapping>;
  customerId: Scalars['Int'];
  customerPickTypes: Array<CustomerPickType>;
  defaultOrderTypeId?: Maybe<Scalars['Int']>;
  freightDeliveryMethod?: Maybe<FreightDeliveryMethod>;
  freightDeliveryMethodId?: Maybe<Scalars['Int']>;
  freightSettingId: Scalars['Int'];
  freightSettingType: FreightSettingType;
  freightSettingTypeId: Scalars['Int'];
  fuelLevy?: Maybe<Scalars['Decimal']>;
  isActive: Scalars['Boolean'];
  minimumWeightKg?: Maybe<Scalars['Decimal']>;
  modified: Scalars['DateTime'];
  name: Scalars['String'];
  purgeDate?: Maybe<Scalars['DateTime']>;
  removed: Scalars['Boolean'];
  roleFreightMaps: Array<RoleFreightMap>;
  services: Array<CarrierService>;
  simpleBase?: Maybe<Scalars['Decimal']>;
  simpleScale?: Maybe<Scalars['Decimal']>;
  textToDisplayForOption?: Maybe<Scalars['String']>;
  upToQuantity?: Maybe<Scalars['Int']>;
  upToWeightKg?: Maybe<Scalars['Decimal']>;
  userModifiedId: Scalars['Int'];
};

export type CustomOrderType = {
  __typename?: 'CustomOrderType';
  bypassFees: Scalars['Boolean'];
  categories: Array<Category>;
  etemplateType: Scalars['Boolean'];
  isActive: Scalars['Boolean'];
  isPurchase: Scalars['Boolean'];
  isSale: Scalars['Boolean'];
  name?: Maybe<Scalars['String']>;
  orderShippings: Array<OrderShippingType>;
  orderTypeId: Scalars['Int'];
  products: Array<ProductType>;
  roleOrderTypes: Array<RoleOrderType>;
  selectable: Scalars['Boolean'];
  sohCheckType: Scalars['Boolean'];
};

export type Customer = {
  __typename?: 'Customer';
  accpacAccount?: Maybe<Scalars['String']>;
  active: Scalars['Boolean'];
  activities: Array<Activity>;
  advertisementMasterPages: Array<AdvertisementMasterPage>;
  advertisementPages: Array<AdvertisementPage>;
  bankDetails: BankDetail;
  bankDetailsId: Scalars['Int'];
  billingAddress?: Maybe<Address>;
  billingAddressId?: Maybe<Scalars['Int']>;
  businessLevels: Array<BusinessLevel>;
  campaigns: Array<Campaign>;
  categories: Array<Category>;
  categoryPromoters: Array<CategoryPromoter>;
  cmsBlockStatuses: Array<CmsBlockStatus>;
  contactEmail?: Maybe<Scalars['String']>;
  contactUsPhone: Scalars['String'];
  created: Scalars['DateTime'];
  crmguid: Scalars['UUID'];
  crmid?: Maybe<Scalars['String']>;
  customerEmailSettings: Array<CustomerEmailSetting>;
  customerExchangeRates: Array<CustomerExchangeRate>;
  customerFinancials: Array<CustomerFinancial>;
  customerFreightSettings: Array<CustomerFreightSettingType>;
  customerId: Scalars['Int'];
  customerInterfaces: Array<CustomerInterface>;
  customerLiveChatCategories: Array<CustomerLiveChatCategory>;
  customerOptData: Array<CustomerOptDatum>;
  customerOptHeads: Array<CustomerOptHead>;
  customerOrderOptions: Array<CustomerOrderOption>;
  customerPaymentOptions: Array<CustomerPaymentOption>;
  customerPermissions: Array<CustomerPermission>;
  customerPickPdfsettings: Array<CustomerPickPdfsetting>;
  customerPostcodeRestrictions: Array<CustomerPostcodeRestriction>;
  customerProperties: Array<CustomerProperty>;
  customerRegistrationSettings: Array<CustomerRegistrationSetting>;
  customerShopSettings: Array<CustomerShopSetting>;
  customerStocktakeSettings: Array<CustomerStocktakeSetting>;
  customerThirdPartyApisettings: Array<CustomerThirdPartyApisetting>;
  deliveryAddress?: Maybe<Address>;
  deliveryAddressId?: Maybe<Scalars['Int']>;
  documentCategories: Array<DocumentCategory>;
  documents: Array<Document>;
  emailAdBlockData: Array<EmailAdBlockDatum>;
  emailAdPages: Array<EmailAdPage>;
  emailHeaders: Array<EmailHeader>;
  emailTemplates: Array<EmailTemplate>;
  etemplateData: Array<EtemplateDatum>;
  faqs: Array<FaqType>;
  isNotUpdateFeeLine: Scalars['Boolean'];
  loginUrl?: Maybe<Scalars['String']>;
  maintenance: Scalars['Boolean'];
  margin: Scalars['Decimal'];
  modified: Scalars['DateTime'];
  name?: Maybe<Scalars['String']>;
  oldCustomerId?: Maybe<Scalars['Int']>;
  orderCreditNoticeEmail?: Maybe<Scalars['String']>;
  orderTerms: Array<OrderTerm>;
  orderUpdateEmail?: Maybe<Scalars['String']>;
  orders: Array<Order>;
  productInfoUpdateEmail: Scalars['String'];
  productMappings: Array<ProductMapping>;
  productNewTemporaries: Array<ProductNewTemporary>;
  productPrefix?: Maybe<Scalars['String']>;
  products: Array<ProductType>;
  promoCodes: Array<PromoCode>;
  purgeDate?: Maybe<Scalars['DateTime']>;
  recipientData: Array<RecipientData>;
  recordTimestamp: Array<Scalars['ByteArray']>;
  removed: Scalars['Boolean'];
  reorderInfoEmail?: Maybe<Scalars['String']>;
  reportSchedules: Array<ReportScheduleType>;
  reports: Array<Report>;
  roles: Array<RoleType>;
  sapcontractMode: Scalars['Int'];
  sapprojectCode?: Maybe<Scalars['String']>;
  siteMapOverrides: Array<SiteMapOverride>;
  smsRequests: Array<SmsRequest>;
  smsTemplates: Array<SmsTemplate>;
  stocktake: Scalars['Boolean'];
  surveySubmissionHeaders: Array<SurveySubmissionHeader>;
  taxRate: Scalars['Decimal'];
  teamCustomers: Array<TeamCustomer>;
  theme?: Maybe<Theme>;
  translations: Array<Translation>;
  tsuCustomerFeatures: Array<TsuCustomerFeature>;
  userCreatedId: Scalars['Int'];
  userModifiedId: Scalars['Int'];
  waivestarCustomer: Scalars['Boolean'];
  wbsownedStock: Scalars['Boolean'];
  wmsRgas: Array<WmsRga>;
  zeescapeJobs: Array<ZeescapeJob>;
  zeroFreightOrderAmount?: Maybe<Scalars['Decimal']>;
};

export type CustomerEmailSetting = {
  __typename?: 'CustomerEmailSetting';
  bcc?: Maybe<Scalars['String']>;
  customer: Customer;
  customerEmailSettingId: Scalars['Int'];
  customerId: Scalars['Int'];
  email: Email;
  emailId: Scalars['Int'];
  emailType: EmailType;
  emailTypeId: Scalars['Int'];
  replyTo: Scalars['String'];
  role?: Maybe<RoleType>;
  roleId?: Maybe<Scalars['Int']>;
  sendGridTemplateId?: Maybe<Scalars['String']>;
};

export type CustomerEmailSettingFilterInput = {
  and?: InputMaybe<Array<CustomerEmailSettingFilterInput>>;
  bcc?: InputMaybe<StringOperationFilterInput>;
  customer?: InputMaybe<CustomerFilterInput>;
  customerEmailSettingId?: InputMaybe<ComparableInt32OperationFilterInput>;
  customerId?: InputMaybe<ComparableInt32OperationFilterInput>;
  email?: InputMaybe<EmailFilterInput>;
  emailId?: InputMaybe<ComparableInt32OperationFilterInput>;
  emailType?: InputMaybe<EmailTypeFilterInput>;
  emailTypeId?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<CustomerEmailSettingFilterInput>>;
  replyTo?: InputMaybe<StringOperationFilterInput>;
  role?: InputMaybe<RoleFilterInput>;
  roleId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  sendGridTemplateId?: InputMaybe<StringOperationFilterInput>;
};

export type CustomerExchangeRate = {
  __typename?: 'CustomerExchangeRate';
  autoUpdate: Scalars['Boolean'];
  businessLevels: Array<BusinessLevel>;
  code: Scalars['String'];
  currencyFullName: Scalars['String'];
  customer: Customer;
  customerId: Scalars['Int'];
  id: Scalars['Int'];
  rate: Scalars['Decimal'];
  rowVersion: Array<Scalars['ByteArray']>;
  taxRate?: Maybe<Scalars['Decimal']>;
};

export type CustomerExchangeRateFilterInput = {
  and?: InputMaybe<Array<CustomerExchangeRateFilterInput>>;
  autoUpdate?: InputMaybe<BooleanOperationFilterInput>;
  businessLevels?: InputMaybe<ListFilterInputTypeOfBusinessLevelFilterInput>;
  code?: InputMaybe<StringOperationFilterInput>;
  currencyFullName?: InputMaybe<StringOperationFilterInput>;
  customer?: InputMaybe<CustomerFilterInput>;
  customerId?: InputMaybe<ComparableInt32OperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<CustomerExchangeRateFilterInput>>;
  rate?: InputMaybe<ComparableDecimalOperationFilterInput>;
  rowVersion?: InputMaybe<ListComparableByteOperationFilterInput>;
  taxRate?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
};

export type CustomerExchangeRateSortInput = {
  autoUpdate?: InputMaybe<SortEnumType>;
  code?: InputMaybe<SortEnumType>;
  currencyFullName?: InputMaybe<SortEnumType>;
  customer?: InputMaybe<CustomerSortInput>;
  customerId?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  rate?: InputMaybe<SortEnumType>;
  taxRate?: InputMaybe<SortEnumType>;
};

export type CustomerFilterInput = {
  accpacAccount?: InputMaybe<StringOperationFilterInput>;
  active?: InputMaybe<BooleanOperationFilterInput>;
  activities?: InputMaybe<ListFilterInputTypeOfActivityFilterInput>;
  advertisementMasterPages?: InputMaybe<ListFilterInputTypeOfAdvertisementMasterPageFilterInput>;
  advertisementPages?: InputMaybe<ListFilterInputTypeOfAdvertisementPageFilterInput>;
  and?: InputMaybe<Array<CustomerFilterInput>>;
  bankDetails?: InputMaybe<BankDetailFilterInput>;
  bankDetailsId?: InputMaybe<ComparableInt32OperationFilterInput>;
  billingAddress?: InputMaybe<AddressFilterInput>;
  billingAddressId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  businessLevels?: InputMaybe<ListFilterInputTypeOfBusinessLevelFilterInput>;
  campaigns?: InputMaybe<ListFilterInputTypeOfCampaignFilterInput>;
  categories?: InputMaybe<ListFilterInputTypeOfCategoryFilterInput>;
  categoryPromoters?: InputMaybe<ListFilterInputTypeOfCategoryPromoterFilterInput>;
  cmsBlockStatuses?: InputMaybe<ListFilterInputTypeOfCmsBlockStatusFilterInput>;
  contactEmail?: InputMaybe<StringOperationFilterInput>;
  contactUsPhone?: InputMaybe<StringOperationFilterInput>;
  created?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  crmguid?: InputMaybe<ComparableGuidOperationFilterInput>;
  crmid?: InputMaybe<StringOperationFilterInput>;
  customerEmailSettings?: InputMaybe<ListFilterInputTypeOfCustomerEmailSettingFilterInput>;
  customerExchangeRates?: InputMaybe<ListFilterInputTypeOfCustomerExchangeRateFilterInput>;
  customerFinancials?: InputMaybe<ListFilterInputTypeOfCustomerFinancialFilterInput>;
  customerFreightSettings?: InputMaybe<ListFilterInputTypeOfCustomerFreightSettingFilterInput>;
  customerId?: InputMaybe<ComparableInt32OperationFilterInput>;
  customerInterfaces?: InputMaybe<ListFilterInputTypeOfCustomerInterfaceFilterInput>;
  customerLiveChatCategories?: InputMaybe<ListFilterInputTypeOfCustomerLiveChatCategoryFilterInput>;
  customerOptData?: InputMaybe<ListFilterInputTypeOfCustomerOptDatumFilterInput>;
  customerOptHeads?: InputMaybe<ListFilterInputTypeOfCustomerOptHeadFilterInput>;
  customerOrderOptions?: InputMaybe<ListFilterInputTypeOfCustomerOrderOptionFilterInput>;
  customerPaymentOptions?: InputMaybe<ListFilterInputTypeOfCustomerPaymentOptionFilterInput>;
  customerPermissions?: InputMaybe<ListFilterInputTypeOfCustomerPermissionFilterInput>;
  customerPickPdfsettings?: InputMaybe<ListFilterInputTypeOfCustomerPickPdfsettingFilterInput>;
  customerPostcodeRestrictions?: InputMaybe<ListFilterInputTypeOfCustomerPostcodeRestrictionFilterInput>;
  customerProperties?: InputMaybe<ListFilterInputTypeOfCustomerPropertyFilterInput>;
  customerRegistrationSettings?: InputMaybe<ListFilterInputTypeOfCustomerRegistrationSettingFilterInput>;
  customerShopSettings?: InputMaybe<ListFilterInputTypeOfCustomerShopSettingFilterInput>;
  customerStocktakeSettings?: InputMaybe<ListFilterInputTypeOfCustomerStocktakeSettingFilterInput>;
  customerThirdPartyApisettings?: InputMaybe<ListFilterInputTypeOfCustomerThirdPartyApisettingFilterInput>;
  deliveryAddress?: InputMaybe<AddressFilterInput>;
  deliveryAddressId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  documentCategories?: InputMaybe<ListFilterInputTypeOfDocumentCategoryFilterInput>;
  documents?: InputMaybe<ListFilterInputTypeOfDocumentFilterInput>;
  emailAdBlockData?: InputMaybe<ListFilterInputTypeOfEmailAdBlockDatumFilterInput>;
  emailAdPages?: InputMaybe<ListFilterInputTypeOfEmailAdPageFilterInput>;
  emailHeaders?: InputMaybe<ListFilterInputTypeOfEmailHeaderFilterInput>;
  emailTemplates?: InputMaybe<ListFilterInputTypeOfEmailTemplateFilterInput>;
  etemplateData?: InputMaybe<ListFilterInputTypeOfEtemplateDatumFilterInput>;
  faqs?: InputMaybe<ListFilterInputTypeOfFaqFilterInput>;
  isNotUpdateFeeLine?: InputMaybe<BooleanOperationFilterInput>;
  loginUrl?: InputMaybe<StringOperationFilterInput>;
  maintenance?: InputMaybe<BooleanOperationFilterInput>;
  margin?: InputMaybe<ComparableDecimalOperationFilterInput>;
  modified?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  oldCustomerId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  or?: InputMaybe<Array<CustomerFilterInput>>;
  orderCreditNoticeEmail?: InputMaybe<StringOperationFilterInput>;
  orderTerms?: InputMaybe<ListFilterInputTypeOfOrderTermFilterInput>;
  orderUpdateEmail?: InputMaybe<StringOperationFilterInput>;
  orders?: InputMaybe<ListFilterInputTypeOfOrderFilterInput>;
  productInfoUpdateEmail?: InputMaybe<StringOperationFilterInput>;
  productMappings?: InputMaybe<ListFilterInputTypeOfProductMappingFilterInput>;
  productNewTemporaries?: InputMaybe<ListFilterInputTypeOfProductNewTemporaryFilterInput>;
  productPrefix?: InputMaybe<StringOperationFilterInput>;
  products?: InputMaybe<ListFilterInputTypeOfProductFilterInput>;
  promoCodes?: InputMaybe<ListFilterInputTypeOfPromoCodeFilterInput>;
  purgeDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  recipientData?: InputMaybe<ListFilterInputTypeOfRecipientDataFilterInput>;
  recordTimestamp?: InputMaybe<ListComparableByteOperationFilterInput>;
  removed?: InputMaybe<BooleanOperationFilterInput>;
  reorderInfoEmail?: InputMaybe<StringOperationFilterInput>;
  reportSchedules?: InputMaybe<ListFilterInputTypeOfReportScheduleFilterInput>;
  reports?: InputMaybe<ListFilterInputTypeOfReportFilterInput>;
  roles?: InputMaybe<ListFilterInputTypeOfRoleFilterInput>;
  sapcontractMode?: InputMaybe<ComparableInt32OperationFilterInput>;
  sapprojectCode?: InputMaybe<StringOperationFilterInput>;
  siteMapOverrides?: InputMaybe<ListFilterInputTypeOfSiteMapOverrideFilterInput>;
  smsRequests?: InputMaybe<ListFilterInputTypeOfSmsRequestFilterInput>;
  smsTemplates?: InputMaybe<ListFilterInputTypeOfSmsTemplateFilterInput>;
  stocktake?: InputMaybe<BooleanOperationFilterInput>;
  surveySubmissionHeaders?: InputMaybe<ListFilterInputTypeOfSurveySubmissionHeaderFilterInput>;
  taxRate?: InputMaybe<ComparableDecimalOperationFilterInput>;
  teamCustomers?: InputMaybe<ListFilterInputTypeOfTeamCustomerFilterInput>;
  theme?: InputMaybe<ThemeFilterInput>;
  translations?: InputMaybe<ListFilterInputTypeOfTranslationFilterInput>;
  tsuCustomerFeatures?: InputMaybe<ListFilterInputTypeOfTsuCustomerFeatureFilterInput>;
  userCreatedId?: InputMaybe<ComparableInt32OperationFilterInput>;
  userModifiedId?: InputMaybe<ComparableInt32OperationFilterInput>;
  waivestarCustomer?: InputMaybe<BooleanOperationFilterInput>;
  wbsownedStock?: InputMaybe<BooleanOperationFilterInput>;
  wmsRgas?: InputMaybe<ListFilterInputTypeOfWmsRgaFilterInput>;
  zeescapeJobs?: InputMaybe<ListFilterInputTypeOfZeescapeJobFilterInput>;
  zeroFreightOrderAmount?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
};

export type CustomerFinancial = {
  __typename?: 'CustomerFinancial';
  archiveLodgement: Scalars['Decimal'];
  archiveStorage: Scalars['Decimal'];
  artworkOnlySell: Scalars['Decimal'];
  cancelSell?: Maybe<Scalars['Decimal']>;
  collectSell?: Maybe<Scalars['Decimal']>;
  created: Scalars['DateTime'];
  customer: Customer;
  customerId: Scalars['Int'];
  destructionPerBox?: Maybe<Scalars['Decimal']>;
  destructionPerPallet?: Maybe<Scalars['Decimal']>;
  dpterms?: Maybe<Scalars['Int']>;
  financialId: Scalars['Int'];
  loadingFeeFiveMins?: Maybe<Scalars['Decimal']>;
  manualOrderSell?: Maybe<Scalars['Decimal']>;
  modified: Scalars['DateTime'];
  monthlyServiceFee?: Maybe<Scalars['Decimal']>;
  newCartonSell?: Maybe<Scalars['Decimal']>;
  newTubeSell?: Maybe<Scalars['Decimal']>;
  paymentTerms: Scalars['Int'];
  paysForOnDemandStorage: Scalars['Boolean'];
  perEmailSell?: Maybe<Scalars['Decimal']>;
  perSmssell?: Maybe<Scalars['Decimal']>;
  poBoxSurchargeSell?: Maybe<Scalars['Decimal']>;
  replenishPerPallet?: Maybe<Scalars['Decimal']>;
  rowVersion: Array<Scalars['ByteArray']>;
  shrinkWrapPerPallet?: Maybe<Scalars['Decimal']>;
  storagePerCubeMeterPerDay?: Maybe<Scalars['Decimal']>;
  urgentPickSell?: Maybe<Scalars['Decimal']>;
  usePaymentGateway: Scalars['Boolean'];
  userModifiedId: Scalars['Int'];
  warehouseLabourPerHour?: Maybe<Scalars['Decimal']>;
};

export type CustomerFinancialFilterInput = {
  and?: InputMaybe<Array<CustomerFinancialFilterInput>>;
  archiveLodgement?: InputMaybe<ComparableDecimalOperationFilterInput>;
  archiveStorage?: InputMaybe<ComparableDecimalOperationFilterInput>;
  artworkOnlySell?: InputMaybe<ComparableDecimalOperationFilterInput>;
  cancelSell?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  collectSell?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  created?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  customer?: InputMaybe<CustomerFilterInput>;
  customerId?: InputMaybe<ComparableInt32OperationFilterInput>;
  destructionPerBox?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  destructionPerPallet?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  dpterms?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  financialId?: InputMaybe<ComparableInt32OperationFilterInput>;
  loadingFeeFiveMins?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  manualOrderSell?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  modified?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  monthlyServiceFee?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  newCartonSell?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  newTubeSell?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  or?: InputMaybe<Array<CustomerFinancialFilterInput>>;
  paymentTerms?: InputMaybe<ComparableInt32OperationFilterInput>;
  paysForOnDemandStorage?: InputMaybe<BooleanOperationFilterInput>;
  perEmailSell?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  perSmssell?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  poBoxSurchargeSell?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  replenishPerPallet?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  rowVersion?: InputMaybe<ListComparableByteOperationFilterInput>;
  shrinkWrapPerPallet?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  storagePerCubeMeterPerDay?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  urgentPickSell?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  usePaymentGateway?: InputMaybe<BooleanOperationFilterInput>;
  userModifiedId?: InputMaybe<ComparableInt32OperationFilterInput>;
  warehouseLabourPerHour?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
};

export type CustomerFreightRate = {
  __typename?: 'CustomerFreightRate';
  active: Scalars['Boolean'];
  base: Scalars['Decimal'];
  created: Scalars['DateTime'];
  custFreightId: Scalars['Int'];
  freightSetting: CustomerFreightSettingType;
  freightSettingId: Scalars['Int'];
  modified: Scalars['DateTime'];
  purgeDate?: Maybe<Scalars['DateTime']>;
  removed: Scalars['Boolean'];
  scale?: Maybe<Scalars['Decimal']>;
  userModifiedId: Scalars['Int'];
  zone: Scalars['String'];
};

export type CustomerFreightRateFilterInput = {
  active?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<CustomerFreightRateFilterInput>>;
  base?: InputMaybe<ComparableDecimalOperationFilterInput>;
  created?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  custFreightId?: InputMaybe<ComparableInt32OperationFilterInput>;
  freightSetting?: InputMaybe<CustomerFreightSettingFilterInput>;
  freightSettingId?: InputMaybe<ComparableInt32OperationFilterInput>;
  modified?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<CustomerFreightRateFilterInput>>;
  purgeDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  removed?: InputMaybe<BooleanOperationFilterInput>;
  scale?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  userModifiedId?: InputMaybe<ComparableInt32OperationFilterInput>;
  zone?: InputMaybe<StringOperationFilterInput>;
};

export type CustomerFreightSettingFilterInput = {
  active?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<CustomerFreightSettingFilterInput>>;
  bypassPobox?: InputMaybe<BooleanOperationFilterInput>;
  created?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  customer?: InputMaybe<CustomerFilterInput>;
  customerFreightRates?: InputMaybe<ListFilterInputTypeOfCustomerFreightRateFilterInput>;
  customerFsmappingChildcfsses?: InputMaybe<ListFilterInputTypeOfCustomerFsmappingFilterInput>;
  customerFsmappingParentcfsses?: InputMaybe<ListFilterInputTypeOfCustomerFsmappingFilterInput>;
  customerId?: InputMaybe<ComparableInt32OperationFilterInput>;
  customerPickTypes?: InputMaybe<ListFilterInputTypeOfCustomerPickTypeFilterInput>;
  defaultOrderTypeId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  freightDeliveryMethod?: InputMaybe<FreightDeliveryMethodFilterInput>;
  freightDeliveryMethodId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  freightSettingId?: InputMaybe<ComparableInt32OperationFilterInput>;
  freightSettingType?: InputMaybe<FreightSettingTypeFilterInput>;
  freightSettingTypeId?: InputMaybe<ComparableInt32OperationFilterInput>;
  fuelLevy?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  minimumWeightKg?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  modified?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CustomerFreightSettingFilterInput>>;
  purgeDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  removed?: InputMaybe<BooleanOperationFilterInput>;
  roleFreightMaps?: InputMaybe<ListFilterInputTypeOfRoleFreightMapFilterInput>;
  services?: InputMaybe<ListFilterInputTypeOfCarrierServiceFilterInput>;
  simpleBase?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  simpleScale?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  textToDisplayForOption?: InputMaybe<StringOperationFilterInput>;
  upToQuantity?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  upToWeightKg?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  userModifiedId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type CustomerFreightSettingSortInput = {
  active?: InputMaybe<SortEnumType>;
  bypassPobox?: InputMaybe<SortEnumType>;
  created?: InputMaybe<SortEnumType>;
  customer?: InputMaybe<CustomerSortInput>;
  customerId?: InputMaybe<SortEnumType>;
  defaultOrderTypeId?: InputMaybe<SortEnumType>;
  freightDeliveryMethod?: InputMaybe<FreightDeliveryMethodSortInput>;
  freightDeliveryMethodId?: InputMaybe<SortEnumType>;
  freightSettingId?: InputMaybe<SortEnumType>;
  freightSettingType?: InputMaybe<FreightSettingTypeSortInput>;
  freightSettingTypeId?: InputMaybe<SortEnumType>;
  fuelLevy?: InputMaybe<SortEnumType>;
  minimumWeightKg?: InputMaybe<SortEnumType>;
  modified?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  purgeDate?: InputMaybe<SortEnumType>;
  removed?: InputMaybe<SortEnumType>;
  simpleBase?: InputMaybe<SortEnumType>;
  simpleScale?: InputMaybe<SortEnumType>;
  textToDisplayForOption?: InputMaybe<SortEnumType>;
  upToQuantity?: InputMaybe<SortEnumType>;
  upToWeightKg?: InputMaybe<SortEnumType>;
  userModifiedId?: InputMaybe<SortEnumType>;
};

/** Represents a customer's freight settings. */
export type CustomerFreightSettingType = {
  __typename?: 'CustomerFreightSettingType';
  /** Represents the unique ID of the freight setting. */
  freightSettingId: Scalars['Int'];
  /** Represents the name of the freight setting. */
  name: Scalars['String'];
};

export type CustomerFsmapping = {
  __typename?: 'CustomerFsmapping';
  childcfss: CustomerFreightSettingType;
  childcfssId: Scalars['Int'];
  customerFsmappingId: Scalars['Int'];
  parentcfss: CustomerFreightSettingType;
  parentcfssId: Scalars['Int'];
  removed: Scalars['Boolean'];
  rowVersion: Array<Scalars['ByteArray']>;
};

export type CustomerFsmappingFilterInput = {
  and?: InputMaybe<Array<CustomerFsmappingFilterInput>>;
  childcfss?: InputMaybe<CustomerFreightSettingFilterInput>;
  childcfssId?: InputMaybe<ComparableInt32OperationFilterInput>;
  customerFsmappingId?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<CustomerFsmappingFilterInput>>;
  parentcfss?: InputMaybe<CustomerFreightSettingFilterInput>;
  parentcfssId?: InputMaybe<ComparableInt32OperationFilterInput>;
  removed?: InputMaybe<BooleanOperationFilterInput>;
  rowVersion?: InputMaybe<ListComparableByteOperationFilterInput>;
};

export type CustomerInterface = {
  __typename?: 'CustomerInterface';
  cachedVersion: Scalars['Int'];
  created: Scalars['DateTime'];
  customer: Customer;
  customerId: Scalars['Int'];
  customerPassword?: Maybe<Scalars['String']>;
  customisedCss?: Maybe<Scalars['String']>;
  emailAddressToNotifyOfUserEmailChange?: Maybe<Scalars['String']>;
  footerHtml?: Maybe<Scalars['String']>;
  forceReceivingWeightMeasure: Scalars['Boolean'];
  googleAnalyticsUserId?: Maybe<Scalars['String']>;
  modified: Scalars['DateTime'];
  noteIsRequired: Scalars['Boolean'];
  orderConfirmationMessage?: Maybe<Scalars['String']>;
  orderMessageBottom?: Maybe<Scalars['String']>;
  orderMessageTop?: Maybe<Scalars['String']>;
  primaryColour?: Maybe<Scalars['String']>;
  primaryDarkColour?: Maybe<Scalars['String']>;
  rowVersion: Array<Scalars['ByteArray']>;
  secondaryColour?: Maybe<Scalars['String']>;
  settingsId: Scalars['Int'];
  skin?: Maybe<Skin>;
  skinId?: Maybe<Scalars['Int']>;
  userModifiedId: Scalars['Int'];
  workFlowColour?: Maybe<Scalars['String']>;
};

export type CustomerInterfaceFilterInput = {
  and?: InputMaybe<Array<CustomerInterfaceFilterInput>>;
  cachedVersion?: InputMaybe<ComparableInt32OperationFilterInput>;
  created?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  customer?: InputMaybe<CustomerFilterInput>;
  customerId?: InputMaybe<ComparableInt32OperationFilterInput>;
  customerPassword?: InputMaybe<StringOperationFilterInput>;
  customisedCss?: InputMaybe<StringOperationFilterInput>;
  emailAddressToNotifyOfUserEmailChange?: InputMaybe<StringOperationFilterInput>;
  footerHtml?: InputMaybe<StringOperationFilterInput>;
  forceReceivingWeightMeasure?: InputMaybe<BooleanOperationFilterInput>;
  googleAnalyticsUserId?: InputMaybe<StringOperationFilterInput>;
  modified?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  noteIsRequired?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<CustomerInterfaceFilterInput>>;
  orderConfirmationMessage?: InputMaybe<StringOperationFilterInput>;
  orderMessageBottom?: InputMaybe<StringOperationFilterInput>;
  orderMessageTop?: InputMaybe<StringOperationFilterInput>;
  primaryColour?: InputMaybe<StringOperationFilterInput>;
  primaryDarkColour?: InputMaybe<StringOperationFilterInput>;
  rowVersion?: InputMaybe<ListComparableByteOperationFilterInput>;
  secondaryColour?: InputMaybe<StringOperationFilterInput>;
  settingsId?: InputMaybe<ComparableInt32OperationFilterInput>;
  skin?: InputMaybe<SkinFilterInput>;
  skinId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  userModifiedId?: InputMaybe<ComparableInt32OperationFilterInput>;
  workFlowColour?: InputMaybe<StringOperationFilterInput>;
};

export type CustomerLiveChatCategory = {
  __typename?: 'CustomerLiveChatCategory';
  created: Scalars['DateTime'];
  customer: Customer;
  customerId: Scalars['Int'];
  liveChatCategoryId: Scalars['Int'];
  modified: Scalars['DateTime'];
  name: Scalars['String'];
  priority: Scalars['Int'];
  rowVersion: Array<Scalars['ByteArray']>;
};

export type CustomerLiveChatCategoryFilterInput = {
  and?: InputMaybe<Array<CustomerLiveChatCategoryFilterInput>>;
  created?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  customer?: InputMaybe<CustomerFilterInput>;
  customerId?: InputMaybe<ComparableInt32OperationFilterInput>;
  liveChatCategoryId?: InputMaybe<ComparableInt32OperationFilterInput>;
  modified?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CustomerLiveChatCategoryFilterInput>>;
  priority?: InputMaybe<ComparableInt32OperationFilterInput>;
  rowVersion?: InputMaybe<ListComparableByteOperationFilterInput>;
};

export type CustomerOptDatum = {
  __typename?: 'CustomerOptDatum';
  binary?: Maybe<Array<Scalars['ByteArray']>>;
  customer: Customer;
  customerId: Scalars['Int'];
  dataId: Scalars['Int'];
  dateTime?: Maybe<Scalars['DateTime']>;
  decimal?: Maybe<Scalars['Decimal']>;
  int?: Maybe<Scalars['Int']>;
  nvarchar50?: Maybe<Scalars['String']>;
  nvarcharMax?: Maybe<Scalars['String']>;
};

export type CustomerOptDatumFilterInput = {
  and?: InputMaybe<Array<CustomerOptDatumFilterInput>>;
  binary?: InputMaybe<ListComparableByteOperationFilterInput>;
  customer?: InputMaybe<CustomerFilterInput>;
  customerId?: InputMaybe<ComparableInt32OperationFilterInput>;
  dataId?: InputMaybe<ComparableInt32OperationFilterInput>;
  dateTime?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  decimal?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  int?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  nvarchar50?: InputMaybe<StringOperationFilterInput>;
  nvarcharMax?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CustomerOptDatumFilterInput>>;
};

export type CustomerOptEnum = {
  __typename?: 'CustomerOptEnum';
  enumId: Scalars['Int'];
  name: Scalars['String'];
  optHead: CustomerOptHead;
  optHeadId: Scalars['Int'];
};

export type CustomerOptEnumFilterInput = {
  and?: InputMaybe<Array<CustomerOptEnumFilterInput>>;
  enumId?: InputMaybe<ComparableInt32OperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  optHead?: InputMaybe<CustomerOptHeadFilterInput>;
  optHeadId?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<CustomerOptEnumFilterInput>>;
};

export type CustomerOptHead = {
  __typename?: 'CustomerOptHead';
  customer: Customer;
  customerId: Scalars['Int'];
  customerOptEnums: Array<CustomerOptEnum>;
  dataType: Scalars['String'];
  name: Scalars['String'];
  optHeadId: Scalars['Int'];
};

export type CustomerOptHeadFilterInput = {
  and?: InputMaybe<Array<CustomerOptHeadFilterInput>>;
  customer?: InputMaybe<CustomerFilterInput>;
  customerId?: InputMaybe<ComparableInt32OperationFilterInput>;
  customerOptEnums?: InputMaybe<ListFilterInputTypeOfCustomerOptEnumFilterInput>;
  dataType?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  optHeadId?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<CustomerOptHeadFilterInput>>;
};

export type CustomerOrderOption = {
  __typename?: 'CustomerOrderOption';
  confirmationEmailTo?: Maybe<Scalars['String']>;
  consolidateDay?: Maybe<Scalars['Int']>;
  consolidateNextDate?: Maybe<Scalars['DateTime']>;
  consolidateRecurrence?: Maybe<Scalars['Int']>;
  consolidation: Scalars['Boolean'];
  consolidationName?: Maybe<Scalars['String']>;
  consolidationType?: Maybe<ConsolidationType>;
  consolidationTypeId?: Maybe<Scalars['Int']>;
  created: Scalars['DateTime'];
  customer: Customer;
  customerId: Scalars['Int'];
  cutOffDaysRequired?: Maybe<Scalars['Int']>;
  imaphostName?: Maybe<Scalars['String']>;
  imapisSecureConection?: Maybe<Scalars['Boolean']>;
  imappassword?: Maybe<Scalars['String']>;
  imapport?: Maybe<Scalars['Int']>;
  imapusername?: Maybe<Scalars['String']>;
  modified: Scalars['DateTime'];
  orderOptionId: Scalars['Int'];
  pickCutoffTime?: Maybe<Scalars['TimeSpan']>;
  rowVersion: Array<Scalars['ByteArray']>;
  shopifyAccessToken?: Maybe<Scalars['String']>;
  shopifyAppUrl?: Maybe<Scalars['String']>;
  smtpemail?: Maybe<Scalars['String']>;
  smtpfromName?: Maybe<Scalars['String']>;
  smtphostName?: Maybe<Scalars['String']>;
  smtpisSecureConnection?: Maybe<Scalars['Boolean']>;
  smtppassword?: Maybe<Scalars['String']>;
  smtpport?: Maybe<Scalars['Int']>;
  smtpusername?: Maybe<Scalars['String']>;
  urgentPickCutoffTime?: Maybe<Scalars['TimeSpan']>;
  useCreditCardAndCreditSystem: Scalars['Boolean'];
  useCreditCardAndPointSystem: Scalars['Boolean'];
  usePointSystem: Scalars['Boolean'];
  usePreGeneratedFreightSell: Scalars['Boolean'];
  useShopify: Scalars['Boolean'];
  userModifiedId: Scalars['Int'];
  zeroFreightSell: Scalars['Boolean'];
};

export type CustomerOrderOptionFilterInput = {
  and?: InputMaybe<Array<CustomerOrderOptionFilterInput>>;
  confirmationEmailTo?: InputMaybe<StringOperationFilterInput>;
  consolidateDay?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  consolidateNextDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  consolidateRecurrence?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  consolidation?: InputMaybe<BooleanOperationFilterInput>;
  consolidationName?: InputMaybe<StringOperationFilterInput>;
  consolidationType?: InputMaybe<ConsolidationTypeFilterInput>;
  consolidationTypeId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  created?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  customer?: InputMaybe<CustomerFilterInput>;
  customerId?: InputMaybe<ComparableInt32OperationFilterInput>;
  cutOffDaysRequired?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  imaphostName?: InputMaybe<StringOperationFilterInput>;
  imapisSecureConection?: InputMaybe<BooleanOperationFilterInput>;
  imappassword?: InputMaybe<StringOperationFilterInput>;
  imapport?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  imapusername?: InputMaybe<StringOperationFilterInput>;
  modified?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<CustomerOrderOptionFilterInput>>;
  orderOptionId?: InputMaybe<ComparableInt32OperationFilterInput>;
  pickCutoffTime?: InputMaybe<ComparableNullableOfTimeSpanOperationFilterInput>;
  rowVersion?: InputMaybe<ListComparableByteOperationFilterInput>;
  shopifyAccessToken?: InputMaybe<StringOperationFilterInput>;
  shopifyAppUrl?: InputMaybe<StringOperationFilterInput>;
  smtpemail?: InputMaybe<StringOperationFilterInput>;
  smtpfromName?: InputMaybe<StringOperationFilterInput>;
  smtphostName?: InputMaybe<StringOperationFilterInput>;
  smtpisSecureConnection?: InputMaybe<BooleanOperationFilterInput>;
  smtppassword?: InputMaybe<StringOperationFilterInput>;
  smtpport?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  smtpusername?: InputMaybe<StringOperationFilterInput>;
  urgentPickCutoffTime?: InputMaybe<ComparableNullableOfTimeSpanOperationFilterInput>;
  useCreditCardAndCreditSystem?: InputMaybe<BooleanOperationFilterInput>;
  useCreditCardAndPointSystem?: InputMaybe<BooleanOperationFilterInput>;
  usePointSystem?: InputMaybe<BooleanOperationFilterInput>;
  usePreGeneratedFreightSell?: InputMaybe<BooleanOperationFilterInput>;
  useShopify?: InputMaybe<BooleanOperationFilterInput>;
  userModifiedId?: InputMaybe<ComparableInt32OperationFilterInput>;
  zeroFreightSell?: InputMaybe<BooleanOperationFilterInput>;
};

export type CustomerPaymentGatewayErrorCode = {
  __typename?: 'CustomerPaymentGatewayErrorCode';
  description: Scalars['String'];
  errorCode: Scalars['String'];
  errorId: Scalars['Int'];
  gatewayType: CustomerPaymentGatewayType;
  gatewayTypeId: Scalars['Int'];
};

export type CustomerPaymentGatewayErrorCodeFilterInput = {
  and?: InputMaybe<Array<CustomerPaymentGatewayErrorCodeFilterInput>>;
  description?: InputMaybe<StringOperationFilterInput>;
  errorCode?: InputMaybe<StringOperationFilterInput>;
  errorId?: InputMaybe<ComparableInt32OperationFilterInput>;
  gatewayType?: InputMaybe<CustomerPaymentGatewayTypeFilterInput>;
  gatewayTypeId?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<CustomerPaymentGatewayErrorCodeFilterInput>>;
};

export type CustomerPaymentGatewayType = {
  __typename?: 'CustomerPaymentGatewayType';
  actionType?: Maybe<Scalars['String']>;
  checkTrnPostString?: Maybe<Scalars['String']>;
  checkTrnStatusUrl?: Maybe<Scalars['String']>;
  customerPaymentGatewayErrorCodes: Array<CustomerPaymentGatewayErrorCode>;
  customerPaymentOptions: Array<CustomerPaymentOption>;
  gatewayTypeId: Scalars['Int'];
  name: Scalars['String'];
  postString?: Maybe<Scalars['String']>;
  postUrl?: Maybe<Scalars['String']>;
  responseAuthCodeName?: Maybe<Scalars['String']>;
  responseCodeName?: Maybe<Scalars['String']>;
  responseGatewayCodeName?: Maybe<Scalars['String']>;
  responseOrderIdname?: Maybe<Scalars['String']>;
  responseSuccessCode1?: Maybe<Scalars['String']>;
  responseSuccessCode2?: Maybe<Scalars['String']>;
  responseTotalPriceName?: Maybe<Scalars['String']>;
  responseTransactionCodeName?: Maybe<Scalars['String']>;
  responseType?: Maybe<Scalars['String']>;
};

export type CustomerPaymentGatewayTypeFilterInput = {
  actionType?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<CustomerPaymentGatewayTypeFilterInput>>;
  checkTrnPostString?: InputMaybe<StringOperationFilterInput>;
  checkTrnStatusUrl?: InputMaybe<StringOperationFilterInput>;
  customerPaymentGatewayErrorCodes?: InputMaybe<ListFilterInputTypeOfCustomerPaymentGatewayErrorCodeFilterInput>;
  customerPaymentOptions?: InputMaybe<ListFilterInputTypeOfCustomerPaymentOptionFilterInput>;
  gatewayTypeId?: InputMaybe<ComparableInt32OperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CustomerPaymentGatewayTypeFilterInput>>;
  postString?: InputMaybe<StringOperationFilterInput>;
  postUrl?: InputMaybe<StringOperationFilterInput>;
  responseAuthCodeName?: InputMaybe<StringOperationFilterInput>;
  responseCodeName?: InputMaybe<StringOperationFilterInput>;
  responseGatewayCodeName?: InputMaybe<StringOperationFilterInput>;
  responseOrderIdname?: InputMaybe<StringOperationFilterInput>;
  responseSuccessCode1?: InputMaybe<StringOperationFilterInput>;
  responseSuccessCode2?: InputMaybe<StringOperationFilterInput>;
  responseTotalPriceName?: InputMaybe<StringOperationFilterInput>;
  responseTransactionCodeName?: InputMaybe<StringOperationFilterInput>;
  responseType?: InputMaybe<StringOperationFilterInput>;
};

export type CustomerPaymentOption = {
  __typename?: 'CustomerPaymentOption';
  amex?: Maybe<Scalars['Boolean']>;
  amexSurcharge?: Maybe<Scalars['Decimal']>;
  bankcard?: Maybe<Scalars['Boolean']>;
  bankcardSurcharge?: Maybe<Scalars['Decimal']>;
  bccReceiptEmail?: Maybe<Scalars['String']>;
  bypassPaymentHtml?: Maybe<Scalars['String']>;
  ccCost?: Maybe<Scalars['Decimal']>;
  ccText?: Maybe<Scalars['String']>;
  chequeCost?: Maybe<Scalars['Decimal']>;
  chequeText?: Maybe<Scalars['String']>;
  customer: Customer;
  customerId: Scalars['Int'];
  diners?: Maybe<Scalars['Boolean']>;
  dinersSurcharge?: Maybe<Scalars['Decimal']>;
  discover?: Maybe<Scalars['Boolean']>;
  discoverSurcharge?: Maybe<Scalars['Decimal']>;
  eftCost?: Maybe<Scalars['Decimal']>;
  eftText?: Maybe<Scalars['String']>;
  gatewayType?: Maybe<CustomerPaymentGatewayType>;
  gatewayTypeId?: Maybe<Scalars['Int']>;
  globalSurcharge?: Maybe<Scalars['Decimal']>;
  invoiceFromAddress?: Maybe<Scalars['String']>;
  jcbCard?: Maybe<Scalars['Boolean']>;
  jcbSurcharge?: Maybe<Scalars['Decimal']>;
  mastercard?: Maybe<Scalars['Boolean']>;
  mastercardSurcharge?: Maybe<Scalars['Decimal']>;
  merchantAction?: Maybe<Scalars['String']>;
  merchantApipassword?: Maybe<Scalars['String']>;
  merchantApiusername?: Maybe<Scalars['String']>;
  merchantCategory?: Maybe<Scalars['String']>;
  merchantId?: Maybe<Scalars['String']>;
  merchantPassword?: Maybe<Scalars['String']>;
  motorTradeCard: Scalars['Boolean'];
  motorTradeSurcharge?: Maybe<Scalars['Decimal']>;
  payToWaiveStar: Scalars['Boolean'];
  paymentId: Scalars['Int'];
  paymentOptions: Scalars['Int'];
  paypal: Scalars['Boolean'];
  paypalApipassword?: Maybe<Scalars['String']>;
  paypalApisignature?: Maybe<Scalars['String']>;
  paypalApiusername?: Maybe<Scalars['String']>;
  paypalBusinessName?: Maybe<Scalars['String']>;
  paypalPostUrl?: Maybe<Scalars['String']>;
  paypalSurcharge?: Maybe<Scalars['Decimal']>;
  preOrderTotal?: Maybe<Scalars['Int']>;
  roleId?: Maybe<Scalars['Int']>;
  rowVersion: Array<Scalars['ByteArray']>;
  visa?: Maybe<Scalars['Boolean']>;
  visaSurcharge?: Maybe<Scalars['Decimal']>;
};

export type CustomerPaymentOptionFilterInput = {
  amex?: InputMaybe<BooleanOperationFilterInput>;
  amexSurcharge?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  and?: InputMaybe<Array<CustomerPaymentOptionFilterInput>>;
  bankcard?: InputMaybe<BooleanOperationFilterInput>;
  bankcardSurcharge?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  bccReceiptEmail?: InputMaybe<StringOperationFilterInput>;
  bypassPaymentHtml?: InputMaybe<StringOperationFilterInput>;
  ccCost?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  ccText?: InputMaybe<StringOperationFilterInput>;
  chequeCost?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  chequeText?: InputMaybe<StringOperationFilterInput>;
  customer?: InputMaybe<CustomerFilterInput>;
  customerId?: InputMaybe<ComparableInt32OperationFilterInput>;
  diners?: InputMaybe<BooleanOperationFilterInput>;
  dinersSurcharge?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  discover?: InputMaybe<BooleanOperationFilterInput>;
  discoverSurcharge?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  eftCost?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  eftText?: InputMaybe<StringOperationFilterInput>;
  gatewayType?: InputMaybe<CustomerPaymentGatewayTypeFilterInput>;
  gatewayTypeId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  globalSurcharge?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  invoiceFromAddress?: InputMaybe<StringOperationFilterInput>;
  jcbCard?: InputMaybe<BooleanOperationFilterInput>;
  jcbSurcharge?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  mastercard?: InputMaybe<BooleanOperationFilterInput>;
  mastercardSurcharge?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  merchantAction?: InputMaybe<StringOperationFilterInput>;
  merchantApipassword?: InputMaybe<StringOperationFilterInput>;
  merchantApiusername?: InputMaybe<StringOperationFilterInput>;
  merchantCategory?: InputMaybe<StringOperationFilterInput>;
  merchantId?: InputMaybe<StringOperationFilterInput>;
  merchantPassword?: InputMaybe<StringOperationFilterInput>;
  motorTradeCard?: InputMaybe<BooleanOperationFilterInput>;
  motorTradeSurcharge?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  or?: InputMaybe<Array<CustomerPaymentOptionFilterInput>>;
  payToWaiveStar?: InputMaybe<BooleanOperationFilterInput>;
  paymentId?: InputMaybe<ComparableInt32OperationFilterInput>;
  paymentOptions?: InputMaybe<ComparableInt32OperationFilterInput>;
  paypal?: InputMaybe<BooleanOperationFilterInput>;
  paypalApipassword?: InputMaybe<StringOperationFilterInput>;
  paypalApisignature?: InputMaybe<StringOperationFilterInput>;
  paypalApiusername?: InputMaybe<StringOperationFilterInput>;
  paypalBusinessName?: InputMaybe<StringOperationFilterInput>;
  paypalPostUrl?: InputMaybe<StringOperationFilterInput>;
  paypalSurcharge?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  preOrderTotal?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  roleId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  rowVersion?: InputMaybe<ListComparableByteOperationFilterInput>;
  visa?: InputMaybe<BooleanOperationFilterInput>;
  visaSurcharge?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
};

export type CustomerPermission = {
  __typename?: 'CustomerPermission';
  action: UserActionType;
  actionId: Scalars['Int'];
  created: Scalars['DateTime'];
  custRoleId: Scalars['Int'];
  customer: Customer;
  customerId: Scalars['Int'];
  modified: Scalars['DateTime'];
  rowVersion: Scalars['Int'];
  userModifiedId: Scalars['Int'];
};

export type CustomerPermissionFilterInput = {
  action?: InputMaybe<UserActionFilterInput>;
  actionId?: InputMaybe<ComparableInt32OperationFilterInput>;
  and?: InputMaybe<Array<CustomerPermissionFilterInput>>;
  created?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  custRoleId?: InputMaybe<ComparableInt32OperationFilterInput>;
  customer?: InputMaybe<CustomerFilterInput>;
  customerId?: InputMaybe<ComparableInt32OperationFilterInput>;
  modified?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<CustomerPermissionFilterInput>>;
  rowVersion?: InputMaybe<ComparableInt32OperationFilterInput>;
  userModifiedId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

/** table not used at this point, itextsharp can not load html with images */
export type CustomerPickPdfsetting = {
  __typename?: 'CustomerPickPdfsetting';
  customer: Customer;
  customerId: Scalars['Int'];
  ddocketFooterHtml?: Maybe<Scalars['String']>;
  ddocketHeaderHtml: Scalars['String'];
  logo?: Maybe<Scalars['String']>;
  logoHeight?: Maybe<Scalars['Int']>;
  logowidth?: Maybe<Scalars['Int']>;
  pdfId: Scalars['Int'];
  pickPageFooterHtml?: Maybe<Scalars['String']>;
  pickPageHeaderHtml: Scalars['String'];
};

/** table not used at this point, itextsharp can not load html with images */
export type CustomerPickPdfsettingFilterInput = {
  and?: InputMaybe<Array<CustomerPickPdfsettingFilterInput>>;
  customer?: InputMaybe<CustomerFilterInput>;
  customerId?: InputMaybe<ComparableInt32OperationFilterInput>;
  ddocketFooterHtml?: InputMaybe<StringOperationFilterInput>;
  ddocketHeaderHtml?: InputMaybe<StringOperationFilterInput>;
  logo?: InputMaybe<StringOperationFilterInput>;
  logoHeight?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  logowidth?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  or?: InputMaybe<Array<CustomerPickPdfsettingFilterInput>>;
  pdfId?: InputMaybe<ComparableInt32OperationFilterInput>;
  pickPageFooterHtml?: InputMaybe<StringOperationFilterInput>;
  pickPageHeaderHtml?: InputMaybe<StringOperationFilterInput>;
};

export type CustomerPickType = {
  __typename?: 'CustomerPickType';
  base: Scalars['Int'];
  basePrice: Scalars['Decimal'];
  break1?: Maybe<Scalars['Int']>;
  break2?: Maybe<Scalars['Int']>;
  break3?: Maybe<Scalars['Int']>;
  break4?: Maybe<Scalars['Int']>;
  break5?: Maybe<Scalars['Int']>;
  break6?: Maybe<Scalars['Int']>;
  break7?: Maybe<Scalars['Int']>;
  break8?: Maybe<Scalars['Int']>;
  break9?: Maybe<Scalars['Int']>;
  break10?: Maybe<Scalars['Int']>;
  created: Scalars['DateTime'];
  customerPickTypeId: Scalars['Int'];
  freightSetting: CustomerFreightSettingType;
  freightSettingId: Scalars['Int'];
  modified: Scalars['DateTime'];
  name: Scalars['String'];
  pickType: PickType;
  pickTypeId: Scalars['Int'];
  price1?: Maybe<Scalars['Decimal']>;
  price2?: Maybe<Scalars['Decimal']>;
  price3?: Maybe<Scalars['Decimal']>;
  price4?: Maybe<Scalars['Decimal']>;
  price5?: Maybe<Scalars['Decimal']>;
  price6?: Maybe<Scalars['Decimal']>;
  price7?: Maybe<Scalars['Decimal']>;
  price8?: Maybe<Scalars['Decimal']>;
  price9?: Maybe<Scalars['Decimal']>;
  price10?: Maybe<Scalars['Decimal']>;
  products: Array<ProductType>;
  rowTimeStamp: Array<Scalars['ByteArray']>;
  userModifiedId: Scalars['Int'];
};

export type CustomerPickTypeFilterInput = {
  and?: InputMaybe<Array<CustomerPickTypeFilterInput>>;
  base?: InputMaybe<ComparableInt32OperationFilterInput>;
  basePrice?: InputMaybe<ComparableDecimalOperationFilterInput>;
  break1?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  break2?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  break3?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  break4?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  break5?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  break6?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  break7?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  break8?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  break9?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  break10?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  created?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  customerPickTypeId?: InputMaybe<ComparableInt32OperationFilterInput>;
  freightSetting?: InputMaybe<CustomerFreightSettingFilterInput>;
  freightSettingId?: InputMaybe<ComparableInt32OperationFilterInput>;
  modified?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CustomerPickTypeFilterInput>>;
  pickType?: InputMaybe<PickTypeFilterInput>;
  pickTypeId?: InputMaybe<ComparableInt32OperationFilterInput>;
  price1?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  price2?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  price3?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  price4?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  price5?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  price6?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  price7?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  price8?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  price9?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  price10?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  products?: InputMaybe<ListFilterInputTypeOfProductFilterInput>;
  rowTimeStamp?: InputMaybe<ListComparableByteOperationFilterInput>;
  userModifiedId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type CustomerPickTypeSortInput = {
  base?: InputMaybe<SortEnumType>;
  basePrice?: InputMaybe<SortEnumType>;
  break1?: InputMaybe<SortEnumType>;
  break2?: InputMaybe<SortEnumType>;
  break3?: InputMaybe<SortEnumType>;
  break4?: InputMaybe<SortEnumType>;
  break5?: InputMaybe<SortEnumType>;
  break6?: InputMaybe<SortEnumType>;
  break7?: InputMaybe<SortEnumType>;
  break8?: InputMaybe<SortEnumType>;
  break9?: InputMaybe<SortEnumType>;
  break10?: InputMaybe<SortEnumType>;
  created?: InputMaybe<SortEnumType>;
  customerPickTypeId?: InputMaybe<SortEnumType>;
  freightSetting?: InputMaybe<CustomerFreightSettingSortInput>;
  freightSettingId?: InputMaybe<SortEnumType>;
  modified?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  pickType?: InputMaybe<PickTypeSortInput>;
  pickTypeId?: InputMaybe<SortEnumType>;
  price1?: InputMaybe<SortEnumType>;
  price2?: InputMaybe<SortEnumType>;
  price3?: InputMaybe<SortEnumType>;
  price4?: InputMaybe<SortEnumType>;
  price5?: InputMaybe<SortEnumType>;
  price6?: InputMaybe<SortEnumType>;
  price7?: InputMaybe<SortEnumType>;
  price8?: InputMaybe<SortEnumType>;
  price9?: InputMaybe<SortEnumType>;
  price10?: InputMaybe<SortEnumType>;
  userModifiedId?: InputMaybe<SortEnumType>;
};

export type CustomerPostcodeRestriction = {
  __typename?: 'CustomerPostcodeRestriction';
  active: Scalars['Boolean'];
  created: Scalars['DateTime'];
  customer: Customer;
  customerId: Scalars['Int'];
  modified: Scalars['DateTime'];
  postcode: Scalars['String'];
  postcodeId: Scalars['Int'];
  removed: Scalars['Boolean'];
  rowVersion?: Maybe<Array<Scalars['ByteArray']>>;
  suburb: Scalars['String'];
};

export type CustomerPostcodeRestrictionFilterInput = {
  active?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<CustomerPostcodeRestrictionFilterInput>>;
  created?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  customer?: InputMaybe<CustomerFilterInput>;
  customerId?: InputMaybe<ComparableInt32OperationFilterInput>;
  modified?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<CustomerPostcodeRestrictionFilterInput>>;
  postcode?: InputMaybe<StringOperationFilterInput>;
  postcodeId?: InputMaybe<ComparableInt32OperationFilterInput>;
  removed?: InputMaybe<BooleanOperationFilterInput>;
  rowVersion?: InputMaybe<ListComparableByteOperationFilterInput>;
  suburb?: InputMaybe<StringOperationFilterInput>;
};

export type CustomerProperty = {
  __typename?: 'CustomerProperty';
  created: Scalars['DateTime'];
  customer: Customer;
  customerId: Scalars['Int'];
  customerPropertyId: Scalars['Int'];
  customerPropertyValues: Array<CustomerPropertyValue>;
  modified: Scalars['DateTime'];
  propertyName: Scalars['String'];
  propertyType: Scalars['String'];
  rowVersion: Array<Scalars['ByteArray']>;
  sortOrder?: Maybe<Scalars['Int']>;
  userCreatedId: Scalars['Int'];
  userModifiedId: Scalars['Int'];
};

export type CustomerPropertyFilterInput = {
  and?: InputMaybe<Array<CustomerPropertyFilterInput>>;
  created?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  customer?: InputMaybe<CustomerFilterInput>;
  customerId?: InputMaybe<ComparableInt32OperationFilterInput>;
  customerPropertyId?: InputMaybe<ComparableInt32OperationFilterInput>;
  customerPropertyValues?: InputMaybe<ListFilterInputTypeOfCustomerPropertyValueFilterInput>;
  modified?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<CustomerPropertyFilterInput>>;
  propertyName?: InputMaybe<StringOperationFilterInput>;
  propertyType?: InputMaybe<StringOperationFilterInput>;
  rowVersion?: InputMaybe<ListComparableByteOperationFilterInput>;
  sortOrder?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  userCreatedId?: InputMaybe<ComparableInt32OperationFilterInput>;
  userModifiedId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type CustomerPropertyValue = {
  __typename?: 'CustomerPropertyValue';
  created: Scalars['DateTime'];
  customerProperty: CustomerProperty;
  customerPropertyId: Scalars['Int'];
  customerPropertyValueId: Scalars['Int'];
  modified: Scalars['DateTime'];
  productCustomerPropertyMaps: Array<ProductCustomerPropertyMap>;
  propertyCssClass?: Maybe<Scalars['String']>;
  propertyValue: Scalars['String'];
  rowVersion: Array<Scalars['ByteArray']>;
  userCreatedId: Scalars['Int'];
  userModifiedId: Scalars['Int'];
};

export type CustomerPropertyValueFilterInput = {
  and?: InputMaybe<Array<CustomerPropertyValueFilterInput>>;
  created?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  customerProperty?: InputMaybe<CustomerPropertyFilterInput>;
  customerPropertyId?: InputMaybe<ComparableInt32OperationFilterInput>;
  customerPropertyValueId?: InputMaybe<ComparableInt32OperationFilterInput>;
  modified?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<CustomerPropertyValueFilterInput>>;
  productCustomerPropertyMaps?: InputMaybe<ListFilterInputTypeOfProductCustomerPropertyMapFilterInput>;
  propertyCssClass?: InputMaybe<StringOperationFilterInput>;
  propertyValue?: InputMaybe<StringOperationFilterInput>;
  rowVersion?: InputMaybe<ListComparableByteOperationFilterInput>;
  userCreatedId?: InputMaybe<ComparableInt32OperationFilterInput>;
  userModifiedId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type CustomerRegistrationSetting = {
  __typename?: 'CustomerRegistrationSetting';
  active?: Maybe<Scalars['Boolean']>;
  approverId?: Maybe<Scalars['Int']>;
  blockContent1?: Maybe<Scalars['String']>;
  blockContent2?: Maybe<Scalars['String']>;
  blockTitle1?: Maybe<Scalars['String']>;
  blockTitle2?: Maybe<Scalars['String']>;
  customer: Customer;
  customerId: Scalars['Int'];
  defaultBusinessLevelId: Scalars['Int'];
  defaultRoleId: Scalars['Int'];
  membersBusinessLevelId?: Maybe<Scalars['Int']>;
  membersRoleId?: Maybe<Scalars['Int']>;
  modified: Scalars['DateTime'];
  recordTimestamp: Array<Scalars['ByteArray']>;
  registrationSettingId: Scalars['Int'];
  userCreatedId: Scalars['Int'];
  userModifiedId: Scalars['Int'];
};

export type CustomerRegistrationSettingFilterInput = {
  active?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<CustomerRegistrationSettingFilterInput>>;
  approverId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  blockContent1?: InputMaybe<StringOperationFilterInput>;
  blockContent2?: InputMaybe<StringOperationFilterInput>;
  blockTitle1?: InputMaybe<StringOperationFilterInput>;
  blockTitle2?: InputMaybe<StringOperationFilterInput>;
  customer?: InputMaybe<CustomerFilterInput>;
  customerId?: InputMaybe<ComparableInt32OperationFilterInput>;
  defaultBusinessLevelId?: InputMaybe<ComparableInt32OperationFilterInput>;
  defaultRoleId?: InputMaybe<ComparableInt32OperationFilterInput>;
  membersBusinessLevelId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  membersRoleId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  modified?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<CustomerRegistrationSettingFilterInput>>;
  recordTimestamp?: InputMaybe<ListComparableByteOperationFilterInput>;
  registrationSettingId?: InputMaybe<ComparableInt32OperationFilterInput>;
  userCreatedId?: InputMaybe<ComparableInt32OperationFilterInput>;
  userModifiedId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type CustomerShopSetting = {
  __typename?: 'CustomerShopSetting';
  aboutUshtml?: Maybe<Scalars['String']>;
  blogMessage?: Maybe<Scalars['String']>;
  blogTitle?: Maybe<Scalars['String']>;
  contactUshtml?: Maybe<Scalars['String']>;
  copyrightLineHtml?: Maybe<Scalars['String']>;
  created: Scalars['DateTime'];
  customer: Customer;
  customerId: Scalars['Int'];
  defaultCategoryId?: Maybe<Scalars['Int']>;
  hideSohbyInStock: Scalars['Boolean'];
  logo?: Maybe<Scalars['String']>;
  masterPage: Scalars['String'];
  modified: Scalars['DateTime'];
  productVariableWidth: Scalars['Boolean'];
  rowVersion: Array<Scalars['ByteArray']>;
  shopSettingId: Scalars['Int'];
  skin: Scalars['String'];
  supportHtml?: Maybe<Scalars['String']>;
  testimonialHtml?: Maybe<Scalars['String']>;
  testimonialTitle?: Maybe<Scalars['String']>;
  userModifiedId: Scalars['Int'];
};

export type CustomerShopSettingFilterInput = {
  aboutUshtml?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<CustomerShopSettingFilterInput>>;
  blogMessage?: InputMaybe<StringOperationFilterInput>;
  blogTitle?: InputMaybe<StringOperationFilterInput>;
  contactUshtml?: InputMaybe<StringOperationFilterInput>;
  copyrightLineHtml?: InputMaybe<StringOperationFilterInput>;
  created?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  customer?: InputMaybe<CustomerFilterInput>;
  customerId?: InputMaybe<ComparableInt32OperationFilterInput>;
  defaultCategoryId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  hideSohbyInStock?: InputMaybe<BooleanOperationFilterInput>;
  logo?: InputMaybe<StringOperationFilterInput>;
  masterPage?: InputMaybe<StringOperationFilterInput>;
  modified?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<CustomerShopSettingFilterInput>>;
  productVariableWidth?: InputMaybe<BooleanOperationFilterInput>;
  rowVersion?: InputMaybe<ListComparableByteOperationFilterInput>;
  shopSettingId?: InputMaybe<ComparableInt32OperationFilterInput>;
  skin?: InputMaybe<StringOperationFilterInput>;
  supportHtml?: InputMaybe<StringOperationFilterInput>;
  testimonialHtml?: InputMaybe<StringOperationFilterInput>;
  testimonialTitle?: InputMaybe<StringOperationFilterInput>;
  userModifiedId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type CustomerSortInput = {
  accpacAccount?: InputMaybe<SortEnumType>;
  active?: InputMaybe<SortEnumType>;
  bankDetails?: InputMaybe<BankDetailSortInput>;
  bankDetailsId?: InputMaybe<SortEnumType>;
  billingAddress?: InputMaybe<AddressSortInput>;
  billingAddressId?: InputMaybe<SortEnumType>;
  contactEmail?: InputMaybe<SortEnumType>;
  contactUsPhone?: InputMaybe<SortEnumType>;
  created?: InputMaybe<SortEnumType>;
  crmguid?: InputMaybe<SortEnumType>;
  crmid?: InputMaybe<SortEnumType>;
  customerId?: InputMaybe<SortEnumType>;
  deliveryAddress?: InputMaybe<AddressSortInput>;
  deliveryAddressId?: InputMaybe<SortEnumType>;
  isNotUpdateFeeLine?: InputMaybe<SortEnumType>;
  loginUrl?: InputMaybe<SortEnumType>;
  maintenance?: InputMaybe<SortEnumType>;
  margin?: InputMaybe<SortEnumType>;
  modified?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  oldCustomerId?: InputMaybe<SortEnumType>;
  orderCreditNoticeEmail?: InputMaybe<SortEnumType>;
  orderUpdateEmail?: InputMaybe<SortEnumType>;
  productInfoUpdateEmail?: InputMaybe<SortEnumType>;
  productPrefix?: InputMaybe<SortEnumType>;
  purgeDate?: InputMaybe<SortEnumType>;
  removed?: InputMaybe<SortEnumType>;
  reorderInfoEmail?: InputMaybe<SortEnumType>;
  sapcontractMode?: InputMaybe<SortEnumType>;
  sapprojectCode?: InputMaybe<SortEnumType>;
  stocktake?: InputMaybe<SortEnumType>;
  taxRate?: InputMaybe<SortEnumType>;
  theme?: InputMaybe<ThemeSortInput>;
  userCreatedId?: InputMaybe<SortEnumType>;
  userModifiedId?: InputMaybe<SortEnumType>;
  waivestarCustomer?: InputMaybe<SortEnumType>;
  wbsownedStock?: InputMaybe<SortEnumType>;
  zeroFreightOrderAmount?: InputMaybe<SortEnumType>;
};

export type CustomerStocktakeSetting = {
  __typename?: 'CustomerStocktakeSetting';
  created: Scalars['DateTime'];
  customer: Customer;
  customerId: Scalars['Int'];
  customerStocktakeId: Scalars['Int'];
  failedCountEmailNotify?: Maybe<Scalars['String']>;
  modified: Scalars['DateTime'];
  recount2Percent: Scalars['Decimal'];
  recountPercent: Scalars['Decimal'];
  rowVersion: Array<Scalars['ByteArray']>;
  stocktakeReoccurrenceDays: Scalars['Int'];
  userModifiedId: Scalars['Int'];
};

export type CustomerStocktakeSettingFilterInput = {
  and?: InputMaybe<Array<CustomerStocktakeSettingFilterInput>>;
  created?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  customer?: InputMaybe<CustomerFilterInput>;
  customerId?: InputMaybe<ComparableInt32OperationFilterInput>;
  customerStocktakeId?: InputMaybe<ComparableInt32OperationFilterInput>;
  failedCountEmailNotify?: InputMaybe<StringOperationFilterInput>;
  modified?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<CustomerStocktakeSettingFilterInput>>;
  recount2Percent?: InputMaybe<ComparableDecimalOperationFilterInput>;
  recountPercent?: InputMaybe<ComparableDecimalOperationFilterInput>;
  rowVersion?: InputMaybe<ListComparableByteOperationFilterInput>;
  stocktakeReoccurrenceDays?: InputMaybe<ComparableInt32OperationFilterInput>;
  userModifiedId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type CustomerThirdPartyApisetting = {
  __typename?: 'CustomerThirdPartyApisetting';
  apiaccessToken?: Maybe<Scalars['String']>;
  apiclientId?: Maybe<Scalars['String']>;
  apiclientSecret?: Maybe<Scalars['String']>;
  apiname: Scalars['String'];
  apipassword?: Maybe<Scalars['String']>;
  apiuserName?: Maybe<Scalars['String']>;
  businessLevelId?: Maybe<Scalars['Int']>;
  created?: Maybe<Scalars['DateTime']>;
  customer: Customer;
  customerId: Scalars['Int'];
  customerThirdPartyApisettingId: Scalars['Int'];
  modified?: Maybe<Scalars['DateTime']>;
};

export type CustomerThirdPartyApisettingFilterInput = {
  and?: InputMaybe<Array<CustomerThirdPartyApisettingFilterInput>>;
  apiaccessToken?: InputMaybe<StringOperationFilterInput>;
  apiclientId?: InputMaybe<StringOperationFilterInput>;
  apiclientSecret?: InputMaybe<StringOperationFilterInput>;
  apiname?: InputMaybe<StringOperationFilterInput>;
  apipassword?: InputMaybe<StringOperationFilterInput>;
  apiuserName?: InputMaybe<StringOperationFilterInput>;
  businessLevelId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  created?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  customer?: InputMaybe<CustomerFilterInput>;
  customerId?: InputMaybe<ComparableInt32OperationFilterInput>;
  customerThirdPartyApisettingId?: InputMaybe<ComparableInt32OperationFilterInput>;
  modified?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<CustomerThirdPartyApisettingFilterInput>>;
};

export type DateFiltersInput = {
  createdOnFrom: Scalars['DateTime'];
  createdOnTo: Scalars['DateTime'];
};

export type DeleteShoppingCartResponse = {
  __typename?: 'DeleteShoppingCartResponse';
  message: Scalars['String'];
};

export type Document = {
  __typename?: 'Document';
  accessLevel: Scalars['Int'];
  accessTime: Scalars['DateTime'];
  activeEndTime?: Maybe<Scalars['DateTime']>;
  activeStartTime?: Maybe<Scalars['DateTime']>;
  activityDocumentMaps: Array<ActivityDocumentMap>;
  approvalId?: Maybe<Scalars['Int']>;
  creationTime: Scalars['DateTime'];
  customer: Customer;
  customerId: Scalars['Int'];
  description?: Maybe<Scalars['String']>;
  documentCategoryMaps: Array<DocumentCategoryMap>;
  documentId: Scalars['Int'];
  documentLinks: Array<DocumentLink>;
  documentMetadata: Array<DocumentMetadata>;
  documentPermissions: Array<DocumentPermission>;
  documentType: Scalars['Int'];
  fileName: Scalars['String'];
  label?: Maybe<Scalars['String']>;
  mimetype: Scalars['String'];
  modifiedTime: Scalars['DateTime'];
  modifyLevel: Scalars['Int'];
  orderLineDocumentMaps: Array<OrderLineDocumentMap>;
  ownerBusinessLevel: BusinessLevel;
  ownerBusinessLevelId: Scalars['Int'];
  ownerUser: UserType;
  ownerUserId: Scalars['Int'];
  removed: Scalars['Boolean'];
  rowVersion: Array<Scalars['ByteArray']>;
};

export type DocumentCategory = {
  __typename?: 'DocumentCategory';
  accessLevel: Scalars['Int'];
  active: Scalars['Boolean'];
  customer: Customer;
  customerId: Scalars['Int'];
  description?: Maybe<Scalars['String']>;
  documentCategoryCustomVisibilities: Array<DocumentCategoryCustomVisibility>;
  documentCategoryId: Scalars['Int'];
  documentCategoryMaps: Array<DocumentCategoryMap>;
  documentCategoryUserFavouriteMaps: Array<DocumentCategoryUserFavouriteMap>;
  documentPermissions: Array<DocumentPermission>;
  imageUrl?: Maybe<Scalars['String']>;
  inverseParent: Array<DocumentCategory>;
  modifyLevel: Scalars['Int'];
  name: Scalars['String'];
  ownerBusinessLevel: BusinessLevel;
  ownerBusinessLevelId: Scalars['Int'];
  ownerUser: UserType;
  ownerUserId: Scalars['Int'];
  parent?: Maybe<DocumentCategory>;
  parentId?: Maybe<Scalars['Int']>;
  removed: Scalars['Boolean'];
  requireApproval: Scalars['Boolean'];
  rowVersion: Array<Scalars['ByteArray']>;
  structureFolder?: Maybe<Scalars['Boolean']>;
  uploadLevel: Scalars['Int'];
};

export type DocumentCategoryCustomVisibility = {
  __typename?: 'DocumentCategoryCustomVisibility';
  businessLevel?: Maybe<BusinessLevel>;
  businessLevelId?: Maybe<Scalars['Int']>;
  documentCategory: DocumentCategory;
  documentCategoryCustomVisibility1: Scalars['Int'];
  documentCategoryId: Scalars['Int'];
  user?: Maybe<UserType>;
  userId?: Maybe<Scalars['Int']>;
};

export type DocumentCategoryCustomVisibilityFilterInput = {
  and?: InputMaybe<Array<DocumentCategoryCustomVisibilityFilterInput>>;
  businessLevel?: InputMaybe<BusinessLevelFilterInput>;
  businessLevelId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  documentCategory?: InputMaybe<DocumentCategoryFilterInput>;
  documentCategoryCustomVisibility1?: InputMaybe<ComparableInt32OperationFilterInput>;
  documentCategoryId?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<DocumentCategoryCustomVisibilityFilterInput>>;
  user?: InputMaybe<UserDetailFilterInput>;
  userId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
};

export type DocumentCategoryFilterInput = {
  accessLevel?: InputMaybe<ComparableInt32OperationFilterInput>;
  active?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<DocumentCategoryFilterInput>>;
  customer?: InputMaybe<CustomerFilterInput>;
  customerId?: InputMaybe<ComparableInt32OperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  documentCategoryCustomVisibilities?: InputMaybe<ListFilterInputTypeOfDocumentCategoryCustomVisibilityFilterInput>;
  documentCategoryId?: InputMaybe<ComparableInt32OperationFilterInput>;
  documentCategoryMaps?: InputMaybe<ListFilterInputTypeOfDocumentCategoryMapFilterInput>;
  documentCategoryUserFavouriteMaps?: InputMaybe<ListFilterInputTypeOfDocumentCategoryUserFavouriteMapFilterInput>;
  documentPermissions?: InputMaybe<ListFilterInputTypeOfDocumentPermissionFilterInput>;
  imageUrl?: InputMaybe<StringOperationFilterInput>;
  inverseParent?: InputMaybe<ListFilterInputTypeOfDocumentCategoryFilterInput>;
  modifyLevel?: InputMaybe<ComparableInt32OperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<DocumentCategoryFilterInput>>;
  ownerBusinessLevel?: InputMaybe<BusinessLevelFilterInput>;
  ownerBusinessLevelId?: InputMaybe<ComparableInt32OperationFilterInput>;
  ownerUser?: InputMaybe<UserDetailFilterInput>;
  ownerUserId?: InputMaybe<ComparableInt32OperationFilterInput>;
  parent?: InputMaybe<DocumentCategoryFilterInput>;
  parentId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  removed?: InputMaybe<BooleanOperationFilterInput>;
  requireApproval?: InputMaybe<BooleanOperationFilterInput>;
  rowVersion?: InputMaybe<ListComparableByteOperationFilterInput>;
  structureFolder?: InputMaybe<BooleanOperationFilterInput>;
  uploadLevel?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type DocumentCategoryMap = {
  __typename?: 'DocumentCategoryMap';
  category: DocumentCategory;
  categoryId: Scalars['Int'];
  document: Document;
  documentCategoryMapId: Scalars['Int'];
  documentId: Scalars['Int'];
};

export type DocumentCategoryMapFilterInput = {
  and?: InputMaybe<Array<DocumentCategoryMapFilterInput>>;
  category?: InputMaybe<DocumentCategoryFilterInput>;
  categoryId?: InputMaybe<ComparableInt32OperationFilterInput>;
  document?: InputMaybe<DocumentFilterInput>;
  documentCategoryMapId?: InputMaybe<ComparableInt32OperationFilterInput>;
  documentId?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<DocumentCategoryMapFilterInput>>;
};

export type DocumentCategoryUserFavouriteMap = {
  __typename?: 'DocumentCategoryUserFavouriteMap';
  documentCategory: DocumentCategory;
  documentCategoryId: Scalars['Int'];
  documentCategoryUserFavouriteMapId: Scalars['Int'];
  user: UserType;
  userId: Scalars['Int'];
};

export type DocumentCategoryUserFavouriteMapFilterInput = {
  and?: InputMaybe<Array<DocumentCategoryUserFavouriteMapFilterInput>>;
  documentCategory?: InputMaybe<DocumentCategoryFilterInput>;
  documentCategoryId?: InputMaybe<ComparableInt32OperationFilterInput>;
  documentCategoryUserFavouriteMapId?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<DocumentCategoryUserFavouriteMapFilterInput>>;
  user?: InputMaybe<UserDetailFilterInput>;
  userId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type DocumentCustomVisibility = {
  __typename?: 'DocumentCustomVisibility';
  businessLevel?: Maybe<BusinessLevel>;
  businessLevelId?: Maybe<Scalars['Int']>;
  documentCustomVisibilityId: Scalars['Int'];
  documentId: Scalars['Int'];
  user?: Maybe<UserType>;
  userId?: Maybe<Scalars['Int']>;
};

export type DocumentCustomVisibilityFilterInput = {
  and?: InputMaybe<Array<DocumentCustomVisibilityFilterInput>>;
  businessLevel?: InputMaybe<BusinessLevelFilterInput>;
  businessLevelId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  documentCustomVisibilityId?: InputMaybe<ComparableInt32OperationFilterInput>;
  documentId?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<DocumentCustomVisibilityFilterInput>>;
  user?: InputMaybe<UserDetailFilterInput>;
  userId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
};

export type DocumentFilterInput = {
  accessLevel?: InputMaybe<ComparableInt32OperationFilterInput>;
  accessTime?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  activeEndTime?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  activeStartTime?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  activityDocumentMaps?: InputMaybe<ListFilterInputTypeOfActivityDocumentMapFilterInput>;
  and?: InputMaybe<Array<DocumentFilterInput>>;
  approvalId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  creationTime?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  customer?: InputMaybe<CustomerFilterInput>;
  customerId?: InputMaybe<ComparableInt32OperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  documentCategoryMaps?: InputMaybe<ListFilterInputTypeOfDocumentCategoryMapFilterInput>;
  documentId?: InputMaybe<ComparableInt32OperationFilterInput>;
  documentLinks?: InputMaybe<ListFilterInputTypeOfDocumentLinkFilterInput>;
  documentMetadata?: InputMaybe<ListFilterInputTypeOfDocumentMetadataFilterInput>;
  documentPermissions?: InputMaybe<ListFilterInputTypeOfDocumentPermissionFilterInput>;
  documentType?: InputMaybe<ComparableInt32OperationFilterInput>;
  fileName?: InputMaybe<StringOperationFilterInput>;
  label?: InputMaybe<StringOperationFilterInput>;
  mimetype?: InputMaybe<StringOperationFilterInput>;
  modifiedTime?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  modifyLevel?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<DocumentFilterInput>>;
  orderLineDocumentMaps?: InputMaybe<ListFilterInputTypeOfOrderLineDocumentMapFilterInput>;
  ownerBusinessLevel?: InputMaybe<BusinessLevelFilterInput>;
  ownerBusinessLevelId?: InputMaybe<ComparableInt32OperationFilterInput>;
  ownerUser?: InputMaybe<UserDetailFilterInput>;
  ownerUserId?: InputMaybe<ComparableInt32OperationFilterInput>;
  removed?: InputMaybe<BooleanOperationFilterInput>;
  rowVersion?: InputMaybe<ListComparableByteOperationFilterInput>;
};

export type DocumentLink = {
  __typename?: 'DocumentLink';
  active: Scalars['Boolean'];
  document: Document;
  documentId: Scalars['Int'];
  documentLinkHits: Array<DocumentLinkHit>;
  documentLinkId: Scalars['Int'];
  downloadLimitedTime?: Maybe<Scalars['Int']>;
  email?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  orderLines: Array<OrderLineType>;
  removed: Scalars['Boolean'];
  rowVersion: Array<Scalars['ByteArray']>;
  urlId: Scalars['String'];
  userCreated: UserType;
  userCreatedId: Scalars['Int'];
};

export type DocumentLinkFilterInput = {
  active?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<DocumentLinkFilterInput>>;
  document?: InputMaybe<DocumentFilterInput>;
  documentId?: InputMaybe<ComparableInt32OperationFilterInput>;
  documentLinkHits?: InputMaybe<ListFilterInputTypeOfDocumentLinkHitFilterInput>;
  documentLinkId?: InputMaybe<ComparableInt32OperationFilterInput>;
  downloadLimitedTime?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  email?: InputMaybe<StringOperationFilterInput>;
  notes?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<DocumentLinkFilterInput>>;
  orderLines?: InputMaybe<ListFilterInputTypeOfOrderLineFilterInput>;
  removed?: InputMaybe<BooleanOperationFilterInput>;
  rowVersion?: InputMaybe<ListComparableByteOperationFilterInput>;
  urlId?: InputMaybe<StringOperationFilterInput>;
  userCreated?: InputMaybe<UserDetailFilterInput>;
  userCreatedId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type DocumentLinkHit = {
  __typename?: 'DocumentLinkHit';
  documentLink: DocumentLink;
  documentLinkHitId: Scalars['Int'];
  documentLinkId: Scalars['Int'];
  extraRequestInfo?: Maybe<Scalars['String']>;
  hitTime: Scalars['DateTime'];
  referrer?: Maybe<Scalars['String']>;
  remoteIp?: Maybe<Scalars['String']>;
};

export type DocumentLinkHitFilterInput = {
  and?: InputMaybe<Array<DocumentLinkHitFilterInput>>;
  documentLink?: InputMaybe<DocumentLinkFilterInput>;
  documentLinkHitId?: InputMaybe<ComparableInt32OperationFilterInput>;
  documentLinkId?: InputMaybe<ComparableInt32OperationFilterInput>;
  extraRequestInfo?: InputMaybe<StringOperationFilterInput>;
  hitTime?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<DocumentLinkHitFilterInput>>;
  referrer?: InputMaybe<StringOperationFilterInput>;
  remoteIp?: InputMaybe<StringOperationFilterInput>;
};

export type DocumentMetadata = {
  __typename?: 'DocumentMetadata';
  accessDate: Scalars['DateTime'];
  active: Scalars['Boolean'];
  activityEmailCommsDocumentMaps: Array<ActivityEmailCommsDocumentMap>;
  checksum: Scalars['String'];
  creationDate: Scalars['DateTime'];
  document: Document;
  documentId: Scalars['Int'];
  documentMetadata1: Scalars['Int'];
  externalId?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['Short']>;
  isBig?: Maybe<Scalars['Boolean']>;
  isImage: Scalars['Boolean'];
  md5?: Maybe<Scalars['String']>;
  physicalPath: Scalars['String'];
  removed: Scalars['Boolean'];
  rev?: Maybe<Scalars['String']>;
  rowVersion: Array<Scalars['ByteArray']>;
  size: Scalars['Long'];
  uploader: UserType;
  uploaderId: Scalars['Int'];
  width?: Maybe<Scalars['Short']>;
};

export type DocumentMetadataFilterInput = {
  accessDate?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  active?: InputMaybe<BooleanOperationFilterInput>;
  activityEmailCommsDocumentMaps?: InputMaybe<ListFilterInputTypeOfActivityEmailCommsDocumentMapFilterInput>;
  and?: InputMaybe<Array<DocumentMetadataFilterInput>>;
  checksum?: InputMaybe<StringOperationFilterInput>;
  creationDate?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  document?: InputMaybe<DocumentFilterInput>;
  documentId?: InputMaybe<ComparableInt32OperationFilterInput>;
  documentMetadata1?: InputMaybe<ComparableInt32OperationFilterInput>;
  externalId?: InputMaybe<StringOperationFilterInput>;
  height?: InputMaybe<ComparableNullableOfInt16OperationFilterInput>;
  isBig?: InputMaybe<BooleanOperationFilterInput>;
  isImage?: InputMaybe<BooleanOperationFilterInput>;
  md5?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<DocumentMetadataFilterInput>>;
  physicalPath?: InputMaybe<StringOperationFilterInput>;
  removed?: InputMaybe<BooleanOperationFilterInput>;
  rev?: InputMaybe<StringOperationFilterInput>;
  rowVersion?: InputMaybe<ListComparableByteOperationFilterInput>;
  size?: InputMaybe<ComparableInt64OperationFilterInput>;
  uploader?: InputMaybe<UserDetailFilterInput>;
  uploaderId?: InputMaybe<ComparableInt32OperationFilterInput>;
  width?: InputMaybe<ComparableNullableOfInt16OperationFilterInput>;
};

export type DocumentPermission = {
  __typename?: 'DocumentPermission';
  businessLevelId: Scalars['Int'];
  created: Scalars['DateTime'];
  document?: Maybe<Document>;
  documentCategory?: Maybe<DocumentCategory>;
  documentCategoryId?: Maybe<Scalars['Int']>;
  documentId?: Maybe<Scalars['Int']>;
  documentPermissionId: Scalars['Int'];
  modified: Scalars['DateTime'];
  permission: Scalars['Int'];
  rowVersion: Array<Scalars['ByteArray']>;
};

export type DocumentPermissionFilterInput = {
  and?: InputMaybe<Array<DocumentPermissionFilterInput>>;
  businessLevelId?: InputMaybe<ComparableInt32OperationFilterInput>;
  created?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  document?: InputMaybe<DocumentFilterInput>;
  documentCategory?: InputMaybe<DocumentCategoryFilterInput>;
  documentCategoryId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  documentId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  documentPermissionId?: InputMaybe<ComparableInt32OperationFilterInput>;
  modified?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<DocumentPermissionFilterInput>>;
  permission?: InputMaybe<ComparableInt32OperationFilterInput>;
  rowVersion?: InputMaybe<ListComparableByteOperationFilterInput>;
};

export type DocumentTypeEnumFilterInput = {
  and?: InputMaybe<Array<DocumentTypeEnumFilterInput>>;
  documentTypeId?: InputMaybe<ComparableInt32OperationFilterInput>;
  histories?: InputMaybe<ListFilterInputTypeOfHistoryFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<DocumentTypeEnumFilterInput>>;
};

export type DocumentUserFavouriteMapFilterInput = {
  and?: InputMaybe<Array<DocumentUserFavouriteMapFilterInput>>;
  documentId?: InputMaybe<ComparableInt32OperationFilterInput>;
  documentUserFavouriteMapId?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<DocumentUserFavouriteMapFilterInput>>;
  user?: InputMaybe<UserDetailFilterInput>;
  userId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type Email = {
  __typename?: 'Email';
  customerEmailSettings: Array<CustomerEmailSetting>;
  emailAddress?: Maybe<Scalars['String']>;
  emailAttachments: Array<EmailAttachment>;
  emailId: Scalars['Int'];
  emailReplaceFields: Array<EmailReplaceField>;
  html?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  plainText?: Maybe<Scalars['String']>;
  subject: Scalars['String'];
};

export type EmailAdBlockCategory = {
  __typename?: 'EmailAdBlockCategory';
  emailAdBlockCategoryId: Scalars['Int'];
  emailAdBlockData: Array<EmailAdBlockDatum>;
  name: Scalars['String'];
};

export type EmailAdBlockCategoryFilterInput = {
  and?: InputMaybe<Array<EmailAdBlockCategoryFilterInput>>;
  emailAdBlockCategoryId?: InputMaybe<ComparableInt32OperationFilterInput>;
  emailAdBlockData?: InputMaybe<ListFilterInputTypeOfEmailAdBlockDatumFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<EmailAdBlockCategoryFilterInput>>;
};

export type EmailAdBlockDatum = {
  __typename?: 'EmailAdBlockDatum';
  active: Scalars['Boolean'];
  created: Scalars['DateTime'];
  customer: Customer;
  customerId: Scalars['Int'];
  emailAdBlockCateogry: EmailAdBlockCategory;
  emailAdBlockCateogryId: Scalars['Int'];
  emailAdBlockDataId: Scalars['Int'];
  emailAdBlockRawHtml?: Maybe<Scalars['String']>;
  emailAdPageBlockDataMaps: Array<EmailAdPageBlockDataMap>;
  modified: Scalars['DateTime'];
  remove: Scalars['Boolean'];
  rowVersion: Array<Scalars['ByteArray']>;
  userCreated: UserType;
  userCreatedId: Scalars['Int'];
};

export type EmailAdBlockDatumFilterInput = {
  active?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<EmailAdBlockDatumFilterInput>>;
  created?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  customer?: InputMaybe<CustomerFilterInput>;
  customerId?: InputMaybe<ComparableInt32OperationFilterInput>;
  emailAdBlockCateogry?: InputMaybe<EmailAdBlockCategoryFilterInput>;
  emailAdBlockCateogryId?: InputMaybe<ComparableInt32OperationFilterInput>;
  emailAdBlockDataId?: InputMaybe<ComparableInt32OperationFilterInput>;
  emailAdBlockRawHtml?: InputMaybe<StringOperationFilterInput>;
  emailAdPageBlockDataMaps?: InputMaybe<ListFilterInputTypeOfEmailAdPageBlockDataMapFilterInput>;
  modified?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<EmailAdBlockDatumFilterInput>>;
  remove?: InputMaybe<BooleanOperationFilterInput>;
  rowVersion?: InputMaybe<ListComparableByteOperationFilterInput>;
  userCreated?: InputMaybe<UserDetailFilterInput>;
  userCreatedId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type EmailAdPage = {
  __typename?: 'EmailAdPage';
  active: Scalars['Boolean'];
  created: Scalars['DateTime'];
  customer: Customer;
  customerId: Scalars['Int'];
  emailAdPageBlockDataMaps: Array<EmailAdPageBlockDataMap>;
  emailAdPageId: Scalars['Int'];
  modifed: Scalars['DateTime'];
  rawHtml?: Maybe<Scalars['String']>;
  recipientData?: Maybe<RecipientData>;
  recipientDataId?: Maybe<Scalars['Int']>;
  removed: Scalars['Boolean'];
  rowVersion: Array<Scalars['ByteArray']>;
  status: EmailAdPageStatus;
  statusId: Scalars['Int'];
  subject?: Maybe<Scalars['String']>;
  userCreated: UserType;
  userCreatedId: Scalars['Int'];
};

export type EmailAdPageBlockDataMap = {
  __typename?: 'EmailAdPageBlockDataMap';
  created: Scalars['DateTime'];
  emailAdBlockData: EmailAdBlockDatum;
  emailAdBlockDataId: Scalars['Int'];
  emailAdPage: EmailAdPage;
  emailAdPageBlockDataMapId: Scalars['Int'];
  emailAdPageId: Scalars['Int'];
  modified: Scalars['DateTime'];
  rowVersion: Array<Scalars['ByteArray']>;
  sortOrder: Scalars['Int'];
};

export type EmailAdPageBlockDataMapFilterInput = {
  and?: InputMaybe<Array<EmailAdPageBlockDataMapFilterInput>>;
  created?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  emailAdBlockData?: InputMaybe<EmailAdBlockDatumFilterInput>;
  emailAdBlockDataId?: InputMaybe<ComparableInt32OperationFilterInput>;
  emailAdPage?: InputMaybe<EmailAdPageFilterInput>;
  emailAdPageBlockDataMapId?: InputMaybe<ComparableInt32OperationFilterInput>;
  emailAdPageId?: InputMaybe<ComparableInt32OperationFilterInput>;
  modified?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<EmailAdPageBlockDataMapFilterInput>>;
  rowVersion?: InputMaybe<ListComparableByteOperationFilterInput>;
  sortOrder?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type EmailAdPageFilterInput = {
  active?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<EmailAdPageFilterInput>>;
  created?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  customer?: InputMaybe<CustomerFilterInput>;
  customerId?: InputMaybe<ComparableInt32OperationFilterInput>;
  emailAdPageBlockDataMaps?: InputMaybe<ListFilterInputTypeOfEmailAdPageBlockDataMapFilterInput>;
  emailAdPageId?: InputMaybe<ComparableInt32OperationFilterInput>;
  modifed?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<EmailAdPageFilterInput>>;
  rawHtml?: InputMaybe<StringOperationFilterInput>;
  recipientData?: InputMaybe<RecipientDataFilterInput>;
  recipientDataId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  removed?: InputMaybe<BooleanOperationFilterInput>;
  rowVersion?: InputMaybe<ListComparableByteOperationFilterInput>;
  status?: InputMaybe<EmailAdPageStatusFilterInput>;
  statusId?: InputMaybe<ComparableInt32OperationFilterInput>;
  subject?: InputMaybe<StringOperationFilterInput>;
  userCreated?: InputMaybe<UserDetailFilterInput>;
  userCreatedId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type EmailAdPageStatus = {
  __typename?: 'EmailAdPageStatus';
  emailAdPageStatusId: Scalars['Int'];
  emailAdPages: Array<EmailAdPage>;
  name: Scalars['String'];
};

export type EmailAdPageStatusFilterInput = {
  and?: InputMaybe<Array<EmailAdPageStatusFilterInput>>;
  emailAdPageStatusId?: InputMaybe<ComparableInt32OperationFilterInput>;
  emailAdPages?: InputMaybe<ListFilterInputTypeOfEmailAdPageFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<EmailAdPageStatusFilterInput>>;
};

export type EmailAttachedFile = {
  __typename?: 'EmailAttachedFile';
  active: Scalars['Boolean'];
  created: Scalars['DateTime'];
  emailAttachedFilesId: Scalars['Int'];
  emailHeader: EmailHeader;
  emailHeaderId: Scalars['Int'];
  modified: Scalars['DateTime'];
  removed: Scalars['Boolean'];
  rowVersion: Array<Scalars['ByteArray']>;
  uploadedFile: UploadedFile;
  uploadedFileId: Scalars['Int'];
  userCreatedId: Scalars['Int'];
  userModifiedId: Scalars['Int'];
};

export type EmailAttachedFileFilterInput = {
  active?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<EmailAttachedFileFilterInput>>;
  created?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  emailAttachedFilesId?: InputMaybe<ComparableInt32OperationFilterInput>;
  emailHeader?: InputMaybe<EmailHeaderFilterInput>;
  emailHeaderId?: InputMaybe<ComparableInt32OperationFilterInput>;
  modified?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<EmailAttachedFileFilterInput>>;
  removed?: InputMaybe<BooleanOperationFilterInput>;
  rowVersion?: InputMaybe<ListComparableByteOperationFilterInput>;
  uploadedFile?: InputMaybe<UploadedFileFilterInput>;
  uploadedFileId?: InputMaybe<ComparableInt32OperationFilterInput>;
  userCreatedId?: InputMaybe<ComparableInt32OperationFilterInput>;
  userModifiedId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type EmailAttachment = {
  __typename?: 'EmailAttachment';
  email: Email;
  emailAttachmentId: Scalars['Int'];
  emailId: Scalars['Int'];
  embedImage: Scalars['Boolean'];
  mimeType: MimeType;
  mimeTypeId: Scalars['Int'];
  pathToFile: Scalars['String'];
};

export type EmailAttachmentFilterInput = {
  and?: InputMaybe<Array<EmailAttachmentFilterInput>>;
  email?: InputMaybe<EmailFilterInput>;
  emailAttachmentId?: InputMaybe<ComparableInt32OperationFilterInput>;
  emailId?: InputMaybe<ComparableInt32OperationFilterInput>;
  embedImage?: InputMaybe<BooleanOperationFilterInput>;
  mimeType?: InputMaybe<MimeTypeFilterInput>;
  mimeTypeId?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<EmailAttachmentFilterInput>>;
  pathToFile?: InputMaybe<StringOperationFilterInput>;
};

export type EmailColumn = {
  __typename?: 'EmailColumn';
  active: Scalars['Boolean'];
  columnName: Scalars['String'];
  created: Scalars['DateTime'];
  emailColumnId: Scalars['Int'];
  emailData: Array<EmailDatum>;
  emailHeader: EmailHeader;
  emailHeaderId: Scalars['Int'];
  modified: Scalars['DateTime'];
  removed: Scalars['Boolean'];
  rowVersion: Array<Scalars['ByteArray']>;
  userCreatedId: Scalars['Int'];
  userModifiedId: Scalars['Int'];
};

export type EmailColumnFilterInput = {
  active?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<EmailColumnFilterInput>>;
  columnName?: InputMaybe<StringOperationFilterInput>;
  created?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  emailColumnId?: InputMaybe<ComparableInt32OperationFilterInput>;
  emailData?: InputMaybe<ListFilterInputTypeOfEmailDatumFilterInput>;
  emailHeader?: InputMaybe<EmailHeaderFilterInput>;
  emailHeaderId?: InputMaybe<ComparableInt32OperationFilterInput>;
  modified?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<EmailColumnFilterInput>>;
  removed?: InputMaybe<BooleanOperationFilterInput>;
  rowVersion?: InputMaybe<ListComparableByteOperationFilterInput>;
  userCreatedId?: InputMaybe<ComparableInt32OperationFilterInput>;
  userModifiedId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type EmailConnectionType = {
  __typename?: 'EmailConnectionType';
  emailConnectionTypeId: Scalars['Int'];
  emailHeaders: Array<EmailHeader>;
  name: Scalars['String'];
};

export type EmailConnectionTypeFilterInput = {
  and?: InputMaybe<Array<EmailConnectionTypeFilterInput>>;
  emailConnectionTypeId?: InputMaybe<ComparableInt32OperationFilterInput>;
  emailHeaders?: InputMaybe<ListFilterInputTypeOfEmailHeaderFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<EmailConnectionTypeFilterInput>>;
};

export type EmailDatum = {
  __typename?: 'EmailDatum';
  active: Scalars['Boolean'];
  created: Scalars['DateTime'];
  data?: Maybe<Scalars['String']>;
  emailColumn: EmailColumn;
  emailColumnId: Scalars['Int'];
  emailDataId: Scalars['Int'];
  emailDetails: EmailDetail;
  emailDetailsId: Scalars['Int'];
  linkClicked: Scalars['Int'];
  modified: Scalars['DateTime'];
  removed: Scalars['Boolean'];
  rowVersion: Array<Scalars['ByteArray']>;
  userCreatedId: Scalars['Int'];
  userModifiedId: Scalars['Int'];
};

export type EmailDatumFilterInput = {
  active?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<EmailDatumFilterInput>>;
  created?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  data?: InputMaybe<StringOperationFilterInput>;
  emailColumn?: InputMaybe<EmailColumnFilterInput>;
  emailColumnId?: InputMaybe<ComparableInt32OperationFilterInput>;
  emailDataId?: InputMaybe<ComparableInt32OperationFilterInput>;
  emailDetails?: InputMaybe<EmailDetailFilterInput>;
  emailDetailsId?: InputMaybe<ComparableInt32OperationFilterInput>;
  linkClicked?: InputMaybe<ComparableInt32OperationFilterInput>;
  modified?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<EmailDatumFilterInput>>;
  removed?: InputMaybe<BooleanOperationFilterInput>;
  rowVersion?: InputMaybe<ListComparableByteOperationFilterInput>;
  userCreatedId?: InputMaybe<ComparableInt32OperationFilterInput>;
  userModifiedId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type EmailDetail = {
  __typename?: 'EmailDetail';
  active: Scalars['Boolean'];
  businessLevel: BusinessLevel;
  businessLevelId: Scalars['Int'];
  clicked: Scalars['Boolean'];
  created: Scalars['DateTime'];
  downloaded: Scalars['Boolean'];
  emailAddress: Scalars['String'];
  emailData: Array<EmailDatum>;
  emailDetailsId: Scalars['Int'];
  emailEvents: Array<EmailEvent>;
  emailHeader: EmailHeader;
  emailHeaderId: Scalars['Int'];
  emailLinks: Array<EmailLink>;
  ipAddress?: Maybe<Scalars['String']>;
  isocode?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  modified: Scalars['DateTime'];
  optOut: Scalars['Boolean'];
  optOutReason?: Maybe<Scalars['String']>;
  processed?: Maybe<Scalars['DateTime']>;
  removed: Scalars['Boolean'];
  rowVersion: Array<Scalars['ByteArray']>;
  sendDuration?: Maybe<Scalars['Decimal']>;
  status: EmailStatus;
  statusId: Scalars['Int'];
  statusInformation?: Maybe<Scalars['String']>;
  uid: Scalars['String'];
  userAgent?: Maybe<Scalars['String']>;
  userCreatedId: Scalars['Int'];
  userModifiedId: Scalars['Int'];
};

export type EmailDetailFilterInput = {
  active?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<EmailDetailFilterInput>>;
  businessLevel?: InputMaybe<BusinessLevelFilterInput>;
  businessLevelId?: InputMaybe<ComparableInt32OperationFilterInput>;
  clicked?: InputMaybe<BooleanOperationFilterInput>;
  created?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  downloaded?: InputMaybe<BooleanOperationFilterInput>;
  emailAddress?: InputMaybe<StringOperationFilterInput>;
  emailData?: InputMaybe<ListFilterInputTypeOfEmailDatumFilterInput>;
  emailDetailsId?: InputMaybe<ComparableInt32OperationFilterInput>;
  emailEvents?: InputMaybe<ListFilterInputTypeOfEmailEventFilterInput>;
  emailHeader?: InputMaybe<EmailHeaderFilterInput>;
  emailHeaderId?: InputMaybe<ComparableInt32OperationFilterInput>;
  emailLinks?: InputMaybe<ListFilterInputTypeOfEmailLinkFilterInput>;
  ipAddress?: InputMaybe<StringOperationFilterInput>;
  isocode?: InputMaybe<StringOperationFilterInput>;
  location?: InputMaybe<StringOperationFilterInput>;
  modified?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  optOut?: InputMaybe<BooleanOperationFilterInput>;
  optOutReason?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<EmailDetailFilterInput>>;
  processed?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  removed?: InputMaybe<BooleanOperationFilterInput>;
  rowVersion?: InputMaybe<ListComparableByteOperationFilterInput>;
  sendDuration?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  status?: InputMaybe<EmailStatusFilterInput>;
  statusId?: InputMaybe<ComparableInt32OperationFilterInput>;
  statusInformation?: InputMaybe<StringOperationFilterInput>;
  uid?: InputMaybe<StringOperationFilterInput>;
  userAgent?: InputMaybe<StringOperationFilterInput>;
  userCreatedId?: InputMaybe<ComparableInt32OperationFilterInput>;
  userModifiedId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type EmailEvent = {
  __typename?: 'EmailEvent';
  emailDetail: EmailDetail;
  emailDetailId: Scalars['Int'];
  emailEventCode: Scalars['Int'];
  emailEventId: Scalars['Int'];
  emailLink?: Maybe<EmailLink>;
  emailLinkId?: Maybe<Scalars['Int']>;
  eventDatetime: Scalars['DateTime'];
};

export type EmailEventFilterInput = {
  and?: InputMaybe<Array<EmailEventFilterInput>>;
  emailDetail?: InputMaybe<EmailDetailFilterInput>;
  emailDetailId?: InputMaybe<ComparableInt32OperationFilterInput>;
  emailEventCode?: InputMaybe<ComparableInt32OperationFilterInput>;
  emailEventId?: InputMaybe<ComparableInt32OperationFilterInput>;
  emailLink?: InputMaybe<EmailLinkFilterInput>;
  emailLinkId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  eventDatetime?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<EmailEventFilterInput>>;
};

export type EmailFilterInput = {
  and?: InputMaybe<Array<EmailFilterInput>>;
  customerEmailSettings?: InputMaybe<ListFilterInputTypeOfCustomerEmailSettingFilterInput>;
  emailAddress?: InputMaybe<StringOperationFilterInput>;
  emailAttachments?: InputMaybe<ListFilterInputTypeOfEmailAttachmentFilterInput>;
  emailId?: InputMaybe<ComparableInt32OperationFilterInput>;
  emailReplaceFields?: InputMaybe<ListFilterInputTypeOfEmailReplaceFieldFilterInput>;
  html?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<EmailFilterInput>>;
  plainText?: InputMaybe<StringOperationFilterInput>;
  subject?: InputMaybe<StringOperationFilterInput>;
};

export type EmailHeader = {
  __typename?: 'EmailHeader';
  active: Scalars['Boolean'];
  approverSecondUserId?: Maybe<Scalars['Int']>;
  approverUserId?: Maybe<Scalars['Int']>;
  campaigns: Array<Campaign>;
  checkPeriodDays?: Maybe<Scalars['Int']>;
  costPerEmail?: Maybe<Scalars['Decimal']>;
  created: Scalars['DateTime'];
  customer?: Maybe<Customer>;
  customerId?: Maybe<Scalars['Int']>;
  emailAttachedFiles: Array<EmailAttachedFile>;
  emailColumns: Array<EmailColumn>;
  emailConnectionType?: Maybe<EmailConnectionType>;
  emailConnectionTypeId?: Maybe<Scalars['Int']>;
  emailDetails: Array<EmailDetail>;
  emailHeaderId: Scalars['Int'];
  emailImageLinks: Array<EmailImageLink>;
  emailOutStarted?: Maybe<Scalars['DateTime']>;
  emailRequestStatusId?: Maybe<Scalars['Int']>;
  fromAddress?: Maybe<Scalars['String']>;
  fromName?: Maybe<Scalars['String']>;
  html?: Maybe<Scalars['String']>;
  isCampaignEmail: Scalars['Boolean'];
  lastCheck?: Maybe<Scalars['DateTime']>;
  modified: Scalars['DateTime'];
  modifiedHtml?: Maybe<Scalars['String']>;
  optoutLink: Scalars['Boolean'];
  orderLine?: Maybe<OrderLineType>;
  orderLineId?: Maybe<Scalars['Int']>;
  removed: Scalars['Boolean'];
  replyTo?: Maybe<Scalars['String']>;
  replyToAddress?: Maybe<Scalars['String']>;
  replyToPassword?: Maybe<Scalars['String']>;
  replyToServer?: Maybe<Scalars['String']>;
  replyToServerPort: Scalars['Int'];
  replyToSslenabled: Scalars['Boolean'];
  replyToUsername?: Maybe<Scalars['String']>;
  rowVersion: Array<Scalars['ByteArray']>;
  smtpPassword?: Maybe<Scalars['String']>;
  smtpPort?: Maybe<Scalars['Int']>;
  smtpServer?: Maybe<Scalars['String']>;
  smtpUsername?: Maybe<Scalars['String']>;
  smtpVerified: Scalars['Boolean'];
  sslEnabled: Scalars['Boolean'];
  subject?: Maybe<Scalars['String']>;
  trackClicks: Scalars['Boolean'];
  trackFaliures: Scalars['Boolean'];
  trackOptOut: Scalars['Boolean'];
  trackViews: Scalars['Boolean'];
  userCreatedId: Scalars['Int'];
  userModifiedId: Scalars['Int'];
  viewInBrowser: Scalars['Boolean'];
};

export type EmailHeaderFilterInput = {
  active?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<EmailHeaderFilterInput>>;
  approverSecondUserId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  approverUserId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  campaigns?: InputMaybe<ListFilterInputTypeOfCampaignFilterInput>;
  checkPeriodDays?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  costPerEmail?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  created?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  customer?: InputMaybe<CustomerFilterInput>;
  customerId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  emailAttachedFiles?: InputMaybe<ListFilterInputTypeOfEmailAttachedFileFilterInput>;
  emailColumns?: InputMaybe<ListFilterInputTypeOfEmailColumnFilterInput>;
  emailConnectionType?: InputMaybe<EmailConnectionTypeFilterInput>;
  emailConnectionTypeId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  emailDetails?: InputMaybe<ListFilterInputTypeOfEmailDetailFilterInput>;
  emailHeaderId?: InputMaybe<ComparableInt32OperationFilterInput>;
  emailImageLinks?: InputMaybe<ListFilterInputTypeOfEmailImageLinkFilterInput>;
  emailOutStarted?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  emailRequestStatusId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  fromAddress?: InputMaybe<StringOperationFilterInput>;
  fromName?: InputMaybe<StringOperationFilterInput>;
  html?: InputMaybe<StringOperationFilterInput>;
  isCampaignEmail?: InputMaybe<BooleanOperationFilterInput>;
  lastCheck?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  modified?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  modifiedHtml?: InputMaybe<StringOperationFilterInput>;
  optoutLink?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<EmailHeaderFilterInput>>;
  orderLine?: InputMaybe<OrderLineFilterInput>;
  orderLineId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  removed?: InputMaybe<BooleanOperationFilterInput>;
  replyTo?: InputMaybe<StringOperationFilterInput>;
  replyToAddress?: InputMaybe<StringOperationFilterInput>;
  replyToPassword?: InputMaybe<StringOperationFilterInput>;
  replyToServer?: InputMaybe<StringOperationFilterInput>;
  replyToServerPort?: InputMaybe<ComparableInt32OperationFilterInput>;
  replyToSslenabled?: InputMaybe<BooleanOperationFilterInput>;
  replyToUsername?: InputMaybe<StringOperationFilterInput>;
  rowVersion?: InputMaybe<ListComparableByteOperationFilterInput>;
  smtpPassword?: InputMaybe<StringOperationFilterInput>;
  smtpPort?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  smtpServer?: InputMaybe<StringOperationFilterInput>;
  smtpUsername?: InputMaybe<StringOperationFilterInput>;
  smtpVerified?: InputMaybe<BooleanOperationFilterInput>;
  sslEnabled?: InputMaybe<BooleanOperationFilterInput>;
  subject?: InputMaybe<StringOperationFilterInput>;
  trackClicks?: InputMaybe<BooleanOperationFilterInput>;
  trackFaliures?: InputMaybe<BooleanOperationFilterInput>;
  trackOptOut?: InputMaybe<BooleanOperationFilterInput>;
  trackViews?: InputMaybe<BooleanOperationFilterInput>;
  userCreatedId?: InputMaybe<ComparableInt32OperationFilterInput>;
  userModifiedId?: InputMaybe<ComparableInt32OperationFilterInput>;
  viewInBrowser?: InputMaybe<BooleanOperationFilterInput>;
};

export type EmailImageLink = {
  __typename?: 'EmailImageLink';
  active: Scalars['Boolean'];
  created: Scalars['DateTime'];
  emailHeader: EmailHeader;
  emailHeaderId: Scalars['Int'];
  emailImageLinksId: Scalars['Int'];
  modified: Scalars['DateTime'];
  orginalPath: Scalars['String'];
  removed: Scalars['Boolean'];
  rowVersion: Array<Scalars['ByteArray']>;
  uploadedFile: UploadedFile;
  uploadedFileId: Scalars['Int'];
  userCreatedId: Scalars['Int'];
  userModifiedId: Scalars['Int'];
};

export type EmailImageLinkFilterInput = {
  active?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<EmailImageLinkFilterInput>>;
  created?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  emailHeader?: InputMaybe<EmailHeaderFilterInput>;
  emailHeaderId?: InputMaybe<ComparableInt32OperationFilterInput>;
  emailImageLinksId?: InputMaybe<ComparableInt32OperationFilterInput>;
  modified?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<EmailImageLinkFilterInput>>;
  orginalPath?: InputMaybe<StringOperationFilterInput>;
  removed?: InputMaybe<BooleanOperationFilterInput>;
  rowVersion?: InputMaybe<ListComparableByteOperationFilterInput>;
  uploadedFile?: InputMaybe<UploadedFileFilterInput>;
  uploadedFileId?: InputMaybe<ComparableInt32OperationFilterInput>;
  userCreatedId?: InputMaybe<ComparableInt32OperationFilterInput>;
  userModifiedId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type EmailLink = {
  __typename?: 'EmailLink';
  active: Scalars['Boolean'];
  clicked: Scalars['Int'];
  created: Scalars['DateTime'];
  emailDetails: EmailDetail;
  emailDetailsId: Scalars['Int'];
  emailEvents: Array<EmailEvent>;
  emailLinksId: Scalars['Int'];
  modified: Scalars['DateTime'];
  orginalLink: Scalars['String'];
  removed: Scalars['Boolean'];
  rowversion: Array<Scalars['ByteArray']>;
  uid: Scalars['String'];
  userCreatedId: Scalars['Int'];
  userModifiedId: Scalars['Int'];
  wnId?: Maybe<Scalars['Int']>;
};

export type EmailLinkFilterInput = {
  active?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<EmailLinkFilterInput>>;
  clicked?: InputMaybe<ComparableInt32OperationFilterInput>;
  created?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  emailDetails?: InputMaybe<EmailDetailFilterInput>;
  emailDetailsId?: InputMaybe<ComparableInt32OperationFilterInput>;
  emailEvents?: InputMaybe<ListFilterInputTypeOfEmailEventFilterInput>;
  emailLinksId?: InputMaybe<ComparableInt32OperationFilterInput>;
  modified?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<EmailLinkFilterInput>>;
  orginalLink?: InputMaybe<StringOperationFilterInput>;
  removed?: InputMaybe<BooleanOperationFilterInput>;
  rowversion?: InputMaybe<ListComparableByteOperationFilterInput>;
  uid?: InputMaybe<StringOperationFilterInput>;
  userCreatedId?: InputMaybe<ComparableInt32OperationFilterInput>;
  userModifiedId?: InputMaybe<ComparableInt32OperationFilterInput>;
  wnId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
};

export type EmailReplaceField = {
  __typename?: 'EmailReplaceField';
  email: Email;
  emailId: Scalars['Int'];
  emailReplaceId: Scalars['Int'];
  helpText?: Maybe<Scalars['String']>;
  replaceField: Scalars['String'];
};

export type EmailReplaceFieldFilterInput = {
  and?: InputMaybe<Array<EmailReplaceFieldFilterInput>>;
  email?: InputMaybe<EmailFilterInput>;
  emailId?: InputMaybe<ComparableInt32OperationFilterInput>;
  emailReplaceId?: InputMaybe<ComparableInt32OperationFilterInput>;
  helpText?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<EmailReplaceFieldFilterInput>>;
  replaceField?: InputMaybe<StringOperationFilterInput>;
};

export type EmailStatus = {
  __typename?: 'EmailStatus';
  emailDetails: Array<EmailDetail>;
  emailStatusId: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
};

export type EmailStatusFilterInput = {
  and?: InputMaybe<Array<EmailStatusFilterInput>>;
  emailDetails?: InputMaybe<ListFilterInputTypeOfEmailDetailFilterInput>;
  emailStatusId?: InputMaybe<ComparableInt32OperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<EmailStatusFilterInput>>;
};

export type EmailTemplate = {
  __typename?: 'EmailTemplate';
  active: Scalars['Boolean'];
  businessLevel: BusinessLevel;
  businessLevelId: Scalars['Int'];
  campaigns: Array<Campaign>;
  created: Scalars['DateTime'];
  customer: Customer;
  customerId: Scalars['Int'];
  emailTemplateId: Scalars['Int'];
  mjml?: Maybe<Scalars['String']>;
  modified: Scalars['DateTime'];
  name: Scalars['String'];
  previewFile?: Maybe<UploadedFile>;
  previewFileId?: Maybe<Scalars['Int']>;
  rawHtml?: Maybe<Scalars['String']>;
  removed: Scalars['Boolean'];
  rowVersion: Array<Scalars['ByteArray']>;
  subject?: Maybe<Scalars['String']>;
  userCreated: UserType;
  userCreatedId: Scalars['Int'];
  userModified: UserType;
  userModifiedId: Scalars['Int'];
  visibilitySetting: Scalars['Int'];
};

export type EmailTemplateFilterInput = {
  active?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<EmailTemplateFilterInput>>;
  businessLevel?: InputMaybe<BusinessLevelFilterInput>;
  businessLevelId?: InputMaybe<ComparableInt32OperationFilterInput>;
  campaigns?: InputMaybe<ListFilterInputTypeOfCampaignFilterInput>;
  created?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  customer?: InputMaybe<CustomerFilterInput>;
  customerId?: InputMaybe<ComparableInt32OperationFilterInput>;
  emailTemplateId?: InputMaybe<ComparableInt32OperationFilterInput>;
  mjml?: InputMaybe<StringOperationFilterInput>;
  modified?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<EmailTemplateFilterInput>>;
  previewFile?: InputMaybe<UploadedFileFilterInput>;
  previewFileId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  rawHtml?: InputMaybe<StringOperationFilterInput>;
  removed?: InputMaybe<BooleanOperationFilterInput>;
  rowVersion?: InputMaybe<ListComparableByteOperationFilterInput>;
  subject?: InputMaybe<StringOperationFilterInput>;
  userCreated?: InputMaybe<UserDetailFilterInput>;
  userCreatedId?: InputMaybe<ComparableInt32OperationFilterInput>;
  userModified?: InputMaybe<UserDetailFilterInput>;
  userModifiedId?: InputMaybe<ComparableInt32OperationFilterInput>;
  visibilitySetting?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type EmailType = {
  __typename?: 'EmailType';
  customerEmailSettings: Array<CustomerEmailSetting>;
  emailTypeId: Scalars['Int'];
  name: Scalars['String'];
};

export type EmailTypeFilterInput = {
  and?: InputMaybe<Array<EmailTypeFilterInput>>;
  customerEmailSettings?: InputMaybe<ListFilterInputTypeOfCustomerEmailSettingFilterInput>;
  emailTypeId?: InputMaybe<ComparableInt32OperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<EmailTypeFilterInput>>;
};

export type Etemplate = {
  __typename?: 'Etemplate';
  active: Scalars['Boolean'];
  approved?: Maybe<Scalars['Boolean']>;
  artworkOnly: Scalars['Boolean'];
  attentionTo?: Maybe<Scalars['String']>;
  campaigns: Array<Campaign>;
  created: Scalars['DateTime'];
  emailFull: Scalars['String'];
  emailProof: Scalars['String'];
  etemplateId: Scalars['Int'];
  etemplateImageLines: Array<EtemplateImageLine>;
  etemplateObjectStyles: Array<EtemplateObjectStyle>;
  etemplateRestApirequests: Array<EtemplateRestApirequest>;
  etemplateTextLines: Array<EtemplateTextLine>;
  etemplateTextRecords: Array<EtemplateTextRecord>;
  exportFileType?: Maybe<Scalars['String']>;
  fullEmailSent: Scalars['Boolean'];
  fullGenerated: Scalars['Boolean'];
  generateMessage?: Maybe<Scalars['String']>;
  inDesignArtworkOnlyPrintPreset?: Maybe<Scalars['String']>;
  inDesignPrintPreset: Scalars['String'];
  inDesignProofPreset: Scalars['String'];
  inDesignWebPreset?: Maybe<Scalars['String']>;
  largeArtwork?: Maybe<Scalars['Boolean']>;
  masterFile: Scalars['String'];
  modified: Scalars['DateTime'];
  name?: Maybe<Scalars['String']>;
  orderLines: Array<OrderLineType>;
  productAttribEtemplate: ProductAttribEtemplate;
  productAttribEtemplateId: Scalars['Int'];
  proofEmailSent: Scalars['Boolean'];
  proofGenerated: Scalars['Boolean'];
  purgeDate?: Maybe<Scalars['DateTime']>;
  rawJsonData?: Maybe<Scalars['String']>;
  reOrderable: Scalars['Boolean'];
  removed: Scalars['Boolean'];
  stopUsingJson?: Maybe<Scalars['Boolean']>;
  useNamedTags: Scalars['Boolean'];
  userCreatedId: Scalars['Int'];
  userModifiedId: Scalars['Int'];
};

export type EtemplateDataBusinessLevelMap = {
  __typename?: 'EtemplateDataBusinessLevelMap';
  businessLevel: BusinessLevel;
  businessLevelId: Scalars['Int'];
  etemplateData: EtemplateDatum;
  etemplateDataId: Scalars['Int'];
  mapId: Scalars['Int'];
};

export type EtemplateDataBusinessLevelMapFilterInput = {
  and?: InputMaybe<Array<EtemplateDataBusinessLevelMapFilterInput>>;
  businessLevel?: InputMaybe<BusinessLevelFilterInput>;
  businessLevelId?: InputMaybe<ComparableInt32OperationFilterInput>;
  etemplateData?: InputMaybe<EtemplateDatumFilterInput>;
  etemplateDataId?: InputMaybe<ComparableInt32OperationFilterInput>;
  mapId?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<EtemplateDataBusinessLevelMapFilterInput>>;
};

export type EtemplateDataType = {
  __typename?: 'EtemplateDataType';
  customerId?: Maybe<Scalars['Int']>;
  etemplateData: Array<EtemplateDatum>;
  isAdminOnly: Scalars['Boolean'];
  name: Scalars['String'];
  typeId: Scalars['Int'];
};

export type EtemplateDataTypeFilterInput = {
  and?: InputMaybe<Array<EtemplateDataTypeFilterInput>>;
  customerId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  etemplateData?: InputMaybe<ListFilterInputTypeOfEtemplateDatumFilterInput>;
  isAdminOnly?: InputMaybe<BooleanOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<EtemplateDataTypeFilterInput>>;
  typeId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type EtemplateDatum = {
  __typename?: 'EtemplateDatum';
  active: Scalars['Boolean'];
  category?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  created: Scalars['DateTime'];
  customer: Customer;
  customerId: Scalars['Int'];
  dataText1?: Maybe<Scalars['String']>;
  etemplateDataBusinessLevelMaps: Array<EtemplateDataBusinessLevelMap>;
  etemplateDataId: Scalars['Int'];
  filterByBusinessLevel: Scalars['Boolean'];
  height?: Maybe<Scalars['Int']>;
  inverseParent: Array<EtemplateDatum>;
  isImageData: Scalars['Boolean'];
  modified: Scalars['DateTime'];
  name: Scalars['String'];
  overRideProportionally: Scalars['Boolean'];
  parent?: Maybe<EtemplateDatum>;
  parentId?: Maybe<Scalars['Int']>;
  rating?: Maybe<Scalars['Decimal']>;
  rowVersion: Array<Scalars['ByteArray']>;
  templateImagePath?: Maybe<Scalars['String']>;
  /** if this is a drop down type, display a textbox after selecting it. */
  textBoxAfter: Scalars['Boolean'];
  type: EtemplateDataType;
  typeId: Scalars['Int'];
  uploadedFile?: Maybe<UploadedFile>;
  uploadedFileId?: Maybe<Scalars['Int']>;
  userCreatedId: Scalars['Int'];
  userModifiedId: Scalars['Int'];
  webImagePath?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Int']>;
  xDpi?: Maybe<Scalars['Int']>;
  yDpi?: Maybe<Scalars['Int']>;
};

export type EtemplateDatumFilterInput = {
  active?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<EtemplateDatumFilterInput>>;
  category?: InputMaybe<StringOperationFilterInput>;
  comment?: InputMaybe<StringOperationFilterInput>;
  created?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  customer?: InputMaybe<CustomerFilterInput>;
  customerId?: InputMaybe<ComparableInt32OperationFilterInput>;
  dataText1?: InputMaybe<StringOperationFilterInput>;
  etemplateDataBusinessLevelMaps?: InputMaybe<ListFilterInputTypeOfEtemplateDataBusinessLevelMapFilterInput>;
  etemplateDataId?: InputMaybe<ComparableInt32OperationFilterInput>;
  filterByBusinessLevel?: InputMaybe<BooleanOperationFilterInput>;
  height?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  inverseParent?: InputMaybe<ListFilterInputTypeOfEtemplateDatumFilterInput>;
  isImageData?: InputMaybe<BooleanOperationFilterInput>;
  modified?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<EtemplateDatumFilterInput>>;
  overRideProportionally?: InputMaybe<BooleanOperationFilterInput>;
  parent?: InputMaybe<EtemplateDatumFilterInput>;
  parentId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  rating?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  rowVersion?: InputMaybe<ListComparableByteOperationFilterInput>;
  templateImagePath?: InputMaybe<StringOperationFilterInput>;
  /** if this is a drop down type, display a textbox after selecting it. */
  textBoxAfter?: InputMaybe<BooleanOperationFilterInput>;
  type?: InputMaybe<EtemplateDataTypeFilterInput>;
  typeId?: InputMaybe<ComparableInt32OperationFilterInput>;
  uploadedFile?: InputMaybe<UploadedFileFilterInput>;
  uploadedFileId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  userCreatedId?: InputMaybe<ComparableInt32OperationFilterInput>;
  userModifiedId?: InputMaybe<ComparableInt32OperationFilterInput>;
  webImagePath?: InputMaybe<StringOperationFilterInput>;
  width?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  xDpi?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  yDpi?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
};

export type EtemplateFilterInput = {
  active?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<EtemplateFilterInput>>;
  approved?: InputMaybe<BooleanOperationFilterInput>;
  artworkOnly?: InputMaybe<BooleanOperationFilterInput>;
  attentionTo?: InputMaybe<StringOperationFilterInput>;
  campaigns?: InputMaybe<ListFilterInputTypeOfCampaignFilterInput>;
  created?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  emailFull?: InputMaybe<StringOperationFilterInput>;
  emailProof?: InputMaybe<StringOperationFilterInput>;
  etemplateId?: InputMaybe<ComparableInt32OperationFilterInput>;
  etemplateImageLines?: InputMaybe<ListFilterInputTypeOfEtemplateImageLineFilterInput>;
  etemplateObjectStyles?: InputMaybe<ListFilterInputTypeOfEtemplateObjectStyleFilterInput>;
  etemplateRestApirequests?: InputMaybe<ListFilterInputTypeOfEtemplateRestApirequestFilterInput>;
  etemplateTextLines?: InputMaybe<ListFilterInputTypeOfEtemplateTextLineFilterInput>;
  etemplateTextRecords?: InputMaybe<ListFilterInputTypeOfEtemplateTextRecordFilterInput>;
  exportFileType?: InputMaybe<StringOperationFilterInput>;
  fullEmailSent?: InputMaybe<BooleanOperationFilterInput>;
  fullGenerated?: InputMaybe<BooleanOperationFilterInput>;
  generateMessage?: InputMaybe<StringOperationFilterInput>;
  inDesignArtworkOnlyPrintPreset?: InputMaybe<StringOperationFilterInput>;
  inDesignPrintPreset?: InputMaybe<StringOperationFilterInput>;
  inDesignProofPreset?: InputMaybe<StringOperationFilterInput>;
  inDesignWebPreset?: InputMaybe<StringOperationFilterInput>;
  largeArtwork?: InputMaybe<BooleanOperationFilterInput>;
  masterFile?: InputMaybe<StringOperationFilterInput>;
  modified?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<EtemplateFilterInput>>;
  orderLines?: InputMaybe<ListFilterInputTypeOfOrderLineFilterInput>;
  productAttribEtemplate?: InputMaybe<ProductAttribEtemplateFilterInput>;
  productAttribEtemplateId?: InputMaybe<ComparableInt32OperationFilterInput>;
  proofEmailSent?: InputMaybe<BooleanOperationFilterInput>;
  proofGenerated?: InputMaybe<BooleanOperationFilterInput>;
  purgeDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  rawJsonData?: InputMaybe<StringOperationFilterInput>;
  reOrderable?: InputMaybe<BooleanOperationFilterInput>;
  removed?: InputMaybe<BooleanOperationFilterInput>;
  stopUsingJson?: InputMaybe<BooleanOperationFilterInput>;
  useNamedTags?: InputMaybe<BooleanOperationFilterInput>;
  userCreatedId?: InputMaybe<ComparableInt32OperationFilterInput>;
  userModifiedId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type EtemplateImageLine = {
  __typename?: 'EtemplateImageLine';
  etemplate: Etemplate;
  etemplateDataId?: Maybe<Scalars['Int']>;
  etemplateId: Scalars['Int'];
  etemplateImageLineId: Scalars['Int'];
  height?: Maybe<Scalars['Float']>;
  hideFromPrintPdf: Scalars['Boolean'];
  id?: Maybe<Scalars['String']>;
  imagePath?: Maybe<Scalars['String']>;
  makeCrop?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  numberOfPreviousNulls: Scalars['Int'];
  objectStyleName?: Maybe<Scalars['String']>;
  offsetx?: Maybe<Scalars['String']>;
  offsety?: Maybe<Scalars['String']>;
  overRideProportionally: Scalars['Boolean'];
  sortOrder?: Maybe<Scalars['Int']>;
  src?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  useDataBaseImage: Scalars['Boolean'];
  width?: Maybe<Scalars['Float']>;
  x1?: Maybe<Scalars['Float']>;
  x2?: Maybe<Scalars['Float']>;
  y1?: Maybe<Scalars['Float']>;
  y2?: Maybe<Scalars['Float']>;
};

export type EtemplateImageLineFilterInput = {
  and?: InputMaybe<Array<EtemplateImageLineFilterInput>>;
  etemplate?: InputMaybe<EtemplateFilterInput>;
  etemplateDataId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  etemplateId?: InputMaybe<ComparableInt32OperationFilterInput>;
  etemplateImageLineId?: InputMaybe<ComparableInt32OperationFilterInput>;
  height?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  hideFromPrintPdf?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  imagePath?: InputMaybe<StringOperationFilterInput>;
  makeCrop?: InputMaybe<BooleanOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  numberOfPreviousNulls?: InputMaybe<ComparableInt32OperationFilterInput>;
  objectStyleName?: InputMaybe<StringOperationFilterInput>;
  offsetx?: InputMaybe<StringOperationFilterInput>;
  offsety?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<EtemplateImageLineFilterInput>>;
  overRideProportionally?: InputMaybe<BooleanOperationFilterInput>;
  sortOrder?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  src?: InputMaybe<StringOperationFilterInput>;
  type?: InputMaybe<StringOperationFilterInput>;
  url?: InputMaybe<StringOperationFilterInput>;
  useDataBaseImage?: InputMaybe<BooleanOperationFilterInput>;
  width?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  x1?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  x2?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  y1?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  y2?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
};

export type EtemplateObjectStyle = {
  __typename?: 'EtemplateObjectStyle';
  etemplate: Etemplate;
  etemplateDataId?: Maybe<Scalars['Int']>;
  etemplateId: Scalars['Int'];
  etemplateObjectStyleId: Scalars['Int'];
  fillColor: Scalars['String'];
  inddObjectName: Scalars['String'];
};

export type EtemplateObjectStyleFilterInput = {
  and?: InputMaybe<Array<EtemplateObjectStyleFilterInput>>;
  etemplate?: InputMaybe<EtemplateFilterInput>;
  etemplateDataId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  etemplateId?: InputMaybe<ComparableInt32OperationFilterInput>;
  etemplateObjectStyleId?: InputMaybe<ComparableInt32OperationFilterInput>;
  fillColor?: InputMaybe<StringOperationFilterInput>;
  inddObjectName?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<EtemplateObjectStyleFilterInput>>;
};

export type EtemplateRestApirequest = {
  __typename?: 'EtemplateRestApirequest';
  etemplate: Etemplate;
  etemplateId: Scalars['Int'];
  etemplateRestApirequestId: Scalars['Int'];
  removed: Scalars['Boolean'];
  serialisedDescriptor?: Maybe<Array<Scalars['ByteArray']>>;
  status: Scalars['Int'];
  token: Scalars['String'];
  user: UserType;
  userId: Scalars['Int'];
};

export type EtemplateRestApirequestFilterInput = {
  and?: InputMaybe<Array<EtemplateRestApirequestFilterInput>>;
  etemplate?: InputMaybe<EtemplateFilterInput>;
  etemplateId?: InputMaybe<ComparableInt32OperationFilterInput>;
  etemplateRestApirequestId?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<EtemplateRestApirequestFilterInput>>;
  removed?: InputMaybe<BooleanOperationFilterInput>;
  serialisedDescriptor?: InputMaybe<ListComparableByteOperationFilterInput>;
  status?: InputMaybe<ComparableInt32OperationFilterInput>;
  token?: InputMaybe<StringOperationFilterInput>;
  user?: InputMaybe<UserDetailFilterInput>;
  userId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type EtemplateTextLine = {
  __typename?: 'EtemplateTextLine';
  changeTemplateFieldBefore: Scalars['Boolean'];
  etemplate: Etemplate;
  etemplateDataId?: Maybe<Scalars['Int']>;
  etemplateId: Scalars['Int'];
  etemplateTextLineId: Scalars['Int'];
  name: Scalars['String'];
  valueBool?: Maybe<Scalars['Boolean']>;
  valueDate?: Maybe<Scalars['DateTime']>;
  valueDecimal?: Maybe<Scalars['Decimal']>;
  valueInt?: Maybe<Scalars['Int']>;
  valueText?: Maybe<Scalars['String']>;
};

export type EtemplateTextLineFilterInput = {
  and?: InputMaybe<Array<EtemplateTextLineFilterInput>>;
  changeTemplateFieldBefore?: InputMaybe<BooleanOperationFilterInput>;
  etemplate?: InputMaybe<EtemplateFilterInput>;
  etemplateDataId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  etemplateId?: InputMaybe<ComparableInt32OperationFilterInput>;
  etemplateTextLineId?: InputMaybe<ComparableInt32OperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<EtemplateTextLineFilterInput>>;
  valueBool?: InputMaybe<BooleanOperationFilterInput>;
  valueDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  valueDecimal?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  valueInt?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  valueText?: InputMaybe<StringOperationFilterInput>;
};

export type EtemplateTextRecord = {
  __typename?: 'EtemplateTextRecord';
  align?: Maybe<Scalars['Int']>;
  autofit?: Maybe<Scalars['Boolean']>;
  bold?: Maybe<Scalars['Boolean']>;
  color?: Maybe<Scalars['String']>;
  defaultValue?: Maybe<Scalars['String']>;
  enablealign?: Maybe<Scalars['Boolean']>;
  enableautofit?: Maybe<Scalars['Boolean']>;
  enablecolor?: Maybe<Scalars['Boolean']>;
  enablefont?: Maybe<Scalars['Boolean']>;
  enablesize?: Maybe<Scalars['Boolean']>;
  enablestyle?: Maybe<Scalars['Boolean']>;
  etemplate: Etemplate;
  etemplateDataId?: Maybe<Scalars['Int']>;
  etemplateId: Scalars['Int'];
  etemplateTextRecordId: Scalars['Int'];
  font?: Maybe<Scalars['String']>;
  fontsize?: Maybe<Scalars['Float']>;
  group?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  innDfield?: Maybe<Scalars['String']>;
  isChangeTemplate?: Maybe<Scalars['Boolean']>;
  italic?: Maybe<Scalars['Boolean']>;
  orderLineNamingContainer?: Maybe<Scalars['String']>;
  plaintext?: Maybe<Scalars['Boolean']>;
  prefix?: Maybe<Scalars['String']>;
  separator?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['Int']>;
  text: Scalars['String'];
  type: Scalars['String'];
  underline?: Maybe<Scalars['Boolean']>;
};

export type EtemplateTextRecordFilterInput = {
  align?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<EtemplateTextRecordFilterInput>>;
  autofit?: InputMaybe<BooleanOperationFilterInput>;
  bold?: InputMaybe<BooleanOperationFilterInput>;
  color?: InputMaybe<StringOperationFilterInput>;
  defaultValue?: InputMaybe<StringOperationFilterInput>;
  enablealign?: InputMaybe<BooleanOperationFilterInput>;
  enableautofit?: InputMaybe<BooleanOperationFilterInput>;
  enablecolor?: InputMaybe<BooleanOperationFilterInput>;
  enablefont?: InputMaybe<BooleanOperationFilterInput>;
  enablesize?: InputMaybe<BooleanOperationFilterInput>;
  enablestyle?: InputMaybe<BooleanOperationFilterInput>;
  etemplate?: InputMaybe<EtemplateFilterInput>;
  etemplateDataId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  etemplateId?: InputMaybe<ComparableInt32OperationFilterInput>;
  etemplateTextRecordId?: InputMaybe<ComparableInt32OperationFilterInput>;
  font?: InputMaybe<StringOperationFilterInput>;
  fontsize?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  group?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  innDfield?: InputMaybe<StringOperationFilterInput>;
  isChangeTemplate?: InputMaybe<BooleanOperationFilterInput>;
  italic?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<EtemplateTextRecordFilterInput>>;
  orderLineNamingContainer?: InputMaybe<StringOperationFilterInput>;
  plaintext?: InputMaybe<BooleanOperationFilterInput>;
  prefix?: InputMaybe<StringOperationFilterInput>;
  separator?: InputMaybe<StringOperationFilterInput>;
  sortOrder?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  text?: InputMaybe<StringOperationFilterInput>;
  type?: InputMaybe<StringOperationFilterInput>;
  underline?: InputMaybe<BooleanOperationFilterInput>;
};

export type EWayTransactionInput = {
  /** Optional variables */
  company?: InputMaybe<Scalars['String']>;
  street2?: InputMaybe<Scalars['String']>;
  mobile?: InputMaybe<Scalars['String']>;
  /** The Order Shipping ID */
  orderId: Scalars['Int'];
  orderShipId: Scalars['Int'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  email: Scalars['String'];
  street1: Scalars['String'];
  suburb: Scalars['String'];
  state: Scalars['String'];
  postcode: Scalars['String'];
  country: Scalars['String'];
  phone: Scalars['String'];
  totalAmount: Scalars['Int'];
};

export type FaqFilterInput = {
  active?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<FaqFilterInput>>;
  created?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  customer?: InputMaybe<CustomerFilterInput>;
  customerId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  defaultQuestion?: InputMaybe<BooleanOperationFilterInput>;
  fAnswer?: InputMaybe<StringOperationFilterInput>;
  fQuestion?: InputMaybe<StringOperationFilterInput>;
  faqId?: InputMaybe<ComparableInt32OperationFilterInput>;
  modified?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<FaqFilterInput>>;
  purgeDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  removed?: InputMaybe<BooleanOperationFilterInput>;
  roleId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  rowVersion?: InputMaybe<ListComparableByteOperationFilterInput>;
  sortOrder?: InputMaybe<ComparableInt32OperationFilterInput>;
  userCreatedId?: InputMaybe<ComparableInt32OperationFilterInput>;
  userModifiedId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

/** Represents a Frequently Asked Question. */
export type FaqType = {
  __typename?: 'FaqType';
  active: Scalars['Boolean'];
  created: Scalars['DateTime'];
  customer?: Maybe<Customer>;
  customerId?: Maybe<Scalars['Int']>;
  defaultQuestion: Scalars['Boolean'];
  /** Represents the Answer. */
  fAnswer: Scalars['String'];
  fQuestion: Scalars['String'];
  faqId: Scalars['Int'];
  modified: Scalars['DateTime'];
  purgeDate?: Maybe<Scalars['DateTime']>;
  removed?: Maybe<Scalars['Boolean']>;
  roleId?: Maybe<Scalars['Int']>;
  rowVersion: Array<Scalars['ByteArray']>;
  sortOrder: Scalars['Int'];
  userCreatedId: Scalars['Int'];
  userModifiedId: Scalars['Int'];
};

/** Represents a favorite entry */
export type Favorite = {
  __typename?: 'Favorite';
  /** Represents the favorite entry's creation DateTime */
  created?: Maybe<Scalars['DateTime']>;
  /** Represents the customer ID which the favorite record belongs to */
  customerId: Scalars['Int'];
  /** Represents the favorite entry's unique Object ID */
  id?: Maybe<Scalars['String']>;
  /** Represents the favorite entry's last modified DateTime */
  modified?: Maybe<Scalars['DateTime']>;
  /** Represents the user's list of favorite products */
  products: Array<FavoriteProductEntry>;
  /** Represents the user's ID which the favorite record belongs to */
  userId: Scalars['Int'];
};

export type FavoriteProductEntry = {
  __typename?: 'FavoriteProductEntry';
  /** Represents the Product Entity pertaining to this Favorite Product Entry */
  product?: Maybe<ProductType>;
  /** Represents the Product ID pertaining to this Favorite Product Entry */
  productId: Scalars['Int'];
};

export type FavoriteProductEntryInput = {
  /** Represents the Product ID pertaining to this Favorite Product Entry */
  productId: Scalars['Int'];
};

export type FilterInput = {
  column: Scalars['String'];
  value: Scalars['String'];
};

export type Fonts = {
  __typename?: 'Fonts';
  body: Scalars['String'];
  navigationAndHeading: Scalars['String'];
};

export type FontsUpdatesInput = {
  body?: InputMaybe<Scalars['String']>;
  navigationAndHeading?: InputMaybe<Scalars['String']>;
};

export type Footer = {
  __typename?: 'Footer';
  background: Scalars['String'];
  button: Scalars['String'];
  buttonHover: Scalars['String'];
  buttonText: Scalars['String'];
  text: Scalars['String'];
};

export type FooterUpdatesInput = {
  background?: InputMaybe<Scalars['String']>;
  button?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
};

export type FordDepartment = {
  __typename?: 'FordDepartment';
  fordDepartmentId: Scalars['Int'];
  fordTransactions: Array<FordTransaction>;
  fordTransactionsRctis: Array<FordTransactionsRcti>;
  name: Scalars['String'];
};

export type FordDepartmentFilterInput = {
  and?: InputMaybe<Array<FordDepartmentFilterInput>>;
  fordDepartmentId?: InputMaybe<ComparableInt32OperationFilterInput>;
  fordTransactions?: InputMaybe<ListFilterInputTypeOfFordTransactionFilterInput>;
  fordTransactionsRctis?: InputMaybe<ListFilterInputTypeOfFordTransactionsRctiFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<FordDepartmentFilterInput>>;
};

export type FordTransaction = {
  __typename?: 'FordTransaction';
  businessLevel: BusinessLevel;
  businessLevelId: Scalars['Int'];
  creditType?: Maybe<Scalars['String']>;
  date: Scalars['DateTime'];
  dealerCode: Scalars['String'];
  fordDepartment: FordDepartment;
  fordDepartmentId: Scalars['Int'];
  gsdb?: Maybe<Scalars['String']>;
  gst: Scalars['Decimal'];
  id: Scalars['Int'];
  itemCode?: Maybe<Scalars['String']>;
  itemDescription: Scalars['String'];
  priceExGst: Scalars['Decimal'];
  rowVersion: Array<Scalars['ByteArray']>;
  sendDate?: Maybe<Scalars['DateTime']>;
  total: Scalars['Decimal'];
  upload: FordUpload;
  uploadId: Scalars['Int'];
};

export type FordTransactionFilterInput = {
  and?: InputMaybe<Array<FordTransactionFilterInput>>;
  businessLevel?: InputMaybe<BusinessLevelFilterInput>;
  businessLevelId?: InputMaybe<ComparableInt32OperationFilterInput>;
  creditType?: InputMaybe<StringOperationFilterInput>;
  date?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  dealerCode?: InputMaybe<StringOperationFilterInput>;
  fordDepartment?: InputMaybe<FordDepartmentFilterInput>;
  fordDepartmentId?: InputMaybe<ComparableInt32OperationFilterInput>;
  gsdb?: InputMaybe<StringOperationFilterInput>;
  gst?: InputMaybe<ComparableDecimalOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  itemCode?: InputMaybe<StringOperationFilterInput>;
  itemDescription?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<FordTransactionFilterInput>>;
  priceExGst?: InputMaybe<ComparableDecimalOperationFilterInput>;
  rowVersion?: InputMaybe<ListComparableByteOperationFilterInput>;
  sendDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  total?: InputMaybe<ComparableDecimalOperationFilterInput>;
  upload?: InputMaybe<FordUploadFilterInput>;
  uploadId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type FordTransactionsRcti = {
  __typename?: 'FordTransactionsRcti';
  businessLevel: BusinessLevel;
  businessLevelId: Scalars['Int'];
  creditType?: Maybe<Scalars['String']>;
  date: Scalars['DateTime'];
  dealerCode: Scalars['String'];
  fordDepartment: FordDepartment;
  fordDepartmentId: Scalars['Int'];
  gsdb?: Maybe<Scalars['String']>;
  gst: Scalars['Decimal'];
  id: Scalars['Int'];
  itemCode?: Maybe<Scalars['String']>;
  itemDescription: Scalars['String'];
  priceExGst: Scalars['Decimal'];
  rowVersion: Array<Scalars['ByteArray']>;
  sendDate?: Maybe<Scalars['DateTime']>;
  total: Scalars['Decimal'];
  upload: FordUpload;
  uploadId: Scalars['Int'];
};

export type FordTransactionsRctiFilterInput = {
  and?: InputMaybe<Array<FordTransactionsRctiFilterInput>>;
  businessLevel?: InputMaybe<BusinessLevelFilterInput>;
  businessLevelId?: InputMaybe<ComparableInt32OperationFilterInput>;
  creditType?: InputMaybe<StringOperationFilterInput>;
  date?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  dealerCode?: InputMaybe<StringOperationFilterInput>;
  fordDepartment?: InputMaybe<FordDepartmentFilterInput>;
  fordDepartmentId?: InputMaybe<ComparableInt32OperationFilterInput>;
  gsdb?: InputMaybe<StringOperationFilterInput>;
  gst?: InputMaybe<ComparableDecimalOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  itemCode?: InputMaybe<StringOperationFilterInput>;
  itemDescription?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<FordTransactionsRctiFilterInput>>;
  priceExGst?: InputMaybe<ComparableDecimalOperationFilterInput>;
  rowVersion?: InputMaybe<ListComparableByteOperationFilterInput>;
  sendDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  total?: InputMaybe<ComparableDecimalOperationFilterInput>;
  upload?: InputMaybe<FordUploadFilterInput>;
  uploadId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type FordUpload = {
  __typename?: 'FordUpload';
  code: Scalars['String'];
  created: Scalars['DateTime'];
  description: Scalars['String'];
  fordTransactions: Array<FordTransaction>;
  fordTransactionsRctis: Array<FordTransactionsRcti>;
  name: Scalars['String'];
  uploadId: Scalars['Int'];
  userCreatedId: Scalars['Int'];
};

export type FordUploadFilterInput = {
  and?: InputMaybe<Array<FordUploadFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  created?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  fordTransactions?: InputMaybe<ListFilterInputTypeOfFordTransactionFilterInput>;
  fordTransactionsRctis?: InputMaybe<ListFilterInputTypeOfFordTransactionsRctiFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<FordUploadFilterInput>>;
  uploadId?: InputMaybe<ComparableInt32OperationFilterInput>;
  userCreatedId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type FranchiseeAwardFilterInput = {
  achievedDate?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  and?: InputMaybe<Array<FranchiseeAwardFilterInput>>;
  franchisee?: InputMaybe<FranchiseeFilterInput>;
  franchiseeAwardId?: InputMaybe<ComparableInt32OperationFilterInput>;
  franchiseeId?: InputMaybe<ComparableInt32OperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<FranchiseeAwardFilterInput>>;
  rowVersion?: InputMaybe<ListComparableByteOperationFilterInput>;
};

export type FranchiseeDirectorFilterInput = {
  and?: InputMaybe<Array<FranchiseeDirectorFilterInput>>;
  crmcontact?: InputMaybe<CrmcontactFilterInput>;
  crmcontactId?: InputMaybe<ComparableInt32OperationFilterInput>;
  directorId?: InputMaybe<ComparableInt32OperationFilterInput>;
  franchisee?: InputMaybe<FranchiseeFilterInput>;
  franchiseeId?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<FranchiseeDirectorFilterInput>>;
  removed?: InputMaybe<BooleanOperationFilterInput>;
  rowVersion?: InputMaybe<ListComparableByteOperationFilterInput>;
};

export type FranchiseeFilterInput = {
  abn?: InputMaybe<StringOperationFilterInput>;
  acn?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<FranchiseeFilterInput>>;
  companyName?: InputMaybe<StringOperationFilterInput>;
  crmaddress?: InputMaybe<ComparableInt32OperationFilterInput>;
  franchiseeAwards?: InputMaybe<ListFilterInputTypeOfFranchiseeAwardFilterInput>;
  franchiseeCategory?: InputMaybe<ComparableInt32OperationFilterInput>;
  franchiseeDirectors?: InputMaybe<ListFilterInputTypeOfFranchiseeDirectorFilterInput>;
  franchiseesId?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<FranchiseeFilterInput>>;
  recruitments?: InputMaybe<ListFilterInputTypeOfRecruitmentFilterInput>;
  removed?: InputMaybe<BooleanOperationFilterInput>;
  rowVersion?: InputMaybe<ListComparableByteOperationFilterInput>;
};

export type FranchiseeStoreFilterInput = {
  accountNumber?: InputMaybe<StringOperationFilterInput>;
  agreement?: InputMaybe<AgreementFilterInput>;
  agreementId?: InputMaybe<ComparableInt32OperationFilterInput>;
  and?: InputMaybe<Array<FranchiseeStoreFilterInput>>;
  crmaddress?: InputMaybe<CrmaddressFilterInput>;
  crmaddressId?: InputMaybe<ComparableInt32OperationFilterInput>;
  manager?: InputMaybe<CrmcontactFilterInput>;
  managerId?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<FranchiseeStoreFilterInput>>;
  removed?: InputMaybe<BooleanOperationFilterInput>;
  rowVersion?: InputMaybe<ListComparableByteOperationFilterInput>;
  storeId?: InputMaybe<ComparableInt32OperationFilterInput>;
  storeName?: InputMaybe<StringOperationFilterInput>;
};

export type FreightDeliveryMethod = {
  __typename?: 'FreightDeliveryMethod';
  customerFreightSettings: Array<CustomerFreightSettingType>;
  deliveryMethodId: Scalars['Int'];
  name: Scalars['String'];
};

export type FreightDeliveryMethodFilterInput = {
  and?: InputMaybe<Array<FreightDeliveryMethodFilterInput>>;
  customerFreightSettings?: InputMaybe<ListFilterInputTypeOfCustomerFreightSettingFilterInput>;
  deliveryMethodId?: InputMaybe<ComparableInt32OperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<FreightDeliveryMethodFilterInput>>;
};

export type FreightDeliveryMethodSortInput = {
  deliveryMethodId?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
};

export type FreightSettingType = {
  __typename?: 'FreightSettingType';
  customerFreightSettings: Array<CustomerFreightSettingType>;
  freightSettingTypeId: Scalars['Int'];
  name: Scalars['String'];
};

export type FreightSettingTypeFilterInput = {
  and?: InputMaybe<Array<FreightSettingTypeFilterInput>>;
  customerFreightSettings?: InputMaybe<ListFilterInputTypeOfCustomerFreightSettingFilterInput>;
  freightSettingTypeId?: InputMaybe<ComparableInt32OperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<FreightSettingTypeFilterInput>>;
};

export type FreightSettingTypeSortInput = {
  freightSettingTypeId?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
};

export type FrequencyInput = {
  days: Array<Scalars['String']>;
  endType: Scalars['String'];
  endValue: Scalars['String'];
  frequency: Scalars['String'];
  startDateTime: Scalars['DateTime'];
};

/** Represents the input to retrieve freight settings. */
export type GetFreightSettingsInputType = {
  /** Represents the weight to find freight settings by. */
  weight: Scalars['Decimal'];
};

export type GetProductManagementInput = {
  catId?: InputMaybe<Scalars['Int']>;
  orderTypeId?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
};

export type GetProductsInput = {
  catId?: InputMaybe<Scalars['Int']>;
};

export type GetProductsTotalPriceInput = {
  products: Array<ProductsTotalPriceItemInput>;
};

export type GetProductsTotalPriceOutput = {
  __typename?: 'GetProductsTotalPriceOutput';
  total: Scalars['Decimal'];
};

export type GuarantorFilterInput = {
  agreement?: InputMaybe<AgreementFilterInput>;
  agreementId?: InputMaybe<ComparableInt32OperationFilterInput>;
  and?: InputMaybe<Array<GuarantorFilterInput>>;
  crmcontact?: InputMaybe<CrmcontactFilterInput>;
  crmcontactId?: InputMaybe<ComparableInt32OperationFilterInput>;
  guarantorId?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<GuarantorFilterInput>>;
};

export type HistoryFilterInput = {
  and?: InputMaybe<Array<HistoryFilterInput>>;
  comments?: InputMaybe<StringOperationFilterInput>;
  documentType?: InputMaybe<DocumentTypeEnumFilterInput>;
  documentTypeId?: InputMaybe<ComparableInt32OperationFilterInput>;
  historyId?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<HistoryFilterInput>>;
  recruitment?: InputMaybe<RecruitmentFilterInput>;
  recruitmentId?: InputMaybe<ComparableInt32OperationFilterInput>;
  rowVersion?: InputMaybe<ListComparableByteOperationFilterInput>;
  uploadedDocumentFileId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type KeyValuePairOfStringAndString = {
  __typename?: 'KeyValuePairOfStringAndString';
  key: Scalars['String'];
  value: Scalars['String'];
};

export type ListComparableByteOperationFilterInput = {
  all?: InputMaybe<ComparableByteOperationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ComparableByteOperationFilterInput>;
  some?: InputMaybe<ComparableByteOperationFilterInput>;
};

export type ListFilterInputTypeOfActivityAttendeeFilterInput = {
  all?: InputMaybe<ActivityAttendeeFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ActivityAttendeeFilterInput>;
  some?: InputMaybe<ActivityAttendeeFilterInput>;
};

export type ListFilterInputTypeOfActivityBusinessLevelRateFilterInput = {
  all?: InputMaybe<ActivityBusinessLevelRateFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ActivityBusinessLevelRateFilterInput>;
  some?: InputMaybe<ActivityBusinessLevelRateFilterInput>;
};

export type ListFilterInputTypeOfActivityCommentFilterInput = {
  all?: InputMaybe<ActivityCommentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ActivityCommentFilterInput>;
  some?: InputMaybe<ActivityCommentFilterInput>;
};

export type ListFilterInputTypeOfActivityDocumentMapFilterInput = {
  all?: InputMaybe<ActivityDocumentMapFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ActivityDocumentMapFilterInput>;
  some?: InputMaybe<ActivityDocumentMapFilterInput>;
};

export type ListFilterInputTypeOfActivityDueDateFilterInput = {
  all?: InputMaybe<ActivityDueDateFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ActivityDueDateFilterInput>;
  some?: InputMaybe<ActivityDueDateFilterInput>;
};

export type ListFilterInputTypeOfActivityEmailCommFilterInput = {
  all?: InputMaybe<ActivityEmailCommFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ActivityEmailCommFilterInput>;
  some?: InputMaybe<ActivityEmailCommFilterInput>;
};

export type ListFilterInputTypeOfActivityEmailCommsDocumentMapFilterInput = {
  all?: InputMaybe<ActivityEmailCommsDocumentMapFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ActivityEmailCommsDocumentMapFilterInput>;
  some?: InputMaybe<ActivityEmailCommsDocumentMapFilterInput>;
};

export type ListFilterInputTypeOfActivityFilterInput = {
  all?: InputMaybe<ActivityFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ActivityFilterInput>;
  some?: InputMaybe<ActivityFilterInput>;
};

export type ListFilterInputTypeOfActivityLabelFilterInput = {
  all?: InputMaybe<ActivityLabelFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ActivityLabelFilterInput>;
  some?: InputMaybe<ActivityLabelFilterInput>;
};

export type ListFilterInputTypeOfActivityMeetingFilterInput = {
  all?: InputMaybe<ActivityMeetingFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ActivityMeetingFilterInput>;
  some?: InputMaybe<ActivityMeetingFilterInput>;
};

export type ListFilterInputTypeOfActivityTypeRoleVisibilityFilterInput = {
  all?: InputMaybe<ActivityTypeRoleVisibilityFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ActivityTypeRoleVisibilityFilterInput>;
  some?: InputMaybe<ActivityTypeRoleVisibilityFilterInput>;
};

export type ListFilterInputTypeOfAddressOptDatumFilterInput = {
  all?: InputMaybe<AddressOptDatumFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<AddressOptDatumFilterInput>;
  some?: InputMaybe<AddressOptDatumFilterInput>;
};

export type ListFilterInputTypeOfAddressOptEnumFilterInput = {
  all?: InputMaybe<AddressOptEnumFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<AddressOptEnumFilterInput>;
  some?: InputMaybe<AddressOptEnumFilterInput>;
};

export type ListFilterInputTypeOfAddressOptHeadFilterInput = {
  all?: InputMaybe<AddressOptHeadFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<AddressOptHeadFilterInput>;
  some?: InputMaybe<AddressOptHeadFilterInput>;
};

export type ListFilterInputTypeOfAdvertisementBlockDataFilterInput = {
  all?: InputMaybe<AdvertisementBlockDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<AdvertisementBlockDataFilterInput>;
  some?: InputMaybe<AdvertisementBlockDataFilterInput>;
};

export type ListFilterInputTypeOfAdvertisementBlockFilterInput = {
  all?: InputMaybe<AdvertisementBlockFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<AdvertisementBlockFilterInput>;
  some?: InputMaybe<AdvertisementBlockFilterInput>;
};

export type ListFilterInputTypeOfAdvertisementMasterPageFilterInput = {
  all?: InputMaybe<AdvertisementMasterPageFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<AdvertisementMasterPageFilterInput>;
  some?: InputMaybe<AdvertisementMasterPageFilterInput>;
};

export type ListFilterInputTypeOfAdvertisementPageFilterInput = {
  all?: InputMaybe<AdvertisementPageFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<AdvertisementPageFilterInput>;
  some?: InputMaybe<AdvertisementPageFilterInput>;
};

export type ListFilterInputTypeOfAgreementFilterInput = {
  all?: InputMaybe<AgreementFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<AgreementFilterInput>;
  some?: InputMaybe<AgreementFilterInput>;
};

export type ListFilterInputTypeOfBmwcampaignSubmissionFilterInput = {
  all?: InputMaybe<BmwcampaignSubmissionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<BmwcampaignSubmissionFilterInput>;
  some?: InputMaybe<BmwcampaignSubmissionFilterInput>;
};

export type ListFilterInputTypeOfBmwcommunicationBriefFilterInput = {
  all?: InputMaybe<BmwcommunicationBriefFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<BmwcommunicationBriefFilterInput>;
  some?: InputMaybe<BmwcommunicationBriefFilterInput>;
};

export type ListFilterInputTypeOfBmwcommunicationFileFilterInput = {
  all?: InputMaybe<BmwcommunicationFileFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<BmwcommunicationFileFilterInput>;
  some?: InputMaybe<BmwcommunicationFileFilterInput>;
};

export type ListFilterInputTypeOfBusinessLevelCommentFilterInput = {
  all?: InputMaybe<BusinessLevelCommentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<BusinessLevelCommentFilterInput>;
  some?: InputMaybe<BusinessLevelCommentFilterInput>;
};

export type ListFilterInputTypeOfBusinessLevelFilterInput = {
  all?: InputMaybe<BusinessLevelFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<BusinessLevelFilterInput>;
  some?: InputMaybe<BusinessLevelFilterInput>;
};

export type ListFilterInputTypeOfBusinessLevelOptDatumFilterInput = {
  all?: InputMaybe<BusinessLevelOptDatumFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<BusinessLevelOptDatumFilterInput>;
  some?: InputMaybe<BusinessLevelOptDatumFilterInput>;
};

export type ListFilterInputTypeOfBusinessLevelOptEnumFilterInput = {
  all?: InputMaybe<BusinessLevelOptEnumFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<BusinessLevelOptEnumFilterInput>;
  some?: InputMaybe<BusinessLevelOptEnumFilterInput>;
};

export type ListFilterInputTypeOfBusinessLevelOptHeadFilterInput = {
  all?: InputMaybe<BusinessLevelOptHeadFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<BusinessLevelOptHeadFilterInput>;
  some?: InputMaybe<BusinessLevelOptHeadFilterInput>;
};

export type ListFilterInputTypeOfCampaignFilterInput = {
  all?: InputMaybe<CampaignFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<CampaignFilterInput>;
  some?: InputMaybe<CampaignFilterInput>;
};

export type ListFilterInputTypeOfCarrierServiceFilterInput = {
  all?: InputMaybe<CarrierServiceFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<CarrierServiceFilterInput>;
  some?: InputMaybe<CarrierServiceFilterInput>;
};

export type ListFilterInputTypeOfCategoryFilterInput = {
  all?: InputMaybe<CategoryFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<CategoryFilterInput>;
  some?: InputMaybe<CategoryFilterInput>;
};

export type ListFilterInputTypeOfCategoryPromoterFilterInput = {
  all?: InputMaybe<CategoryPromoterFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<CategoryPromoterFilterInput>;
  some?: InputMaybe<CategoryPromoterFilterInput>;
};

export type ListFilterInputTypeOfCategoryPromoterVisibilityFilterInput = {
  all?: InputMaybe<CategoryPromoterVisibilityFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<CategoryPromoterVisibilityFilterInput>;
  some?: InputMaybe<CategoryPromoterVisibilityFilterInput>;
};

export type ListFilterInputTypeOfCategoryVisibilityFilterInput = {
  all?: InputMaybe<CategoryVisibilityFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<CategoryVisibilityFilterInput>;
  some?: InputMaybe<CategoryVisibilityFilterInput>;
};

export type ListFilterInputTypeOfCmsAdvertisementBlockFilterInput = {
  all?: InputMaybe<CmsAdvertisementBlockFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<CmsAdvertisementBlockFilterInput>;
  some?: InputMaybe<CmsAdvertisementBlockFilterInput>;
};

export type ListFilterInputTypeOfCmsBlockStatusFilterInput = {
  all?: InputMaybe<CmsBlockStatusFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<CmsBlockStatusFilterInput>;
  some?: InputMaybe<CmsBlockStatusFilterInput>;
};

export type ListFilterInputTypeOfCmsChatBlockFilterInput = {
  all?: InputMaybe<CmsChatBlockFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<CmsChatBlockFilterInput>;
  some?: InputMaybe<CmsChatBlockFilterInput>;
};

export type ListFilterInputTypeOfCmsDashBoardBlockFilterInput = {
  all?: InputMaybe<CmsDashBoardBlockFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<CmsDashBoardBlockFilterInput>;
  some?: InputMaybe<CmsDashBoardBlockFilterInput>;
};

export type ListFilterInputTypeOfCmsFeaturedProdBlockFilterInput = {
  all?: InputMaybe<CmsFeaturedProdBlockFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<CmsFeaturedProdBlockFilterInput>;
  some?: InputMaybe<CmsFeaturedProdBlockFilterInput>;
};

export type ListFilterInputTypeOfCmsNewsBlockFilterInput = {
  all?: InputMaybe<CmsNewsBlockFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<CmsNewsBlockFilterInput>;
  some?: InputMaybe<CmsNewsBlockFilterInput>;
};

export type ListFilterInputTypeOfCmsPageBlockFilterInput = {
  all?: InputMaybe<CmsPageBlockFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<CmsPageBlockFilterInput>;
  some?: InputMaybe<CmsPageBlockFilterInput>;
};

export type ListFilterInputTypeOfCmsPageFilterInput = {
  all?: InputMaybe<CmsPageFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<CmsPageFilterInput>;
  some?: InputMaybe<CmsPageFilterInput>;
};

export type ListFilterInputTypeOfCmsPendingApprovalsBlockFilterInput = {
  all?: InputMaybe<CmsPendingApprovalsBlockFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<CmsPendingApprovalsBlockFilterInput>;
  some?: InputMaybe<CmsPendingApprovalsBlockFilterInput>;
};

export type ListFilterInputTypeOfCmsWelcomeBlock2FilterInput = {
  all?: InputMaybe<CmsWelcomeBlock2FilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<CmsWelcomeBlock2FilterInput>;
  some?: InputMaybe<CmsWelcomeBlock2FilterInput>;
};

export type ListFilterInputTypeOfCmsWelcomeBlockFilterInput = {
  all?: InputMaybe<CmsWelcomeBlockFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<CmsWelcomeBlockFilterInput>;
  some?: InputMaybe<CmsWelcomeBlockFilterInput>;
};

export type ListFilterInputTypeOfCrmcontactFilterInput = {
  all?: InputMaybe<CrmcontactFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<CrmcontactFilterInput>;
  some?: InputMaybe<CrmcontactFilterInput>;
};

export type ListFilterInputTypeOfCrmemailFilterInput = {
  all?: InputMaybe<CrmemailFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<CrmemailFilterInput>;
  some?: InputMaybe<CrmemailFilterInput>;
};

export type ListFilterInputTypeOfCrmkeyDateFilterInput = {
  all?: InputMaybe<CrmkeyDateFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<CrmkeyDateFilterInput>;
  some?: InputMaybe<CrmkeyDateFilterInput>;
};

export type ListFilterInputTypeOfCrmphoneFilterInput = {
  all?: InputMaybe<CrmphoneFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<CrmphoneFilterInput>;
  some?: InputMaybe<CrmphoneFilterInput>;
};

export type ListFilterInputTypeOfCustomerEmailSettingFilterInput = {
  all?: InputMaybe<CustomerEmailSettingFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<CustomerEmailSettingFilterInput>;
  some?: InputMaybe<CustomerEmailSettingFilterInput>;
};

export type ListFilterInputTypeOfCustomerExchangeRateFilterInput = {
  all?: InputMaybe<CustomerExchangeRateFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<CustomerExchangeRateFilterInput>;
  some?: InputMaybe<CustomerExchangeRateFilterInput>;
};

export type ListFilterInputTypeOfCustomerFilterInput = {
  all?: InputMaybe<CustomerFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<CustomerFilterInput>;
  some?: InputMaybe<CustomerFilterInput>;
};

export type ListFilterInputTypeOfCustomerFinancialFilterInput = {
  all?: InputMaybe<CustomerFinancialFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<CustomerFinancialFilterInput>;
  some?: InputMaybe<CustomerFinancialFilterInput>;
};

export type ListFilterInputTypeOfCustomerFreightRateFilterInput = {
  all?: InputMaybe<CustomerFreightRateFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<CustomerFreightRateFilterInput>;
  some?: InputMaybe<CustomerFreightRateFilterInput>;
};

export type ListFilterInputTypeOfCustomerFreightSettingFilterInput = {
  all?: InputMaybe<CustomerFreightSettingFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<CustomerFreightSettingFilterInput>;
  some?: InputMaybe<CustomerFreightSettingFilterInput>;
};

export type ListFilterInputTypeOfCustomerFsmappingFilterInput = {
  all?: InputMaybe<CustomerFsmappingFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<CustomerFsmappingFilterInput>;
  some?: InputMaybe<CustomerFsmappingFilterInput>;
};

export type ListFilterInputTypeOfCustomerInterfaceFilterInput = {
  all?: InputMaybe<CustomerInterfaceFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<CustomerInterfaceFilterInput>;
  some?: InputMaybe<CustomerInterfaceFilterInput>;
};

export type ListFilterInputTypeOfCustomerLiveChatCategoryFilterInput = {
  all?: InputMaybe<CustomerLiveChatCategoryFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<CustomerLiveChatCategoryFilterInput>;
  some?: InputMaybe<CustomerLiveChatCategoryFilterInput>;
};

export type ListFilterInputTypeOfCustomerOptDatumFilterInput = {
  all?: InputMaybe<CustomerOptDatumFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<CustomerOptDatumFilterInput>;
  some?: InputMaybe<CustomerOptDatumFilterInput>;
};

export type ListFilterInputTypeOfCustomerOptEnumFilterInput = {
  all?: InputMaybe<CustomerOptEnumFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<CustomerOptEnumFilterInput>;
  some?: InputMaybe<CustomerOptEnumFilterInput>;
};

export type ListFilterInputTypeOfCustomerOptHeadFilterInput = {
  all?: InputMaybe<CustomerOptHeadFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<CustomerOptHeadFilterInput>;
  some?: InputMaybe<CustomerOptHeadFilterInput>;
};

export type ListFilterInputTypeOfCustomerOrderOptionFilterInput = {
  all?: InputMaybe<CustomerOrderOptionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<CustomerOrderOptionFilterInput>;
  some?: InputMaybe<CustomerOrderOptionFilterInput>;
};

export type ListFilterInputTypeOfCustomerPaymentGatewayErrorCodeFilterInput = {
  all?: InputMaybe<CustomerPaymentGatewayErrorCodeFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<CustomerPaymentGatewayErrorCodeFilterInput>;
  some?: InputMaybe<CustomerPaymentGatewayErrorCodeFilterInput>;
};

export type ListFilterInputTypeOfCustomerPaymentOptionFilterInput = {
  all?: InputMaybe<CustomerPaymentOptionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<CustomerPaymentOptionFilterInput>;
  some?: InputMaybe<CustomerPaymentOptionFilterInput>;
};

export type ListFilterInputTypeOfCustomerPermissionFilterInput = {
  all?: InputMaybe<CustomerPermissionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<CustomerPermissionFilterInput>;
  some?: InputMaybe<CustomerPermissionFilterInput>;
};

export type ListFilterInputTypeOfCustomerPickPdfsettingFilterInput = {
  all?: InputMaybe<CustomerPickPdfsettingFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<CustomerPickPdfsettingFilterInput>;
  some?: InputMaybe<CustomerPickPdfsettingFilterInput>;
};

export type ListFilterInputTypeOfCustomerPickTypeFilterInput = {
  all?: InputMaybe<CustomerPickTypeFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<CustomerPickTypeFilterInput>;
  some?: InputMaybe<CustomerPickTypeFilterInput>;
};

export type ListFilterInputTypeOfCustomerPostcodeRestrictionFilterInput = {
  all?: InputMaybe<CustomerPostcodeRestrictionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<CustomerPostcodeRestrictionFilterInput>;
  some?: InputMaybe<CustomerPostcodeRestrictionFilterInput>;
};

export type ListFilterInputTypeOfCustomerPropertyFilterInput = {
  all?: InputMaybe<CustomerPropertyFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<CustomerPropertyFilterInput>;
  some?: InputMaybe<CustomerPropertyFilterInput>;
};

export type ListFilterInputTypeOfCustomerPropertyValueFilterInput = {
  all?: InputMaybe<CustomerPropertyValueFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<CustomerPropertyValueFilterInput>;
  some?: InputMaybe<CustomerPropertyValueFilterInput>;
};

export type ListFilterInputTypeOfCustomerRegistrationSettingFilterInput = {
  all?: InputMaybe<CustomerRegistrationSettingFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<CustomerRegistrationSettingFilterInput>;
  some?: InputMaybe<CustomerRegistrationSettingFilterInput>;
};

export type ListFilterInputTypeOfCustomerShopSettingFilterInput = {
  all?: InputMaybe<CustomerShopSettingFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<CustomerShopSettingFilterInput>;
  some?: InputMaybe<CustomerShopSettingFilterInput>;
};

export type ListFilterInputTypeOfCustomerStocktakeSettingFilterInput = {
  all?: InputMaybe<CustomerStocktakeSettingFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<CustomerStocktakeSettingFilterInput>;
  some?: InputMaybe<CustomerStocktakeSettingFilterInput>;
};

export type ListFilterInputTypeOfCustomerThirdPartyApisettingFilterInput = {
  all?: InputMaybe<CustomerThirdPartyApisettingFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<CustomerThirdPartyApisettingFilterInput>;
  some?: InputMaybe<CustomerThirdPartyApisettingFilterInput>;
};

export type ListFilterInputTypeOfDocumentCategoryCustomVisibilityFilterInput = {
  all?: InputMaybe<DocumentCategoryCustomVisibilityFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<DocumentCategoryCustomVisibilityFilterInput>;
  some?: InputMaybe<DocumentCategoryCustomVisibilityFilterInput>;
};

export type ListFilterInputTypeOfDocumentCategoryFilterInput = {
  all?: InputMaybe<DocumentCategoryFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<DocumentCategoryFilterInput>;
  some?: InputMaybe<DocumentCategoryFilterInput>;
};

export type ListFilterInputTypeOfDocumentCategoryMapFilterInput = {
  all?: InputMaybe<DocumentCategoryMapFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<DocumentCategoryMapFilterInput>;
  some?: InputMaybe<DocumentCategoryMapFilterInput>;
};

export type ListFilterInputTypeOfDocumentCategoryUserFavouriteMapFilterInput = {
  all?: InputMaybe<DocumentCategoryUserFavouriteMapFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<DocumentCategoryUserFavouriteMapFilterInput>;
  some?: InputMaybe<DocumentCategoryUserFavouriteMapFilterInput>;
};

export type ListFilterInputTypeOfDocumentCustomVisibilityFilterInput = {
  all?: InputMaybe<DocumentCustomVisibilityFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<DocumentCustomVisibilityFilterInput>;
  some?: InputMaybe<DocumentCustomVisibilityFilterInput>;
};

export type ListFilterInputTypeOfDocumentFilterInput = {
  all?: InputMaybe<DocumentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<DocumentFilterInput>;
  some?: InputMaybe<DocumentFilterInput>;
};

export type ListFilterInputTypeOfDocumentLinkFilterInput = {
  all?: InputMaybe<DocumentLinkFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<DocumentLinkFilterInput>;
  some?: InputMaybe<DocumentLinkFilterInput>;
};

export type ListFilterInputTypeOfDocumentLinkHitFilterInput = {
  all?: InputMaybe<DocumentLinkHitFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<DocumentLinkHitFilterInput>;
  some?: InputMaybe<DocumentLinkHitFilterInput>;
};

export type ListFilterInputTypeOfDocumentMetadataFilterInput = {
  all?: InputMaybe<DocumentMetadataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<DocumentMetadataFilterInput>;
  some?: InputMaybe<DocumentMetadataFilterInput>;
};

export type ListFilterInputTypeOfDocumentPermissionFilterInput = {
  all?: InputMaybe<DocumentPermissionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<DocumentPermissionFilterInput>;
  some?: InputMaybe<DocumentPermissionFilterInput>;
};

export type ListFilterInputTypeOfDocumentUserFavouriteMapFilterInput = {
  all?: InputMaybe<DocumentUserFavouriteMapFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<DocumentUserFavouriteMapFilterInput>;
  some?: InputMaybe<DocumentUserFavouriteMapFilterInput>;
};

export type ListFilterInputTypeOfEmailAdBlockDatumFilterInput = {
  all?: InputMaybe<EmailAdBlockDatumFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<EmailAdBlockDatumFilterInput>;
  some?: InputMaybe<EmailAdBlockDatumFilterInput>;
};

export type ListFilterInputTypeOfEmailAdPageBlockDataMapFilterInput = {
  all?: InputMaybe<EmailAdPageBlockDataMapFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<EmailAdPageBlockDataMapFilterInput>;
  some?: InputMaybe<EmailAdPageBlockDataMapFilterInput>;
};

export type ListFilterInputTypeOfEmailAdPageFilterInput = {
  all?: InputMaybe<EmailAdPageFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<EmailAdPageFilterInput>;
  some?: InputMaybe<EmailAdPageFilterInput>;
};

export type ListFilterInputTypeOfEmailAttachedFileFilterInput = {
  all?: InputMaybe<EmailAttachedFileFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<EmailAttachedFileFilterInput>;
  some?: InputMaybe<EmailAttachedFileFilterInput>;
};

export type ListFilterInputTypeOfEmailAttachmentFilterInput = {
  all?: InputMaybe<EmailAttachmentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<EmailAttachmentFilterInput>;
  some?: InputMaybe<EmailAttachmentFilterInput>;
};

export type ListFilterInputTypeOfEmailColumnFilterInput = {
  all?: InputMaybe<EmailColumnFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<EmailColumnFilterInput>;
  some?: InputMaybe<EmailColumnFilterInput>;
};

export type ListFilterInputTypeOfEmailDatumFilterInput = {
  all?: InputMaybe<EmailDatumFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<EmailDatumFilterInput>;
  some?: InputMaybe<EmailDatumFilterInput>;
};

export type ListFilterInputTypeOfEmailDetailFilterInput = {
  all?: InputMaybe<EmailDetailFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<EmailDetailFilterInput>;
  some?: InputMaybe<EmailDetailFilterInput>;
};

export type ListFilterInputTypeOfEmailEventFilterInput = {
  all?: InputMaybe<EmailEventFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<EmailEventFilterInput>;
  some?: InputMaybe<EmailEventFilterInput>;
};

export type ListFilterInputTypeOfEmailHeaderFilterInput = {
  all?: InputMaybe<EmailHeaderFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<EmailHeaderFilterInput>;
  some?: InputMaybe<EmailHeaderFilterInput>;
};

export type ListFilterInputTypeOfEmailImageLinkFilterInput = {
  all?: InputMaybe<EmailImageLinkFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<EmailImageLinkFilterInput>;
  some?: InputMaybe<EmailImageLinkFilterInput>;
};

export type ListFilterInputTypeOfEmailLinkFilterInput = {
  all?: InputMaybe<EmailLinkFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<EmailLinkFilterInput>;
  some?: InputMaybe<EmailLinkFilterInput>;
};

export type ListFilterInputTypeOfEmailReplaceFieldFilterInput = {
  all?: InputMaybe<EmailReplaceFieldFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<EmailReplaceFieldFilterInput>;
  some?: InputMaybe<EmailReplaceFieldFilterInput>;
};

export type ListFilterInputTypeOfEmailTemplateFilterInput = {
  all?: InputMaybe<EmailTemplateFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<EmailTemplateFilterInput>;
  some?: InputMaybe<EmailTemplateFilterInput>;
};

export type ListFilterInputTypeOfEtemplateDataBusinessLevelMapFilterInput = {
  all?: InputMaybe<EtemplateDataBusinessLevelMapFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<EtemplateDataBusinessLevelMapFilterInput>;
  some?: InputMaybe<EtemplateDataBusinessLevelMapFilterInput>;
};

export type ListFilterInputTypeOfEtemplateDatumFilterInput = {
  all?: InputMaybe<EtemplateDatumFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<EtemplateDatumFilterInput>;
  some?: InputMaybe<EtemplateDatumFilterInput>;
};

export type ListFilterInputTypeOfEtemplateFilterInput = {
  all?: InputMaybe<EtemplateFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<EtemplateFilterInput>;
  some?: InputMaybe<EtemplateFilterInput>;
};

export type ListFilterInputTypeOfEtemplateImageLineFilterInput = {
  all?: InputMaybe<EtemplateImageLineFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<EtemplateImageLineFilterInput>;
  some?: InputMaybe<EtemplateImageLineFilterInput>;
};

export type ListFilterInputTypeOfEtemplateObjectStyleFilterInput = {
  all?: InputMaybe<EtemplateObjectStyleFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<EtemplateObjectStyleFilterInput>;
  some?: InputMaybe<EtemplateObjectStyleFilterInput>;
};

export type ListFilterInputTypeOfEtemplateRestApirequestFilterInput = {
  all?: InputMaybe<EtemplateRestApirequestFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<EtemplateRestApirequestFilterInput>;
  some?: InputMaybe<EtemplateRestApirequestFilterInput>;
};

export type ListFilterInputTypeOfEtemplateTextLineFilterInput = {
  all?: InputMaybe<EtemplateTextLineFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<EtemplateTextLineFilterInput>;
  some?: InputMaybe<EtemplateTextLineFilterInput>;
};

export type ListFilterInputTypeOfEtemplateTextRecordFilterInput = {
  all?: InputMaybe<EtemplateTextRecordFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<EtemplateTextRecordFilterInput>;
  some?: InputMaybe<EtemplateTextRecordFilterInput>;
};

export type ListFilterInputTypeOfFaqFilterInput = {
  all?: InputMaybe<FaqFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<FaqFilterInput>;
  some?: InputMaybe<FaqFilterInput>;
};

export type ListFilterInputTypeOfFordTransactionFilterInput = {
  all?: InputMaybe<FordTransactionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<FordTransactionFilterInput>;
  some?: InputMaybe<FordTransactionFilterInput>;
};

export type ListFilterInputTypeOfFordTransactionsRctiFilterInput = {
  all?: InputMaybe<FordTransactionsRctiFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<FordTransactionsRctiFilterInput>;
  some?: InputMaybe<FordTransactionsRctiFilterInput>;
};

export type ListFilterInputTypeOfFranchiseeAwardFilterInput = {
  all?: InputMaybe<FranchiseeAwardFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<FranchiseeAwardFilterInput>;
  some?: InputMaybe<FranchiseeAwardFilterInput>;
};

export type ListFilterInputTypeOfFranchiseeDirectorFilterInput = {
  all?: InputMaybe<FranchiseeDirectorFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<FranchiseeDirectorFilterInput>;
  some?: InputMaybe<FranchiseeDirectorFilterInput>;
};

export type ListFilterInputTypeOfFranchiseeStoreFilterInput = {
  all?: InputMaybe<FranchiseeStoreFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<FranchiseeStoreFilterInput>;
  some?: InputMaybe<FranchiseeStoreFilterInput>;
};

export type ListFilterInputTypeOfGuarantorFilterInput = {
  all?: InputMaybe<GuarantorFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<GuarantorFilterInput>;
  some?: InputMaybe<GuarantorFilterInput>;
};

export type ListFilterInputTypeOfHistoryFilterInput = {
  all?: InputMaybe<HistoryFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<HistoryFilterInput>;
  some?: InputMaybe<HistoryFilterInput>;
};

export type ListFilterInputTypeOfMinimumPerformanceFilterInput = {
  all?: InputMaybe<MinimumPerformanceFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<MinimumPerformanceFilterInput>;
  some?: InputMaybe<MinimumPerformanceFilterInput>;
};

export type ListFilterInputTypeOfOneOffFeeFilterInput = {
  all?: InputMaybe<OneOffFeeFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<OneOffFeeFilterInput>;
  some?: InputMaybe<OneOffFeeFilterInput>;
};

export type ListFilterInputTypeOfOrderFilterInput = {
  all?: InputMaybe<OrderFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<OrderFilterInput>;
  some?: InputMaybe<OrderFilterInput>;
};

export type ListFilterInputTypeOfOrderLineDocumentMapFilterInput = {
  all?: InputMaybe<OrderLineDocumentMapFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<OrderLineDocumentMapFilterInput>;
  some?: InputMaybe<OrderLineDocumentMapFilterInput>;
};

export type ListFilterInputTypeOfOrderLineFilterInput = {
  all?: InputMaybe<OrderLineFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<OrderLineFilterInput>;
  some?: InputMaybe<OrderLineFilterInput>;
};

export type ListFilterInputTypeOfOrderLinePropertyMapFilterInput = {
  all?: InputMaybe<OrderLinePropertyMapFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<OrderLinePropertyMapFilterInput>;
  some?: InputMaybe<OrderLinePropertyMapFilterInput>;
};

export type ListFilterInputTypeOfOrderLineSelectedDataIdFilterInput = {
  all?: InputMaybe<OrderLineSelectedDataIdFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<OrderLineSelectedDataIdFilterInput>;
  some?: InputMaybe<OrderLineSelectedDataIdFilterInput>;
};

export type ListFilterInputTypeOfOrderOptDatumFilterInput = {
  all?: InputMaybe<OrderOptDatumFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<OrderOptDatumFilterInput>;
  some?: InputMaybe<OrderOptDatumFilterInput>;
};

export type ListFilterInputTypeOfOrderOptEnumFilterInput = {
  all?: InputMaybe<OrderOptEnumFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<OrderOptEnumFilterInput>;
  some?: InputMaybe<OrderOptEnumFilterInput>;
};

export type ListFilterInputTypeOfOrderOptHeadFilterInput = {
  all?: InputMaybe<OrderOptHeadFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<OrderOptHeadFilterInput>;
  some?: InputMaybe<OrderOptHeadFilterInput>;
};

export type ListFilterInputTypeOfOrderPaymentHistoryFilterInput = {
  all?: InputMaybe<OrderPaymentHistoryFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<OrderPaymentHistoryFilterInput>;
  some?: InputMaybe<OrderPaymentHistoryFilterInput>;
};

export type ListFilterInputTypeOfOrderShippingFilterInput = {
  all?: InputMaybe<OrderShippingFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<OrderShippingFilterInput>;
  some?: InputMaybe<OrderShippingFilterInput>;
};

export type ListFilterInputTypeOfOrderTermFilterInput = {
  all?: InputMaybe<OrderTermFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<OrderTermFilterInput>;
  some?: InputMaybe<OrderTermFilterInput>;
};

export type ListFilterInputTypeOfPaypalPaymentFilterInput = {
  all?: InputMaybe<PaypalPaymentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<PaypalPaymentFilterInput>;
  some?: InputMaybe<PaypalPaymentFilterInput>;
};

export type ListFilterInputTypeOfPremierFundingServicesLoanFilterInput = {
  all?: InputMaybe<PremierFundingServicesLoanFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<PremierFundingServicesLoanFilterInput>;
  some?: InputMaybe<PremierFundingServicesLoanFilterInput>;
};

export type ListFilterInputTypeOfProductAllowedQuantityFilterInput = {
  all?: InputMaybe<ProductAllowedQuantityFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ProductAllowedQuantityFilterInput>;
  some?: InputMaybe<ProductAllowedQuantityFilterInput>;
};

export type ListFilterInputTypeOfProductArchiveFilterInput = {
  all?: InputMaybe<ProductArchiveFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ProductArchiveFilterInput>;
  some?: InputMaybe<ProductArchiveFilterInput>;
};

export type ListFilterInputTypeOfProductAttribDataMapFilterInput = {
  all?: InputMaybe<ProductAttribDataMapFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ProductAttribDataMapFilterInput>;
  some?: InputMaybe<ProductAttribDataMapFilterInput>;
};

export type ListFilterInputTypeOfProductAttribDataTypeFilterInput = {
  all?: InputMaybe<ProductAttribDataTypeFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ProductAttribDataTypeFilterInput>;
  some?: InputMaybe<ProductAttribDataTypeFilterInput>;
};

export type ListFilterInputTypeOfProductAttribDatumFilterInput = {
  all?: InputMaybe<ProductAttribDatumFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ProductAttribDatumFilterInput>;
  some?: InputMaybe<ProductAttribDatumFilterInput>;
};

export type ListFilterInputTypeOfProductAttribEmailFilterInput = {
  all?: InputMaybe<ProductAttribEmailFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ProductAttribEmailFilterInput>;
  some?: InputMaybe<ProductAttribEmailFilterInput>;
};

export type ListFilterInputTypeOfProductAttribEtemplateFilterInput = {
  all?: InputMaybe<ProductAttribEtemplateFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ProductAttribEtemplateFilterInput>;
  some?: InputMaybe<ProductAttribEtemplateFilterInput>;
};

export type ListFilterInputTypeOfProductAttributeFilterInput = {
  all?: InputMaybe<ProductAttributeFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ProductAttributeFilterInput>;
  some?: InputMaybe<ProductAttributeFilterInput>;
};

export type ListFilterInputTypeOfProductCategoryOrderLimitByRoleFilterInput = {
  all?: InputMaybe<ProductCategoryOrderLimitByRoleFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ProductCategoryOrderLimitByRoleFilterInput>;
  some?: InputMaybe<ProductCategoryOrderLimitByRoleFilterInput>;
};

export type ListFilterInputTypeOfProductCodeHistoryFilterInput = {
  all?: InputMaybe<ProductCodeHistoryFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ProductCodeHistoryFilterInput>;
  some?: InputMaybe<ProductCodeHistoryFilterInput>;
};

export type ListFilterInputTypeOfProductCustomerPropertyMapFilterInput = {
  all?: InputMaybe<ProductCustomerPropertyMapFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ProductCustomerPropertyMapFilterInput>;
  some?: InputMaybe<ProductCustomerPropertyMapFilterInput>;
};

export type ListFilterInputTypeOfProductDocumentFilterInput = {
  all?: InputMaybe<ProductDocumentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ProductDocumentFilterInput>;
  some?: InputMaybe<ProductDocumentFilterInput>;
};

export type ListFilterInputTypeOfProductFilterInput = {
  all?: InputMaybe<ProductFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ProductFilterInput>;
  some?: InputMaybe<ProductFilterInput>;
};

export type ListFilterInputTypeOfProductHistoryFilterInput = {
  all?: InputMaybe<ProductHistoryFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ProductHistoryFilterInput>;
  some?: InputMaybe<ProductHistoryFilterInput>;
};

export type ListFilterInputTypeOfProductKittingFilterInput = {
  all?: InputMaybe<ProductKittingFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ProductKittingFilterInput>;
  some?: InputMaybe<ProductKittingFilterInput>;
};

export type ListFilterInputTypeOfProductMappingFilterInput = {
  all?: InputMaybe<ProductMappingFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ProductMappingFilterInput>;
  some?: InputMaybe<ProductMappingFilterInput>;
};

export type ListFilterInputTypeOfProductMediumFilterInput = {
  all?: InputMaybe<ProductMediumFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ProductMediumFilterInput>;
  some?: InputMaybe<ProductMediumFilterInput>;
};

export type ListFilterInputTypeOfProductNewTempAllowedQuantFilterInput = {
  all?: InputMaybe<ProductNewTempAllowedQuantFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ProductNewTempAllowedQuantFilterInput>;
  some?: InputMaybe<ProductNewTempAllowedQuantFilterInput>;
};

export type ListFilterInputTypeOfProductNewTemporaryFilterInput = {
  all?: InputMaybe<ProductNewTemporaryFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ProductNewTemporaryFilterInput>;
  some?: InputMaybe<ProductNewTemporaryFilterInput>;
};

export type ListFilterInputTypeOfProductOrderLimitByRoleFilterInput = {
  all?: InputMaybe<ProductOrderLimitByRoleFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ProductOrderLimitByRoleFilterInput>;
  some?: InputMaybe<ProductOrderLimitByRoleFilterInput>;
};

export type ListFilterInputTypeOfProductRelatedItemFilterInput = {
  all?: InputMaybe<ProductRelatedItemFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ProductRelatedItemFilterInput>;
  some?: InputMaybe<ProductRelatedItemFilterInput>;
};

export type ListFilterInputTypeOfProductReplenishmentAlertFilterInput = {
  all?: InputMaybe<ProductReplenishmentAlertFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ProductReplenishmentAlertFilterInput>;
  some?: InputMaybe<ProductReplenishmentAlertFilterInput>;
};

export type ListFilterInputTypeOfProductStocktakeSettingFilterInput = {
  all?: InputMaybe<ProductStocktakeSettingFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ProductStocktakeSettingFilterInput>;
  some?: InputMaybe<ProductStocktakeSettingFilterInput>;
};

export type ListFilterInputTypeOfProductUomFilterInput = {
  all?: InputMaybe<ProductUomFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ProductUomFilterInput>;
  some?: InputMaybe<ProductUomFilterInput>;
};

export type ListFilterInputTypeOfProductVisibilityFilterInput = {
  all?: InputMaybe<ProductVisibilityFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ProductVisibilityFilterInput>;
  some?: InputMaybe<ProductVisibilityFilterInput>;
};

export type ListFilterInputTypeOfProjectFilterInput = {
  all?: InputMaybe<ProjectFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ProjectFilterInput>;
  some?: InputMaybe<ProjectFilterInput>;
};

export type ListFilterInputTypeOfProjectStageAttendeeFilterInput = {
  all?: InputMaybe<ProjectStageAttendeeFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ProjectStageAttendeeFilterInput>;
  some?: InputMaybe<ProjectStageAttendeeFilterInput>;
};

export type ListFilterInputTypeOfProjectStageFilterInput = {
  all?: InputMaybe<ProjectStageFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ProjectStageFilterInput>;
  some?: InputMaybe<ProjectStageFilterInput>;
};

export type ListFilterInputTypeOfProjectVisibilityFilterInput = {
  all?: InputMaybe<ProjectVisibilityFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ProjectVisibilityFilterInput>;
  some?: InputMaybe<ProjectVisibilityFilterInput>;
};

export type ListFilterInputTypeOfPromoCodeFilterInput = {
  all?: InputMaybe<PromoCodeFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<PromoCodeFilterInput>;
  some?: InputMaybe<PromoCodeFilterInput>;
};

export type ListFilterInputTypeOfRecipientDataFilterInput = {
  all?: InputMaybe<RecipientDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<RecipientDataFilterInput>;
  some?: InputMaybe<RecipientDataFilterInput>;
};

export type ListFilterInputTypeOfRecruitmentFilterInput = {
  all?: InputMaybe<RecruitmentFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<RecruitmentFilterInput>;
  some?: InputMaybe<RecruitmentFilterInput>;
};

export type ListFilterInputTypeOfRecruitmentStepFilterInput = {
  all?: InputMaybe<RecruitmentStepFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<RecruitmentStepFilterInput>;
  some?: InputMaybe<RecruitmentStepFilterInput>;
};

export type ListFilterInputTypeOfRecurringFeeFilterInput = {
  all?: InputMaybe<RecurringFeeFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<RecurringFeeFilterInput>;
  some?: InputMaybe<RecurringFeeFilterInput>;
};

export type ListFilterInputTypeOfReportBusinessLevelVisibilityFilterInput = {
  all?: InputMaybe<ReportBusinessLevelVisibilityFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ReportBusinessLevelVisibilityFilterInput>;
  some?: InputMaybe<ReportBusinessLevelVisibilityFilterInput>;
};

export type ListFilterInputTypeOfReportColumnFilterInput = {
  all?: InputMaybe<ReportColumnFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ReportColumnFilterInput>;
  some?: InputMaybe<ReportColumnFilterInput>;
};

export type ListFilterInputTypeOfReportFilterInput = {
  all?: InputMaybe<ReportFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ReportFilterInput>;
  some?: InputMaybe<ReportFilterInput>;
};

export type ListFilterInputTypeOfReportRoleTableListVisibilityFilterInput = {
  all?: InputMaybe<ReportRoleTableListVisibilityFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ReportRoleTableListVisibilityFilterInput>;
  some?: InputMaybe<ReportRoleTableListVisibilityFilterInput>;
};

export type ListFilterInputTypeOfReportRoleVisibilityFilterInput = {
  all?: InputMaybe<ReportRoleVisibilityFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ReportRoleVisibilityFilterInput>;
  some?: InputMaybe<ReportRoleVisibilityFilterInput>;
};

export type ListFilterInputTypeOfReportScheduleFilterInput = {
  all?: InputMaybe<ReportScheduleFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ReportScheduleFilterInput>;
  some?: InputMaybe<ReportScheduleFilterInput>;
};

export type ListFilterInputTypeOfReportTableColumnListFilterInput = {
  all?: InputMaybe<ReportTableColumnListFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ReportTableColumnListFilterInput>;
  some?: InputMaybe<ReportTableColumnListFilterInput>;
};

export type ListFilterInputTypeOfReportTableListFilterInput = {
  all?: InputMaybe<ReportTableListFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ReportTableListFilterInput>;
  some?: InputMaybe<ReportTableListFilterInput>;
};

export type ListFilterInputTypeOfRoleCategoryDiscountFilterInput = {
  all?: InputMaybe<RoleCategoryDiscountFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<RoleCategoryDiscountFilterInput>;
  some?: InputMaybe<RoleCategoryDiscountFilterInput>;
};

export type ListFilterInputTypeOfRoleCategoryVisibilityFilterInput = {
  all?: InputMaybe<RoleCategoryVisibilityFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<RoleCategoryVisibilityFilterInput>;
  some?: InputMaybe<RoleCategoryVisibilityFilterInput>;
};

export type ListFilterInputTypeOfRoleFilterInput = {
  all?: InputMaybe<RoleFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<RoleFilterInput>;
  some?: InputMaybe<RoleFilterInput>;
};

export type ListFilterInputTypeOfRoleFreightMapFilterInput = {
  all?: InputMaybe<RoleFreightMapFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<RoleFreightMapFilterInput>;
  some?: InputMaybe<RoleFreightMapFilterInput>;
};

export type ListFilterInputTypeOfRoleOrderTypeFilterInput = {
  all?: InputMaybe<RoleOrderTypeFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<RoleOrderTypeFilterInput>;
  some?: InputMaybe<RoleOrderTypeFilterInput>;
};

export type ListFilterInputTypeOfRolePermissionFilterInput = {
  all?: InputMaybe<RolePermissionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<RolePermissionFilterInput>;
  some?: InputMaybe<RolePermissionFilterInput>;
};

export type ListFilterInputTypeOfRoleProductDiscountFilterInput = {
  all?: InputMaybe<RoleProductDiscountFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<RoleProductDiscountFilterInput>;
  some?: InputMaybe<RoleProductDiscountFilterInput>;
};

export type ListFilterInputTypeOfSalesForceSettingFilterInput = {
  all?: InputMaybe<SalesForceSettingFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<SalesForceSettingFilterInput>;
  some?: InputMaybe<SalesForceSettingFilterInput>;
};

export type ListFilterInputTypeOfSiteMapFilterInput = {
  all?: InputMaybe<SiteMapFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<SiteMapFilterInput>;
  some?: InputMaybe<SiteMapFilterInput>;
};

export type ListFilterInputTypeOfSiteMapOverrideFilterInput = {
  all?: InputMaybe<SiteMapOverrideFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<SiteMapOverrideFilterInput>;
  some?: InputMaybe<SiteMapOverrideFilterInput>;
};

export type ListFilterInputTypeOfSiteMapPageMapFilterInput = {
  all?: InputMaybe<SiteMapPageMapFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<SiteMapPageMapFilterInput>;
  some?: InputMaybe<SiteMapPageMapFilterInput>;
};

export type ListFilterInputTypeOfSmsDetailFilterInput = {
  all?: InputMaybe<SmsDetailFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<SmsDetailFilterInput>;
  some?: InputMaybe<SmsDetailFilterInput>;
};

export type ListFilterInputTypeOfSmsReplyFilterInput = {
  all?: InputMaybe<SmsReplyFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<SmsReplyFilterInput>;
  some?: InputMaybe<SmsReplyFilterInput>;
};

export type ListFilterInputTypeOfSmsRequestFilterInput = {
  all?: InputMaybe<SmsRequestFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<SmsRequestFilterInput>;
  some?: InputMaybe<SmsRequestFilterInput>;
};

export type ListFilterInputTypeOfSmsTemplateFilterInput = {
  all?: InputMaybe<SmsTemplateFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<SmsTemplateFilterInput>;
  some?: InputMaybe<SmsTemplateFilterInput>;
};

export type ListFilterInputTypeOfSpecialConditionFilterInput = {
  all?: InputMaybe<SpecialConditionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<SpecialConditionFilterInput>;
  some?: InputMaybe<SpecialConditionFilterInput>;
};

export type ListFilterInputTypeOfStihlbaseOrderSubmissionFilterInput = {
  all?: InputMaybe<StihlbaseOrderSubmissionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<StihlbaseOrderSubmissionFilterInput>;
  some?: InputMaybe<StihlbaseOrderSubmissionFilterInput>;
};

export type ListFilterInputTypeOfSubTaskFilterInput = {
  all?: InputMaybe<SubTaskFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<SubTaskFilterInput>;
  some?: InputMaybe<SubTaskFilterInput>;
};

export type ListFilterInputTypeOfSurveySubmissionAnswerFilterInput = {
  all?: InputMaybe<SurveySubmissionAnswerFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<SurveySubmissionAnswerFilterInput>;
  some?: InputMaybe<SurveySubmissionAnswerFilterInput>;
};

export type ListFilterInputTypeOfSurveySubmissionHeaderFilterInput = {
  all?: InputMaybe<SurveySubmissionHeaderFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<SurveySubmissionHeaderFilterInput>;
  some?: InputMaybe<SurveySubmissionHeaderFilterInput>;
};

export type ListFilterInputTypeOfSurveySubmissionQuestionFilterInput = {
  all?: InputMaybe<SurveySubmissionQuestionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<SurveySubmissionQuestionFilterInput>;
  some?: InputMaybe<SurveySubmissionQuestionFilterInput>;
};

export type ListFilterInputTypeOfTeamCustomerFilterInput = {
  all?: InputMaybe<TeamCustomerFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<TeamCustomerFilterInput>;
  some?: InputMaybe<TeamCustomerFilterInput>;
};

export type ListFilterInputTypeOfTranslationFilterInput = {
  all?: InputMaybe<TranslationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<TranslationFilterInput>;
  some?: InputMaybe<TranslationFilterInput>;
};

export type ListFilterInputTypeOfTsuCustomerFeatureFilterInput = {
  all?: InputMaybe<TsuCustomerFeatureFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<TsuCustomerFeatureFilterInput>;
  some?: InputMaybe<TsuCustomerFeatureFilterInput>;
};

export type ListFilterInputTypeOfUserActionFilterInput = {
  all?: InputMaybe<UserActionFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<UserActionFilterInput>;
  some?: InputMaybe<UserActionFilterInput>;
};

export type ListFilterInputTypeOfUserCreditByCategoryFilterInput = {
  all?: InputMaybe<UserCreditByCategoryFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<UserCreditByCategoryFilterInput>;
  some?: InputMaybe<UserCreditByCategoryFilterInput>;
};

export type ListFilterInputTypeOfUserDetailFilterInput = {
  all?: InputMaybe<UserDetailFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<UserDetailFilterInput>;
  some?: InputMaybe<UserDetailFilterInput>;
};

export type ListFilterInputTypeOfUserProfileFilterInput = {
  all?: InputMaybe<UserProfileFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<UserProfileFilterInput>;
  some?: InputMaybe<UserProfileFilterInput>;
};

export type ListFilterInputTypeOfUserSpendByCategoryFilterInput = {
  all?: InputMaybe<UserSpendByCategoryFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<UserSpendByCategoryFilterInput>;
  some?: InputMaybe<UserSpendByCategoryFilterInput>;
};

export type ListFilterInputTypeOfWmsAssignedNumberFilterInput = {
  all?: InputMaybe<WmsAssignedNumberFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<WmsAssignedNumberFilterInput>;
  some?: InputMaybe<WmsAssignedNumberFilterInput>;
};

export type ListFilterInputTypeOfWmsCyclicProductFilterInput = {
  all?: InputMaybe<WmsCyclicProductFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<WmsCyclicProductFilterInput>;
  some?: InputMaybe<WmsCyclicProductFilterInput>;
};

export type ListFilterInputTypeOfWmsCyclicStockCountFilterInput = {
  all?: InputMaybe<WmsCyclicStockCountFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<WmsCyclicStockCountFilterInput>;
  some?: InputMaybe<WmsCyclicStockCountFilterInput>;
};

export type ListFilterInputTypeOfWmsLocationFilterInput = {
  all?: InputMaybe<WmsLocationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<WmsLocationFilterInput>;
  some?: InputMaybe<WmsLocationFilterInput>;
};

export type ListFilterInputTypeOfWmsPickDetailFilterInput = {
  all?: InputMaybe<WmsPickDetailFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<WmsPickDetailFilterInput>;
  some?: InputMaybe<WmsPickDetailFilterInput>;
};

export type ListFilterInputTypeOfWmsPickedStockFilterInput = {
  all?: InputMaybe<WmsPickedStockFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<WmsPickedStockFilterInput>;
  some?: InputMaybe<WmsPickedStockFilterInput>;
};

export type ListFilterInputTypeOfWmsRgaFilterInput = {
  all?: InputMaybe<WmsRgaFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<WmsRgaFilterInput>;
  some?: InputMaybe<WmsRgaFilterInput>;
};

export type ListFilterInputTypeOfWmsRgareceivedFilterInput = {
  all?: InputMaybe<WmsRgareceivedFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<WmsRgareceivedFilterInput>;
  some?: InputMaybe<WmsRgareceivedFilterInput>;
};

export type ListFilterInputTypeOfWmsSerialNumberFilterInput = {
  all?: InputMaybe<WmsSerialNumberFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<WmsSerialNumberFilterInput>;
  some?: InputMaybe<WmsSerialNumberFilterInput>;
};

export type ListFilterInputTypeOfWmsStockQuantityFilterInput = {
  all?: InputMaybe<WmsStockQuantityFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<WmsStockQuantityFilterInput>;
  some?: InputMaybe<WmsStockQuantityFilterInput>;
};

export type ListFilterInputTypeOfZeecapeJobDetailsv2FilterInput = {
  all?: InputMaybe<ZeecapeJobDetailsv2FilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ZeecapeJobDetailsv2FilterInput>;
  some?: InputMaybe<ZeecapeJobDetailsv2FilterInput>;
};

export type ListFilterInputTypeOfZeescapeJobApplicationFilterInput = {
  all?: InputMaybe<ZeescapeJobApplicationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ZeescapeJobApplicationFilterInput>;
  some?: InputMaybe<ZeescapeJobApplicationFilterInput>;
};

export type ListFilterInputTypeOfZeescapeJobDetailFilterInput = {
  all?: InputMaybe<ZeescapeJobDetailFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ZeescapeJobDetailFilterInput>;
  some?: InputMaybe<ZeescapeJobDetailFilterInput>;
};

export type ListFilterInputTypeOfZeescapeJobFilterInput = {
  all?: InputMaybe<ZeescapeJobFilterInput>;
  any?: InputMaybe<Scalars['Boolean']>;
  none?: InputMaybe<ZeescapeJobFilterInput>;
  some?: InputMaybe<ZeescapeJobFilterInput>;
};

/** Represents the input to login. */
export type LoginInputType = {
  /** Represents the user email. */
  email: Scalars['String'];
  /** Represents the user password. */
  password: Scalars['String'];
};

/** Represents the payload return for user login. */
export type LoginPayloadType = {
  __typename?: 'LoginPayloadType';
  /** Represents the unix time the token expires at. */
  expires: Scalars['Long'];
  refreshToken: Scalars['String'];
  refreshTokenExpires: Scalars['Long'];
  /** Represents the JWT. */
  token: Scalars['String'];
};

export type MimeType = {
  __typename?: 'MimeType';
  emailAttachments: Array<EmailAttachment>;
  extension: Scalars['String'];
  imageType: Scalars['Boolean'];
  mime: Scalars['String'];
  mimeTypeId: Scalars['Int'];
  thumbImage?: Maybe<Array<Scalars['ByteArray']>>;
};

export type MimeTypeFilterInput = {
  and?: InputMaybe<Array<MimeTypeFilterInput>>;
  emailAttachments?: InputMaybe<ListFilterInputTypeOfEmailAttachmentFilterInput>;
  extension?: InputMaybe<StringOperationFilterInput>;
  imageType?: InputMaybe<BooleanOperationFilterInput>;
  mime?: InputMaybe<StringOperationFilterInput>;
  mimeTypeId?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<MimeTypeFilterInput>>;
  thumbImage?: InputMaybe<ListComparableByteOperationFilterInput>;
};

export type MinimumPerformanceFilterInput = {
  agreement?: InputMaybe<AgreementFilterInput>;
  agreementId?: InputMaybe<ComparableInt32OperationFilterInput>;
  and?: InputMaybe<Array<MinimumPerformanceFilterInput>>;
  measure?: InputMaybe<StringOperationFilterInput>;
  minimumPerformanceId?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<MinimumPerformanceFilterInput>>;
  rowVersion?: InputMaybe<ListComparableByteOperationFilterInput>;
  value?: InputMaybe<ComparableDecimalOperationFilterInput>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addFeature?: Maybe<TsuFeature>;
  /** Create a new user. */
  addUser?: Maybe<UserType>;
  /** Approve multiple Order Shipping Requests. */
  approveMultipleOrderShippings?: Maybe<Array<OrderShippingType>>;
  /** Approves an Order Shipping Request. */
  approveOrderShipping?: Maybe<OrderShippingType>;
  autoPopulateCustomerFeatures: AutoPopulateCustomerFeaturesPayload;
  /** Cancels an Order Shipping Request. */
  cancelOrderShipping?: Maybe<OrderShippingType>;
  /** Changes a logged in user's customer. */
  changeCustomer: LoginPayloadType;
  contactUs?: Maybe<ContactUsResponse>;
  /** Create a temporary cart. */
  createCart?: Maybe<Cart>;
  createChildProduct?: Maybe<ProductType>;
  createProduct?: Maybe<SimpleMessageResponse>;
  /** Creates a Report Schedule. */
  createReportSchedule?: Maybe<ReportScheduleType>;
  createUom?: Maybe<SimpleMessageResponse>;
  /** Delete Product. */
  deleteProduct?: Maybe<SimpleMessageResponse>;
  /** Deletes a user's shopping cart. */
  deleteShoppingCart?: Maybe<DeleteShoppingCartResponse>;
  /** Punchout to Legacy Waivenet RGA List page */
  punchoutRgaWaivenet: WaivenetPunchoutPayload;
  /** Punchout to Legacy Waivenet */
  punchoutWaivenet: WaivenetPunchoutPayload;
  /** Punchout to Legacy Waivenet Document Manager page */
  punchoutWaivenetDocMana: WaivenetPunchoutPayload;
  /** Punchout to Legacy Waivenet Project Management page */
  punchoutWaivenetPms: WaivenetPunchoutPayload;
  /** Punchout to Legacy Waivenet Reports page */
  punchoutWaivenetReport: WaivenetPunchoutPayload;
  /** Punchout to Legacy Waivenet Rga list page */
  punchoutRgaListWaivenet: WaivenetPunchoutPayload;
  /** Punchout to Legacy Waivenet Rga list page */
  punchoutExpectedDeliveryUploadWaivenet: WaivenetPunchoutPayload;
  refreshAccessToken: LoginPayloadType;
  removeFeature: RemoveFeaturePayload;
  removeUom?: Maybe<ProductUom>;
  /** Sends password reset email. */
  resetEmail: ResetEmailPayload;
  /** Resets a user's password. */
  resetPassword: ResetPasswordPayloadType;
  /** Restore Product. */
  restoreProduct?: Maybe<SimpleMessageResponse>;
  /** Submits an order. */
  submitOrder: SubmitOrderPayloadType;
  /** Submits an order without sending order confirmation email. */
  submitOrderWithoutEmail: SubmitOrderPayloadType;
  /** Submits a csv file to the backend to process multiple cart items. */
  bulkCartCsvUpload: string;
  /** Submits a csv file to the backend to process multiple orders. */
  bulkOrderCsvUpload: string;
  /** Load a saved order parameters into the current user cart. */
  loadSavedOrder: string;
  /** Updates a temporary cart. */
  updateCart?: Maybe<Cart>;
  updateCrossUpSales?: Maybe<SimpleMessageResponse>;
  updateCustomerFeature?: Maybe<TsuCustomerFeature>;
  /** Updates a user's details. */
  updateDetails: UpdateDetailsPayload;
  /** Updates a user's favorites. */
  updateFavorites?: Maybe<Favorite>;
  updateMultipleCustomerFeatures?: Maybe<Array<TsuCustomerFeature>>;
  /** Update the quantity and active of an order line. */
  updateOrderLineQuantity?: Maybe<OrderLineType>;
  /** Update Product's Categories. */
  updateProductCategories?: Maybe<SimpleMessageResponse>;
  /** Update Product Details. */
  updateProductDetails?: Maybe<SimpleMessageResponse>;
  updateProductParent?: Maybe<ProductType>;
  /** Update a role. */
  updateRole?: Maybe<RoleType>;
  /** Updates a user's shopping cart. */
  updateShoppingCart?: Maybe<ShoppingCartType>;
  /** Update an existing Theme. */
  updateTheme?: Maybe<TsunamiTheme>;
  updateUom?: Maybe<SimpleMessageResponse>;
  /** Logs in a user. */
  userLogin: LoginPayloadType;
};


export type MutationAddFeatureArgs = {
  input: AddFeatureInput;
};


export type MutationAddUserArgs = {
  input: CreateUserInputType;
};


export type MutationApproveMultipleOrderShippingsArgs = {
  input: ApproveMultipleOrderShippingsInput;
};


export type MutationApproveOrderShippingArgs = {
  input: ApproveOrderShippingInput;
};


export type MutationCancelOrderShippingArgs = {
  input: ApproveOrderShippingInput;
};

export type MutationUpdateOrderShippingFeeArgs = {
  input: UpdateOrderShippingFeeInput;
};


export type MutationChangeCustomerArgs = {
  input: ChangeCustomerInputType;
};


export type MutationContactUsArgs = {
  input: ContactUsInput;
};


export type MutationCreateCartArgs = {
  input: CartInformationInput;
};


export type MutationCreateChildProductArgs = {
  attribDataId: Scalars['Int'];
  productId: Scalars['Int'];
};


export type MutationCreateProductArgs = {
  payload: CreateProductPayloadInput;
};


export type MutationCreateReportScheduleArgs = {
  input: CreateReportScheduleInput;
};


export type MutationCreateUomArgs = {
  input: CreateProductUomPayloadInput;
  productId: Scalars['Int'];
};


export type MutationDeleteProductArgs = {
  productId: Scalars['Int'];
};


export type MutationDeleteShoppingCartArgs = {
  shoppingCartId?: InputMaybe<Scalars['String']>;
};

export type MutationPunchoutRgaWaivenetArgs = {
  input: WaivenetPunchoutInput;
};


export type MutationPunchoutWaivenetArgs = {
  input: WaivenetPunchoutInput;
};


export type MutationPunchoutWaivenetDocManaArgs = {
  input: WaivenetPunchoutInput;
};


export type MutationPunchoutWaivenetPmsArgs = {
  input: WaivenetPunchoutInput;
};


export type MutationPunchoutWaivenetReportArgs = {
  input: WaivenetPunchoutInput;
};

export type MutationPunchoutRgaListWaivenetArgs = {
  input: WaivenetPunchoutInput;
};

export type MutationPunchoutExpectedDeliveryUploadWaivenetArgs = {
  input: WaivenetPunchoutInput;
};


export type MutationRefreshAccessTokenArgs = {
  refreshToken: Scalars['String'];
};


export type MutationRemoveFeatureArgs = {
  tsuFeatureId: Scalars['Int'];
};


export type MutationRemoveUomArgs = {
  uomId: Scalars['Int'];
};


export type MutationResetEmailArgs = {
  input: ResetEmailInputType;
};


export type MutationResetPasswordArgs = {
  input: ResetPasswordInputType;
};


export type MutationRestoreProductArgs = {
  productId: Scalars['Int'];
};


export type MutationSubmitOrderArgs = {
  cartId: Scalars['String'];
};


export type MutationUpdateCartArgs = {
  cartId: Scalars['String'];
  input: CartInformationInput;
};


export type MutationUpdateCrossUpSalesArgs = {
  payload: UpdateCrossUpSalesPayloadInput;
};


export type MutationUpdateCustomerFeatureArgs = {
  input: UpdateCustomerFeatureInput;
};


export type MutationUpdateDetailsArgs = {
  input: UpdateDetailsInputType;
};


export type MutationUpdateFavoritesArgs = {
  favoriteId?: InputMaybe<Scalars['String']>;
  input: Array<FavoriteProductEntryInput>;
};


export type MutationUpdateMultipleCustomerFeaturesArgs = {
  input: UpdateMultipleCustomerFeaturesInput;
};


export type MutationUpdateOrderLineQuantityArgs = {
  input: UpdateOrderLineQuantityInput;
};

export type MutationUpdateOrderShippingStatusArgs = {
  input: UpdateOrderShippingStatusInput;
};

export type MutationUpdateOrderSavedArgs = {
  input: UpdateOrderSavedInput;
};

export type MutationUpdateProductCategoriesArgs = {
  payload: UpdateProductCategoryPayloadInput;
  productId: Scalars['Int'];
};


export type MutationUpdateProductDetailsArgs = {
  payload: ProductDetailsPayloadInput;
  productId: Scalars['Int'];
};


export type MutationUpdateProductParentArgs = {
  childProductId: Scalars['Int'];
  link?: InputMaybe<Scalars['Boolean']>;
  productId: Scalars['Int'];
};


export type MutationUpdateRoleArgs = {
  input: UpdateRoleDetailsInput;
};


export type MutationUpdateShoppingCartArgs = {
  cartItems: Array<ShoppingCartItemInput>;
  shoppingCartId?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateThemeArgs = {
  input: UpdateThemeRequestInput;
};


export type MutationUpdateUomArgs = {
  input: CreateProductUomPayloadInput;
  uomId: Scalars['Int'];
};


export type MutationUserLoginArgs = {
  input: LoginInputType;
};

export type NavigationBar = {
  __typename?: 'NavigationBar';
  background: Scalars['String'];
  buttonActive: Scalars['String'];
  buttonRadius: Scalars['Int'];
  text: Scalars['String'];
  textActive: Scalars['String'];
};

export type NavigationBarUpdatesInput = {
  background?: InputMaybe<Scalars['String']>;
  buttonActive?: InputMaybe<Scalars['String']>;
  buttonRadius?: InputMaybe<Scalars['Int']>;
  text?: InputMaybe<Scalars['String']>;
  textActive?: InputMaybe<Scalars['String']>;
};

export type OneOffFeeFilterInput = {
  agreement?: InputMaybe<AgreementFilterInput>;
  agreementId?: InputMaybe<ComparableInt32OperationFilterInput>;
  and?: InputMaybe<Array<OneOffFeeFilterInput>>;
  assignment?: InputMaybe<StringOperationFilterInput>;
  initial?: InputMaybe<ComparableDecimalOperationFilterInput>;
  oneOffFeeId?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<OneOffFeeFilterInput>>;
  renewal?: InputMaybe<ComparableDateTimeOperationFilterInput>;
};

export type Order = {
  __typename?: 'Order';
  active: Scalars['Boolean'];
  activity?: Maybe<Activity>;
  activityId?: Maybe<Scalars['Int']>;
  appliedOrderCredit?: Maybe<Scalars['Decimal']>;
  campaigns: Array<Campaign>;
  contractNumber?: Maybe<Scalars['String']>;
  created: Scalars['DateTime'];
  customer: Customer;
  customerId: Scalars['Int'];
  customerOrderRef?: Maybe<Scalars['String']>;
  despatchDate?: Maybe<Scalars['DateTime']>;
  favourite: Scalars['Boolean'];
  favouriteName?: Maybe<Scalars['String']>;
  grandTotal?: Maybe<Scalars['Decimal']>;
  gstpercent?: Maybe<Scalars['Decimal']>;
  gsttotal?: Maybe<Scalars['Decimal']>;
  jobNumber: Scalars['Int'];
  modified: Scalars['DateTime'];
  optIn?: Maybe<Scalars['Boolean']>;
  orderId: Scalars['Int'];
  orderOptData: Array<OrderOptDatum>;
  orderOptHeads: Array<OrderOptHead>;
  orderPaymentHistories: Array<OrderPaymentHistory>;
  orderShipMultiShipment: Scalars['Boolean'];
  orderShipPartShipment: Scalars['Boolean'];
  orderShipSingleShipment: Scalars['Boolean'];
  orderShippings: Array<OrderShippingType>;
  paypalPayments: Array<PaypalPayment>;
  pickTotal?: Maybe<Scalars['Decimal']>;
  preOrderCreditTotal?: Maybe<Scalars['Decimal']>;
  project?: Maybe<Project>;
  projectId?: Maybe<Scalars['Int']>;
  purgeDate?: Maybe<Scalars['DateTime']>;
  removed: Scalars['Boolean'];
  rowVersion: Array<Scalars['ByteArray']>;
  savedOrder: Scalars['Boolean'];
  selectedCreditCard?: Maybe<Scalars['Int']>;
  sellersAbn?: Maybe<Scalars['String']>;
  sellersCompanyName?: Maybe<Scalars['String']>;
  sellersCountry?: Maybe<Scalars['String']>;
  sellersEmail?: Maybe<Scalars['String']>;
  sellersPhone?: Maybe<Scalars['String']>;
  sellersPostcode?: Maybe<Scalars['String']>;
  sellersState?: Maybe<Scalars['String']>;
  sellersStreet1?: Maybe<Scalars['String']>;
  sellersSuburb?: Maybe<Scalars['String']>;
  shippingTotal?: Maybe<Scalars['Decimal']>;
  subTotal?: Maybe<Scalars['Decimal']>;
  surchargePercent?: Maybe<Scalars['Decimal']>;
  surchargeTotal?: Maybe<Scalars['Decimal']>;
  tncAnswers?: Maybe<Scalars['String']>;
  userCreatedFirstName: Scalars['String'];
  userCreatedId: Scalars['Int'];
  userCreatedLastName: Scalars['String'];
  userModifiedId: Scalars['Int'];
  zeescapeJobs: Array<ZeescapeJob>;
  zeroFreightOrderAmount?: Maybe<Scalars['Decimal']>;
};

/** Represents the input for an order's address. */
export type OrderAddressInputType = {
  /** Represents the address' company name. */
  company?: InputMaybe<Scalars['String']>;
  /** Represents the address country. */
  country: Scalars['String'];
  /** Represents the address contact email. */
  email: Scalars['String'];
  /** Represents the address contact mobile number. */
  mobile?: InputMaybe<Scalars['String']>;
  /** Represents the address contact phone number. */
  phone: Scalars['String'];
  /** Represents the address postcode. */
  postcode: Scalars['String'];
  /** Represents the address state. */
  state: Scalars['String'];
  /** Represents the street 1. */
  street1: Scalars['String'];
  /** Represents the street 2. */
  street2?: InputMaybe<Scalars['String']>;
  /** Represents the street 3. */
  street3?: InputMaybe<Scalars['String']>;
  /** Represents the street 4. */
  street4?: InputMaybe<Scalars['String']>;
  /** Represents the address suburb. */
  suburb: Scalars['String'];
};

export type OrderAdvancedReportRecord = {
  __typename?: 'OrderAdvancedReportRecord';
  billingBusinessLevel: Scalars['String'];
  companyName: Scalars['String'];
  createdOn: Scalars['DateTime'];
  deliveryNote: Scalars['String'];
  deliveryPostcode: Scalars['String'];
  deliveryStreetAddress: Scalars['String'];
  deliverySuburb: Scalars['String'];
  despatchDate: Scalars['DateTime'];
  grandTotal: Scalars['Decimal'];
  gstTotal: Scalars['Decimal'];
  orderStatus: Scalars['String'];
  orderTotal: Scalars['Decimal'];
  orderType: Scalars['String'];
  ordererFirstName: Scalars['String'];
  ordererLastName: Scalars['String'];
  recipientFirstName: Scalars['String'];
  recipientLastName: Scalars['String'];
  shippingNo: Scalars['String'];
  uniqueId: Scalars['String'];
};

export type OrderAdvancedReportRecordCollectionSegment = {
  __typename?: 'OrderAdvancedReportRecordCollectionSegment';
  items?: Maybe<Array<OrderAdvancedReportRecord>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type OrderAdvancedReportRecordFilterInput = {
  and?: InputMaybe<Array<OrderAdvancedReportRecordFilterInput>>;
  billingBusinessLevel?: InputMaybe<StringOperationFilterInput>;
  companyName?: InputMaybe<StringOperationFilterInput>;
  createdOn?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  deliveryNote?: InputMaybe<StringOperationFilterInput>;
  deliveryPostcode?: InputMaybe<StringOperationFilterInput>;
  deliveryStreetAddress?: InputMaybe<StringOperationFilterInput>;
  deliverySuburb?: InputMaybe<StringOperationFilterInput>;
  despatchDate?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  grandTotal?: InputMaybe<ComparableDecimalOperationFilterInput>;
  gstTotal?: InputMaybe<ComparableDecimalOperationFilterInput>;
  or?: InputMaybe<Array<OrderAdvancedReportRecordFilterInput>>;
  orderStatus?: InputMaybe<StringOperationFilterInput>;
  orderTotal?: InputMaybe<ComparableDecimalOperationFilterInput>;
  orderType?: InputMaybe<StringOperationFilterInput>;
  ordererFirstName?: InputMaybe<StringOperationFilterInput>;
  ordererLastName?: InputMaybe<StringOperationFilterInput>;
  recipientFirstName?: InputMaybe<StringOperationFilterInput>;
  recipientLastName?: InputMaybe<StringOperationFilterInput>;
  shippingNo?: InputMaybe<StringOperationFilterInput>;
  uniqueId?: InputMaybe<StringOperationFilterInput>;
};

export type OrderAdvancedReportRecordSortInput = {
  billingBusinessLevel?: InputMaybe<SortEnumType>;
  companyName?: InputMaybe<SortEnumType>;
  createdOn?: InputMaybe<SortEnumType>;
  deliveryNote?: InputMaybe<SortEnumType>;
  deliveryPostcode?: InputMaybe<SortEnumType>;
  deliveryStreetAddress?: InputMaybe<SortEnumType>;
  deliverySuburb?: InputMaybe<SortEnumType>;
  despatchDate?: InputMaybe<SortEnumType>;
  grandTotal?: InputMaybe<SortEnumType>;
  gstTotal?: InputMaybe<SortEnumType>;
  orderStatus?: InputMaybe<SortEnumType>;
  orderTotal?: InputMaybe<SortEnumType>;
  orderType?: InputMaybe<SortEnumType>;
  ordererFirstName?: InputMaybe<SortEnumType>;
  ordererLastName?: InputMaybe<SortEnumType>;
  recipientFirstName?: InputMaybe<SortEnumType>;
  recipientLastName?: InputMaybe<SortEnumType>;
  shippingNo?: InputMaybe<SortEnumType>;
  uniqueId?: InputMaybe<SortEnumType>;
};

export type OrderBasicReportRecord = {
  __typename?: 'OrderBasicReportRecord';
  companyName: Scalars['String'];
  deliveryPostcode: Scalars['String'];
  deliveryStreetAddress: Scalars['String'];
  deliverySuburb: Scalars['String'];
  despatchDate: Scalars['DateTime'];
  grandTotal: Scalars['Decimal'];
  gstTotal: Scalars['Decimal'];
  orderStatus: Scalars['String'];
  orderTotal: Scalars['Decimal'];
  recipientFirstName: Scalars['String'];
  recipientLastName: Scalars['String'];
  shippingNo: Scalars['String'];
  uniqueId: Scalars['String'];
};

export type OrderBasicReportRecordCollectionSegment = {
  __typename?: 'OrderBasicReportRecordCollectionSegment';
  items?: Maybe<Array<OrderBasicReportRecord>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type OrderBasicReportRecordFilterInput = {
  and?: InputMaybe<Array<OrderBasicReportRecordFilterInput>>;
  companyName?: InputMaybe<StringOperationFilterInput>;
  deliveryPostcode?: InputMaybe<StringOperationFilterInput>;
  deliveryStreetAddress?: InputMaybe<StringOperationFilterInput>;
  deliverySuburb?: InputMaybe<StringOperationFilterInput>;
  despatchDate?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  grandTotal?: InputMaybe<ComparableDecimalOperationFilterInput>;
  gstTotal?: InputMaybe<ComparableDecimalOperationFilterInput>;
  or?: InputMaybe<Array<OrderBasicReportRecordFilterInput>>;
  orderStatus?: InputMaybe<StringOperationFilterInput>;
  orderTotal?: InputMaybe<ComparableDecimalOperationFilterInput>;
  recipientFirstName?: InputMaybe<StringOperationFilterInput>;
  recipientLastName?: InputMaybe<StringOperationFilterInput>;
  shippingNo?: InputMaybe<StringOperationFilterInput>;
  uniqueId?: InputMaybe<StringOperationFilterInput>;
};

export type OrderBasicReportSortInput = {
  column: Scalars['String'];
  order: Scalars['String'];
};

export type OrderCollectionSegment = {
  __typename?: 'OrderCollectionSegment';
  items?: Maybe<Array<Order>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

/**
 * Represents an order's costs
 *
 *
 * **Returns:**
 * The OrderCosts object
 */
export type OrderCosts = {
  __typename?: 'OrderCosts';
  /** Represents the cart's fees */
  fees: OrderFees;
  /** Represents the grand total */
  grandTotal: Scalars['Decimal'];
  /** Represents the total GST */
  gst: Scalars['Decimal'];
  /** Represents the total item cost */
  itemCost: Scalars['Decimal'];
  /** Represents the subtotal excluding GST */
  subTotal: Scalars['Decimal'];
};

/**
 * Represents an order's single fee
 *
 *
 * **Returns:**
 * The OrderFee object
 */
export type OrderFee = {
  __typename?: 'OrderFee';
  /** Represents the total fee excluding GST */
  fee: Scalars['Decimal'];
  /** Represents the fee's GST */
  gst: Scalars['Decimal'];
  /** Represents if the fee is payed for */
  paysFor: Scalars['Boolean'];
};

/**
 * Represents an order's fees. All fees are set, but the totals determine the checkout cost
 *
 *
 * **Returns:**
 * The OrderFees object
 */
export type OrderFees = {
  __typename?: 'OrderFees';
  /** Represents the cancellation fee */
  cancelFee: OrderFee;
  /** Represents the carton fee */
  cartonFee: OrderFee;
  /** Represents the collection fee */
  collectFee: OrderFee;
  /** Represents the total fuel levy fee */
  fuelLevyFee: OrderFee;
  /** Represents the fuel levy percentage charged */
  fuelLevyPercent: Scalars['Decimal'];
  /** Represents the fee grand total */
  grandTotal: Scalars['Decimal'];
  /** Represents the total fee GST */
  gst: Scalars['Decimal'];
  /** Represents the loading fee */
  loadingFee: OrderFee;
  /** Represents the manual order / processing fee */
  manualOrderFee: OrderFee;
  /** Represents the picking fee */
  pickFee: OrderFee;
  /** Represents the po box fee */
  poBoxFee: OrderFee;
  /** Represents the shipping ETA maximum days */
  shippingEtaMax?: Maybe<Scalars['Int']>;
  /** Represents the shipping ETA minimum days */
  shippingEtaMin?: Maybe<Scalars['Int']>;
  /** Represents the shipping fee */
  shippingFee: OrderFee;
  /** Represents the shrink wrap fee */
  shrinkWrapFee: OrderFee;
  /** Represents the fee total excluding GST */
  subTotal: Scalars['Decimal'];
  /** Represents the tax rate used */
  taxRate: Scalars['Decimal'];
  /** Represents the tube fee */
  tubeFee: OrderFee;
  /** Represents the urgent picking fee */
  urgentPickFee: OrderFee;
};

export type OrderFilterInput = {
  active?: InputMaybe<BooleanOperationFilterInput>;
  activity?: InputMaybe<ActivityFilterInput>;
  activityId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<OrderFilterInput>>;
  appliedOrderCredit?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  campaigns?: InputMaybe<ListFilterInputTypeOfCampaignFilterInput>;
  contractNumber?: InputMaybe<StringOperationFilterInput>;
  created?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  customer?: InputMaybe<CustomerFilterInput>;
  customerId?: InputMaybe<ComparableInt32OperationFilterInput>;
  customerOrderRef?: InputMaybe<StringOperationFilterInput>;
  despatchDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  favourite?: InputMaybe<BooleanOperationFilterInput>;
  favouriteName?: InputMaybe<StringOperationFilterInput>;
  grandTotal?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  gstpercent?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  gsttotal?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  jobNumber?: InputMaybe<ComparableInt32OperationFilterInput>;
  modified?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  optIn?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<OrderFilterInput>>;
  orderId?: InputMaybe<ComparableInt32OperationFilterInput>;
  orderOptData?: InputMaybe<ListFilterInputTypeOfOrderOptDatumFilterInput>;
  orderOptHeads?: InputMaybe<ListFilterInputTypeOfOrderOptHeadFilterInput>;
  orderPaymentHistories?: InputMaybe<ListFilterInputTypeOfOrderPaymentHistoryFilterInput>;
  orderShipMultiShipment?: InputMaybe<BooleanOperationFilterInput>;
  orderShipPartShipment?: InputMaybe<BooleanOperationFilterInput>;
  orderShipSingleShipment?: InputMaybe<BooleanOperationFilterInput>;
  orderShippings?: InputMaybe<ListFilterInputTypeOfOrderShippingFilterInput>;
  paypalPayments?: InputMaybe<ListFilterInputTypeOfPaypalPaymentFilterInput>;
  pickTotal?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  preOrderCreditTotal?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  project?: InputMaybe<ProjectFilterInput>;
  projectId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  purgeDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  removed?: InputMaybe<BooleanOperationFilterInput>;
  rowVersion?: InputMaybe<ListComparableByteOperationFilterInput>;
  savedOrder?: InputMaybe<BooleanOperationFilterInput>;
  selectedCreditCard?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  sellersAbn?: InputMaybe<StringOperationFilterInput>;
  sellersCompanyName?: InputMaybe<StringOperationFilterInput>;
  sellersCountry?: InputMaybe<StringOperationFilterInput>;
  sellersEmail?: InputMaybe<StringOperationFilterInput>;
  sellersPhone?: InputMaybe<StringOperationFilterInput>;
  sellersPostcode?: InputMaybe<StringOperationFilterInput>;
  sellersState?: InputMaybe<StringOperationFilterInput>;
  sellersStreet1?: InputMaybe<StringOperationFilterInput>;
  sellersSuburb?: InputMaybe<StringOperationFilterInput>;
  shippingTotal?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  subTotal?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  surchargePercent?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  surchargeTotal?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  tncAnswers?: InputMaybe<StringOperationFilterInput>;
  userCreatedFirstName?: InputMaybe<StringOperationFilterInput>;
  userCreatedId?: InputMaybe<ComparableInt32OperationFilterInput>;
  userCreatedLastName?: InputMaybe<StringOperationFilterInput>;
  userModifiedId?: InputMaybe<ComparableInt32OperationFilterInput>;
  zeescapeJobs?: InputMaybe<ListFilterInputTypeOfZeescapeJobFilterInput>;
  zeroFreightOrderAmount?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
};

/** Represents the input to submit an order. */
export type OrderInputType = {
  /** Represents the order's billing address. */
  billingAddress?: InputMaybe<OrderAddressInputType>;
  /** Represents the unique client order reference. */
  clientReference?: InputMaybe<Scalars['String']>;
  /** Represents the order's delivery address. */
  deliveryAddress: OrderAddressInputType;
  /** Represents the selected delivery method ID. */
  deliveryMethodId: Scalars['Int'];
  /** The selected delivery service code */
  deliveryService?: InputMaybe<Scalars['String']>;
  /** Represents the order contact's first name. */
  firstName: Scalars['String'];
  /** Represents the order's delivery instructions. */
  instructions?: InputMaybe<Scalars['String']>;
  /** Represents the order contact's last name. */
  lastName: Scalars['String'];
  /** Represents a list of the lines in the order. */
  orderLines: Array<OrderLineInputType>;
  /** Represents the order's type ID. */
  orderTypeId?: InputMaybe<Scalars['Int']>;
  /** Represents if the billing address is the same as the delivery address. */
  useDeliveryAsBilling: Scalars['Boolean'];
};

export type OrderLineDocumentMap = {
  __typename?: 'OrderLineDocumentMap';
  created: Scalars['DateTime'];
  document: Document;
  documentId: Scalars['Int'];
  modified: Scalars['DateTime'];
  orderLine: OrderLineType;
  orderLineDocumentMapId: Scalars['Int'];
  orderLineId: Scalars['Int'];
  userCreatedId: Scalars['Int'];
  userModifiedId: Scalars['Int'];
};

export type OrderLineDocumentMapFilterInput = {
  and?: InputMaybe<Array<OrderLineDocumentMapFilterInput>>;
  created?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  document?: InputMaybe<DocumentFilterInput>;
  documentId?: InputMaybe<ComparableInt32OperationFilterInput>;
  modified?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<OrderLineDocumentMapFilterInput>>;
  orderLine?: InputMaybe<OrderLineFilterInput>;
  orderLineDocumentMapId?: InputMaybe<ComparableInt32OperationFilterInput>;
  orderLineId?: InputMaybe<ComparableInt32OperationFilterInput>;
  userCreatedId?: InputMaybe<ComparableInt32OperationFilterInput>;
  userModifiedId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type OrderLineFilterInput = {
  active?: InputMaybe<BooleanOperationFilterInput>;
  activity?: InputMaybe<ActivityFilterInput>;
  activityId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<OrderLineFilterInput>>;
  categoryId?: InputMaybe<ComparableInt32OperationFilterInput>;
  clientProductCode?: InputMaybe<StringOperationFilterInput>;
  created?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  currencyCode?: InputMaybe<StringOperationFilterInput>;
  currencyExchangeRate?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  customField?: InputMaybe<StringOperationFilterInput>;
  defaultWarehouse?: InputMaybe<StringOperationFilterInput>;
  deliveryDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  deliveryType?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  despatchedQuantity?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  docLink?: InputMaybe<DocumentLinkFilterInput>;
  docLinkId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  emailHeaders?: InputMaybe<ListFilterInputTypeOfEmailHeaderFilterInput>;
  etemplate?: InputMaybe<EtemplateFilterInput>;
  etemplateId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  expectedDeliveryDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  feeLine?: InputMaybe<BooleanOperationFilterInput>;
  isOverCommitted?: InputMaybe<BooleanOperationFilterInput>;
  kitProduct?: InputMaybe<BooleanOperationFilterInput>;
  lineDiscount?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  lineStatus?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  lineType?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  modified?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  multiplier?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  or?: InputMaybe<Array<OrderLineFilterInput>>;
  orderId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  orderLineDocumentMaps?: InputMaybe<ListFilterInputTypeOfOrderLineDocumentMapFilterInput>;
  orderLineId?: InputMaybe<ComparableInt32OperationFilterInput>;
  orderLinePropertyMaps?: InputMaybe<ListFilterInputTypeOfOrderLinePropertyMapFilterInput>;
  orderLineSelectedDataIds?: InputMaybe<ListFilterInputTypeOfOrderLineSelectedDataIdFilterInput>;
  orderShip?: InputMaybe<OrderShippingFilterInput>;
  orderShipId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  parentOrderLineId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  processDays?: InputMaybe<ComparableInt32OperationFilterInput>;
  product?: InputMaybe<ProductFilterInput>;
  productCode?: InputMaybe<StringOperationFilterInput>;
  productId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  productName?: InputMaybe<StringOperationFilterInput>;
  purchaseCurrency?: InputMaybe<StringOperationFilterInput>;
  purchaseCurrencyExchangeRate?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  purchaseMultplier?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  purchaseQuantity?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  purchaseTaxRate?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  purchaseUomid?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  purchaseUomname?: InputMaybe<StringOperationFilterInput>;
  purgeDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  quantity?: InputMaybe<ComparableInt32OperationFilterInput>;
  rga?: InputMaybe<WmsRgaFilterInput>;
  rgaid?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  rowVersion?: InputMaybe<ListComparableByteOperationFilterInput>;
  taxRate?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  tempLineId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  totalWeightCubed?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  totalWeightKg?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  unitCost?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  unitSell?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  uomdesc?: InputMaybe<StringOperationFilterInput>;
  uomid?: InputMaybe<ComparableInt32OperationFilterInput>;
  userCreatedId?: InputMaybe<ComparableInt32OperationFilterInput>;
  userModifiedId?: InputMaybe<ComparableInt32OperationFilterInput>;
  wmsAssignedNumbers?: InputMaybe<ListFilterInputTypeOfWmsAssignedNumberFilterInput>;
  wmsPickedStocks?: InputMaybe<ListFilterInputTypeOfWmsPickedStockFilterInput>;
  zeescapeJobApplications?: InputMaybe<ListFilterInputTypeOfZeescapeJobApplicationFilterInput>;
};

/** Represents the input for an individual order line. */
export type OrderLineInputType = {
  /** Represents the client product code for the line. */
  clientProductCode?: InputMaybe<Scalars['String']>;
  /** Represents the product code for the line. */
  productCode: Scalars['String'];
  /** Represents the unique product id for the line. */
  productId: Scalars['Int'];
  /** Represents the quantity of items in the line. */
  quantity: Scalars['Int'];
};

export type OrderLinePropertyMap = {
  __typename?: 'OrderLinePropertyMap';
  created: Scalars['DateTime'];
  isSuppplierOnly: Scalars['Boolean'];
  modified: Scalars['DateTime'];
  orderLine: OrderLineType;
  orderLineId: Scalars['Int'];
  orderLinePropertyMapId: Scalars['Int'];
  propertyName: Scalars['String'];
  value: Scalars['String'];
};

export type OrderLinePropertyMapFilterInput = {
  and?: InputMaybe<Array<OrderLinePropertyMapFilterInput>>;
  created?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  isSuppplierOnly?: InputMaybe<BooleanOperationFilterInput>;
  modified?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<OrderLinePropertyMapFilterInput>>;
  orderLine?: InputMaybe<OrderLineFilterInput>;
  orderLineId?: InputMaybe<ComparableInt32OperationFilterInput>;
  orderLinePropertyMapId?: InputMaybe<ComparableInt32OperationFilterInput>;
  propertyName?: InputMaybe<StringOperationFilterInput>;
  value?: InputMaybe<StringOperationFilterInput>;
};

export type OrderLineSelectedDataId = {
  __typename?: 'OrderLineSelectedDataId';
  dataId: Scalars['Int'];
  orderLine: OrderLineType;
  orderLineId: Scalars['Int'];
  tableId: Scalars['Int'];
};

export type OrderLineSelectedDataIdFilterInput = {
  and?: InputMaybe<Array<OrderLineSelectedDataIdFilterInput>>;
  dataId?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<OrderLineSelectedDataIdFilterInput>>;
  orderLine?: InputMaybe<OrderLineFilterInput>;
  orderLineId?: InputMaybe<ComparableInt32OperationFilterInput>;
  tableId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

/** Represents an Order Line entry. */
export type OrderLineType = {
  __typename?: 'OrderLineType';
  active: Scalars['Boolean'];
  activity?: Maybe<Activity>;
  activityId?: Maybe<Scalars['Int']>;
  categoryId: Scalars['Int'];
  clientProductCode?: Maybe<Scalars['String']>;
  created: Scalars['DateTime'];
  currencyCode?: Maybe<Scalars['String']>;
  currencyExchangeRate?: Maybe<Scalars['Decimal']>;
  customField?: Maybe<Scalars['String']>;
  defaultWarehouse?: Maybe<Scalars['String']>;
  deliveryDate?: Maybe<Scalars['DateTime']>;
  deliveryType?: Maybe<Scalars['Int']>;
  despatchedQuantity?: Maybe<Scalars['Int']>;
  docLink?: Maybe<DocumentLink>;
  docLinkId?: Maybe<Scalars['Int']>;
  emailHeaders: Array<EmailHeader>;
  etemplate?: Maybe<Etemplate>;
  etemplateId?: Maybe<Scalars['Int']>;
  expectedDeliveryDate?: Maybe<Scalars['DateTime']>;
  feeLine: Scalars['Boolean'];
  isOverCommitted: Scalars['Boolean'];
  kitProduct: Scalars['Boolean'];
  lineDiscount?: Maybe<Scalars['Decimal']>;
  lineStatus?: Maybe<Scalars['Int']>;
  lineType?: Maybe<Scalars['Int']>;
  modified: Scalars['DateTime'];
  multiplier?: Maybe<Scalars['Int']>;
  orderId?: Maybe<Scalars['Int']>;
  orderLineDocumentMaps: Array<OrderLineDocumentMap>;
  orderLineId: Scalars['Int'];
  orderLinePropertyMaps: Array<OrderLinePropertyMap>;
  orderLineSelectedDataIds: Array<OrderLineSelectedDataId>;
  orderShip?: Maybe<OrderShippingType>;
  orderShipId?: Maybe<Scalars['Int']>;
  /** The order shipping which contains the Order Shipping entry */
  orderedByOrderShipping?: Maybe<OrderShippingType>;
  parentOrderLineId?: Maybe<Scalars['Int']>;
  processDays: Scalars['Int'];
  product?: Maybe<ProductType>;
  productCode: Scalars['String'];
  productId?: Maybe<Scalars['Int']>;
  productName?: Maybe<Scalars['String']>;
  purchaseCurrency?: Maybe<Scalars['String']>;
  purchaseCurrencyExchangeRate?: Maybe<Scalars['Decimal']>;
  purchaseMultplier?: Maybe<Scalars['Int']>;
  purchaseQuantity?: Maybe<Scalars['Int']>;
  purchaseTaxRate?: Maybe<Scalars['Decimal']>;
  purchaseUomid?: Maybe<Scalars['Int']>;
  purchaseUomname?: Maybe<Scalars['String']>;
  purgeDate?: Maybe<Scalars['DateTime']>;
  quantity: Scalars['Int'];
  rga?: Maybe<WmsRga>;
  rgaid?: Maybe<Scalars['Int']>;
  rowVersion: Array<Scalars['ByteArray']>;
  taxRate?: Maybe<Scalars['Decimal']>;
  tempLineId?: Maybe<Scalars['Int']>;
  totalWeightCubed?: Maybe<Scalars['Decimal']>;
  totalWeightKg?: Maybe<Scalars['Decimal']>;
  unitCost?: Maybe<Scalars['Decimal']>;
  unitSell?: Maybe<Scalars['Decimal']>;
  uomdesc: Scalars['String'];
  uomid: Scalars['Int'];
  userCreatedId: Scalars['Int'];
  userModifiedId: Scalars['Int'];
  wmsAssignedNumbers: Array<WmsAssignedNumber>;
  wmsPickedStocks: Array<WmsPickedStock>;
  zeescapeJobApplications: Array<ZeescapeJobApplication>;
};

export type OrderOptDatum = {
  __typename?: 'OrderOptDatum';
  binary?: Maybe<Array<Scalars['ByteArray']>>;
  dataId: Scalars['Int'];
  dateTime?: Maybe<Scalars['DateTime']>;
  decimal?: Maybe<Scalars['Decimal']>;
  int?: Maybe<Scalars['Int']>;
  nvarchar50?: Maybe<Scalars['String']>;
  nvarcharMax?: Maybe<Scalars['String']>;
  order: Order;
  orderId: Scalars['Int'];
};

export type OrderOptDatumFilterInput = {
  and?: InputMaybe<Array<OrderOptDatumFilterInput>>;
  binary?: InputMaybe<ListComparableByteOperationFilterInput>;
  dataId?: InputMaybe<ComparableInt32OperationFilterInput>;
  dateTime?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  decimal?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  int?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  nvarchar50?: InputMaybe<StringOperationFilterInput>;
  nvarcharMax?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<OrderOptDatumFilterInput>>;
  order?: InputMaybe<OrderFilterInput>;
  orderId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type OrderOptEnum = {
  __typename?: 'OrderOptEnum';
  enumId: Scalars['Int'];
  name: Scalars['String'];
  optHead: OrderOptHead;
  optHeadId: Scalars['Int'];
};

export type OrderOptEnumFilterInput = {
  and?: InputMaybe<Array<OrderOptEnumFilterInput>>;
  enumId?: InputMaybe<ComparableInt32OperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  optHead?: InputMaybe<OrderOptHeadFilterInput>;
  optHeadId?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<OrderOptEnumFilterInput>>;
};

export type OrderOptHead = {
  __typename?: 'OrderOptHead';
  dataType: Scalars['String'];
  name: Scalars['String'];
  optHeadId: Scalars['Int'];
  order: Order;
  orderId: Scalars['Int'];
  orderOptEnums: Array<OrderOptEnum>;
};

export type OrderOptHeadFilterInput = {
  and?: InputMaybe<Array<OrderOptHeadFilterInput>>;
  dataType?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  optHeadId?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<OrderOptHeadFilterInput>>;
  order?: InputMaybe<OrderFilterInput>;
  orderId?: InputMaybe<ComparableInt32OperationFilterInput>;
  orderOptEnums?: InputMaybe<ListFilterInputTypeOfOrderOptEnumFilterInput>;
};

export type OrderPaymentHistory = {
  __typename?: 'OrderPaymentHistory';
  authCode?: Maybe<Scalars['String']>;
  created: Scalars['DateTime'];
  gatewayCode?: Maybe<Scalars['String']>;
  historyId: Scalars['Int'];
  modified: Scalars['DateTime'];
  order: Order;
  orderId: Scalars['Int'];
  responseCode: Scalars['String'];
  responseOrderId?: Maybe<Scalars['String']>;
  responseTotalPrice?: Maybe<Scalars['String']>;
  responseXml?: Maybe<Scalars['String']>;
  sentXml?: Maybe<Scalars['String']>;
  taxInvoice?: Maybe<Scalars['String']>;
  transactionCode?: Maybe<Scalars['String']>;
  transactionSuccess: Scalars['Boolean'];
  userModifiedId: Scalars['Int'];
};

export type OrderPaymentHistoryFilterInput = {
  and?: InputMaybe<Array<OrderPaymentHistoryFilterInput>>;
  authCode?: InputMaybe<StringOperationFilterInput>;
  created?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  gatewayCode?: InputMaybe<StringOperationFilterInput>;
  historyId?: InputMaybe<ComparableInt32OperationFilterInput>;
  modified?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<OrderPaymentHistoryFilterInput>>;
  order?: InputMaybe<OrderFilterInput>;
  orderId?: InputMaybe<ComparableInt32OperationFilterInput>;
  responseCode?: InputMaybe<StringOperationFilterInput>;
  responseOrderId?: InputMaybe<StringOperationFilterInput>;
  responseTotalPrice?: InputMaybe<StringOperationFilterInput>;
  responseXml?: InputMaybe<StringOperationFilterInput>;
  sentXml?: InputMaybe<StringOperationFilterInput>;
  taxInvoice?: InputMaybe<StringOperationFilterInput>;
  transactionCode?: InputMaybe<StringOperationFilterInput>;
  transactionSuccess?: InputMaybe<BooleanOperationFilterInput>;
  userModifiedId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type OrderReportHeader = {
  __typename?: 'OrderReportHeader';
  text: Scalars['String'];
  value: Scalars['String'];
};

export type OrderShippingFilterInput = {
  accpacAccount?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<OrderShippingFilterInput>>;
  appliedOrderCredit?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  billingAbn?: InputMaybe<StringOperationFilterInput>;
  billingAddressId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  billingBusinessLevelIdlist?: InputMaybe<StringOperationFilterInput>;
  billingBusinessLevelNameList?: InputMaybe<StringOperationFilterInput>;
  billingChildBusinessLevelId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  billingCityId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  billingClientBusinessLevelId?: InputMaybe<StringOperationFilterInput>;
  billingCompanyName?: InputMaybe<StringOperationFilterInput>;
  billingCountry?: InputMaybe<StringOperationFilterInput>;
  billingCountryId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  billingCountryIso2?: InputMaybe<StringOperationFilterInput>;
  billingEmail?: InputMaybe<StringOperationFilterInput>;
  billingMobile?: InputMaybe<StringOperationFilterInput>;
  billingNote?: InputMaybe<StringOperationFilterInput>;
  billingPhone?: InputMaybe<StringOperationFilterInput>;
  billingPostcode?: InputMaybe<StringOperationFilterInput>;
  billingPostcodeId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  billingRegionId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  billingState?: InputMaybe<StringOperationFilterInput>;
  billingStreet1?: InputMaybe<StringOperationFilterInput>;
  billingStreet2?: InputMaybe<StringOperationFilterInput>;
  billingStreet3?: InputMaybe<StringOperationFilterInput>;
  billingStreet4?: InputMaybe<StringOperationFilterInput>;
  billingSuburb?: InputMaybe<StringOperationFilterInput>;
  billingUserFirstName?: InputMaybe<StringOperationFilterInput>;
  billingUserId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  billingUserLastName?: InputMaybe<StringOperationFilterInput>;
  boxInfo?: InputMaybe<StringOperationFilterInput>;
  cancelSell?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  cartons?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  cartonsSell?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  collect?: InputMaybe<BooleanOperationFilterInput>;
  collectSell?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  connoteDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  consolidateByDate?: InputMaybe<BooleanOperationFilterInput>;
  courier?: InputMaybe<CourierFilterInput>;
  courierId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  created?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  crmid?: InputMaybe<StringOperationFilterInput>;
  customerId?: InputMaybe<ComparableInt32OperationFilterInput>;
  dateApproved?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  deliveryAddressId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  deliveryChildBusinessLevelId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  deliveryChildBusinessLevelName?: InputMaybe<StringOperationFilterInput>;
  deliveryCityId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  deliveryCompanyName?: InputMaybe<StringOperationFilterInput>;
  deliveryConsolidate?: InputMaybe<BooleanOperationFilterInput>;
  deliveryCountry?: InputMaybe<StringOperationFilterInput>;
  deliveryCountryId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  deliveryCountryIso2?: InputMaybe<StringOperationFilterInput>;
  deliveryEmail?: InputMaybe<StringOperationFilterInput>;
  deliveryMethod?: InputMaybe<StringOperationFilterInput>;
  deliveryMobile?: InputMaybe<StringOperationFilterInput>;
  deliveryNote?: InputMaybe<StringOperationFilterInput>;
  deliveryPhone?: InputMaybe<StringOperationFilterInput>;
  deliveryPostcode?: InputMaybe<StringOperationFilterInput>;
  deliveryPostcodeId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  deliveryRegionId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  deliveryState?: InputMaybe<StringOperationFilterInput>;
  deliveryStreet1?: InputMaybe<StringOperationFilterInput>;
  deliveryStreet2?: InputMaybe<StringOperationFilterInput>;
  deliveryStreet3?: InputMaybe<StringOperationFilterInput>;
  deliveryStreet4?: InputMaybe<StringOperationFilterInput>;
  deliverySuburb?: InputMaybe<StringOperationFilterInput>;
  deliveryUserFirstName?: InputMaybe<StringOperationFilterInput>;
  deliveryUserId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  deliveryUserLastName?: InputMaybe<StringOperationFilterInput>;
  deliveryUserSalutation?: InputMaybe<StringOperationFilterInput>;
  despatchedDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  discountTotal?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  expectedDeliveryDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  feeTotal?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  fuelLevyPercent?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  fuelLevyTotal?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  grandTotal?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  gsttotal?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  indicatorCode?: InputMaybe<StringOperationFilterInput>;
  invoiceFromDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  invoiceNumber?: InputMaybe<StringOperationFilterInput>;
  invoiceOrderShipId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  invoiceToDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  invoiceTotal?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  isDespatched?: InputMaybe<BooleanOperationFilterInput>;
  lateDespatchReason?: InputMaybe<StringOperationFilterInput>;
  loadingCost?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  loadingSell?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  manualOrder?: InputMaybe<BooleanOperationFilterInput>;
  manualOrderSell?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  manualOrderWaiveReason?: InputMaybe<StringOperationFilterInput>;
  minimumDespatchDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  modified?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<OrderShippingFilterInput>>;
  order?: InputMaybe<OrderFilterInput>;
  orderId?: InputMaybe<ComparableInt32OperationFilterInput>;
  orderLines?: InputMaybe<ListFilterInputTypeOfOrderLineFilterInput>;
  orderShipId?: InputMaybe<ComparableInt32OperationFilterInput>;
  orderType?: InputMaybe<OrderTypeFilterInput>;
  orderTypeId?: InputMaybe<ComparableInt32OperationFilterInput>;
  parcels?: InputMaybe<ComparableInt32OperationFilterInput>;
  parentOrderShipId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  partShipProducts?: InputMaybe<BooleanOperationFilterInput>;
  partSupply?: InputMaybe<BooleanOperationFilterInput>;
  pickCost?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  pickSell?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  pickType?: InputMaybe<PickTypeFilterInput>;
  pickTypeId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  poBoxSurchargeCost?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  poBoxSurchargeSell?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  primaryApprover2ndPassId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  primaryApproverId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  productSellTotal?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  rowVersion?: InputMaybe<ListComparableByteOperationFilterInput>;
  secondaryApprover2ndPassId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  secondaryApproverId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  shippingCalcOnCost?: InputMaybe<BooleanOperationFilterInput>;
  shippingConsignment?: InputMaybe<StringOperationFilterInput>;
  shippingCost?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  shippingSell?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  shippingTrackLink?: InputMaybe<StringOperationFilterInput>;
  shrinkWrapSell?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  shrinkwrap?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  status?: InputMaybe<OrderStatusFilterInput>;
  statusId?: InputMaybe<ComparableInt32OperationFilterInput>;
  totalDownPayment?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  tubes?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  tubesSell?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  urgentPick?: InputMaybe<BooleanOperationFilterInput>;
  urgentSell?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  userModifiedId?: InputMaybe<ComparableInt32OperationFilterInput>;
  waitForProductionOshipBeforePick?: InputMaybe<BooleanOperationFilterInput>;
  waivestarComment?: InputMaybe<StringOperationFilterInput>;
  weightCube?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  weightKg?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  wmsPickDetails?: InputMaybe<ListFilterInputTypeOfWmsPickDetailFilterInput>;
  zeescapeJobDetails?: InputMaybe<ListFilterInputTypeOfZeescapeJobDetailFilterInput>;
};

export type OrderShippingSortInput = {
  accpacAccount?: InputMaybe<SortEnumType>;
  appliedOrderCredit?: InputMaybe<SortEnumType>;
  billingAbn?: InputMaybe<SortEnumType>;
  billingAddressId?: InputMaybe<SortEnumType>;
  billingBusinessLevelIdlist?: InputMaybe<SortEnumType>;
  billingBusinessLevelNameList?: InputMaybe<SortEnumType>;
  billingChildBusinessLevelId?: InputMaybe<SortEnumType>;
  billingCityId?: InputMaybe<SortEnumType>;
  billingClientBusinessLevelId?: InputMaybe<SortEnumType>;
  billingCompanyName?: InputMaybe<SortEnumType>;
  billingCountry?: InputMaybe<SortEnumType>;
  billingCountryId?: InputMaybe<SortEnumType>;
  billingCountryIso2?: InputMaybe<SortEnumType>;
  billingEmail?: InputMaybe<SortEnumType>;
  billingMobile?: InputMaybe<SortEnumType>;
  billingNote?: InputMaybe<SortEnumType>;
  billingPhone?: InputMaybe<SortEnumType>;
  billingPostcode?: InputMaybe<SortEnumType>;
  billingPostcodeId?: InputMaybe<SortEnumType>;
  billingRegionId?: InputMaybe<SortEnumType>;
  billingState?: InputMaybe<SortEnumType>;
  billingStreet1?: InputMaybe<SortEnumType>;
  billingStreet2?: InputMaybe<SortEnumType>;
  billingStreet3?: InputMaybe<SortEnumType>;
  billingStreet4?: InputMaybe<SortEnumType>;
  billingSuburb?: InputMaybe<SortEnumType>;
  billingUserFirstName?: InputMaybe<SortEnumType>;
  billingUserId?: InputMaybe<SortEnumType>;
  billingUserLastName?: InputMaybe<SortEnumType>;
  boxInfo?: InputMaybe<SortEnumType>;
  cancelSell?: InputMaybe<SortEnumType>;
  cartons?: InputMaybe<SortEnumType>;
  cartonsSell?: InputMaybe<SortEnumType>;
  collect?: InputMaybe<SortEnumType>;
  collectSell?: InputMaybe<SortEnumType>;
  connoteDate?: InputMaybe<SortEnumType>;
  consolidateByDate?: InputMaybe<SortEnumType>;
  courier?: InputMaybe<CourierSortInput>;
  courierId?: InputMaybe<SortEnumType>;
  created?: InputMaybe<SortEnumType>;
  crmid?: InputMaybe<SortEnumType>;
  customerId?: InputMaybe<SortEnumType>;
  dateApproved?: InputMaybe<SortEnumType>;
  deliveryAddressId?: InputMaybe<SortEnumType>;
  deliveryChildBusinessLevelId?: InputMaybe<SortEnumType>;
  deliveryChildBusinessLevelName?: InputMaybe<SortEnumType>;
  deliveryCityId?: InputMaybe<SortEnumType>;
  deliveryCompanyName?: InputMaybe<SortEnumType>;
  deliveryConsolidate?: InputMaybe<SortEnumType>;
  deliveryCountry?: InputMaybe<SortEnumType>;
  deliveryCountryId?: InputMaybe<SortEnumType>;
  deliveryCountryIso2?: InputMaybe<SortEnumType>;
  deliveryEmail?: InputMaybe<SortEnumType>;
  deliveryMethod?: InputMaybe<SortEnumType>;
  deliveryMobile?: InputMaybe<SortEnumType>;
  deliveryNote?: InputMaybe<SortEnumType>;
  deliveryPhone?: InputMaybe<SortEnumType>;
  deliveryPostcode?: InputMaybe<SortEnumType>;
  deliveryPostcodeId?: InputMaybe<SortEnumType>;
  deliveryRegionId?: InputMaybe<SortEnumType>;
  deliveryState?: InputMaybe<SortEnumType>;
  deliveryStreet1?: InputMaybe<SortEnumType>;
  deliveryStreet2?: InputMaybe<SortEnumType>;
  deliveryStreet3?: InputMaybe<SortEnumType>;
  deliveryStreet4?: InputMaybe<SortEnumType>;
  deliverySuburb?: InputMaybe<SortEnumType>;
  deliveryUserFirstName?: InputMaybe<SortEnumType>;
  deliveryUserId?: InputMaybe<SortEnumType>;
  deliveryUserLastName?: InputMaybe<SortEnumType>;
  deliveryUserSalutation?: InputMaybe<SortEnumType>;
  despatchedDate?: InputMaybe<SortEnumType>;
  discountTotal?: InputMaybe<SortEnumType>;
  expectedDeliveryDate?: InputMaybe<SortEnumType>;
  feeTotal?: InputMaybe<SortEnumType>;
  fuelLevyPercent?: InputMaybe<SortEnumType>;
  fuelLevyTotal?: InputMaybe<SortEnumType>;
  grandTotal?: InputMaybe<SortEnumType>;
  gsttotal?: InputMaybe<SortEnumType>;
  indicatorCode?: InputMaybe<SortEnumType>;
  invoiceFromDate?: InputMaybe<SortEnumType>;
  invoiceNumber?: InputMaybe<SortEnumType>;
  invoiceOrderShipId?: InputMaybe<SortEnumType>;
  invoiceToDate?: InputMaybe<SortEnumType>;
  invoiceTotal?: InputMaybe<SortEnumType>;
  isDespatched?: InputMaybe<SortEnumType>;
  lateDespatchReason?: InputMaybe<SortEnumType>;
  loadingCost?: InputMaybe<SortEnumType>;
  loadingSell?: InputMaybe<SortEnumType>;
  manualOrder?: InputMaybe<SortEnumType>;
  manualOrderSell?: InputMaybe<SortEnumType>;
  manualOrderWaiveReason?: InputMaybe<SortEnumType>;
  minimumDespatchDate?: InputMaybe<SortEnumType>;
  modified?: InputMaybe<SortEnumType>;
  order?: InputMaybe<OrderSortInput>;
  orderId?: InputMaybe<SortEnumType>;
  orderShipId?: InputMaybe<SortEnumType>;
  orderType?: InputMaybe<OrderTypeSortInput>;
  orderTypeId?: InputMaybe<SortEnumType>;
  parcels?: InputMaybe<SortEnumType>;
  parentOrderShipId?: InputMaybe<SortEnumType>;
  partShipProducts?: InputMaybe<SortEnumType>;
  partSupply?: InputMaybe<SortEnumType>;
  pickCost?: InputMaybe<SortEnumType>;
  pickSell?: InputMaybe<SortEnumType>;
  pickType?: InputMaybe<PickTypeSortInput>;
  pickTypeId?: InputMaybe<SortEnumType>;
  poBoxSurchargeCost?: InputMaybe<SortEnumType>;
  poBoxSurchargeSell?: InputMaybe<SortEnumType>;
  primaryApprover2ndPassId?: InputMaybe<SortEnumType>;
  primaryApproverId?: InputMaybe<SortEnumType>;
  productSellTotal?: InputMaybe<SortEnumType>;
  secondaryApprover2ndPassId?: InputMaybe<SortEnumType>;
  secondaryApproverId?: InputMaybe<SortEnumType>;
  shippingCalcOnCost?: InputMaybe<SortEnumType>;
  shippingConsignment?: InputMaybe<SortEnumType>;
  shippingCost?: InputMaybe<SortEnumType>;
  shippingSell?: InputMaybe<SortEnumType>;
  shippingTrackLink?: InputMaybe<SortEnumType>;
  shrinkWrapSell?: InputMaybe<SortEnumType>;
  shrinkwrap?: InputMaybe<SortEnumType>;
  status?: InputMaybe<OrderStatusSortInput>;
  statusId?: InputMaybe<SortEnumType>;
  totalDownPayment?: InputMaybe<SortEnumType>;
  tubes?: InputMaybe<SortEnumType>;
  tubesSell?: InputMaybe<SortEnumType>;
  urgentPick?: InputMaybe<SortEnumType>;
  urgentSell?: InputMaybe<SortEnumType>;
  userModifiedId?: InputMaybe<SortEnumType>;
  waitForProductionOshipBeforePick?: InputMaybe<SortEnumType>;
  waivestarComment?: InputMaybe<SortEnumType>;
  weightCube?: InputMaybe<SortEnumType>;
  weightKg?: InputMaybe<SortEnumType>;
};

/** Represents an Order Shipping entry. */
export type OrderShippingType = {
  __typename?: 'OrderShippingType';
  accpacAccount?: Maybe<Scalars['String']>;
  appliedOrderCredit?: Maybe<Scalars['Decimal']>;
  billingAbn?: Maybe<Scalars['String']>;
  billingAddressId?: Maybe<Scalars['Int']>;
  billingBusinessLevelIdlist?: Maybe<Scalars['String']>;
  billingBusinessLevelNameList?: Maybe<Scalars['String']>;
  billingChildBusinessLevelId?: Maybe<Scalars['Int']>;
  billingCityId?: Maybe<Scalars['Int']>;
  billingClientBusinessLevelId?: Maybe<Scalars['String']>;
  billingCompanyName?: Maybe<Scalars['String']>;
  billingCountry?: Maybe<Scalars['String']>;
  billingCountryId?: Maybe<Scalars['Int']>;
  billingCountryIso2?: Maybe<Scalars['String']>;
  billingEmail?: Maybe<Scalars['String']>;
  billingMobile?: Maybe<Scalars['String']>;
  billingNote?: Maybe<Scalars['String']>;
  billingPhone?: Maybe<Scalars['String']>;
  billingPostcode?: Maybe<Scalars['String']>;
  billingPostcodeId?: Maybe<Scalars['Int']>;
  billingRegionId?: Maybe<Scalars['Int']>;
  billingState?: Maybe<Scalars['String']>;
  billingStreet1?: Maybe<Scalars['String']>;
  billingStreet2?: Maybe<Scalars['String']>;
  billingStreet3?: Maybe<Scalars['String']>;
  billingStreet4?: Maybe<Scalars['String']>;
  billingSuburb?: Maybe<Scalars['String']>;
  billingUserFirstName?: Maybe<Scalars['String']>;
  billingUserId?: Maybe<Scalars['Int']>;
  billingUserLastName?: Maybe<Scalars['String']>;
  boxInfo?: Maybe<Scalars['String']>;
  cancelSell?: Maybe<Scalars['Decimal']>;
  cartons?: Maybe<Scalars['Int']>;
  cartonsSell?: Maybe<Scalars['Decimal']>;
  collect: Scalars['Boolean'];
  collectSell?: Maybe<Scalars['Decimal']>;
  connoteDate?: Maybe<Scalars['DateTime']>;
  consolidateByDate: Scalars['Boolean'];
  courier?: Maybe<Courier>;
  courierId?: Maybe<Scalars['Int']>;
  created: Scalars['DateTime'];
  crmid?: Maybe<Scalars['String']>;
  customerId: Scalars['Int'];
  dateApproved?: Maybe<Scalars['DateTime']>;
  deliveryAddressId?: Maybe<Scalars['Int']>;
  deliveryChildBusinessLevelId?: Maybe<Scalars['Int']>;
  deliveryChildBusinessLevelName?: Maybe<Scalars['String']>;
  deliveryCityId?: Maybe<Scalars['Int']>;
  deliveryCompanyName?: Maybe<Scalars['String']>;
  deliveryConsolidate: Scalars['Boolean'];
  deliveryCountry?: Maybe<Scalars['String']>;
  deliveryCountryId?: Maybe<Scalars['Int']>;
  deliveryCountryIso2?: Maybe<Scalars['String']>;
  deliveryEmail?: Maybe<Scalars['String']>;
  deliveryMethod?: Maybe<Scalars['String']>;
  deliveryMobile?: Maybe<Scalars['String']>;
  deliveryNote?: Maybe<Scalars['String']>;
  deliveryPhone?: Maybe<Scalars['String']>;
  deliveryPostcode?: Maybe<Scalars['String']>;
  deliveryPostcodeId?: Maybe<Scalars['Int']>;
  deliveryRegionId?: Maybe<Scalars['Int']>;
  deliveryState?: Maybe<Scalars['String']>;
  deliveryStreet1: Scalars['String'];
  deliveryStreet2?: Maybe<Scalars['String']>;
  deliveryStreet3?: Maybe<Scalars['String']>;
  deliveryStreet4?: Maybe<Scalars['String']>;
  deliverySuburb?: Maybe<Scalars['String']>;
  deliveryUserFirstName?: Maybe<Scalars['String']>;
  deliveryUserId?: Maybe<Scalars['Int']>;
  deliveryUserLastName?: Maybe<Scalars['String']>;
  deliveryUserSalutation?: Maybe<Scalars['String']>;
  despatchedDate?: Maybe<Scalars['DateTime']>;
  discountTotal?: Maybe<Scalars['Decimal']>;
  expectedDeliveryDate?: Maybe<Scalars['DateTime']>;
  feeTotal?: Maybe<Scalars['Decimal']>;
  fuelLevyPercent?: Maybe<Scalars['Decimal']>;
  fuelLevyTotal?: Maybe<Scalars['Decimal']>;
  grandTotal?: Maybe<Scalars['Decimal']>;
  gsttotal?: Maybe<Scalars['Decimal']>;
  indicatorCode?: Maybe<Scalars['String']>;
  invoiceFromDate?: Maybe<Scalars['DateTime']>;
  invoiceNumber?: Maybe<Scalars['String']>;
  invoiceOrderShipId?: Maybe<Scalars['Int']>;
  invoiceToDate?: Maybe<Scalars['DateTime']>;
  invoiceTotal?: Maybe<Scalars['Decimal']>;
  isDespatched?: Maybe<Scalars['Boolean']>;
  lateDespatchReason?: Maybe<Scalars['String']>;
  loadingCost?: Maybe<Scalars['Decimal']>;
  loadingSell?: Maybe<Scalars['Decimal']>;
  manualOrder: Scalars['Boolean'];
  manualOrderSell?: Maybe<Scalars['Decimal']>;
  manualOrderWaiveReason?: Maybe<Scalars['String']>;
  minimumDespatchDate?: Maybe<Scalars['DateTime']>;
  modified: Scalars['DateTime'];
  order: Order;
  orderId: Scalars['Int'];
  orderLines: Array<OrderLineType>;
  orderShipId: Scalars['Int'];
  orderType: OrderTypeGqlType;
  orderTypeId: Scalars['Int'];
  /** The user who created the Order Shipping entry */
  orderedByUser?: Maybe<UserType>;
  parcels: Scalars['Int'];
  parentOrderShipId?: Maybe<Scalars['Int']>;
  partShipProducts: Scalars['Boolean'];
  partSupply: Scalars['Boolean'];
  pickCost?: Maybe<Scalars['Decimal']>;
  pickSell?: Maybe<Scalars['Decimal']>;
  pickType?: Maybe<PickType>;
  pickTypeId?: Maybe<Scalars['Int']>;
  poBoxSurchargeCost?: Maybe<Scalars['Decimal']>;
  poBoxSurchargeSell?: Maybe<Scalars['Decimal']>;
  primaryApprover2ndPassId?: Maybe<Scalars['Int']>;
  primaryApproverId?: Maybe<Scalars['Int']>;
  productSellTotal?: Maybe<Scalars['Decimal']>;
  rowVersion: Array<Scalars['ByteArray']>;
  secondaryApprover2ndPassId?: Maybe<Scalars['Int']>;
  secondaryApproverId?: Maybe<Scalars['Int']>;
  shippingCalcOnCost: Scalars['Boolean'];
  shippingConsignment?: Maybe<Scalars['String']>;
  shippingCost?: Maybe<Scalars['Decimal']>;
  shippingSell?: Maybe<Scalars['Decimal']>;
  shippingTrackLink?: Maybe<Scalars['String']>;
  shrinkWrapSell?: Maybe<Scalars['Decimal']>;
  shrinkwrap?: Maybe<Scalars['Int']>;
  status: OrderStatus;
  statusId: Scalars['Int'];
  totalDownPayment?: Maybe<Scalars['Decimal']>;
  tubes?: Maybe<Scalars['Int']>;
  tubesSell?: Maybe<Scalars['Decimal']>;
  urgentPick: Scalars['Boolean'];
  urgentSell?: Maybe<Scalars['Decimal']>;
  userModifiedId: Scalars['Int'];
  waitForProductionOshipBeforePick: Scalars['Boolean'];
  waivestarComment?: Maybe<Scalars['String']>;
  weightCube?: Maybe<Scalars['Decimal']>;
  weightKg?: Maybe<Scalars['Decimal']>;
  wmsPickDetails: Array<WmsPickDetail>;
  zeescapeJobDetails: Array<ZeescapeJobDetail>;
};

export type OrderShippingTypeCollectionSegment = {
  __typename?: 'OrderShippingTypeCollectionSegment';
  items?: Maybe<Array<OrderShippingType>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type OrderSortInput = {
  active?: InputMaybe<SortEnumType>;
  activity?: InputMaybe<ActivitySortInput>;
  activityId?: InputMaybe<SortEnumType>;
  appliedOrderCredit?: InputMaybe<SortEnumType>;
  contractNumber?: InputMaybe<SortEnumType>;
  created?: InputMaybe<SortEnumType>;
  customer?: InputMaybe<CustomerSortInput>;
  customerId?: InputMaybe<SortEnumType>;
  customerOrderRef?: InputMaybe<SortEnumType>;
  despatchDate?: InputMaybe<SortEnumType>;
  favourite?: InputMaybe<SortEnumType>;
  favouriteName?: InputMaybe<SortEnumType>;
  grandTotal?: InputMaybe<SortEnumType>;
  gstpercent?: InputMaybe<SortEnumType>;
  gsttotal?: InputMaybe<SortEnumType>;
  jobNumber?: InputMaybe<SortEnumType>;
  modified?: InputMaybe<SortEnumType>;
  optIn?: InputMaybe<SortEnumType>;
  orderId?: InputMaybe<SortEnumType>;
  orderShipMultiShipment?: InputMaybe<SortEnumType>;
  orderShipPartShipment?: InputMaybe<SortEnumType>;
  orderShipSingleShipment?: InputMaybe<SortEnumType>;
  pickTotal?: InputMaybe<SortEnumType>;
  preOrderCreditTotal?: InputMaybe<SortEnumType>;
  project?: InputMaybe<ProjectSortInput>;
  projectId?: InputMaybe<SortEnumType>;
  purgeDate?: InputMaybe<SortEnumType>;
  removed?: InputMaybe<SortEnumType>;
  savedOrder?: InputMaybe<SortEnumType>;
  selectedCreditCard?: InputMaybe<SortEnumType>;
  sellersAbn?: InputMaybe<SortEnumType>;
  sellersCompanyName?: InputMaybe<SortEnumType>;
  sellersCountry?: InputMaybe<SortEnumType>;
  sellersEmail?: InputMaybe<SortEnumType>;
  sellersPhone?: InputMaybe<SortEnumType>;
  sellersPostcode?: InputMaybe<SortEnumType>;
  sellersState?: InputMaybe<SortEnumType>;
  sellersStreet1?: InputMaybe<SortEnumType>;
  sellersSuburb?: InputMaybe<SortEnumType>;
  shippingTotal?: InputMaybe<SortEnumType>;
  subTotal?: InputMaybe<SortEnumType>;
  surchargePercent?: InputMaybe<SortEnumType>;
  surchargeTotal?: InputMaybe<SortEnumType>;
  tncAnswers?: InputMaybe<SortEnumType>;
  userCreatedFirstName?: InputMaybe<SortEnumType>;
  userCreatedId?: InputMaybe<SortEnumType>;
  userCreatedLastName?: InputMaybe<SortEnumType>;
  userModifiedId?: InputMaybe<SortEnumType>;
  zeroFreightOrderAmount?: InputMaybe<SortEnumType>;
};

export type OrderStatus = {
  __typename?: 'OrderStatus';
  archiveDeliveryStatus: Scalars['Boolean'];
  archivePickupStatus: Scalars['Boolean'];
  commitStockStatuses: Scalars['Boolean'];
  downloadStatus: Scalars['Boolean'];
  etempStatus: Scalars['Boolean'];
  limitComparisonStatuses: Scalars['Boolean'];
  name: Scalars['String'];
  onDemandStatus: Scalars['Boolean'];
  orderShippings: Array<OrderShippingType>;
  sortColumn: Scalars['Int'];
  stationeryStatus: Scalars['Boolean'];
  statusId: Scalars['Int'];
};

export type OrderStatusFilterInput = {
  and?: InputMaybe<Array<OrderStatusFilterInput>>;
  archiveDeliveryStatus?: InputMaybe<BooleanOperationFilterInput>;
  archivePickupStatus?: InputMaybe<BooleanOperationFilterInput>;
  commitStockStatuses?: InputMaybe<BooleanOperationFilterInput>;
  downloadStatus?: InputMaybe<BooleanOperationFilterInput>;
  etempStatus?: InputMaybe<BooleanOperationFilterInput>;
  limitComparisonStatuses?: InputMaybe<BooleanOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  onDemandStatus?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<OrderStatusFilterInput>>;
  orderShippings?: InputMaybe<ListFilterInputTypeOfOrderShippingFilterInput>;
  sortColumn?: InputMaybe<ComparableInt32OperationFilterInput>;
  stationeryStatus?: InputMaybe<BooleanOperationFilterInput>;
  statusId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type OrderStatusSortInput = {
  archiveDeliveryStatus?: InputMaybe<SortEnumType>;
  archivePickupStatus?: InputMaybe<SortEnumType>;
  commitStockStatuses?: InputMaybe<SortEnumType>;
  downloadStatus?: InputMaybe<SortEnumType>;
  etempStatus?: InputMaybe<SortEnumType>;
  limitComparisonStatuses?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  onDemandStatus?: InputMaybe<SortEnumType>;
  sortColumn?: InputMaybe<SortEnumType>;
  stationeryStatus?: InputMaybe<SortEnumType>;
  statusId?: InputMaybe<SortEnumType>;
};

export type OrderTerm = {
  __typename?: 'OrderTerm';
  customer: Customer;
  customerId: Scalars['Int'];
  id: Scalars['Int'];
  isMandatory: Scalars['Boolean'];
  isRemoved: Scalars['Boolean'];
  sortOrder: Scalars['Int'];
  termsData: Scalars['String'];
};

export type OrderTermFilterInput = {
  and?: InputMaybe<Array<OrderTermFilterInput>>;
  customer?: InputMaybe<CustomerFilterInput>;
  customerId?: InputMaybe<ComparableInt32OperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  isMandatory?: InputMaybe<BooleanOperationFilterInput>;
  isRemoved?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<OrderTermFilterInput>>;
  sortOrder?: InputMaybe<ComparableInt32OperationFilterInput>;
  termsData?: InputMaybe<StringOperationFilterInput>;
};

export type OrderTypeFilterInput = {
  and?: InputMaybe<Array<OrderTypeFilterInput>>;
  bypassFees?: InputMaybe<BooleanOperationFilterInput>;
  categories?: InputMaybe<ListFilterInputTypeOfCategoryFilterInput>;
  etemplateType?: InputMaybe<BooleanOperationFilterInput>;
  isPurchase?: InputMaybe<BooleanOperationFilterInput>;
  isSale?: InputMaybe<BooleanOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<OrderTypeFilterInput>>;
  orderShippings?: InputMaybe<ListFilterInputTypeOfOrderShippingFilterInput>;
  orderTypeId?: InputMaybe<ComparableInt32OperationFilterInput>;
  products?: InputMaybe<ListFilterInputTypeOfProductFilterInput>;
  roleOrderTypes?: InputMaybe<ListFilterInputTypeOfRoleOrderTypeFilterInput>;
  selectable?: InputMaybe<BooleanOperationFilterInput>;
  sohCheckType?: InputMaybe<BooleanOperationFilterInput>;
};

/** Represents an OrderType. */
export type OrderTypeGqlType = {
  __typename?: 'OrderTypeGQLType';
  bypassFees: Scalars['Boolean'];
  categories: Array<Category>;
  etemplateType: Scalars['Boolean'];
  isPurchase: Scalars['Boolean'];
  isSale: Scalars['Boolean'];
  name?: Maybe<Scalars['String']>;
  /** OrderType Order Shippings */
  orderShippings?: Maybe<Array<OrderShippingType>>;
  orderTypeId: Scalars['Int'];
  products: Array<ProductType>;
  roleOrderTypes: Array<RoleOrderType>;
  selectable: Scalars['Boolean'];
  sohCheckType: Scalars['Boolean'];
};

export type OrderTypeSortInput = {
  bypassFees?: InputMaybe<SortEnumType>;
  etemplateType?: InputMaybe<SortEnumType>;
  isPurchase?: InputMaybe<SortEnumType>;
  isSale?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  orderTypeId?: InputMaybe<SortEnumType>;
  selectable?: InputMaybe<SortEnumType>;
  sohCheckType?: InputMaybe<SortEnumType>;
};

export type PageHeader = {
  __typename?: 'PageHeader';
  background: Scalars['String'];
  cart: Scalars['String'];
  cartNumberBackground: Scalars['String'];
  text: Scalars['String'];
};

export type PageHeaderUpdatesInput = {
  background?: InputMaybe<Scalars['String']>;
  cart?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
};

export type PaymentCardInput = {
  nameOnCard: Scalars['String'];
  cardNumber: Scalars['String'];
  expiryMonth: Scalars['String'];
  expiryYear: Scalars['String'];
  securityCode: Scalars['String'];
  recipientEmail: Scalars['String'];
  totalAmount: Scalars['Int'];
};

export type PaypalPayment = {
  __typename?: 'PaypalPayment';
  checkoutCustom?: Maybe<Scalars['String']>;
  checkoutNote?: Maybe<Scalars['String']>;
  checkoutStatus?: Maybe<Scalars['String']>;
  ecbuild?: Maybe<Scalars['String']>;
  eccorrelationId?: Maybe<Scalars['String']>;
  ecinitiateTime: Scalars['DateTime'];
  ecstatus?: Maybe<Scalars['String']>;
  handlingTotal?: Maybe<Scalars['Decimal']>;
  insuranceTotal?: Maybe<Scalars['Decimal']>;
  itemTotal?: Maybe<Scalars['Decimal']>;
  order: Order;
  orderId: Scalars['Int'];
  orderTotal?: Maybe<Scalars['Decimal']>;
  payer?: Maybe<Scalars['String']>;
  payerAddress?: Maybe<Scalars['String']>;
  payerBusiness?: Maybe<Scalars['String']>;
  payerContactPhone?: Maybe<Scalars['String']>;
  payerCountry?: Maybe<Scalars['String']>;
  payerFirstName?: Maybe<Scalars['String']>;
  payerId?: Maybe<Scalars['String']>;
  payerLastName?: Maybe<Scalars['String']>;
  payerMiddleName?: Maybe<Scalars['String']>;
  payerSalutation?: Maybe<Scalars['String']>;
  payerStatus?: Maybe<Scalars['String']>;
  paypalAccount: Scalars['String'];
  paypalAdjustment?: Maybe<Scalars['Decimal']>;
  paypalDate?: Maybe<Scalars['String']>;
  paypalPaymentId: Scalars['Int'];
  rowVersion: Array<Scalars['ByteArray']>;
  shippingTotal?: Maybe<Scalars['Decimal']>;
  taxTotal?: Maybe<Scalars['Decimal']>;
  token: Scalars['String'];
  transactionId?: Maybe<Scalars['String']>;
};

export type PaypalPaymentFilterInput = {
  and?: InputMaybe<Array<PaypalPaymentFilterInput>>;
  checkoutCustom?: InputMaybe<StringOperationFilterInput>;
  checkoutNote?: InputMaybe<StringOperationFilterInput>;
  checkoutStatus?: InputMaybe<StringOperationFilterInput>;
  ecbuild?: InputMaybe<StringOperationFilterInput>;
  eccorrelationId?: InputMaybe<StringOperationFilterInput>;
  ecinitiateTime?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  ecstatus?: InputMaybe<StringOperationFilterInput>;
  handlingTotal?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  insuranceTotal?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  itemTotal?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  or?: InputMaybe<Array<PaypalPaymentFilterInput>>;
  order?: InputMaybe<OrderFilterInput>;
  orderId?: InputMaybe<ComparableInt32OperationFilterInput>;
  orderTotal?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  payer?: InputMaybe<StringOperationFilterInput>;
  payerAddress?: InputMaybe<StringOperationFilterInput>;
  payerBusiness?: InputMaybe<StringOperationFilterInput>;
  payerContactPhone?: InputMaybe<StringOperationFilterInput>;
  payerCountry?: InputMaybe<StringOperationFilterInput>;
  payerFirstName?: InputMaybe<StringOperationFilterInput>;
  payerId?: InputMaybe<StringOperationFilterInput>;
  payerLastName?: InputMaybe<StringOperationFilterInput>;
  payerMiddleName?: InputMaybe<StringOperationFilterInput>;
  payerSalutation?: InputMaybe<StringOperationFilterInput>;
  payerStatus?: InputMaybe<StringOperationFilterInput>;
  paypalAccount?: InputMaybe<StringOperationFilterInput>;
  paypalAdjustment?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  paypalDate?: InputMaybe<StringOperationFilterInput>;
  paypalPaymentId?: InputMaybe<ComparableInt32OperationFilterInput>;
  rowVersion?: InputMaybe<ListComparableByteOperationFilterInput>;
  shippingTotal?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  taxTotal?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  token?: InputMaybe<StringOperationFilterInput>;
  transactionId?: InputMaybe<StringOperationFilterInput>;
};

export type PickType = {
  __typename?: 'PickType';
  customerPickTypes: Array<CustomerPickType>;
  name: Scalars['String'];
  orderShippings: Array<OrderShippingType>;
  pickTypeId: Scalars['Int'];
};

export type PickTypeFilterInput = {
  and?: InputMaybe<Array<PickTypeFilterInput>>;
  customerPickTypes?: InputMaybe<ListFilterInputTypeOfCustomerPickTypeFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<PickTypeFilterInput>>;
  orderShippings?: InputMaybe<ListFilterInputTypeOfOrderShippingFilterInput>;
  pickTypeId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type PickTypeSortInput = {
  name?: InputMaybe<SortEnumType>;
  pickTypeId?: InputMaybe<SortEnumType>;
};

export type PremierFundingServicesLoan = {
  __typename?: 'PremierFundingServicesLoan';
  activity: Activity;
  activityId: Scalars['Int'];
  amountFinanced: Scalars['Decimal'];
  applicationDate?: Maybe<Scalars['DateTime']>;
  brokerCode?: Maybe<Scalars['String']>;
  businessPartnerId?: Maybe<Scalars['Int']>;
  comission: Scalars['Decimal'];
  contact?: Maybe<Scalars['String']>;
  created: Scalars['DateTime'];
  id: Scalars['Int'];
  loanNumber: Scalars['Int'];
  modified: Scalars['DateTime'];
  rowVersion: Array<Scalars['ByteArray']>;
  settlementDate?: Maybe<Scalars['DateTime']>;
  userCreatedId: Scalars['Int'];
  userModifiedId: Scalars['Int'];
};

export type PremierFundingServicesLoanFilterInput = {
  activity?: InputMaybe<ActivityFilterInput>;
  activityId?: InputMaybe<ComparableInt32OperationFilterInput>;
  amountFinanced?: InputMaybe<ComparableDecimalOperationFilterInput>;
  and?: InputMaybe<Array<PremierFundingServicesLoanFilterInput>>;
  applicationDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  brokerCode?: InputMaybe<StringOperationFilterInput>;
  businessPartnerId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  comission?: InputMaybe<ComparableDecimalOperationFilterInput>;
  contact?: InputMaybe<StringOperationFilterInput>;
  created?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  loanNumber?: InputMaybe<ComparableInt32OperationFilterInput>;
  modified?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<PremierFundingServicesLoanFilterInput>>;
  rowVersion?: InputMaybe<ListComparableByteOperationFilterInput>;
  settlementDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  userCreatedId?: InputMaybe<ComparableInt32OperationFilterInput>;
  userModifiedId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type ProductAllowedQuantity = {
  __typename?: 'ProductAllowedQuantity';
  active: Scalars['Boolean'];
  allowedQuantityId: Scalars['Int'];
  created: Scalars['DateTime'];
  modified: Scalars['DateTime'];
  product: ProductType;
  productId: Scalars['Int'];
  purgeDate?: Maybe<Scalars['DateTime']>;
  quantity: Scalars['Int'];
  removed?: Maybe<Scalars['Boolean']>;
  rowVersion: Scalars['Int'];
  sellPrice: Scalars['Decimal'];
  userCreatedId: Scalars['Int'];
  userModifiedId: Scalars['Int'];
};

export type ProductAllowedQuantityFilterInput = {
  active?: InputMaybe<BooleanOperationFilterInput>;
  allowedQuantityId?: InputMaybe<ComparableInt32OperationFilterInput>;
  and?: InputMaybe<Array<ProductAllowedQuantityFilterInput>>;
  created?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  modified?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<ProductAllowedQuantityFilterInput>>;
  product?: InputMaybe<ProductFilterInput>;
  productId?: InputMaybe<ComparableInt32OperationFilterInput>;
  purgeDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  quantity?: InputMaybe<ComparableInt32OperationFilterInput>;
  removed?: InputMaybe<BooleanOperationFilterInput>;
  rowVersion?: InputMaybe<ComparableInt32OperationFilterInput>;
  sellPrice?: InputMaybe<ComparableDecimalOperationFilterInput>;
  userCreatedId?: InputMaybe<ComparableInt32OperationFilterInput>;
  userModifiedId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type ProductApprover = {
  __typename?: 'ProductApprover';
  name: Scalars['String'];
  userId: Scalars['Int'];
};

export type ProductArchiveFilterInput = {
  and?: InputMaybe<Array<ProductArchiveFilterInput>>;
  archiveDestructionDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  archiveEndDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  archiveStartDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  created?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  modified?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<ProductArchiveFilterInput>>;
  product?: InputMaybe<ProductFilterInput>;
  productAttribArchiveId?: InputMaybe<ComparableInt32OperationFilterInput>;
  productId?: InputMaybe<ComparableInt32OperationFilterInput>;
  rowVersion?: InputMaybe<ComparableInt32OperationFilterInput>;
  userModifiedId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type ProductAttribBackendTypeFilterInput = {
  and?: InputMaybe<Array<ProductAttribBackendTypeFilterInput>>;
  backendTypeId?: InputMaybe<ComparableInt32OperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ProductAttribBackendTypeFilterInput>>;
  productAttribDataTypes?: InputMaybe<ListFilterInputTypeOfProductAttribDataTypeFilterInput>;
};

export type ProductAttribDataMapFilterInput = {
  and?: InputMaybe<Array<ProductAttribDataMapFilterInput>>;
  attribData?: InputMaybe<ProductAttribDatumFilterInput>;
  attribDataId?: InputMaybe<ComparableInt32OperationFilterInput>;
  mapId?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<ProductAttribDataMapFilterInput>>;
  product?: InputMaybe<ProductFilterInput>;
  productId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type ProductAttribDataTypeFilterInput = {
  and?: InputMaybe<Array<ProductAttribDataTypeFilterInput>>;
  attribDataTypeId?: InputMaybe<ComparableInt32OperationFilterInput>;
  backendType?: InputMaybe<ProductAttribBackendTypeFilterInput>;
  backendTypeId?: InputMaybe<ComparableInt32OperationFilterInput>;
  frontendType?: InputMaybe<ProductAttribFrontendTypeFilterInput>;
  frontendTypeId?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<ProductAttribDataTypeFilterInput>>;
  productAttributes?: InputMaybe<ListFilterInputTypeOfProductAttributeFilterInput>;
};

export type ProductAttribDatumFilterInput = {
  active?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<ProductAttribDatumFilterInput>>;
  attribDataId?: InputMaybe<ComparableInt32OperationFilterInput>;
  attribute?: InputMaybe<ProductAttributeFilterInput>;
  attributeId?: InputMaybe<ComparableInt32OperationFilterInput>;
  created?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  dataAbbr?: InputMaybe<StringOperationFilterInput>;
  datetime?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  decimal?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  int?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  modified?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<ProductAttribDatumFilterInput>>;
  productAttribDataMaps?: InputMaybe<ListFilterInputTypeOfProductAttribDataMapFilterInput>;
  purgeDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  removed?: InputMaybe<BooleanOperationFilterInput>;
  rowVersion?: InputMaybe<ComparableInt32OperationFilterInput>;
  sortOrder?: InputMaybe<ComparableInt32OperationFilterInput>;
  userCreatedId?: InputMaybe<ComparableInt32OperationFilterInput>;
  userModifiedId?: InputMaybe<ComparableInt32OperationFilterInput>;
  varchar?: InputMaybe<StringOperationFilterInput>;
};

export type ProductAttribEmailFilterInput = {
  active?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<ProductAttribEmailFilterInput>>;
  created?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  modified?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<ProductAttribEmailFilterInput>>;
  pricePerClick?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  pricePerDownload?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  pricePerEmail?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  pricePerMegabyte?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  pricePerNonDelivery?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  pricePerOptOut?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  product?: InputMaybe<ProductFilterInput>;
  productAttribEmailId?: InputMaybe<ComparableInt32OperationFilterInput>;
  productId?: InputMaybe<ComparableInt32OperationFilterInput>;
  removed?: InputMaybe<BooleanOperationFilterInput>;
  rowVersion?: InputMaybe<ListComparableByteOperationFilterInput>;
  userCreatedId?: InputMaybe<ComparableInt32OperationFilterInput>;
  userModifiedId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type ProductAttribEtemplate = {
  __typename?: 'ProductAttribEtemplate';
  active: Scalars['Boolean'];
  cannotOrderArtworkOnly?: Maybe<Scalars['Boolean']>;
  cannotOrderPrintAndDelivery?: Maybe<Scalars['Boolean']>;
  created: Scalars['DateTime'];
  editionOnOrderPage?: Maybe<Scalars['Boolean']>;
  etemplates: Array<Etemplate>;
  hideFromOrderWorkflow: Scalars['Boolean'];
  inDesignArtworkOnlyPrintPreset?: Maybe<Scalars['String']>;
  inDesignPrintPreset: Scalars['String'];
  inDesignProofPreset: Scalars['String'];
  inDesignWebPreset?: Maybe<Scalars['String']>;
  largeArtwork?: Maybe<Scalars['Boolean']>;
  masterFile: Scalars['String'];
  modified: Scalars['DateTime'];
  name: Scalars['String'];
  product: ProductType;
  productAttribEtemplateId: Scalars['Int'];
  productId: Scalars['Int'];
  purgeDate?: Maybe<Scalars['DateTime']>;
  removed: Scalars['Boolean'];
  stopUsingJson?: Maybe<Scalars['Boolean']>;
  useNamedTags: Scalars['Boolean'];
  userCreatedId: Scalars['Int'];
  userModifiedId: Scalars['Int'];
  visibleOnEtemplateOrder?: Maybe<Scalars['Boolean']>;
};

export type ProductAttribEtemplateFilterInput = {
  active?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<ProductAttribEtemplateFilterInput>>;
  cannotOrderArtworkOnly?: InputMaybe<BooleanOperationFilterInput>;
  cannotOrderPrintAndDelivery?: InputMaybe<BooleanOperationFilterInput>;
  created?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  editionOnOrderPage?: InputMaybe<BooleanOperationFilterInput>;
  etemplates?: InputMaybe<ListFilterInputTypeOfEtemplateFilterInput>;
  hideFromOrderWorkflow?: InputMaybe<BooleanOperationFilterInput>;
  inDesignArtworkOnlyPrintPreset?: InputMaybe<StringOperationFilterInput>;
  inDesignPrintPreset?: InputMaybe<StringOperationFilterInput>;
  inDesignProofPreset?: InputMaybe<StringOperationFilterInput>;
  inDesignWebPreset?: InputMaybe<StringOperationFilterInput>;
  largeArtwork?: InputMaybe<BooleanOperationFilterInput>;
  masterFile?: InputMaybe<StringOperationFilterInput>;
  modified?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ProductAttribEtemplateFilterInput>>;
  product?: InputMaybe<ProductFilterInput>;
  productAttribEtemplateId?: InputMaybe<ComparableInt32OperationFilterInput>;
  productId?: InputMaybe<ComparableInt32OperationFilterInput>;
  purgeDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  removed?: InputMaybe<BooleanOperationFilterInput>;
  stopUsingJson?: InputMaybe<BooleanOperationFilterInput>;
  useNamedTags?: InputMaybe<BooleanOperationFilterInput>;
  userCreatedId?: InputMaybe<ComparableInt32OperationFilterInput>;
  userModifiedId?: InputMaybe<ComparableInt32OperationFilterInput>;
  visibleOnEtemplateOrder?: InputMaybe<BooleanOperationFilterInput>;
};

export type ProductAttribFrontendTypeFilterInput = {
  and?: InputMaybe<Array<ProductAttribFrontendTypeFilterInput>>;
  frontendTypeId?: InputMaybe<ComparableInt32OperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ProductAttribFrontendTypeFilterInput>>;
  productAttribDataTypes?: InputMaybe<ListFilterInputTypeOfProductAttribDataTypeFilterInput>;
};

export type ProductAttribSetFilterInput = {
  active?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<ProductAttribSetFilterInput>>;
  attributeSetId?: InputMaybe<ComparableInt32OperationFilterInput>;
  created?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  customerId?: InputMaybe<ComparableInt32OperationFilterInput>;
  modified?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ProductAttribSetFilterInput>>;
  productAttributes?: InputMaybe<ListFilterInputTypeOfProductAttributeFilterInput>;
  products?: InputMaybe<ListFilterInputTypeOfProductFilterInput>;
  purgeDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  removed?: InputMaybe<BooleanOperationFilterInput>;
  userModifiedId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type ProductAttribSetSortInput = {
  active?: InputMaybe<SortEnumType>;
  attributeSetId?: InputMaybe<SortEnumType>;
  created?: InputMaybe<SortEnumType>;
  customerId?: InputMaybe<SortEnumType>;
  modified?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  purgeDate?: InputMaybe<SortEnumType>;
  removed?: InputMaybe<SortEnumType>;
  userModifiedId?: InputMaybe<SortEnumType>;
};

export type ProductAttribTitleFilterInput = {
  active?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<ProductAttribTitleFilterInput>>;
  attribTitleId?: InputMaybe<ComparableInt32OperationFilterInput>;
  created?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  modified?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ProductAttribTitleFilterInput>>;
  productAttributes?: InputMaybe<ListFilterInputTypeOfProductAttributeFilterInput>;
  purgeDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  removed?: InputMaybe<BooleanOperationFilterInput>;
  rowVersion?: InputMaybe<ComparableInt32OperationFilterInput>;
  userCreatedId?: InputMaybe<ComparableInt32OperationFilterInput>;
  userModifiedId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type ProductAttributeFilterInput = {
  active?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<ProductAttributeFilterInput>>;
  attribDataType?: InputMaybe<ProductAttribDataTypeFilterInput>;
  attribDataTypeId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  attribTitle?: InputMaybe<ProductAttribTitleFilterInput>;
  attribTitleId?: InputMaybe<ComparableInt32OperationFilterInput>;
  attributeId?: InputMaybe<ComparableInt32OperationFilterInput>;
  attributeSet?: InputMaybe<ProductAttribSetFilterInput>;
  attributeSetId?: InputMaybe<ComparableInt32OperationFilterInput>;
  created?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  modified?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<ProductAttributeFilterInput>>;
  productAttribData?: InputMaybe<ListFilterInputTypeOfProductAttribDatumFilterInput>;
  purgeDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  removed?: InputMaybe<BooleanOperationFilterInput>;
  sortOrder?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  systemOnly?: InputMaybe<BooleanOperationFilterInput>;
  userCreatedId?: InputMaybe<ComparableInt32OperationFilterInput>;
  userModifiedId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type ProductAttributesViewModel = {
  __typename?: 'ProductAttributesViewModel';
  attributes: Array<AttributeViewModel>;
  name: Scalars['String'];
};

export type ProductCategory = {
  __typename?: 'ProductCategory';
  categoryId: Scalars['Int'];
  name: Scalars['String'];
};

export type ProductCategoryOrderLimitByRole = {
  __typename?: 'ProductCategoryOrderLimitByRole';
  id: Scalars['Int'];
  maxOrderQtyForDays: Scalars['Int'];
  numberOfDays: Scalars['Int'];
  productCategory: Category;
  productCategoryId: Scalars['Int'];
  role: RoleType;
  roleId: Scalars['Int'];
  rowVersion: Array<Scalars['ByteArray']>;
};

export type ProductCategoryOrderLimitByRoleFilterInput = {
  and?: InputMaybe<Array<ProductCategoryOrderLimitByRoleFilterInput>>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  maxOrderQtyForDays?: InputMaybe<ComparableInt32OperationFilterInput>;
  numberOfDays?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<ProductCategoryOrderLimitByRoleFilterInput>>;
  productCategory?: InputMaybe<CategoryFilterInput>;
  productCategoryId?: InputMaybe<ComparableInt32OperationFilterInput>;
  role?: InputMaybe<RoleFilterInput>;
  roleId?: InputMaybe<ComparableInt32OperationFilterInput>;
  rowVersion?: InputMaybe<ListComparableByteOperationFilterInput>;
};

export type ProductCodeHistoryFilterInput = {
  and?: InputMaybe<Array<ProductCodeHistoryFilterInput>>;
  created?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  createdUserId?: InputMaybe<ComparableInt32OperationFilterInput>;
  modified?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  modifiedUserId?: InputMaybe<ComparableInt32OperationFilterInput>;
  newCode?: InputMaybe<StringOperationFilterInput>;
  oldCode?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ProductCodeHistoryFilterInput>>;
  product?: InputMaybe<ProductFilterInput>;
  productCodeHistoryId?: InputMaybe<ComparableInt32OperationFilterInput>;
  productId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type ProductCustomerPropertyMap = {
  __typename?: 'ProductCustomerPropertyMap';
  created: Scalars['DateTime'];
  customerPropertyValue: CustomerPropertyValue;
  customerPropertyValueId: Scalars['Int'];
  isSuppplierOnly: Scalars['Boolean'];
  modified: Scalars['DateTime'];
  product: ProductType;
  productId: Scalars['Int'];
  productPropertyMapId: Scalars['Int'];
  rowVersion: Array<Scalars['ByteArray']>;
  userCreatedId: Scalars['Int'];
  userModifiedId: Scalars['Int'];
};

export type ProductCustomerPropertyMapFilterInput = {
  and?: InputMaybe<Array<ProductCustomerPropertyMapFilterInput>>;
  created?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  customerPropertyValue?: InputMaybe<CustomerPropertyValueFilterInput>;
  customerPropertyValueId?: InputMaybe<ComparableInt32OperationFilterInput>;
  isSuppplierOnly?: InputMaybe<BooleanOperationFilterInput>;
  modified?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<ProductCustomerPropertyMapFilterInput>>;
  product?: InputMaybe<ProductFilterInput>;
  productId?: InputMaybe<ComparableInt32OperationFilterInput>;
  productPropertyMapId?: InputMaybe<ComparableInt32OperationFilterInput>;
  rowVersion?: InputMaybe<ListComparableByteOperationFilterInput>;
  userCreatedId?: InputMaybe<ComparableInt32OperationFilterInput>;
  userModifiedId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type ProductDetailsPayload = {
  __typename?: 'ProductDetailsPayload';
  approverId?: Maybe<Scalars['Int']>;
  crmSpecification: Scalars['String'];
  crmSupplier: Scalars['String'];
  enableSerialNumberTracking: Scalars['Boolean'];
  externalProductId?: Maybe<Scalars['String']>;
  forceRGA: Scalars['Boolean'];
  gst: Scalars['Decimal'];
  isEmbroidery: Scalars['Boolean'];
  isHidden: Scalars['Boolean'];
  isOverPrintItem: Scalars['Boolean'];
  isRemoved: Scalars['Boolean'];
  isScreenPrintItem: Scalars['Boolean'];
  isSpecialDelivery: Scalars['Boolean'];
  isWBSJobItem: Scalars['Boolean'];
  isWBSOwnedStock: Scalars['Boolean'];
  itemGroupId?: Maybe<Scalars['Int']>;
  maxOrderQuantityLimit?: Maybe<Scalars['Int']>;
  maxOrderQuantityLimitDays?: Maybe<Scalars['Int']>;
  maxQuantityPerOrder?: Maybe<Scalars['Int']>;
  maxStockLevel: Scalars['Int'];
  minQuantityPerOrder?: Maybe<Scalars['Int']>;
  orderTypeId?: Maybe<Scalars['Int']>;
  processDays: Scalars['Int'];
  productCode: Scalars['String'];
  productDescription: Scalars['String'];
  productName: Scalars['String'];
  quantityTypeId?: Maybe<Scalars['Int']>;
  reOrderLevel?: Maybe<Scalars['Int']>;
  serialNumberBookSize?: Maybe<Scalars['Int']>;
  sortOrder?: Maybe<Scalars['Int']>;
  statusId?: Maybe<Scalars['Int']>;
  supplierLeadTime?: Maybe<Scalars['Int']>;
  zeroFreightOrderQuantity: Scalars['Int'];
};

export type ProductDetailsPayloadInput = {
  approverId?: InputMaybe<Scalars['Int']>;
  crmSpecification: Scalars['String'];
  crmSupplier: Scalars['String'];
  enableSerialNumberTracking: Scalars['Boolean'];
  externalProductId?: InputMaybe<Scalars['String']>;
  forceRGA: Scalars['Boolean'];
  gst: Scalars['Decimal'];
  isEmbroidery: Scalars['Boolean'];
  isHidden: Scalars['Boolean'];
  isOverPrintItem: Scalars['Boolean'];
  isRemoved: Scalars['Boolean'];
  isScreenPrintItem: Scalars['Boolean'];
  isSpecialDelivery: Scalars['Boolean'];
  isWBSJobItem: Scalars['Boolean'];
  isWBSOwnedStock: Scalars['Boolean'];
  itemGroupId?: InputMaybe<Scalars['Int']>;
  maxOrderQuantityLimit?: InputMaybe<Scalars['Int']>;
  maxOrderQuantityLimitDays?: InputMaybe<Scalars['Int']>;
  maxQuantityPerOrder?: InputMaybe<Scalars['Int']>;
  maxStockLevel: Scalars['Int'];
  minQuantityPerOrder?: InputMaybe<Scalars['Int']>;
  orderTypeId?: InputMaybe<Scalars['Int']>;
  processDays: Scalars['Int'];
  productCode: Scalars['String'];
  productDescription: Scalars['String'];
  productName: Scalars['String'];
  quantityTypeId?: InputMaybe<Scalars['Int']>;
  reOrderLevel?: InputMaybe<Scalars['Int']>;
  serialNumberBookSize?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<Scalars['Int']>;
  statusId?: InputMaybe<Scalars['Int']>;
  supplierLeadTime?: InputMaybe<Scalars['Int']>;
  zeroFreightOrderQuantity: Scalars['Int'];
};

export type ProductDocumentFilterInput = {
  and?: InputMaybe<Array<ProductDocumentFilterInput>>;
  created?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  documentId?: InputMaybe<ComparableInt32OperationFilterInput>;
  downloadLimitedTime?: InputMaybe<ComparableInt32OperationFilterInput>;
  modfied?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<ProductDocumentFilterInput>>;
  product?: InputMaybe<ProductFilterInput>;
  productDocumentId?: InputMaybe<ComparableInt32OperationFilterInput>;
  productId?: InputMaybe<ComparableInt32OperationFilterInput>;
  removed?: InputMaybe<BooleanOperationFilterInput>;
  rowVersion?: InputMaybe<ListComparableByteOperationFilterInput>;
};

export type ProductFilterInput = {
  active?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<ProductFilterInput>>;
  approver?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  attributeSet?: InputMaybe<ProductAttribSetFilterInput>;
  attributeSetId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  clientProductCode?: InputMaybe<StringOperationFilterInput>;
  created?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  crmSpecification?: InputMaybe<StringOperationFilterInput>;
  crmSupplier?: InputMaybe<StringOperationFilterInput>;
  customCssClass?: InputMaybe<StringOperationFilterInput>;
  customer?: InputMaybe<CustomerFilterInput>;
  customerId?: InputMaybe<ComparableInt32OperationFilterInput>;
  customerPickType?: InputMaybe<CustomerPickTypeFilterInput>;
  customerPickTypeId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  customerStockCommitted?: InputMaybe<ComparableInt32OperationFilterInput>;
  customerStockOnHand?: InputMaybe<ComparableInt32OperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  digitalDownloadInstrction?: InputMaybe<StringOperationFilterInput>;
  digitalDownloadLimitedTime?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  documentId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  expectedReplenishmentDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  forceRga?: InputMaybe<BooleanOperationFilterInput>;
  hasDigitalDownloadLink?: InputMaybe<BooleanOperationFilterInput>;
  hasLicencingAgreement?: InputMaybe<BooleanOperationFilterInput>;
  hidden?: InputMaybe<BooleanOperationFilterInput>;
  inverseParent?: InputMaybe<ListFilterInputTypeOfProductFilterInput>;
  isEmbroidery?: InputMaybe<BooleanOperationFilterInput>;
  isJobItem?: InputMaybe<BooleanOperationFilterInput>;
  isNonInventoryItem?: InputMaybe<BooleanOperationFilterInput>;
  isOverPrint?: InputMaybe<BooleanOperationFilterInput>;
  isPurchaseItem?: InputMaybe<BooleanOperationFilterInput>;
  isScreenPrint?: InputMaybe<BooleanOperationFilterInput>;
  isWaiveStarOwned?: InputMaybe<BooleanOperationFilterInput>;
  itemGroup?: InputMaybe<ProductItemGroupTypeFilterInput>;
  itemGroupId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  licencingAgreementHtml?: InputMaybe<StringOperationFilterInput>;
  limitAmount?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  limitDays?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  maxStockLevel?: InputMaybe<ComparableInt32OperationFilterInput>;
  maximumOrderQuant?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  minimumOrderQuant?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  modified?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ProductFilterInput>>;
  orderLines?: InputMaybe<ListFilterInputTypeOfOrderLineFilterInput>;
  orderType?: InputMaybe<OrderTypeFilterInput>;
  orderTypeId?: InputMaybe<ComparableInt32OperationFilterInput>;
  ownerUser?: InputMaybe<UserDetailFilterInput>;
  ownerUserId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  parent?: InputMaybe<ProductFilterInput>;
  parentId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  processDays?: InputMaybe<ComparableInt32OperationFilterInput>;
  productAllowedQuantities?: InputMaybe<ListFilterInputTypeOfProductAllowedQuantityFilterInput>;
  productArchives?: InputMaybe<ListFilterInputTypeOfProductArchiveFilterInput>;
  productAttribDataMaps?: InputMaybe<ListFilterInputTypeOfProductAttribDataMapFilterInput>;
  productAttribEmails?: InputMaybe<ListFilterInputTypeOfProductAttribEmailFilterInput>;
  productAttribEtemplates?: InputMaybe<ListFilterInputTypeOfProductAttribEtemplateFilterInput>;
  productCode?: InputMaybe<StringOperationFilterInput>;
  productCodeHistories?: InputMaybe<ListFilterInputTypeOfProductCodeHistoryFilterInput>;
  productCustomerPropertyMaps?: InputMaybe<ListFilterInputTypeOfProductCustomerPropertyMapFilterInput>;
  productDocuments?: InputMaybe<ListFilterInputTypeOfProductDocumentFilterInput>;
  productHistories?: InputMaybe<ListFilterInputTypeOfProductHistoryFilterInput>;
  productId?: InputMaybe<ComparableInt32OperationFilterInput>;
  productKittingChildProducts?: InputMaybe<ListFilterInputTypeOfProductKittingFilterInput>;
  productKittingParentProducts?: InputMaybe<ListFilterInputTypeOfProductKittingFilterInput>;
  productMedia?: InputMaybe<ListFilterInputTypeOfProductMediumFilterInput>;
  productOrderLimitByRoles?: InputMaybe<ListFilterInputTypeOfProductOrderLimitByRoleFilterInput>;
  productRelatedItems?: InputMaybe<ListFilterInputTypeOfProductRelatedItemFilterInput>;
  productReplenishmentAlerts?: InputMaybe<ListFilterInputTypeOfProductReplenishmentAlertFilterInput>;
  productStocktakeSettings?: InputMaybe<ListFilterInputTypeOfProductStocktakeSettingFilterInput>;
  productType?: InputMaybe<StringOperationFilterInput>;
  productUoms?: InputMaybe<ListFilterInputTypeOfProductUomFilterInput>;
  productVisibilities?: InputMaybe<ListFilterInputTypeOfProductVisibilityFilterInput>;
  purgeDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  quantType?: InputMaybe<ComparableInt32OperationFilterInput>;
  reOrderLevel?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  removed?: InputMaybe<BooleanOperationFilterInput>;
  reportCategory?: InputMaybe<StringOperationFilterInput>;
  roleProductDiscounts?: InputMaybe<ListFilterInputTypeOfRoleProductDiscountFilterInput>;
  rowVersion?: InputMaybe<ListComparableByteOperationFilterInput>;
  sappriceList?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  sentReOrder?: InputMaybe<BooleanOperationFilterInput>;
  serialNumberModulus?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  serialNumberTracking?: InputMaybe<BooleanOperationFilterInput>;
  singleDelivery?: InputMaybe<BooleanOperationFilterInput>;
  sortOrder?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  status?: InputMaybe<ProductStatusFilterInput>;
  statusId?: InputMaybe<ComparableInt32OperationFilterInput>;
  stockCommitted?: InputMaybe<ComparableInt32OperationFilterInput>;
  stockOnHand?: InputMaybe<ComparableInt32OperationFilterInput>;
  supplierLeadTime?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  taxRate?: InputMaybe<ComparableDecimalOperationFilterInput>;
  userCreatedId?: InputMaybe<ComparableInt32OperationFilterInput>;
  userModifiedId?: InputMaybe<ComparableInt32OperationFilterInput>;
  wmsCyclicProducts?: InputMaybe<ListFilterInputTypeOfWmsCyclicProductFilterInput>;
  wmsRgas?: InputMaybe<ListFilterInputTypeOfWmsRgaFilterInput>;
  wmsSerialNumbers?: InputMaybe<ListFilterInputTypeOfWmsSerialNumberFilterInput>;
  wmsStockQuantities?: InputMaybe<ListFilterInputTypeOfWmsStockQuantityFilterInput>;
  wn2id?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  zeroFreightOrderQuant?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
};

export type ProductHistoryFilterInput = {
  action?: InputMaybe<StringOperationFilterInput>;
  actionDate?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  and?: InputMaybe<Array<ProductHistoryFilterInput>>;
  loginUserId?: InputMaybe<ComparableInt32OperationFilterInput>;
  loginUserPc?: InputMaybe<StringOperationFilterInput>;
  notes?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ProductHistoryFilterInput>>;
  orderId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  product?: InputMaybe<ProductFilterInput>;
  productHistoryId?: InputMaybe<ComparableInt32OperationFilterInput>;
  productId?: InputMaybe<ComparableInt32OperationFilterInput>;
  productName?: InputMaybe<StringOperationFilterInput>;
  unitAfter?: InputMaybe<ComparableInt32OperationFilterInput>;
  unitBefore?: InputMaybe<ComparableInt32OperationFilterInput>;
  unitIn?: InputMaybe<ComparableInt32OperationFilterInput>;
  unitOut?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type ProductItemGroupType = {
  __typename?: 'ProductItemGroupType';
  isActive: Scalars['Boolean'];
  name: Scalars['String'];
  productItemGroupId: Scalars['Int'];
  products: Array<ProductType>;
  sort: Scalars['Int'];
};

export type ProductItemGroupTypeFilterInput = {
  and?: InputMaybe<Array<ProductItemGroupTypeFilterInput>>;
  isActive?: InputMaybe<BooleanOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ProductItemGroupTypeFilterInput>>;
  productItemGroupId?: InputMaybe<ComparableInt32OperationFilterInput>;
  products?: InputMaybe<ListFilterInputTypeOfProductFilterInput>;
  sort?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type ProductItemGroupTypeSortInput = {
  isActive?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  productItemGroupId?: InputMaybe<SortEnumType>;
  sort?: InputMaybe<SortEnumType>;
};

export type ProductKittingFilterInput = {
  and?: InputMaybe<Array<ProductKittingFilterInput>>;
  childProduct?: InputMaybe<ProductFilterInput>;
  childProductId?: InputMaybe<ComparableInt32OperationFilterInput>;
  kitId?: InputMaybe<ComparableInt32OperationFilterInput>;
  maximumQuant?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  multiplier?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<ProductKittingFilterInput>>;
  parentProduct?: InputMaybe<ProductFilterInput>;
  parentProductId?: InputMaybe<ComparableInt32OperationFilterInput>;
  removed?: InputMaybe<BooleanOperationFilterInput>;
  rowVersion?: InputMaybe<ListComparableByteOperationFilterInput>;
  userModifiedId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type ProductMapping = {
  __typename?: 'ProductMapping';
  clientProduct?: Maybe<Scalars['String']>;
  customer?: Maybe<Customer>;
  customerId?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  waivenetProduct: Scalars['String'];
};

export type ProductMappingFilterInput = {
  and?: InputMaybe<Array<ProductMappingFilterInput>>;
  clientProduct?: InputMaybe<StringOperationFilterInput>;
  customer?: InputMaybe<CustomerFilterInput>;
  customerId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<ProductMappingFilterInput>>;
  waivenetProduct?: InputMaybe<StringOperationFilterInput>;
};

export type ProductMediumFilterInput = {
  active?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<ProductMediumFilterInput>>;
  created?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  defaultImage?: InputMaybe<BooleanOperationFilterInput>;
  mediaId?: InputMaybe<ComparableInt32OperationFilterInput>;
  modified?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<ProductMediumFilterInput>>;
  product?: InputMaybe<ProductFilterInput>;
  productId?: InputMaybe<ComparableInt32OperationFilterInput>;
  purgeDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  removed?: InputMaybe<BooleanOperationFilterInput>;
  rowVersion?: InputMaybe<ListComparableByteOperationFilterInput>;
  thumbnailOnly?: InputMaybe<BooleanOperationFilterInput>;
  uploadedFile?: InputMaybe<UploadedFileFilterInput>;
  uploadedFileId?: InputMaybe<ComparableInt32OperationFilterInput>;
  userCreatedId?: InputMaybe<ComparableInt32OperationFilterInput>;
  userModifiedId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

/** Represents a ProductMedium. */
export type ProductMediumType = {
  __typename?: 'ProductMediumType';
  active: Scalars['Boolean'];
  created: Scalars['DateTime'];
  defaultImage: Scalars['Boolean'];
  mediaId: Scalars['Int'];
  modified: Scalars['DateTime'];
  product: ProductType;
  productId: Scalars['Int'];
  purgeDate?: Maybe<Scalars['DateTime']>;
  removed: Scalars['Boolean'];
  rowVersion: Array<Scalars['ByteArray']>;
  thumbnailOnly?: Maybe<Scalars['Boolean']>;
  /** Uploaded File */
  uploadedFile?: Maybe<UploadedFile>;
  uploadedFileId: Scalars['Int'];
  userCreatedId: Scalars['Int'];
  userModifiedId: Scalars['Int'];
};

export type ProductNewTempAllowedQuant = {
  __typename?: 'ProductNewTempAllowedQuant';
  created: Scalars['DateTime'];
  modified: Scalars['DateTime'];
  newTempAllowedQuantId: Scalars['Int'];
  quantity: Scalars['Int'];
  rowVersion: Scalars['Int'];
  salePrice?: Maybe<Scalars['Decimal']>;
  temp: ProductNewTemporary;
  tempId: Scalars['Int'];
  userModifiedId: Scalars['Int'];
};

export type ProductNewTempAllowedQuantFilterInput = {
  and?: InputMaybe<Array<ProductNewTempAllowedQuantFilterInput>>;
  created?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  modified?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  newTempAllowedQuantId?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<ProductNewTempAllowedQuantFilterInput>>;
  quantity?: InputMaybe<ComparableInt32OperationFilterInput>;
  rowVersion?: InputMaybe<ComparableInt32OperationFilterInput>;
  salePrice?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  temp?: InputMaybe<ProductNewTemporaryFilterInput>;
  tempId?: InputMaybe<ComparableInt32OperationFilterInput>;
  userModifiedId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type ProductNewTemporary = {
  __typename?: 'ProductNewTemporary';
  categoryNameList: Scalars['String'];
  created: Scalars['DateTime'];
  customer: Customer;
  customerId: Scalars['Int'];
  description?: Maybe<Scalars['String']>;
  existingCategory?: Maybe<Category>;
  existingCategoryId?: Maybe<Scalars['Int']>;
  expectedArrivalDate?: Maybe<Scalars['DateTime']>;
  limitDays?: Maybe<Scalars['Int']>;
  limitQuantity?: Maybe<Scalars['Int']>;
  maximumOrderQty?: Maybe<Scalars['Int']>;
  minimumOrderQty?: Maybe<Scalars['Int']>;
  modified: Scalars['DateTime'];
  name: Scalars['String'];
  orderTypeId: Scalars['Int'];
  productCode?: Maybe<Scalars['String']>;
  productNewTempAllowedQuants: Array<ProductNewTempAllowedQuant>;
  promoterCategory?: Maybe<CategoryPromoter>;
  promoterCategoryId?: Maybe<Scalars['Int']>;
  purgeDate?: Maybe<Scalars['DateTime']>;
  quantType: Scalars['Int'];
  removed: Scalars['Boolean'];
  reorderLevel?: Maybe<Scalars['Int']>;
  rowVersion: Scalars['Int'];
  salePrice?: Maybe<Scalars['Decimal']>;
  tempId: Scalars['Int'];
  userModifiedId: Scalars['Int'];
};

export type ProductNewTemporaryFilterInput = {
  and?: InputMaybe<Array<ProductNewTemporaryFilterInput>>;
  categoryNameList?: InputMaybe<StringOperationFilterInput>;
  created?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  customer?: InputMaybe<CustomerFilterInput>;
  customerId?: InputMaybe<ComparableInt32OperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  existingCategory?: InputMaybe<CategoryFilterInput>;
  existingCategoryId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  expectedArrivalDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  limitDays?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  limitQuantity?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  maximumOrderQty?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  minimumOrderQty?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  modified?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ProductNewTemporaryFilterInput>>;
  orderTypeId?: InputMaybe<ComparableInt32OperationFilterInput>;
  productCode?: InputMaybe<StringOperationFilterInput>;
  productNewTempAllowedQuants?: InputMaybe<ListFilterInputTypeOfProductNewTempAllowedQuantFilterInput>;
  promoterCategory?: InputMaybe<CategoryPromoterFilterInput>;
  promoterCategoryId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  purgeDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  quantType?: InputMaybe<ComparableInt32OperationFilterInput>;
  removed?: InputMaybe<BooleanOperationFilterInput>;
  reorderLevel?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  rowVersion?: InputMaybe<ComparableInt32OperationFilterInput>;
  salePrice?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  tempId?: InputMaybe<ComparableInt32OperationFilterInput>;
  userModifiedId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type ProductOrderLimitByRole = {
  __typename?: 'ProductOrderLimitByRole';
  id: Scalars['Int'];
  maxOrderQtyForDays: Scalars['Int'];
  numberOfDays: Scalars['Int'];
  product: ProductType;
  productId: Scalars['Int'];
  role: RoleType;
  roleId: Scalars['Int'];
  rowVersion: Array<Scalars['ByteArray']>;
};

export type ProductOrderLimitByRoleFilterInput = {
  and?: InputMaybe<Array<ProductOrderLimitByRoleFilterInput>>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  maxOrderQtyForDays?: InputMaybe<ComparableInt32OperationFilterInput>;
  numberOfDays?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<ProductOrderLimitByRoleFilterInput>>;
  product?: InputMaybe<ProductFilterInput>;
  productId?: InputMaybe<ComparableInt32OperationFilterInput>;
  role?: InputMaybe<RoleFilterInput>;
  roleId?: InputMaybe<ComparableInt32OperationFilterInput>;
  rowVersion?: InputMaybe<ListComparableByteOperationFilterInput>;
};

export type ProductPriceBreakType = {
  __typename?: 'ProductPriceBreakType';
  /** Represents the price for the quantity */
  price: Scalars['Decimal'];
  /** Represents the quantity used in the price break */
  quantity: Scalars['Int'];
};

export type ProductRelatedItemFilterInput = {
  and?: InputMaybe<Array<ProductRelatedItemFilterInput>>;
  clicks?: InputMaybe<ComparableInt32OperationFilterInput>;
  created?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  crossSellUpSell?: InputMaybe<BooleanOperationFilterInput>;
  modified?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<ProductRelatedItemFilterInput>>;
  product?: InputMaybe<ProductFilterInput>;
  productId?: InputMaybe<ComparableInt32OperationFilterInput>;
  purgeDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  relatedId?: InputMaybe<ComparableInt32OperationFilterInput>;
  relatedProductId?: InputMaybe<ComparableInt32OperationFilterInput>;
  removed?: InputMaybe<BooleanOperationFilterInput>;
  rowVersion?: InputMaybe<ComparableInt32OperationFilterInput>;
  userModifiedId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type ProductReplenishmentAlertFilterInput = {
  alertNote?: InputMaybe<StringOperationFilterInput>;
  alertQuantity?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  alertSent?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<ProductReplenishmentAlertFilterInput>>;
  created?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  emailAddress?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ProductReplenishmentAlertFilterInput>>;
  product?: InputMaybe<ProductFilterInput>;
  productId?: InputMaybe<ComparableInt32OperationFilterInput>;
  purgeDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  removed?: InputMaybe<BooleanOperationFilterInput>;
  replenishmentAlertId?: InputMaybe<ComparableInt32OperationFilterInput>;
  rowVersion?: InputMaybe<ComparableInt32OperationFilterInput>;
  sentDateTime?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  userCreatedId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type ProductSortInput = {
  active?: InputMaybe<SortEnumType>;
  approver?: InputMaybe<SortEnumType>;
  attributeSet?: InputMaybe<ProductAttribSetSortInput>;
  attributeSetId?: InputMaybe<SortEnumType>;
  clientProductCode?: InputMaybe<SortEnumType>;
  created?: InputMaybe<SortEnumType>;
  crmSpecification?: InputMaybe<SortEnumType>;
  crmSupplier?: InputMaybe<SortEnumType>;
  customCssClass?: InputMaybe<SortEnumType>;
  customer?: InputMaybe<CustomerSortInput>;
  customerId?: InputMaybe<SortEnumType>;
  customerPickType?: InputMaybe<CustomerPickTypeSortInput>;
  customerPickTypeId?: InputMaybe<SortEnumType>;
  customerStockCommitted?: InputMaybe<SortEnumType>;
  customerStockOnHand?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  digitalDownloadInstrction?: InputMaybe<SortEnumType>;
  digitalDownloadLimitedTime?: InputMaybe<SortEnumType>;
  documentId?: InputMaybe<SortEnumType>;
  expectedReplenishmentDate?: InputMaybe<SortEnumType>;
  forceRga?: InputMaybe<SortEnumType>;
  hasDigitalDownloadLink?: InputMaybe<SortEnumType>;
  hasLicencingAgreement?: InputMaybe<SortEnumType>;
  hidden?: InputMaybe<SortEnumType>;
  isEmbroidery?: InputMaybe<SortEnumType>;
  isJobItem?: InputMaybe<SortEnumType>;
  isNonInventoryItem?: InputMaybe<SortEnumType>;
  isOverPrint?: InputMaybe<SortEnumType>;
  isPurchaseItem?: InputMaybe<SortEnumType>;
  isScreenPrint?: InputMaybe<SortEnumType>;
  isWaiveStarOwned?: InputMaybe<SortEnumType>;
  itemGroup?: InputMaybe<ProductItemGroupTypeSortInput>;
  itemGroupId?: InputMaybe<SortEnumType>;
  licencingAgreementHtml?: InputMaybe<SortEnumType>;
  limitAmount?: InputMaybe<SortEnumType>;
  limitDays?: InputMaybe<SortEnumType>;
  maxStockLevel?: InputMaybe<SortEnumType>;
  maximumOrderQuant?: InputMaybe<SortEnumType>;
  minimumOrderQuant?: InputMaybe<SortEnumType>;
  modified?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  orderType?: InputMaybe<OrderTypeSortInput>;
  orderTypeId?: InputMaybe<SortEnumType>;
  ownerUser?: InputMaybe<UserDetailSortInput>;
  ownerUserId?: InputMaybe<SortEnumType>;
  parent?: InputMaybe<ProductSortInput>;
  parentId?: InputMaybe<SortEnumType>;
  processDays?: InputMaybe<SortEnumType>;
  productCode?: InputMaybe<SortEnumType>;
  productId?: InputMaybe<SortEnumType>;
  productType?: InputMaybe<SortEnumType>;
  purgeDate?: InputMaybe<SortEnumType>;
  quantType?: InputMaybe<SortEnumType>;
  reOrderLevel?: InputMaybe<SortEnumType>;
  removed?: InputMaybe<SortEnumType>;
  reportCategory?: InputMaybe<SortEnumType>;
  sappriceList?: InputMaybe<SortEnumType>;
  sentReOrder?: InputMaybe<SortEnumType>;
  serialNumberModulus?: InputMaybe<SortEnumType>;
  serialNumberTracking?: InputMaybe<SortEnumType>;
  singleDelivery?: InputMaybe<SortEnumType>;
  sortOrder?: InputMaybe<SortEnumType>;
  status?: InputMaybe<ProductStatusSortInput>;
  statusId?: InputMaybe<SortEnumType>;
  stockCommitted?: InputMaybe<SortEnumType>;
  stockOnHand?: InputMaybe<SortEnumType>;
  supplierLeadTime?: InputMaybe<SortEnumType>;
  taxRate?: InputMaybe<SortEnumType>;
  userCreatedId?: InputMaybe<SortEnumType>;
  userModifiedId?: InputMaybe<SortEnumType>;
  wn2id?: InputMaybe<SortEnumType>;
  zeroFreightOrderQuant?: InputMaybe<SortEnumType>;
};

export type ProductStatus = {
  __typename?: 'ProductStatus';
  name: Scalars['String'];
  products: Array<ProductType>;
  statusId: Scalars['Int'];
};

export type ProductStatusFilterInput = {
  and?: InputMaybe<Array<ProductStatusFilterInput>>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ProductStatusFilterInput>>;
  products?: InputMaybe<ListFilterInputTypeOfProductFilterInput>;
  statusId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type ProductStatusSortInput = {
  name?: InputMaybe<SortEnumType>;
  statusId?: InputMaybe<SortEnumType>;
};

export type ProductStocktakeSettingFilterInput = {
  and?: InputMaybe<Array<ProductStocktakeSettingFilterInput>>;
  created?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  failedCountEmailNotify?: InputMaybe<StringOperationFilterInput>;
  modified?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<ProductStocktakeSettingFilterInput>>;
  product?: InputMaybe<ProductFilterInput>;
  productId?: InputMaybe<ComparableInt32OperationFilterInput>;
  productStocktakeId?: InputMaybe<ComparableInt32OperationFilterInput>;
  recount2Percent?: InputMaybe<ComparableDecimalOperationFilterInput>;
  recountPercent?: InputMaybe<ComparableDecimalOperationFilterInput>;
  rowVersion?: InputMaybe<ListComparableByteOperationFilterInput>;
  stocktakeReoccurrenceDays?: InputMaybe<ComparableInt32OperationFilterInput>;
  userModifiedId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

/** Represents a Product. */
export type ProductType = {
  __typename?: 'ProductType';
  /** Represents the Product's categories aggregated into a comma-delimited string */
  categories: Scalars['String'];
  /** The list of child products under the product and the user's Customer ID */
  childProducts?: Maybe<ProductType>;
  /** Represents the Product's Code */
  code: Scalars['String'];
  /** Describes the date the product was created on */
  dateCreated: Scalars['DateTime'];
  /** The default quantity that the product can be ordered with (computed based on discussion with Hollie) */
  defaultQuantity: Scalars['Int'];
  /** Describes the Product */
  description?: Maybe<Scalars['String']>;
  /** Whether or not product is hidden */
  hidden?: Maybe<Scalars['Boolean']>;
  /** Describes whether or not the product uses Price Breaks */
  hasPriceBreaks: Scalars['Boolean'];
  /** Represents the Product's image */
  image?: Maybe<Scalars['ByteArray']>;
  /** The minimum quantity that the product can be ordered with */
  minOrderQuantity?: Maybe<Scalars['Int']>;
  /** Represents the Product's Name */
  name: Scalars['String'];
  /** Represents the product's Order or Product Type */
  orderType: OrderTypeGqlType;
  /** Represents the Product's Order Type's ID */
  orderTypeId: Scalars['Int'];
  /** Represents the Product's Parent ID */
  parentId?: Maybe<Scalars['Int']>;
  /** The product's price as text (computed using Legacy WaiveNet logic). If the product has price breaks, the text may span multiple lines describing the price of each break. */
  priceSummary: Scalars['String'];
  /** Describes the pricing structure the Product uses (based on QuantType) */
  priceType: Scalars['String'];
  /** Represents the price structure of the Product(combine with priceType to determine unit prices and others) */
  prices: Array<ProductPriceBreakType>;
  /** Represents the Product's Unique ID */
  productId: Scalars['Int'];
  /** Represents the Product's Status as descriptive text */
  status: Scalars['String'];
  /** Represents the Product's Status' ID */
  statusId: Scalars['Int'];
  /** Represents the Product's Available Stock (computed using Legacy WaiveNet logic & Ming's advice) */
  stockAvailable: Scalars['Int'];
  /** Represents the quantity of stock currently committed to sales orders */
  stockCommitted: Scalars['Int'];
  /** The product's current stock (on hand) */
  stockOnHand: Scalars['Int'];
  /** Represents the Product's Unit of Measurement as a term (word) */
  unitOfMeasurement?: Maybe<Scalars['String']>;
  /** Represents the Product's Unit of Measurement with Amount as a string */
  unitOfMeasurementAmount?: Maybe<Scalars['String']>;
};


/** Represents a Product. */
export type ProductTypeChildProductsArgs = {
  where?: InputMaybe<ProductFilterInput>;
};

export type ProductTypeCollectionSegment = {
  __typename?: 'ProductTypeCollectionSegment';
  items?: Maybe<Array<ProductType>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type ProductUom = {
  __typename?: 'ProductUom';
  active: Scalars['Boolean'];
  costPrice?: Maybe<Scalars['Decimal']>;
  created: Scalars['DateTime'];
  cube?: Maybe<Scalars['Decimal']>;
  descriptor: Uomdescription;
  descriptorId: Scalars['Int'];
  dimensionXcm?: Maybe<Scalars['Decimal']>;
  dimensionYcm?: Maybe<Scalars['Decimal']>;
  dimensionZcm?: Maybe<Scalars['Decimal']>;
  modified: Scalars['DateTime'];
  multiplier: Scalars['Int'];
  name: Scalars['String'];
  product: ProductType;
  productId: Scalars['Int'];
  purchaseUom: Scalars['Boolean'];
  purgeDate?: Maybe<Scalars['DateTime']>;
  removed?: Maybe<Scalars['Boolean']>;
  rowVersion: Scalars['Int'];
  sellPrice?: Maybe<Scalars['Decimal']>;
  sellUom: Scalars['Boolean'];
  uomid: Scalars['Int'];
  userCreatedId: Scalars['Int'];
  userModifiedId: Scalars['Int'];
  weightKg?: Maybe<Scalars['Decimal']>;
};

export type ProductUomFilterInput = {
  active?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<ProductUomFilterInput>>;
  costPrice?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  created?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  cube?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  descriptor?: InputMaybe<UomdescriptionFilterInput>;
  descriptorId?: InputMaybe<ComparableInt32OperationFilterInput>;
  dimensionXcm?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  dimensionYcm?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  dimensionZcm?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  modified?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  multiplier?: InputMaybe<ComparableInt32OperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ProductUomFilterInput>>;
  product?: InputMaybe<ProductFilterInput>;
  productId?: InputMaybe<ComparableInt32OperationFilterInput>;
  purchaseUom?: InputMaybe<BooleanOperationFilterInput>;
  purgeDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  removed?: InputMaybe<BooleanOperationFilterInput>;
  rowVersion?: InputMaybe<ComparableInt32OperationFilterInput>;
  sellPrice?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  sellUom?: InputMaybe<BooleanOperationFilterInput>;
  uomid?: InputMaybe<ComparableInt32OperationFilterInput>;
  userCreatedId?: InputMaybe<ComparableInt32OperationFilterInput>;
  userModifiedId?: InputMaybe<ComparableInt32OperationFilterInput>;
  weightKg?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
};

export type ProductVisibility = {
  __typename?: 'ProductVisibility';
  category: Category;
  categoryId: Scalars['Int'];
  created: Scalars['DateTime'];
  modified: Scalars['DateTime'];
  product: ProductType;
  productId: Scalars['Int'];
  userModifiedId: Scalars['Int'];
  visibilityId: Scalars['Int'];
};

export type ProductVisibilityFilterInput = {
  and?: InputMaybe<Array<ProductVisibilityFilterInput>>;
  category?: InputMaybe<CategoryFilterInput>;
  categoryId?: InputMaybe<ComparableInt32OperationFilterInput>;
  created?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  modified?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<ProductVisibilityFilterInput>>;
  product?: InputMaybe<ProductFilterInput>;
  productId?: InputMaybe<ComparableInt32OperationFilterInput>;
  userModifiedId?: InputMaybe<ComparableInt32OperationFilterInput>;
  visibilityId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type ProductsTotalPriceItemInput = {
  productId: Scalars['Int'];
  quantity: Scalars['Int'];
};

export type Project = {
  __typename?: 'Project';
  active: Scalars['Boolean'];
  businessLevel: BusinessLevel;
  businessLevelId: Scalars['Int'];
  closedDate?: Maybe<Scalars['DateTime']>;
  createdDateTime: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  isDefaultProject: Scalars['Boolean'];
  modifiedDateTime: Scalars['DateTime'];
  name: Scalars['String'];
  orders: Array<Order>;
  projectGuid?: Maybe<Scalars['UUID']>;
  projectStages: Array<ProjectStage>;
  projectType: ProjectType;
  projectTypeId: Scalars['Int'];
  projectVisibilities: Array<ProjectVisibility>;
  removed?: Maybe<Scalars['Boolean']>;
  roleId?: Maybe<Scalars['Int']>;
  status?: Maybe<ProjectStatus>;
  statusId?: Maybe<Scalars['Int']>;
  userCreatedId?: Maybe<Scalars['Int']>;
};

export type ProjectFilterInput = {
  active?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<ProjectFilterInput>>;
  businessLevel?: InputMaybe<BusinessLevelFilterInput>;
  businessLevelId?: InputMaybe<ComparableInt32OperationFilterInput>;
  closedDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  createdDateTime?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  isDefaultProject?: InputMaybe<BooleanOperationFilterInput>;
  modifiedDateTime?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ProjectFilterInput>>;
  orders?: InputMaybe<ListFilterInputTypeOfOrderFilterInput>;
  projectGuid?: InputMaybe<ComparableNullableOfGuidOperationFilterInput>;
  projectStages?: InputMaybe<ListFilterInputTypeOfProjectStageFilterInput>;
  projectType?: InputMaybe<ProjectTypeFilterInput>;
  projectTypeId?: InputMaybe<ComparableInt32OperationFilterInput>;
  projectVisibilities?: InputMaybe<ListFilterInputTypeOfProjectVisibilityFilterInput>;
  removed?: InputMaybe<BooleanOperationFilterInput>;
  roleId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  status?: InputMaybe<ProjectStatusFilterInput>;
  statusId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  userCreatedId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
};

export type ProjectSortInput = {
  active?: InputMaybe<SortEnumType>;
  businessLevel?: InputMaybe<BusinessLevelSortInput>;
  businessLevelId?: InputMaybe<SortEnumType>;
  closedDate?: InputMaybe<SortEnumType>;
  createdDateTime?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  isDefaultProject?: InputMaybe<SortEnumType>;
  modifiedDateTime?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  projectGuid?: InputMaybe<SortEnumType>;
  projectType?: InputMaybe<ProjectTypeSortInput>;
  projectTypeId?: InputMaybe<SortEnumType>;
  removed?: InputMaybe<SortEnumType>;
  roleId?: InputMaybe<SortEnumType>;
  status?: InputMaybe<ProjectStatusSortInput>;
  statusId?: InputMaybe<SortEnumType>;
  userCreatedId?: InputMaybe<SortEnumType>;
};

export type ProjectStage = {
  __typename?: 'ProjectStage';
  activityDueDates: Array<ActivityDueDate>;
  activityOriginalProjectStages: Array<Activity>;
  activityProjectStages: Array<Activity>;
  archiveColumn: Scalars['Boolean'];
  businessLevelId?: Maybe<Scalars['Int']>;
  collapseColumn: Scalars['Boolean'];
  defaultColor?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  dueDateDisplayMode: Scalars['String'];
  id: Scalars['Int'];
  inverseLinkProjectStage: Array<ProjectStage>;
  linkProjectStage?: Maybe<ProjectStage>;
  linkProjectStageId?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  project: Project;
  projectId: Scalars['Int'];
  projectStageAttendees: Array<ProjectStageAttendee>;
  removed: Scalars['Boolean'];
  responsibleUser?: Maybe<UserType>;
  responsibleUserId?: Maybe<Scalars['Int']>;
  showDescriptionExpanded: Scalars['Boolean'];
  showIconOfResponsibleUser: Scalars['Boolean'];
  showLabelsExpanded: Scalars['Boolean'];
  showNameOfResponsibleUser: Scalars['Boolean'];
  showSubTasksExpanded: Scalars['Boolean'];
  showTimeEstimate: Scalars['Boolean'];
  showTimeSpent: Scalars['Boolean'];
  sortOrder: Scalars['Int'];
  taskLimit?: Maybe<Scalars['Int']>;
};

export type ProjectStageAttendee = {
  __typename?: 'ProjectStageAttendee';
  created?: Maybe<Scalars['DateTime']>;
  modified?: Maybe<Scalars['DateTime']>;
  projectStage: ProjectStage;
  projectStageAttendeeId: Scalars['Int'];
  projectStageId: Scalars['Int'];
  rowVersion: Array<Scalars['ByteArray']>;
  user: UserType;
  userId: Scalars['Int'];
};

export type ProjectStageAttendeeFilterInput = {
  and?: InputMaybe<Array<ProjectStageAttendeeFilterInput>>;
  created?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  modified?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<ProjectStageAttendeeFilterInput>>;
  projectStage?: InputMaybe<ProjectStageFilterInput>;
  projectStageAttendeeId?: InputMaybe<ComparableInt32OperationFilterInput>;
  projectStageId?: InputMaybe<ComparableInt32OperationFilterInput>;
  rowVersion?: InputMaybe<ListComparableByteOperationFilterInput>;
  user?: InputMaybe<UserDetailFilterInput>;
  userId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type ProjectStageFilterInput = {
  activityDueDates?: InputMaybe<ListFilterInputTypeOfActivityDueDateFilterInput>;
  activityOriginalProjectStages?: InputMaybe<ListFilterInputTypeOfActivityFilterInput>;
  activityProjectStages?: InputMaybe<ListFilterInputTypeOfActivityFilterInput>;
  and?: InputMaybe<Array<ProjectStageFilterInput>>;
  archiveColumn?: InputMaybe<BooleanOperationFilterInput>;
  businessLevelId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  collapseColumn?: InputMaybe<BooleanOperationFilterInput>;
  defaultColor?: InputMaybe<StringOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  dueDateDisplayMode?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  inverseLinkProjectStage?: InputMaybe<ListFilterInputTypeOfProjectStageFilterInput>;
  linkProjectStage?: InputMaybe<ProjectStageFilterInput>;
  linkProjectStageId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ProjectStageFilterInput>>;
  project?: InputMaybe<ProjectFilterInput>;
  projectId?: InputMaybe<ComparableInt32OperationFilterInput>;
  projectStageAttendees?: InputMaybe<ListFilterInputTypeOfProjectStageAttendeeFilterInput>;
  removed?: InputMaybe<BooleanOperationFilterInput>;
  responsibleUser?: InputMaybe<UserDetailFilterInput>;
  responsibleUserId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  showDescriptionExpanded?: InputMaybe<BooleanOperationFilterInput>;
  showIconOfResponsibleUser?: InputMaybe<BooleanOperationFilterInput>;
  showLabelsExpanded?: InputMaybe<BooleanOperationFilterInput>;
  showNameOfResponsibleUser?: InputMaybe<BooleanOperationFilterInput>;
  showSubTasksExpanded?: InputMaybe<BooleanOperationFilterInput>;
  showTimeEstimate?: InputMaybe<BooleanOperationFilterInput>;
  showTimeSpent?: InputMaybe<BooleanOperationFilterInput>;
  sortOrder?: InputMaybe<ComparableInt32OperationFilterInput>;
  taskLimit?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
};

export type ProjectStageSortInput = {
  archiveColumn?: InputMaybe<SortEnumType>;
  businessLevelId?: InputMaybe<SortEnumType>;
  collapseColumn?: InputMaybe<SortEnumType>;
  defaultColor?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  dueDateDisplayMode?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  linkProjectStage?: InputMaybe<ProjectStageSortInput>;
  linkProjectStageId?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  project?: InputMaybe<ProjectSortInput>;
  projectId?: InputMaybe<SortEnumType>;
  removed?: InputMaybe<SortEnumType>;
  responsibleUser?: InputMaybe<UserDetailSortInput>;
  responsibleUserId?: InputMaybe<SortEnumType>;
  showDescriptionExpanded?: InputMaybe<SortEnumType>;
  showIconOfResponsibleUser?: InputMaybe<SortEnumType>;
  showLabelsExpanded?: InputMaybe<SortEnumType>;
  showNameOfResponsibleUser?: InputMaybe<SortEnumType>;
  showSubTasksExpanded?: InputMaybe<SortEnumType>;
  showTimeEstimate?: InputMaybe<SortEnumType>;
  showTimeSpent?: InputMaybe<SortEnumType>;
  sortOrder?: InputMaybe<SortEnumType>;
  taskLimit?: InputMaybe<SortEnumType>;
};

export type ProjectStatus = {
  __typename?: 'ProjectStatus';
  name: Scalars['String'];
  projects: Array<Project>;
  statusId: Scalars['Int'];
};

export type ProjectStatusFilterInput = {
  and?: InputMaybe<Array<ProjectStatusFilterInput>>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ProjectStatusFilterInput>>;
  projects?: InputMaybe<ListFilterInputTypeOfProjectFilterInput>;
  statusId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type ProjectStatusSortInput = {
  name?: InputMaybe<SortEnumType>;
  statusId?: InputMaybe<SortEnumType>;
};

export type ProjectType = {
  __typename?: 'ProjectType';
  id: Scalars['Int'];
  name: Scalars['String'];
  projects: Array<Project>;
};

export type ProjectTypeFilterInput = {
  and?: InputMaybe<Array<ProjectTypeFilterInput>>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ProjectTypeFilterInput>>;
  projects?: InputMaybe<ListFilterInputTypeOfProjectFilterInput>;
};

export type ProjectTypeSortInput = {
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
};

export type ProjectVisibility = {
  __typename?: 'ProjectVisibility';
  businessLevel?: Maybe<BusinessLevel>;
  businessLevelId?: Maybe<Scalars['Int']>;
  created: Scalars['DateTime'];
  id: Scalars['Int'];
  modified: Scalars['DateTime'];
  permisssion: Scalars['Int'];
  project: Project;
  projectId: Scalars['Int'];
  rowVersion: Array<Scalars['ByteArray']>;
  user?: Maybe<UserType>;
  userCreatedId: Scalars['Int'];
  userId?: Maybe<Scalars['Int']>;
};

export type ProjectVisibilityFilterInput = {
  and?: InputMaybe<Array<ProjectVisibilityFilterInput>>;
  businessLevel?: InputMaybe<BusinessLevelFilterInput>;
  businessLevelId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  created?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  modified?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<ProjectVisibilityFilterInput>>;
  permisssion?: InputMaybe<ComparableInt32OperationFilterInput>;
  project?: InputMaybe<ProjectFilterInput>;
  projectId?: InputMaybe<ComparableInt32OperationFilterInput>;
  rowVersion?: InputMaybe<ListComparableByteOperationFilterInput>;
  user?: InputMaybe<UserDetailFilterInput>;
  userCreatedId?: InputMaybe<ComparableInt32OperationFilterInput>;
  userId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
};

export type PromoCode = {
  __typename?: 'PromoCode';
  amount: Scalars['Decimal'];
  categoryId?: Maybe<Scalars['Int']>;
  created: Scalars['DateTime'];
  customer: Customer;
  customerId: Scalars['Int'];
  expireDate?: Maybe<Scalars['DateTime']>;
  isPercentage: Scalars['Boolean'];
  modified: Scalars['DateTime'];
  productId?: Maybe<Scalars['Int']>;
  promoCode1: Scalars['String'];
  promoId: Scalars['Int'];
  removed: Scalars['Boolean'];
  rowVersion: Array<Scalars['ByteArray']>;
  userCreatedId: Scalars['Int'];
};

export type PromoCodeFilterInput = {
  amount?: InputMaybe<ComparableDecimalOperationFilterInput>;
  and?: InputMaybe<Array<PromoCodeFilterInput>>;
  categoryId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  created?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  customer?: InputMaybe<CustomerFilterInput>;
  customerId?: InputMaybe<ComparableInt32OperationFilterInput>;
  expireDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  isPercentage?: InputMaybe<BooleanOperationFilterInput>;
  modified?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<PromoCodeFilterInput>>;
  productId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  promoCode1?: InputMaybe<StringOperationFilterInput>;
  promoId?: InputMaybe<ComparableInt32OperationFilterInput>;
  removed?: InputMaybe<BooleanOperationFilterInput>;
  rowVersion?: InputMaybe<ListComparableByteOperationFilterInput>;
  userCreatedId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type Query = {
  __typename?: 'Query';
  adminOrderTypes?: Maybe<Array<CustomOrderType>>;
  advancedReport?: Maybe<OrderAdvancedReportRecordCollectionSegment>;
  advancedReportHeaders: Array<OrderReportHeader>;
  attributeSets?: Maybe<Array<AttributeSetRecord>>;
  basicReport?: Maybe<OrderBasicReportRecordCollectionSegment>;
  basicReportHeaders: Array<OrderReportHeader>;
  /** Retrieves a user's cart. */
  cart?: Maybe<Cart>;
  /** Retrieves the Category by ID */
  category?: Maybe<CategoryType>;
  /** Retrieves the child Categories of the passed Category.If no Category is passed, then it retrieves the top level Categories. */
  childCategories?: Maybe<Array<CategoryType>>;
  childProducts?: Maybe<Array<ProductType>>;
  crossUpSales?: Maybe<Array<CrossUpSaleItem>>;
  /** Retrieves the current user's Customer. */
  currentCustomer?: Maybe<Customer>;
  /** Retrieves the current auth user. */
  currentUser?: Maybe<UserType>;
  /** Retrieves the current customer's FAQ. Note: FAQ answers will be returned as HTML as this has not yet been updated in the database. */
  customerFaq?: Maybe<Array<FaqType>>;
  customerFeatures?: Maybe<Array<TsuCustomerFeature>>;
  /** Retrieves the theme based on the user's Customer ID. */
  customerTheme?: Maybe<TsunamiTheme>;
  /** Retrieves the list of Customers. */
  customers?: Maybe<Array<Customer>>;
  /** Retrieves a list of Frequently Asked Questions. */
  faqs?: Maybe<Array<FaqType>>;
  /** Retrieves a user's favorites. */
  favorites?: Maybe<Favorite>;
  /** Retrieves freight settings by weight. */
  freightSettings?: Maybe<Array<CustomerFreightSettingType>>;
  itemGroups: Array<ProductItemGroupType>;
  orderDetail?: Maybe<Order>;
  /** Retrieves Order Shippings that are awaiting approval. */
  orderShippingsForApproval?: Maybe<OrderShippingTypeCollectionSegment>;
  /** Retrieves the list of order statuses. */
  orderStatuses?: Maybe<Array<OrderStatus>>;
  orderTypes: Array<OrderTypeGqlType>;
  ordersInProgress?: Maybe<OrderCollectionSegment>;
  product?: Maybe<ProductType>;
  productAllowedQuantities: Array<ProductAllowedQuantity>;
  productApprovers: Array<ProductApprover>;
  /** Retrieves the Product's Attribute Set. */
  productAttributes?: Maybe<ProductAttributesViewModel>;
  /** Retrieves a Product's Categories. */
  productCategories?: Maybe<Array<ProductCategory>>;
  /** Retrieves a Product's Details */
  productDetails?: Maybe<ProductDetailsPayload>;
  /** Retrieves a list of products meant for Product Management. */
  productManagement?: Maybe<ProductTypeCollectionSegment>;
  productStatuses: Array<ProductStatus>;
  productUoms?: Maybe<Array<ProductUom>>;
  /** Retrieves a list of products. */
  products?: Maybe<ProductTypeCollectionSegment>;
  productsTotalPrice: GetProductsTotalPriceOutput;
  productsUnderCategory?: Maybe<Array<ProductType>>;
  /** Retrieves the report schedules. */
  reportSchedules?: Maybe<ReportScheduleTypeCollectionSegment>;
  /** Retrieves the reports. */
  reports?: Maybe<OrderShippingTypeCollectionSegment>;
  roleFreightSettings?: Maybe<Array<CustomFreightSetting>>;
  /** Retrieves the list of roles. */
  roles?: Maybe<Array<RoleType>>;
  savedAddress?: Maybe<SavedAddressResponse>;
  savedOrders?: Maybe<OrderCollectionSegment>;
  /** Retrieves the list of security questions. */
  securityQuestions?: Maybe<Array<UserSecurityQuestion>>;
  /** Retrieves the EWay Shared URL for payment */
  sharedPaymentUrl?: Maybe<string>;
  /** Retrieves shipping estimates for an order. */
  shippingEstimate?: Maybe<ShippingEstimatePayloadType>;
  /** Retrieves a user's shopping cart. */
  shoppingCart?: Maybe<ShoppingCartType>;
  /** Retrieves the list of Top Ordered Products (based on X number of months trailing, by default it's this month). */
  topOrderedProducts?: Maybe<TopOrderedProductCollectionSegment>;
  uomDescriptors: Array<Uomdescription>;
  userActions?: Maybe<Array<UserActionCategoryType>>;
  /** Retrieves the current user's cart. */
  userCart?: Maybe<Cart>;
  visibleTabs: Array<Scalars['String']>;
};


export type QueryAdminOrderTypesArgs = {
  roleId: Scalars['Int'];
};


export type QueryAdvancedReportArgs = {
  order?: InputMaybe<Array<OrderAdvancedReportRecordSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<OrderAdvancedReportRecordFilterInput>;
};


export type QueryBasicReportArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<OrderBasicReportSortInput>>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<OrderBasicReportRecordFilterInput>;
};


export type QueryCartArgs = {
  cartId: Scalars['String'];
};


export type QueryCategoryArgs = {
  catId: Scalars['Int'];
};


export type QueryChildCategoriesArgs = {
  catId?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<CustomCategoryEntitySortInput>>;
};


export type QueryChildProductsArgs = {
  productId: Scalars['Int'];
};


export type QueryCrossUpSalesArgs = {
  productId: Scalars['Int'];
};


export type QueryFreightSettingsArgs = {
  input: GetFreightSettingsInputType;
};


export type QueryOrderDetailArgs = {
  orderId: Scalars['Int'];
};

export type QueryOrdersInProgressArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<OrderFilterInput>;
};

export type QueryOrderShippingsForApprovalArgs = {
  order?: InputMaybe<Array<OrderShippingSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<OrderShippingFilterInput>;
};


export type QueryProductArgs = {
  productId: Scalars['Int'];
};


export type QueryProductAllowedQuantitiesArgs = {
  productId: Scalars['Int'];
};


export type QueryProductAttributesArgs = {
  productId: Scalars['Int'];
};


export type QueryProductCategoriesArgs = {
  productId: Scalars['Int'];
};


export type QueryProductDetailsArgs = {
  productId: Scalars['Int'];
};


export type QueryProductManagementArgs = {
  input: GetProductManagementInput;
  order?: InputMaybe<Array<ProductSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ProductFilterInput>;
};


export type QueryProductUomsArgs = {
  productId: Scalars['Int'];
};


export type QueryProductsArgs = {
  input: GetProductsInput;
  order?: InputMaybe<Array<ProductSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ProductFilterInput>;
};


export type QueryProductsTotalPriceArgs = {
  input: GetProductsTotalPriceInput;
};


export type QueryProductsUnderCategoryArgs = {
  categoryId: Scalars['Int'];
};


export type QueryReportSchedulesArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ReportScheduleFilterInput>;
};


export type QueryReportsArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<OrderShippingFilterInput>;
};


export type QueryRoleFreightSettingsArgs = {
  roleId: Scalars['Int'];
};


export type QuerySavedOrdersArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<OrderFilterInput>;
};


export type QueryShippingEstimateArgs = {
  input: ShippingEstimateInputType;
};


export type QueryTopOrderedProductsArgs = {
  monthsTrailing?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Array<TopOrderedProductSortInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TopOrderedProductFilterInput>;
};


export type QueryUserActionsArgs = {
  roleId: Scalars['Int'];
};


export type QueryVisibleTabsArgs = {
  productId: Scalars['Int'];
};

export type RateCategory = {
  __typename?: 'RateCategory';
  activityBusinessLevelRates: Array<ActivityBusinessLevelRate>;
  name: Scalars['String'];
  rateCategoryId: Scalars['Int'];
};

export type RateCategoryFilterInput = {
  activityBusinessLevelRates?: InputMaybe<ListFilterInputTypeOfActivityBusinessLevelRateFilterInput>;
  and?: InputMaybe<Array<RateCategoryFilterInput>>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<RateCategoryFilterInput>>;
  rateCategoryId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type RecipientData = {
  __typename?: 'RecipientData';
  businessLevel: BusinessLevel;
  businessLevelId: Scalars['Int'];
  campaignEmailRecipientData: Array<Campaign>;
  campaignSmsrecipientData: Array<Campaign>;
  created: Scalars['DateTime'];
  customer: Customer;
  customerId: Scalars['Int'];
  emailAdPages: Array<EmailAdPage>;
  fields: Scalars['String'];
  noOfRecords: Scalars['Int'];
  numberOfFields: Scalars['Byte'];
  recipientDataId: Scalars['Int'];
  removed: Scalars['Boolean'];
  rowVersion: Array<Scalars['ByteArray']>;
  serialisedRecipientData: Array<Scalars['ByteArray']>;
  userCreated: UserType;
  userCreatedId: Scalars['Int'];
  visibilitySetting: Scalars['Byte'];
};

export type RecipientDataFilterInput = {
  and?: InputMaybe<Array<RecipientDataFilterInput>>;
  businessLevel?: InputMaybe<BusinessLevelFilterInput>;
  businessLevelId?: InputMaybe<ComparableInt32OperationFilterInput>;
  campaignEmailRecipientData?: InputMaybe<ListFilterInputTypeOfCampaignFilterInput>;
  campaignSmsrecipientData?: InputMaybe<ListFilterInputTypeOfCampaignFilterInput>;
  created?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  customer?: InputMaybe<CustomerFilterInput>;
  customerId?: InputMaybe<ComparableInt32OperationFilterInput>;
  emailAdPages?: InputMaybe<ListFilterInputTypeOfEmailAdPageFilterInput>;
  fields?: InputMaybe<StringOperationFilterInput>;
  noOfRecords?: InputMaybe<ComparableInt32OperationFilterInput>;
  numberOfFields?: InputMaybe<ComparableByteOperationFilterInput>;
  or?: InputMaybe<Array<RecipientDataFilterInput>>;
  recipientDataId?: InputMaybe<ComparableInt32OperationFilterInput>;
  removed?: InputMaybe<BooleanOperationFilterInput>;
  rowVersion?: InputMaybe<ListComparableByteOperationFilterInput>;
  serialisedRecipientData?: InputMaybe<ListComparableByteOperationFilterInput>;
  userCreated?: InputMaybe<UserDetailFilterInput>;
  userCreatedId?: InputMaybe<ComparableInt32OperationFilterInput>;
  visibilitySetting?: InputMaybe<ComparableByteOperationFilterInput>;
};

export type RecruitmentFilterInput = {
  agreements?: InputMaybe<ListFilterInputTypeOfAgreementFilterInput>;
  and?: InputMaybe<Array<RecruitmentFilterInput>>;
  franchisee?: InputMaybe<FranchiseeFilterInput>;
  franchiseeId?: InputMaybe<ComparableInt32OperationFilterInput>;
  histories?: InputMaybe<ListFilterInputTypeOfHistoryFilterInput>;
  keyPerson?: InputMaybe<CrmcontactFilterInput>;
  keyPersonId?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<RecruitmentFilterInput>>;
  recruitmentId?: InputMaybe<ComparableInt32OperationFilterInput>;
  recruitmentStatus?: InputMaybe<RecruitmentStatusEnumFilterInput>;
  recruitmentStatusId?: InputMaybe<ComparableInt32OperationFilterInput>;
  recruitmentSteps?: InputMaybe<ListFilterInputTypeOfRecruitmentStepFilterInput>;
  removed?: InputMaybe<BooleanOperationFilterInput>;
  rowVersion?: InputMaybe<ListComparableByteOperationFilterInput>;
};

export type RecruitmentStatusEnumFilterInput = {
  and?: InputMaybe<Array<RecruitmentStatusEnumFilterInput>>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<RecruitmentStatusEnumFilterInput>>;
  recruitmentStatusId?: InputMaybe<ComparableInt32OperationFilterInput>;
  recruitments?: InputMaybe<ListFilterInputTypeOfRecruitmentFilterInput>;
};

export type RecruitmentStepFilterInput = {
  and?: InputMaybe<Array<RecruitmentStepFilterInput>>;
  completedDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  completionComments?: InputMaybe<StringOperationFilterInput>;
  dateDue?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<RecruitmentStepFilterInput>>;
  recruitment?: InputMaybe<RecruitmentFilterInput>;
  recruitmentId?: InputMaybe<ComparableInt32OperationFilterInput>;
  recruitmentStepId?: InputMaybe<ComparableInt32OperationFilterInput>;
  recruitmentStepStage?: InputMaybe<RecruitmentStepStageEnumFilterInput>;
  recruitmentStepStageId?: InputMaybe<ComparableInt32OperationFilterInput>;
  removed?: InputMaybe<BooleanOperationFilterInput>;
  rowVersion?: InputMaybe<ListComparableByteOperationFilterInput>;
};

export type RecruitmentStepStageEnumFilterInput = {
  and?: InputMaybe<Array<RecruitmentStepStageEnumFilterInput>>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<RecruitmentStepStageEnumFilterInput>>;
  recruitmentStepStageId?: InputMaybe<ComparableInt32OperationFilterInput>;
  recruitmentSteps?: InputMaybe<ListFilterInputTypeOfRecruitmentStepFilterInput>;
};

export type RecurringFeeFilterInput = {
  agreement?: InputMaybe<AgreementFilterInput>;
  agreementId?: InputMaybe<ComparableInt32OperationFilterInput>;
  and?: InputMaybe<Array<RecurringFeeFilterInput>>;
  baseAmount?: InputMaybe<ComparableDecimalOperationFilterInput>;
  firstTierPercentage?: InputMaybe<ComparableDecimalOperationFilterInput>;
  firstTierThreshold?: InputMaybe<ComparableDecimalOperationFilterInput>;
  or?: InputMaybe<Array<RecurringFeeFilterInput>>;
  recurringFeeId?: InputMaybe<ComparableInt32OperationFilterInput>;
  secondTierPercentage?: InputMaybe<ComparableDecimalOperationFilterInput>;
  secondTierThreshold?: InputMaybe<ComparableDecimalOperationFilterInput>;
  thirdTierPercentage?: InputMaybe<ComparableDecimalOperationFilterInput>;
};

export type RemoveFeaturePayload = {
  __typename?: 'RemoveFeaturePayload';
  message: Scalars['String'];
  success: Scalars['Boolean'];
  tsuFeatureId?: Maybe<Scalars['Int']>;
};

export type Report = {
  __typename?: 'Report';
  active: Scalars['Boolean'];
  created: Scalars['DateTime'];
  customFormatterClass?: Maybe<Scalars['String']>;
  customer: Customer;
  customerId: Scalars['Int'];
  defaultReport: Scalars['Boolean'];
  editable: Scalars['Boolean'];
  flattenHierarchy: Scalars['Boolean'];
  groupByColumns?: Maybe<Scalars['String']>;
  groupFooters: Scalars['Boolean'];
  hierarchical: Scalars['Boolean'];
  hierarchicalExpanded: Scalars['Boolean'];
  identityColumn: Scalars['String'];
  linkIdentity: Scalars['Boolean'];
  linkIdentityPagePath?: Maybe<Scalars['String']>;
  maxRecord: Scalars['Int'];
  modified: Scalars['DateTime'];
  name: Scalars['String'];
  pageSize: Scalars['Int'];
  purgeDate?: Maybe<Scalars['DateTime']>;
  recordTimestamp: Array<Scalars['ByteArray']>;
  removed: Scalars['Boolean'];
  reportBusinessLevelVisibilities: Array<ReportBusinessLevelVisibility>;
  reportColumns: Array<ReportColumn>;
  reportId: Scalars['Int'];
  reportRoleVisibilities: Array<ReportRoleVisibility>;
  reportSchedules: Array<ReportScheduleType>;
  reportTableList: ReportTableList;
  reportTableListId: Scalars['Int'];
  sortByColumns?: Maybe<Scalars['String']>;
  userCreatedId: Scalars['Int'];
  userModifiedId: Scalars['Int'];
};

export type ReportBusinessLevelVisibility = {
  __typename?: 'ReportBusinessLevelVisibility';
  businessLevel: BusinessLevel;
  businessLevelId: Scalars['Int'];
  created: Scalars['DateTime'];
  modified: Scalars['DateTime'];
  report: Report;
  reportBusinessLevelVisibilityId: Scalars['Int'];
  reportId: Scalars['Int'];
  userModifiedId: Scalars['Int'];
};

export type ReportBusinessLevelVisibilityFilterInput = {
  and?: InputMaybe<Array<ReportBusinessLevelVisibilityFilterInput>>;
  businessLevel?: InputMaybe<BusinessLevelFilterInput>;
  businessLevelId?: InputMaybe<ComparableInt32OperationFilterInput>;
  created?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  modified?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<ReportBusinessLevelVisibilityFilterInput>>;
  report?: InputMaybe<ReportFilterInput>;
  reportBusinessLevelVisibilityId?: InputMaybe<ComparableInt32OperationFilterInput>;
  reportId?: InputMaybe<ComparableInt32OperationFilterInput>;
  userModifiedId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type ReportColumn = {
  __typename?: 'ReportColumn';
  active: Scalars['Boolean'];
  aggregate?: Maybe<Scalars['String']>;
  allowFiltering: Scalars['Boolean'];
  allowSorting: Scalars['Boolean'];
  calculateExpression?: Maybe<Scalars['String']>;
  columnName: Scalars['String'];
  created: Scalars['DateTime'];
  dataField?: Maybe<Scalars['String']>;
  dataFormatString?: Maybe<Scalars['String']>;
  dataType: Scalars['String'];
  defaultFilterData?: Maybe<Scalars['String']>;
  defaultFilterOperator?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  editableFilterData: Scalars['Boolean'];
  emptyDataText?: Maybe<Scalars['String']>;
  filterOptions?: Maybe<Scalars['String']>;
  filterable: Scalars['Boolean'];
  footerAggregateFormatString?: Maybe<Scalars['String']>;
  headerStyleWidth: Scalars['String'];
  heading: Scalars['String'];
  isComboFilter: Scalars['Boolean'];
  isSpecialColumn: Scalars['Boolean'];
  isSpparameter: Scalars['Boolean'];
  modified: Scalars['DateTime'];
  purgeDate?: Maybe<Scalars['DateTime']>;
  recordTimestamp: Array<Scalars['ByteArray']>;
  removed: Scalars['Boolean'];
  report: Report;
  reportColumnId: Scalars['Int'];
  reportColumnType: ReportColumnType;
  reportColumnTypeId: Scalars['Int'];
  reportId: Scalars['Int'];
  reportTableColumnList: ReportTableColumnList;
  reportTableColumnListId: Scalars['Int'];
  reportTableList?: Maybe<ReportTableList>;
  reportTableListId?: Maybe<Scalars['Int']>;
  seqNo: Scalars['Int'];
  showFilterIcon: Scalars['Boolean'];
  showSortIcon: Scalars['Boolean'];
  showWindow: Scalars['Boolean'];
  sortExpression?: Maybe<Scalars['String']>;
  userCreatedId: Scalars['Int'];
  userModifiedId: Scalars['Int'];
  visible: Scalars['Boolean'];
};

export type ReportColumnFilterInput = {
  active?: InputMaybe<BooleanOperationFilterInput>;
  aggregate?: InputMaybe<StringOperationFilterInput>;
  allowFiltering?: InputMaybe<BooleanOperationFilterInput>;
  allowSorting?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<ReportColumnFilterInput>>;
  calculateExpression?: InputMaybe<StringOperationFilterInput>;
  columnName?: InputMaybe<StringOperationFilterInput>;
  created?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  dataField?: InputMaybe<StringOperationFilterInput>;
  dataFormatString?: InputMaybe<StringOperationFilterInput>;
  dataType?: InputMaybe<StringOperationFilterInput>;
  defaultFilterData?: InputMaybe<StringOperationFilterInput>;
  defaultFilterOperator?: InputMaybe<StringOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  editableFilterData?: InputMaybe<BooleanOperationFilterInput>;
  emptyDataText?: InputMaybe<StringOperationFilterInput>;
  filterOptions?: InputMaybe<StringOperationFilterInput>;
  filterable?: InputMaybe<BooleanOperationFilterInput>;
  footerAggregateFormatString?: InputMaybe<StringOperationFilterInput>;
  headerStyleWidth?: InputMaybe<StringOperationFilterInput>;
  heading?: InputMaybe<StringOperationFilterInput>;
  isComboFilter?: InputMaybe<BooleanOperationFilterInput>;
  isSpecialColumn?: InputMaybe<BooleanOperationFilterInput>;
  isSpparameter?: InputMaybe<BooleanOperationFilterInput>;
  modified?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<ReportColumnFilterInput>>;
  purgeDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  recordTimestamp?: InputMaybe<ListComparableByteOperationFilterInput>;
  removed?: InputMaybe<BooleanOperationFilterInput>;
  report?: InputMaybe<ReportFilterInput>;
  reportColumnId?: InputMaybe<ComparableInt32OperationFilterInput>;
  reportColumnType?: InputMaybe<ReportColumnTypeFilterInput>;
  reportColumnTypeId?: InputMaybe<ComparableInt32OperationFilterInput>;
  reportId?: InputMaybe<ComparableInt32OperationFilterInput>;
  reportTableColumnList?: InputMaybe<ReportTableColumnListFilterInput>;
  reportTableColumnListId?: InputMaybe<ComparableInt32OperationFilterInput>;
  reportTableList?: InputMaybe<ReportTableListFilterInput>;
  reportTableListId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  seqNo?: InputMaybe<ComparableInt32OperationFilterInput>;
  showFilterIcon?: InputMaybe<BooleanOperationFilterInput>;
  showSortIcon?: InputMaybe<BooleanOperationFilterInput>;
  showWindow?: InputMaybe<BooleanOperationFilterInput>;
  sortExpression?: InputMaybe<StringOperationFilterInput>;
  userCreatedId?: InputMaybe<ComparableInt32OperationFilterInput>;
  userModifiedId?: InputMaybe<ComparableInt32OperationFilterInput>;
  visible?: InputMaybe<BooleanOperationFilterInput>;
};

export type ReportColumnType = {
  __typename?: 'ReportColumnType';
  name: Scalars['String'];
  reportColumnTypeId: Scalars['Int'];
  reportColumns: Array<ReportColumn>;
};

export type ReportColumnTypeFilterInput = {
  and?: InputMaybe<Array<ReportColumnTypeFilterInput>>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ReportColumnTypeFilterInput>>;
  reportColumnTypeId?: InputMaybe<ComparableInt32OperationFilterInput>;
  reportColumns?: InputMaybe<ListFilterInputTypeOfReportColumnFilterInput>;
};

export type ReportDetailsInput = {
  emailBody: Scalars['String'];
  emailSubjectName: Scalars['String'];
  emailsToSend: Array<Scalars['String']>;
  fileType: Scalars['String'];
  reportName: Scalars['String'];
};

export type ReportFilterInput = {
  active?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<ReportFilterInput>>;
  created?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  customFormatterClass?: InputMaybe<StringOperationFilterInput>;
  customer?: InputMaybe<CustomerFilterInput>;
  customerId?: InputMaybe<ComparableInt32OperationFilterInput>;
  defaultReport?: InputMaybe<BooleanOperationFilterInput>;
  editable?: InputMaybe<BooleanOperationFilterInput>;
  flattenHierarchy?: InputMaybe<BooleanOperationFilterInput>;
  groupByColumns?: InputMaybe<StringOperationFilterInput>;
  groupFooters?: InputMaybe<BooleanOperationFilterInput>;
  hierarchical?: InputMaybe<BooleanOperationFilterInput>;
  hierarchicalExpanded?: InputMaybe<BooleanOperationFilterInput>;
  identityColumn?: InputMaybe<StringOperationFilterInput>;
  linkIdentity?: InputMaybe<BooleanOperationFilterInput>;
  linkIdentityPagePath?: InputMaybe<StringOperationFilterInput>;
  maxRecord?: InputMaybe<ComparableInt32OperationFilterInput>;
  modified?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ReportFilterInput>>;
  pageSize?: InputMaybe<ComparableInt32OperationFilterInput>;
  purgeDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  recordTimestamp?: InputMaybe<ListComparableByteOperationFilterInput>;
  removed?: InputMaybe<BooleanOperationFilterInput>;
  reportBusinessLevelVisibilities?: InputMaybe<ListFilterInputTypeOfReportBusinessLevelVisibilityFilterInput>;
  reportColumns?: InputMaybe<ListFilterInputTypeOfReportColumnFilterInput>;
  reportId?: InputMaybe<ComparableInt32OperationFilterInput>;
  reportRoleVisibilities?: InputMaybe<ListFilterInputTypeOfReportRoleVisibilityFilterInput>;
  reportSchedules?: InputMaybe<ListFilterInputTypeOfReportScheduleFilterInput>;
  reportTableList?: InputMaybe<ReportTableListFilterInput>;
  reportTableListId?: InputMaybe<ComparableInt32OperationFilterInput>;
  sortByColumns?: InputMaybe<StringOperationFilterInput>;
  userCreatedId?: InputMaybe<ComparableInt32OperationFilterInput>;
  userModifiedId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type ReportRoleTableListVisibility = {
  __typename?: 'ReportRoleTableListVisibility';
  reportRoleTableListVisibilityId: Scalars['Int'];
  reportTableList: ReportTableList;
  reportTableListId: Scalars['Int'];
  role: RoleType;
  roleId: Scalars['Int'];
};

export type ReportRoleTableListVisibilityFilterInput = {
  and?: InputMaybe<Array<ReportRoleTableListVisibilityFilterInput>>;
  or?: InputMaybe<Array<ReportRoleTableListVisibilityFilterInput>>;
  reportRoleTableListVisibilityId?: InputMaybe<ComparableInt32OperationFilterInput>;
  reportTableList?: InputMaybe<ReportTableListFilterInput>;
  reportTableListId?: InputMaybe<ComparableInt32OperationFilterInput>;
  role?: InputMaybe<RoleFilterInput>;
  roleId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type ReportRoleVisibility = {
  __typename?: 'ReportRoleVisibility';
  created: Scalars['DateTime'];
  modified: Scalars['DateTime'];
  report: Report;
  reportId: Scalars['Int'];
  reportRoleVisibilityId: Scalars['Int'];
  role: RoleType;
  roleId: Scalars['Int'];
  userModifiedId: Scalars['Int'];
};

export type ReportRoleVisibilityFilterInput = {
  and?: InputMaybe<Array<ReportRoleVisibilityFilterInput>>;
  created?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  modified?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<ReportRoleVisibilityFilterInput>>;
  report?: InputMaybe<ReportFilterInput>;
  reportId?: InputMaybe<ComparableInt32OperationFilterInput>;
  reportRoleVisibilityId?: InputMaybe<ComparableInt32OperationFilterInput>;
  role?: InputMaybe<RoleFilterInput>;
  roleId?: InputMaybe<ComparableInt32OperationFilterInput>;
  userModifiedId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

/** Contains schedule made for reports */
export type ReportScheduleFilterInput = {
  active?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<ReportScheduleFilterInput>>;
  created?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  cronExpression?: InputMaybe<StringOperationFilterInput>;
  customer?: InputMaybe<CustomerFilterInput>;
  customerId?: InputMaybe<ComparableInt32OperationFilterInput>;
  lastModified?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  lastRunStatus?: InputMaybe<ReportScheduleStatusFilterInput>;
  lastRunStatusId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  lastRunStatusMsg?: InputMaybe<StringOperationFilterInput>;
  lastRunTime?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  note?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ReportScheduleFilterInput>>;
  recipientEmails?: InputMaybe<StringOperationFilterInput>;
  removed?: InputMaybe<BooleanOperationFilterInput>;
  report?: InputMaybe<ReportFilterInput>;
  reportId?: InputMaybe<ComparableInt32OperationFilterInput>;
  reportScheduleId?: InputMaybe<ComparableInt32OperationFilterInput>;
  reportScheduleStatus?: InputMaybe<ReportScheduleStatusFilterInput>;
  reportScheduleStatusId?: InputMaybe<ComparableInt32OperationFilterInput>;
  rowVersion?: InputMaybe<ListComparableByteOperationFilterInput>;
  serialisedFilterData?: InputMaybe<ListComparableByteOperationFilterInput>;
  userCreated?: InputMaybe<UserDetailFilterInput>;
  userCreatedId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type ReportScheduleStatus = {
  __typename?: 'ReportScheduleStatus';
  isFailedStatus: Scalars['Boolean'];
  name: Scalars['String'];
  reportScheduleLastRunStatuses: Array<ReportScheduleType>;
  reportScheduleReportScheduleStatuses: Array<ReportScheduleType>;
  reportScheduleStatusId: Scalars['Int'];
};

export type ReportScheduleStatusFilterInput = {
  and?: InputMaybe<Array<ReportScheduleStatusFilterInput>>;
  isFailedStatus?: InputMaybe<BooleanOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ReportScheduleStatusFilterInput>>;
  reportScheduleLastRunStatuses?: InputMaybe<ListFilterInputTypeOfReportScheduleFilterInput>;
  reportScheduleReportScheduleStatuses?: InputMaybe<ListFilterInputTypeOfReportScheduleFilterInput>;
  reportScheduleStatusId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

/** Represents a Report Schedule. */
export type ReportScheduleType = {
  __typename?: 'ReportScheduleType';
  active: Scalars['Boolean'];
  created: Scalars['DateTime'];
  cronExpression: Scalars['String'];
  customer: Customer;
  customerId: Scalars['Int'];
  lastModified: Scalars['DateTime'];
  lastRunStatus?: Maybe<ReportScheduleStatus>;
  lastRunStatusId?: Maybe<Scalars['Int']>;
  lastRunStatusMsg?: Maybe<Scalars['String']>;
  lastRunTime?: Maybe<Scalars['DateTime']>;
  note?: Maybe<Scalars['String']>;
  recipientEmails: Scalars['String'];
  removed: Scalars['Boolean'];
  report: Report;
  reportId: Scalars['Int'];
  reportScheduleId: Scalars['Int'];
  reportScheduleStatus: ReportScheduleStatus;
  reportScheduleStatusId: Scalars['Int'];
  rowVersion: Array<Scalars['ByteArray']>;
  serialisedFilterData: Array<Scalars['ByteArray']>;
  /** Report Schedule Filter Data */
  stringFilterData?: Maybe<Array<KeyValuePairOfStringAndString>>;
  userCreated: UserType;
  userCreatedId: Scalars['Int'];
};

export type ReportScheduleTypeCollectionSegment = {
  __typename?: 'ReportScheduleTypeCollectionSegment';
  items?: Maybe<Array<ReportScheduleType>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type ReportTableColumnList = {
  __typename?: 'ReportTableColumnList';
  columnTranslation?: Maybe<Scalars['String']>;
  comboFilter: Scalars['Boolean'];
  isCost: Scalars['Boolean'];
  isSpparameter: Scalars['Boolean'];
  name: Scalars['String'];
  reportColumns: Array<ReportColumn>;
  reportTableColumnListId: Scalars['Int'];
  reportTableList: ReportTableList;
  reportTableListId: Scalars['Int'];
  specialColumn: Scalars['Boolean'];
  specialColumnPrimaryTable?: Maybe<Scalars['String']>;
};

export type ReportTableColumnListFilterInput = {
  and?: InputMaybe<Array<ReportTableColumnListFilterInput>>;
  columnTranslation?: InputMaybe<StringOperationFilterInput>;
  comboFilter?: InputMaybe<BooleanOperationFilterInput>;
  isCost?: InputMaybe<BooleanOperationFilterInput>;
  isSpparameter?: InputMaybe<BooleanOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ReportTableColumnListFilterInput>>;
  reportColumns?: InputMaybe<ListFilterInputTypeOfReportColumnFilterInput>;
  reportTableColumnListId?: InputMaybe<ComparableInt32OperationFilterInput>;
  reportTableList?: InputMaybe<ReportTableListFilterInput>;
  reportTableListId?: InputMaybe<ComparableInt32OperationFilterInput>;
  specialColumn?: InputMaybe<BooleanOperationFilterInput>;
  specialColumnPrimaryTable?: InputMaybe<StringOperationFilterInput>;
};

export type ReportTableList = {
  __typename?: 'ReportTableList';
  filterByBl: Scalars['Boolean'];
  filterByRole: Scalars['Boolean'];
  identityColumn: Scalars['String'];
  inverseMappedToTable: Array<ReportTableList>;
  inverseParent: Array<ReportTableList>;
  isStoredProceedure: Scalars['Boolean'];
  mappedToTable?: Maybe<ReportTableList>;
  mappedToTableId?: Maybe<Scalars['Int']>;
  mappingTable: Scalars['Boolean'];
  name: Scalars['String'];
  nameTranslation: Scalars['String'];
  parent?: Maybe<ReportTableList>;
  parentId?: Maybe<Scalars['Int']>;
  reportColumns: Array<ReportColumn>;
  reportRoleTableListVisibilities: Array<ReportRoleTableListVisibility>;
  reportTableColumnLists: Array<ReportTableColumnList>;
  reportTableListId: Scalars['Int'];
  reportable: Scalars['Boolean'];
  reports: Array<Report>;
};

export type ReportTableListFilterInput = {
  and?: InputMaybe<Array<ReportTableListFilterInput>>;
  filterByBl?: InputMaybe<BooleanOperationFilterInput>;
  filterByRole?: InputMaybe<BooleanOperationFilterInput>;
  identityColumn?: InputMaybe<StringOperationFilterInput>;
  inverseMappedToTable?: InputMaybe<ListFilterInputTypeOfReportTableListFilterInput>;
  inverseParent?: InputMaybe<ListFilterInputTypeOfReportTableListFilterInput>;
  isStoredProceedure?: InputMaybe<BooleanOperationFilterInput>;
  mappedToTable?: InputMaybe<ReportTableListFilterInput>;
  mappedToTableId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  mappingTable?: InputMaybe<BooleanOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  nameTranslation?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ReportTableListFilterInput>>;
  parent?: InputMaybe<ReportTableListFilterInput>;
  parentId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  reportColumns?: InputMaybe<ListFilterInputTypeOfReportColumnFilterInput>;
  reportRoleTableListVisibilities?: InputMaybe<ListFilterInputTypeOfReportRoleTableListVisibilityFilterInput>;
  reportTableColumnLists?: InputMaybe<ListFilterInputTypeOfReportTableColumnListFilterInput>;
  reportTableListId?: InputMaybe<ComparableInt32OperationFilterInput>;
  reportable?: InputMaybe<BooleanOperationFilterInput>;
  reports?: InputMaybe<ListFilterInputTypeOfReportFilterInput>;
};

/** Represents the input to send a reset password email. */
export type ResetEmailInputType = {
  /** Represents the user email. */
  email: Scalars['String'];
};

export type ResetEmailPayload = {
  __typename?: 'ResetEmailPayload';
  success: Scalars['Boolean'];
};

/** Represents the payload return for a reset password email. */
export type ResetEmailPayloadType = {
  /** Represents if the email was successfully sent. */
  success: Scalars['Boolean'];
};

/** Represents the input to reset a password. */
export type ResetPasswordInputType = {
  /** Represents the new password */
  password: Scalars['String'];
  /** Represents the user reset token */
  resetToken: Scalars['String'];
};

/** Represents the payload returned for reset password. */
export type ResetPasswordPayloadType = {
  __typename?: 'ResetPasswordPayloadType';
  /** Represents if the reset was successful. */
  success: Scalars['Boolean'];
};

export type RoleCategoryDiscount = {
  __typename?: 'RoleCategoryDiscount';
  category: Category;
  categoryId: Scalars['Int'];
  discount: Scalars['Decimal'];
  discountIsPercentage: Scalars['Boolean'];
  discountUpToQuantityBreak?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  orderMinimumPriceForCategory?: Maybe<Scalars['Decimal']>;
  orderMinimumQuantityForCategory?: Maybe<Scalars['Int']>;
  role: RoleType;
  roleId: Scalars['Int'];
  rowVersion: Array<Scalars['ByteArray']>;
};

export type RoleCategoryDiscountFilterInput = {
  and?: InputMaybe<Array<RoleCategoryDiscountFilterInput>>;
  category?: InputMaybe<CategoryFilterInput>;
  categoryId?: InputMaybe<ComparableInt32OperationFilterInput>;
  discount?: InputMaybe<ComparableDecimalOperationFilterInput>;
  discountIsPercentage?: InputMaybe<BooleanOperationFilterInput>;
  discountUpToQuantityBreak?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<RoleCategoryDiscountFilterInput>>;
  orderMinimumPriceForCategory?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  orderMinimumQuantityForCategory?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  role?: InputMaybe<RoleFilterInput>;
  roleId?: InputMaybe<ComparableInt32OperationFilterInput>;
  rowVersion?: InputMaybe<ListComparableByteOperationFilterInput>;
};

export type RoleCategoryVisibility = {
  __typename?: 'RoleCategoryVisibility';
  category: Category;
  categoryId: Scalars['Int'];
  created: Scalars['DateTime'];
  id: Scalars['Int'];
  modified: Scalars['DateTime'];
  role: RoleType;
  roleId: Scalars['Int'];
  userModifiedId: Scalars['Int'];
  viewOnly?: Maybe<Scalars['Boolean']>;
};

export type RoleCategoryVisibilityFilterInput = {
  and?: InputMaybe<Array<RoleCategoryVisibilityFilterInput>>;
  category?: InputMaybe<CategoryFilterInput>;
  categoryId?: InputMaybe<ComparableInt32OperationFilterInput>;
  created?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  modified?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<RoleCategoryVisibilityFilterInput>>;
  role?: InputMaybe<RoleFilterInput>;
  roleId?: InputMaybe<ComparableInt32OperationFilterInput>;
  userModifiedId?: InputMaybe<ComparableInt32OperationFilterInput>;
  viewOnly?: InputMaybe<BooleanOperationFilterInput>;
};

export type RoleFilterInput = {
  active?: InputMaybe<BooleanOperationFilterInput>;
  activityTypeRoleVisibilities?: InputMaybe<ListFilterInputTypeOfActivityTypeRoleVisibilityFilterInput>;
  additionalRole?: InputMaybe<BooleanOperationFilterInput>;
  adminRole?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<RoleFilterInput>>;
  bodyContent?: InputMaybe<StringOperationFilterInput>;
  created?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  customer?: InputMaybe<CustomerFilterInput>;
  customerDefault?: InputMaybe<BooleanOperationFilterInput>;
  customerEmailSettings?: InputMaybe<ListFilterInputTypeOfCustomerEmailSettingFilterInput>;
  customerId?: InputMaybe<ComparableInt32OperationFilterInput>;
  defaultCategoryId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  defaultRole?: InputMaybe<BooleanOperationFilterInput>;
  defaultWarehouse?: InputMaybe<StringOperationFilterInput>;
  discount?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  discountIsPercentage?: InputMaybe<BooleanOperationFilterInput>;
  exchangeRateCode?: InputMaybe<StringOperationFilterInput>;
  headerContent?: InputMaybe<StringOperationFilterInput>;
  liveChatPriority?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  maxOrderQuantity?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  maxSpendByDays?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  maxSpendDays?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  minOrderTotal?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  modified?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<RoleFilterInput>>;
  orderBy?: InputMaybe<ComparableInt32OperationFilterInput>;
  orderPlacedForwardText?: InputMaybe<StringOperationFilterInput>;
  orderPlacedForwardUrl?: InputMaybe<StringOperationFilterInput>;
  productCategoryOrderLimitByRoles?: InputMaybe<ListFilterInputTypeOfProductCategoryOrderLimitByRoleFilterInput>;
  productOrderLimitByRoles?: InputMaybe<ListFilterInputTypeOfProductOrderLimitByRoleFilterInput>;
  purgeDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  removed?: InputMaybe<BooleanOperationFilterInput>;
  reportRoleTableListVisibilities?: InputMaybe<ListFilterInputTypeOfReportRoleTableListVisibilityFilterInput>;
  reportRoleVisibilities?: InputMaybe<ListFilterInputTypeOfReportRoleVisibilityFilterInput>;
  roleCategoryDiscounts?: InputMaybe<ListFilterInputTypeOfRoleCategoryDiscountFilterInput>;
  roleCategoryVisibilities?: InputMaybe<ListFilterInputTypeOfRoleCategoryVisibilityFilterInput>;
  roleCss?: InputMaybe<StringOperationFilterInput>;
  roleFreightMaps?: InputMaybe<ListFilterInputTypeOfRoleFreightMapFilterInput>;
  roleId?: InputMaybe<ComparableInt32OperationFilterInput>;
  roleOrderTypes?: InputMaybe<ListFilterInputTypeOfRoleOrderTypeFilterInput>;
  rolePermissions?: InputMaybe<ListFilterInputTypeOfRolePermissionFilterInput>;
  roleProductDiscounts?: InputMaybe<ListFilterInputTypeOfRoleProductDiscountFilterInput>;
  rowVersion?: InputMaybe<ComparableInt32OperationFilterInput>;
  siteMaps?: InputMaybe<ListFilterInputTypeOfSiteMapFilterInput>;
  userDetails?: InputMaybe<ListFilterInputTypeOfUserDetailFilterInput>;
  userModifiedId?: InputMaybe<ComparableInt32OperationFilterInput>;
  zeroFreightOrderAmount?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
};

export type RoleFreightMap = {
  __typename?: 'RoleFreightMap';
  freightSetting: CustomerFreightSettingType;
  freightSettingId: Scalars['Int'];
  role: RoleType;
  roleFreightMapId: Scalars['Int'];
  roleId: Scalars['Int'];
};

export type RoleFreightMapFilterInput = {
  and?: InputMaybe<Array<RoleFreightMapFilterInput>>;
  freightSetting?: InputMaybe<CustomerFreightSettingFilterInput>;
  freightSettingId?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<RoleFreightMapFilterInput>>;
  role?: InputMaybe<RoleFilterInput>;
  roleFreightMapId?: InputMaybe<ComparableInt32OperationFilterInput>;
  roleId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type RoleOrderType = {
  __typename?: 'RoleOrderType';
  orderType: OrderTypeGqlType;
  orderTypeId: Scalars['Int'];
  role: RoleType;
  roleId: Scalars['Int'];
  roleOrderTypeId: Scalars['Int'];
  userModifiedId: Scalars['Int'];
};

export type RoleOrderTypeFilterInput = {
  and?: InputMaybe<Array<RoleOrderTypeFilterInput>>;
  or?: InputMaybe<Array<RoleOrderTypeFilterInput>>;
  orderType?: InputMaybe<OrderTypeFilterInput>;
  orderTypeId?: InputMaybe<ComparableInt32OperationFilterInput>;
  role?: InputMaybe<RoleFilterInput>;
  roleId?: InputMaybe<ComparableInt32OperationFilterInput>;
  roleOrderTypeId?: InputMaybe<ComparableInt32OperationFilterInput>;
  userModifiedId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type RolePermission = {
  __typename?: 'RolePermission';
  action: UserActionType;
  actionId: Scalars['Int'];
  created: Scalars['DateTime'];
  modified: Scalars['DateTime'];
  role: RoleType;
  roleId: Scalars['Int'];
  rowVersion: Scalars['Int'];
  userModifiedId: Scalars['Int'];
  userRoleId: Scalars['Int'];
};

export type RolePermissionFilterInput = {
  action?: InputMaybe<UserActionFilterInput>;
  actionId?: InputMaybe<ComparableInt32OperationFilterInput>;
  and?: InputMaybe<Array<RolePermissionFilterInput>>;
  created?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  modified?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<RolePermissionFilterInput>>;
  role?: InputMaybe<RoleFilterInput>;
  roleId?: InputMaybe<ComparableInt32OperationFilterInput>;
  rowVersion?: InputMaybe<ComparableInt32OperationFilterInput>;
  userModifiedId?: InputMaybe<ComparableInt32OperationFilterInput>;
  userRoleId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type RoleProductDiscount = {
  __typename?: 'RoleProductDiscount';
  discount: Scalars['Decimal'];
  discountIsPercentage: Scalars['Boolean'];
  discountUpToQuantityBreak?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  product: ProductType;
  productId: Scalars['Int'];
  role: RoleType;
  roleId: Scalars['Int'];
  rowVersion: Array<Scalars['ByteArray']>;
};

export type RoleProductDiscountFilterInput = {
  and?: InputMaybe<Array<RoleProductDiscountFilterInput>>;
  discount?: InputMaybe<ComparableDecimalOperationFilterInput>;
  discountIsPercentage?: InputMaybe<BooleanOperationFilterInput>;
  discountUpToQuantityBreak?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<RoleProductDiscountFilterInput>>;
  product?: InputMaybe<ProductFilterInput>;
  productId?: InputMaybe<ComparableInt32OperationFilterInput>;
  role?: InputMaybe<RoleFilterInput>;
  roleId?: InputMaybe<ComparableInt32OperationFilterInput>;
  rowVersion?: InputMaybe<ListComparableByteOperationFilterInput>;
};

export type RoleSortInput = {
  active?: InputMaybe<SortEnumType>;
  additionalRole?: InputMaybe<SortEnumType>;
  adminRole?: InputMaybe<SortEnumType>;
  bodyContent?: InputMaybe<SortEnumType>;
  created?: InputMaybe<SortEnumType>;
  customer?: InputMaybe<CustomerSortInput>;
  customerDefault?: InputMaybe<SortEnumType>;
  customerId?: InputMaybe<SortEnumType>;
  defaultCategoryId?: InputMaybe<SortEnumType>;
  defaultRole?: InputMaybe<SortEnumType>;
  defaultWarehouse?: InputMaybe<SortEnumType>;
  discount?: InputMaybe<SortEnumType>;
  discountIsPercentage?: InputMaybe<SortEnumType>;
  exchangeRateCode?: InputMaybe<SortEnumType>;
  headerContent?: InputMaybe<SortEnumType>;
  liveChatPriority?: InputMaybe<SortEnumType>;
  maxOrderQuantity?: InputMaybe<SortEnumType>;
  maxSpendByDays?: InputMaybe<SortEnumType>;
  maxSpendDays?: InputMaybe<SortEnumType>;
  minOrderTotal?: InputMaybe<SortEnumType>;
  modified?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  orderBy?: InputMaybe<SortEnumType>;
  orderPlacedForwardText?: InputMaybe<SortEnumType>;
  orderPlacedForwardUrl?: InputMaybe<SortEnumType>;
  purgeDate?: InputMaybe<SortEnumType>;
  removed?: InputMaybe<SortEnumType>;
  roleCss?: InputMaybe<SortEnumType>;
  roleId?: InputMaybe<SortEnumType>;
  rowVersion?: InputMaybe<SortEnumType>;
  userModifiedId?: InputMaybe<SortEnumType>;
  zeroFreightOrderAmount?: InputMaybe<SortEnumType>;
};

/** Represents a Role. */
export type RoleType = {
  __typename?: 'RoleType';
  /** Desribes if the role is active or inactive */
  active: Scalars['Boolean'];
  /** Describes whether or not this role has admin privileges */
  adminRole: Scalars['Boolean'];
  /** Represents the raw Role Entity */
  baseRole?: Maybe<BaseRoleType>;
  /** Describes whether or not this role is the default */
  defaultRole: Scalars['Boolean'];
  /** Represents any discounts that the role will have when placing orders */
  discount?: Maybe<Scalars['Decimal']>;
  /** This is the name of the Role */
  name: Scalars['String'];
  /** Represents the unique ID of the Role */
  roleId: Scalars['Int'];
};

export type SalesForceSetting = {
  __typename?: 'SalesForceSetting';
  businessLevel: BusinessLevel;
  businessLevelId: Scalars['Int'];
  customerId: Scalars['Int'];
  emailToNotifyOfError?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  lastPushSyncTime?: Maybe<Scalars['DateTime']>;
  lastSyncTime: Scalars['DateTime'];
  salesForceSyncTypeEnum: Scalars['Int'];
  sfpassword: Scalars['String'];
  sfusername: Scalars['String'];
};

export type SalesForceSettingFilterInput = {
  and?: InputMaybe<Array<SalesForceSettingFilterInput>>;
  businessLevel?: InputMaybe<BusinessLevelFilterInput>;
  businessLevelId?: InputMaybe<ComparableInt32OperationFilterInput>;
  customerId?: InputMaybe<ComparableInt32OperationFilterInput>;
  emailToNotifyOfError?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  lastPushSyncTime?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  lastSyncTime?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<SalesForceSettingFilterInput>>;
  salesForceSyncTypeEnum?: InputMaybe<ComparableInt32OperationFilterInput>;
  sfpassword?: InputMaybe<StringOperationFilterInput>;
  sfusername?: InputMaybe<StringOperationFilterInput>;
};

export type SavedAddressResponse = {
  __typename?: 'SavedAddressResponse';
  billingAddress?: Maybe<Address>;
  deliveryAddress?: Maybe<Address>;
};

/** Represents the address request for generating estimates from OneFlo */
export type ShippingEstimateAddressRequest = {
  __typename?: 'ShippingEstimateAddressRequest';
  /** The address 1 line */
  address1?: Maybe<Scalars['String']>;
  /** The address 2 line */
  address2?: Maybe<Scalars['String']>;
  /** The ISO country code */
  countryCode: Scalars['String'];
  /** If the address is residential */
  isResidential?: Maybe<Scalars['Boolean']>;
  /** The locality or suburb */
  locality: Scalars['String'];
  /** The postcode */
  postcode: Scalars['String'];
};

/** Represents the input to retrieve shipping estimates. */
export type ShippingEstimateInputType = {
  /** Represents the cart lines for the estimate. */
  cartLines: Array<CartLineInput>;
  /** Represents the delivery address for the estimate. */
  deliveryAddress: CartAddressInput;
  /** The freight setting ID */
  freightSettingId: Scalars['Int'];
};

/** Represents the item request for generating estimates from OneFlo */
export type ShippingEstimateItemRequest = {
  __typename?: 'ShippingEstimateItemRequest';
  /** The height in cms */
  height?: Maybe<Scalars['Float']>;
  /** The length in cms */
  length?: Maybe<Scalars['Float']>;
  /** The quantity of items */
  noOfItems: Scalars['Int'];
  /** The packaging type enum value */
  packagingType?: Maybe<Scalars['String']>;
  /** The weight in kgs */
  weight: Scalars['Float'];
  /** The width in cms */
  width?: Maybe<Scalars['Float']>;
};

/** Represents the payload for shipping estimates. */
export type ShippingEstimatePayloadType = {
  __typename?: 'ShippingEstimatePayloadType';
  orderRequest: ShippingEstimateRequest;
  /** A list of available service estimates. */
  services: Array<ShippingEstimateServicePayloadType>;
};

/** Represents the request for generating estimates from OneFlo */
export type ShippingEstimateRequest = {
  __typename?: 'ShippingEstimateRequest';
  /** If the order contains dangerous goods */
  containsDangerousGood?: Maybe<Scalars['Boolean']>;
  /** The estimated travel distance (not recommended) */
  distance?: Maybe<Scalars['Float']>;
  /** The effective date for the estimate */
  effectiveDate?: Maybe<Scalars['String']>;
  /** The items in the estimate */
  items?: Maybe<Array<ShippingEstimateItemRequest>>;
  /** The number of items */
  noOfItems?: Maybe<Scalars['Int']>;
  /** The receiver address */
  receiver: ShippingEstimateAddressRequest;
  /** The sender address */
  sender: ShippingEstimateAddressRequest;
  /** The services to filter by */
  serviceList?: Maybe<Array<Scalars['String']>>;
  /** The estimated travel time (not recommended) */
  time?: Maybe<Scalars['Float']>;
  /** The total volume of items in m^3 */
  volume?: Maybe<Scalars['Float']>;
  /** The total weight of items in kg */
  weight?: Maybe<Scalars['Float']>;
};

/** Represents the payload for each service estimate. */
export type ShippingEstimateServicePayloadType = {
  __typename?: 'ShippingEstimateServicePayloadType';
  /** Represents the readable service description. */
  description: Scalars['String'];
  /** The estimated time of arrival */
  eta?: Maybe<Scalars['String']>;
  /** Represents the net service ammount excluding tax. */
  net: Scalars['Float'];
  /** Represents the carrier's code. */
  service: Scalars['String'];
  /** Represents the carrier service code. */
  serviceCode: Scalars['String'];
  /** Represents the tax ammount for the service. */
  tax: Scalars['Float'];
};

export type ShoppingCartItem = {
  __typename?: 'ShoppingCartItem';
  /** Represents the item's E-Template ID (if it is a custom artwork) */
  eTemplateId?: Maybe<Scalars['Int']>;
  /** Represents the item's unique Object ID */
  id?: Maybe<Scalars['String']>;
  /** Represents whether the item is included in checkout or not */
  isSelected: Scalars['Boolean'];
  /** Represents the item's internal product data */
  product?: Maybe<ProductType>;
  /** Represents the item's product code */
  productCode: Scalars['String'];
  /** Represents the item's product ID */
  productId?: Maybe<Scalars['Int']>;
  /** Represents the item's quantity */
  quantity: Scalars['Int'];
};

export type ShoppingCartItemInput = {
  eTemplateId?: InputMaybe<Scalars['Int']>;
  isSelected: Scalars['Boolean'];
  productCode?: InputMaybe<Scalars['String']>;
  productId?: InputMaybe<Scalars['Int']>;
  quantity: Scalars['Int'];
};

/** Represents a shopping cart item. */
export type ShoppingCartItemInputType = {
  __typename?: 'ShoppingCartItemInputType';
  /** Represents the unique e-template id for the cart item. */
  eTemplateId?: Maybe<Scalars['Int']>;
  /** Represents whether or not the item is included in checkout. */
  isSelected: Scalars['Boolean'];
  /** Represents the product code for the cart item. */
  productCode?: Maybe<Scalars['String']>;
  /** Represents the unique product id for the cart item. */
  productId?: Maybe<Scalars['Int']>;
  /** Represents the quantity of items in the cart item. */
  quantity: Scalars['Int'];
};

export type ShoppingCartType = {
  __typename?: 'ShoppingCartType';
  /** Represents the shopping cart order lines */
  cartItems: Array<ShoppingCartItem>;
  /** Represents the customer ID which the shopping cart belongs to */
  customerId?: Maybe<Scalars['Int']>;
  /** Represents the shopping cart's unique Object ID */
  id?: Maybe<Scalars['String']>;
  /** Represents the user ID which the shopping cart belongs to */
  userId?: Maybe<Scalars['Int']>;
};

export type SimpleMessageResponse = {
  __typename?: 'SimpleMessageResponse';
  message: Scalars['String'];
};

export type SiteMap = {
  __typename?: 'SiteMap';
  actionCategoryId: Scalars['Int'];
  active: Scalars['Boolean'];
  /** column to specify which button is the parent (selected) in the interface */
  activeButtonId?: Maybe<Scalars['Int']>;
  buttonImage?: Maybe<Scalars['String']>;
  buttonImageMouseOver?: Maybe<Scalars['String']>;
  buttonText?: Maybe<Scalars['String']>;
  created: Scalars['DateTime'];
  defaultTab?: Maybe<Scalars['Boolean']>;
  helpText?: Maybe<Scalars['String']>;
  inverseParent: Array<SiteMap>;
  isUserCreated: Scalars['Boolean'];
  masterPage: Scalars['String'];
  modified: Scalars['DateTime'];
  name: Scalars['String'];
  newWindow: Scalars['Boolean'];
  pagePath?: Maybe<Scalars['String']>;
  parent?: Maybe<SiteMap>;
  parentId?: Maybe<Scalars['Int']>;
  role: RoleType;
  roleId: Scalars['Int'];
  rowVersion: Array<Scalars['ByteArray']>;
  seqNo: Scalars['Int'];
  siteMapPageMaps: Array<SiteMapPageMap>;
  sitemapId: Scalars['Int'];
  tabOrder?: Maybe<Scalars['Int']>;
  userCreatedId: Scalars['Int'];
  userModifiedId: Scalars['Int'];
  visibleCustomerId?: Maybe<Scalars['Int']>;
};

export type SiteMapFilterInput = {
  actionCategoryId?: InputMaybe<ComparableInt32OperationFilterInput>;
  active?: InputMaybe<BooleanOperationFilterInput>;
  /** column to specify which button is the parent (selected) in the interface */
  activeButtonId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  and?: InputMaybe<Array<SiteMapFilterInput>>;
  buttonImage?: InputMaybe<StringOperationFilterInput>;
  buttonImageMouseOver?: InputMaybe<StringOperationFilterInput>;
  buttonText?: InputMaybe<StringOperationFilterInput>;
  created?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  defaultTab?: InputMaybe<BooleanOperationFilterInput>;
  helpText?: InputMaybe<StringOperationFilterInput>;
  inverseParent?: InputMaybe<ListFilterInputTypeOfSiteMapFilterInput>;
  isUserCreated?: InputMaybe<BooleanOperationFilterInput>;
  masterPage?: InputMaybe<StringOperationFilterInput>;
  modified?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  newWindow?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<SiteMapFilterInput>>;
  pagePath?: InputMaybe<StringOperationFilterInput>;
  parent?: InputMaybe<SiteMapFilterInput>;
  parentId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  role?: InputMaybe<RoleFilterInput>;
  roleId?: InputMaybe<ComparableInt32OperationFilterInput>;
  rowVersion?: InputMaybe<ListComparableByteOperationFilterInput>;
  seqNo?: InputMaybe<ComparableInt32OperationFilterInput>;
  siteMapPageMaps?: InputMaybe<ListFilterInputTypeOfSiteMapPageMapFilterInput>;
  sitemapId?: InputMaybe<ComparableInt32OperationFilterInput>;
  tabOrder?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  userCreatedId?: InputMaybe<ComparableInt32OperationFilterInput>;
  userModifiedId?: InputMaybe<ComparableInt32OperationFilterInput>;
  visibleCustomerId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
};

export type SiteMapOverride = {
  __typename?: 'SiteMapOverride';
  active: Scalars['Boolean'];
  customer: Customer;
  customerId: Scalars['Int'];
  isRegex: Scalars['Boolean'];
  modified: Scalars['DateTime'];
  nameLookFor: Scalars['String'];
  removed: Scalars['Boolean'];
  replacementMasterPage?: Maybe<Scalars['String']>;
  replacementPagePath?: Maybe<Scalars['String']>;
  replacementTabOrder?: Maybe<Scalars['Int']>;
  rowVersion: Array<Scalars['ByteArray']>;
  siteMapOverrideId: Scalars['Int'];
  userCreated: UserType;
  userCreatedId: Scalars['Int'];
};

export type SiteMapOverrideFilterInput = {
  active?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<SiteMapOverrideFilterInput>>;
  customer?: InputMaybe<CustomerFilterInput>;
  customerId?: InputMaybe<ComparableInt32OperationFilterInput>;
  isRegex?: InputMaybe<BooleanOperationFilterInput>;
  modified?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  nameLookFor?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<SiteMapOverrideFilterInput>>;
  removed?: InputMaybe<BooleanOperationFilterInput>;
  replacementMasterPage?: InputMaybe<StringOperationFilterInput>;
  replacementPagePath?: InputMaybe<StringOperationFilterInput>;
  replacementTabOrder?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  rowVersion?: InputMaybe<ListComparableByteOperationFilterInput>;
  siteMapOverrideId?: InputMaybe<ComparableInt32OperationFilterInput>;
  userCreated?: InputMaybe<UserDetailFilterInput>;
  userCreatedId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type SiteMapPageMap = {
  __typename?: 'SiteMapPageMap';
  id: Scalars['Int'];
  isMenuDropDown: Scalars['Boolean'];
  page: CmsPage;
  pageId: Scalars['Int'];
  sitemap: SiteMap;
  sitemapId: Scalars['Int'];
};

export type SiteMapPageMapFilterInput = {
  and?: InputMaybe<Array<SiteMapPageMapFilterInput>>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  isMenuDropDown?: InputMaybe<BooleanOperationFilterInput>;
  or?: InputMaybe<Array<SiteMapPageMapFilterInput>>;
  page?: InputMaybe<CmsPageFilterInput>;
  pageId?: InputMaybe<ComparableInt32OperationFilterInput>;
  sitemap?: InputMaybe<SiteMapFilterInput>;
  sitemapId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type Skin = {
  __typename?: 'Skin';
  customerInterfaces: Array<CustomerInterface>;
  name: Scalars['String'];
  skinId: Scalars['Int'];
  userDetails: Array<UserType>;
};

export type SkinFilterInput = {
  and?: InputMaybe<Array<SkinFilterInput>>;
  customerInterfaces?: InputMaybe<ListFilterInputTypeOfCustomerInterfaceFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<SkinFilterInput>>;
  skinId?: InputMaybe<ComparableInt32OperationFilterInput>;
  userDetails?: InputMaybe<ListFilterInputTypeOfUserDetailFilterInput>;
};

export type SkinSortInput = {
  name?: InputMaybe<SortEnumType>;
  skinId?: InputMaybe<SortEnumType>;
};

export type SmsDetail = {
  __typename?: 'SmsDetail';
  active: Scalars['Boolean'];
  created: Scalars['DateTime'];
  message: Scalars['String'];
  modified: Scalars['DateTime'];
  noOfSplits: Scalars['Short'];
  recipientNo: Scalars['String'];
  removed: Scalars['Boolean'];
  rowVersion: Array<Scalars['ByteArray']>;
  smsId: Scalars['Int'];
  smsRef?: Maybe<Scalars['String']>;
  smsRequest: SmsRequest;
  smsRequestId: Scalars['Int'];
  status: SmsStatus;
  statusId: Scalars['Int'];
  usedSmsaccount?: Maybe<Scalars['String']>;
  userCreated: UserType;
  userCreatedId: Scalars['Int'];
};

export type SmsDetailFilterInput = {
  active?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<SmsDetailFilterInput>>;
  created?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  message?: InputMaybe<StringOperationFilterInput>;
  modified?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  noOfSplits?: InputMaybe<ComparableInt16OperationFilterInput>;
  or?: InputMaybe<Array<SmsDetailFilterInput>>;
  recipientNo?: InputMaybe<StringOperationFilterInput>;
  removed?: InputMaybe<BooleanOperationFilterInput>;
  rowVersion?: InputMaybe<ListComparableByteOperationFilterInput>;
  smsId?: InputMaybe<ComparableInt32OperationFilterInput>;
  smsRef?: InputMaybe<StringOperationFilterInput>;
  smsRequest?: InputMaybe<SmsRequestFilterInput>;
  smsRequestId?: InputMaybe<ComparableInt32OperationFilterInput>;
  status?: InputMaybe<SmsStatusFilterInput>;
  statusId?: InputMaybe<ComparableInt32OperationFilterInput>;
  usedSmsaccount?: InputMaybe<StringOperationFilterInput>;
  userCreated?: InputMaybe<UserDetailFilterInput>;
  userCreatedId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type SmsReply = {
  __typename?: 'SmsReply';
  from: Scalars['String'];
  message: Scalars['String'];
  smsReplyId: Scalars['Int'];
  smsRequest: SmsRequest;
  smsRequestId: Scalars['Int'];
  to: Scalars['String'];
};

export type SmsReplyFilterInput = {
  and?: InputMaybe<Array<SmsReplyFilterInput>>;
  from?: InputMaybe<StringOperationFilterInput>;
  message?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<SmsReplyFilterInput>>;
  smsReplyId?: InputMaybe<ComparableInt32OperationFilterInput>;
  smsRequest?: InputMaybe<SmsRequestFilterInput>;
  smsRequestId?: InputMaybe<ComparableInt32OperationFilterInput>;
  to?: InputMaybe<StringOperationFilterInput>;
};

export type SmsRequest = {
  __typename?: 'SmsRequest';
  active: Scalars['Boolean'];
  allowoptout: Scalars['Boolean'];
  allowreply: Scalars['Boolean'];
  approverSecondUser?: Maybe<UserType>;
  approverSecondUserId?: Maybe<Scalars['Int']>;
  approverUser?: Maybe<UserType>;
  approverUserId?: Maybe<Scalars['Int']>;
  campaigns: Array<Campaign>;
  costPerMessage: Scalars['Decimal'];
  created: Scalars['DateTime'];
  customer: Customer;
  customerId: Scalars['Int'];
  modified: Scalars['DateTime'];
  removed: Scalars['Boolean'];
  rowVersion: Array<Scalars['ByteArray']>;
  sender: Scalars['String'];
  smsDetails: Array<SmsDetail>;
  smsReplies: Array<SmsReply>;
  smsRequestId: Scalars['Int'];
  smsRequestStatus: SmsRequestStatus;
  smsRequestStatusId: Scalars['Int'];
  userCreated: UserType;
  userCreatedId: Scalars['Int'];
};

export type SmsRequestFilterInput = {
  active?: InputMaybe<BooleanOperationFilterInput>;
  allowoptout?: InputMaybe<BooleanOperationFilterInput>;
  allowreply?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<SmsRequestFilterInput>>;
  approverSecondUser?: InputMaybe<UserDetailFilterInput>;
  approverSecondUserId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  approverUser?: InputMaybe<UserDetailFilterInput>;
  approverUserId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  campaigns?: InputMaybe<ListFilterInputTypeOfCampaignFilterInput>;
  costPerMessage?: InputMaybe<ComparableDecimalOperationFilterInput>;
  created?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  customer?: InputMaybe<CustomerFilterInput>;
  customerId?: InputMaybe<ComparableInt32OperationFilterInput>;
  modified?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<SmsRequestFilterInput>>;
  removed?: InputMaybe<BooleanOperationFilterInput>;
  rowVersion?: InputMaybe<ListComparableByteOperationFilterInput>;
  sender?: InputMaybe<StringOperationFilterInput>;
  smsDetails?: InputMaybe<ListFilterInputTypeOfSmsDetailFilterInput>;
  smsReplies?: InputMaybe<ListFilterInputTypeOfSmsReplyFilterInput>;
  smsRequestId?: InputMaybe<ComparableInt32OperationFilterInput>;
  smsRequestStatus?: InputMaybe<SmsRequestStatusFilterInput>;
  smsRequestStatusId?: InputMaybe<ComparableInt32OperationFilterInput>;
  userCreated?: InputMaybe<UserDetailFilterInput>;
  userCreatedId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type SmsRequestStatus = {
  __typename?: 'SmsRequestStatus';
  name: Scalars['String'];
  smsRequestStatusId: Scalars['Int'];
  smsRequests: Array<SmsRequest>;
};

export type SmsRequestStatusFilterInput = {
  and?: InputMaybe<Array<SmsRequestStatusFilterInput>>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<SmsRequestStatusFilterInput>>;
  smsRequestStatusId?: InputMaybe<ComparableInt32OperationFilterInput>;
  smsRequests?: InputMaybe<ListFilterInputTypeOfSmsRequestFilterInput>;
};

export type SmsStatus = {
  __typename?: 'SmsStatus';
  name?: Maybe<Scalars['String']>;
  smsDetails: Array<SmsDetail>;
  smsStatusId: Scalars['Int'];
};

export type SmsStatusFilterInput = {
  and?: InputMaybe<Array<SmsStatusFilterInput>>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<SmsStatusFilterInput>>;
  smsDetails?: InputMaybe<ListFilterInputTypeOfSmsDetailFilterInput>;
  smsStatusId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type SmsTemplate = {
  __typename?: 'SmsTemplate';
  active: Scalars['Boolean'];
  businessLevel: BusinessLevel;
  businessLevelId: Scalars['Int'];
  campaigns: Array<Campaign>;
  created: Scalars['DateTime'];
  customer: Customer;
  customerId: Scalars['Int'];
  modified: Scalars['DateTime'];
  name?: Maybe<Scalars['String']>;
  rawContent?: Maybe<Scalars['String']>;
  removed: Scalars['Boolean'];
  rowVersion: Array<Scalars['ByteArray']>;
  smsTemplateId: Scalars['Int'];
  userCreated: UserType;
  userCreatedId: Scalars['Int'];
  userModified: UserType;
  userModifiedId: Scalars['Int'];
  visibilitySetting: Scalars['Int'];
};

export type SmsTemplateFilterInput = {
  active?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<SmsTemplateFilterInput>>;
  businessLevel?: InputMaybe<BusinessLevelFilterInput>;
  businessLevelId?: InputMaybe<ComparableInt32OperationFilterInput>;
  campaigns?: InputMaybe<ListFilterInputTypeOfCampaignFilterInput>;
  created?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  customer?: InputMaybe<CustomerFilterInput>;
  customerId?: InputMaybe<ComparableInt32OperationFilterInput>;
  modified?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<SmsTemplateFilterInput>>;
  rawContent?: InputMaybe<StringOperationFilterInput>;
  removed?: InputMaybe<BooleanOperationFilterInput>;
  rowVersion?: InputMaybe<ListComparableByteOperationFilterInput>;
  smsTemplateId?: InputMaybe<ComparableInt32OperationFilterInput>;
  userCreated?: InputMaybe<UserDetailFilterInput>;
  userCreatedId?: InputMaybe<ComparableInt32OperationFilterInput>;
  userModified?: InputMaybe<UserDetailFilterInput>;
  userModifiedId?: InputMaybe<ComparableInt32OperationFilterInput>;
  visibilitySetting?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export enum SortEnumType {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type SpecialConditionFilterInput = {
  agreement?: InputMaybe<AgreementFilterInput>;
  agreementId?: InputMaybe<ComparableInt32OperationFilterInput>;
  and?: InputMaybe<Array<SpecialConditionFilterInput>>;
  clauseReference?: InputMaybe<StringOperationFilterInput>;
  condition?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<SpecialConditionFilterInput>>;
  rowVersion?: InputMaybe<ListComparableByteOperationFilterInput>;
  specialConditionId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type StihlbaseOrderSubmission = {
  __typename?: 'StihlbaseOrderSubmission';
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  businessLevel: BusinessLevel;
  businessLevelId: Scalars['Int'];
  companyName?: Maybe<Scalars['String']>;
  contactName?: Maybe<Scalars['String']>;
  created: Scalars['DateTime'];
  email?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  model: Scalars['String'];
  modified: Scalars['DateTime'];
  phoneNumber?: Maybe<Scalars['String']>;
  postcode?: Maybe<Scalars['String']>;
  product: Scalars['String'];
  quantity: Scalars['Int'];
  state?: Maybe<Scalars['String']>;
  suburb?: Maybe<Scalars['String']>;
  userId: Scalars['Int'];
};

export type StihlbaseOrderSubmissionFilterInput = {
  address1?: InputMaybe<StringOperationFilterInput>;
  address2?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<StihlbaseOrderSubmissionFilterInput>>;
  businessLevel?: InputMaybe<BusinessLevelFilterInput>;
  businessLevelId?: InputMaybe<ComparableInt32OperationFilterInput>;
  companyName?: InputMaybe<StringOperationFilterInput>;
  contactName?: InputMaybe<StringOperationFilterInput>;
  created?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  email?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  model?: InputMaybe<StringOperationFilterInput>;
  modified?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<StihlbaseOrderSubmissionFilterInput>>;
  phoneNumber?: InputMaybe<StringOperationFilterInput>;
  postcode?: InputMaybe<StringOperationFilterInput>;
  product?: InputMaybe<StringOperationFilterInput>;
  quantity?: InputMaybe<ComparableInt32OperationFilterInput>;
  state?: InputMaybe<StringOperationFilterInput>;
  suburb?: InputMaybe<StringOperationFilterInput>;
  userId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type StringOperationFilterInput = {
  and?: InputMaybe<Array<StringOperationFilterInput>>;
  contains?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  eq?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ncontains?: InputMaybe<Scalars['String']>;
  nendsWith?: InputMaybe<Scalars['String']>;
  neq?: InputMaybe<Scalars['String']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  nstartsWith?: InputMaybe<Scalars['String']>;
  or?: InputMaybe<Array<StringOperationFilterInput>>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export type SubTask = {
  __typename?: 'SubTask';
  activity: Activity;
  activityId: Scalars['Int'];
  done: Scalars['Boolean'];
  id: Scalars['Int'];
  name: Scalars['String'];
  taskIndex: Scalars['Int'];
};

export type SubTaskFilterInput = {
  activity?: InputMaybe<ActivityFilterInput>;
  activityId?: InputMaybe<ComparableInt32OperationFilterInput>;
  and?: InputMaybe<Array<SubTaskFilterInput>>;
  done?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<SubTaskFilterInput>>;
  taskIndex?: InputMaybe<ComparableInt32OperationFilterInput>;
};

/** Represents the payload return for submit order. */
export type SubmitOrderPayloadType = {
  __typename?: 'SubmitOrderPayloadType';
  /** Represents the created order reference. */
  orderReference: Scalars['String'];
};

export type SurveyDescriptor = {
  __typename?: 'SurveyDescriptor';
  cmsPageBlocks: Array<CmsPageBlock>;
  created: Scalars['DateTime'];
  id: Scalars['Int'];
  name: Scalars['String'];
  rowVersion: Array<Scalars['ByteArray']>;
  surveySubmissionHeaders: Array<SurveySubmissionHeader>;
  userCreatedId: Scalars['Int'];
};

export type SurveyDescriptorFilterInput = {
  and?: InputMaybe<Array<SurveyDescriptorFilterInput>>;
  cmsPageBlocks?: InputMaybe<ListFilterInputTypeOfCmsPageBlockFilterInput>;
  created?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<SurveyDescriptorFilterInput>>;
  rowVersion?: InputMaybe<ListComparableByteOperationFilterInput>;
  surveySubmissionHeaders?: InputMaybe<ListFilterInputTypeOfSurveySubmissionHeaderFilterInput>;
  userCreatedId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type SurveySubmissionAnswer = {
  __typename?: 'SurveySubmissionAnswer';
  answer: Scalars['String'];
  id: Scalars['Int'];
  surveyQuestion: SurveySubmissionQuestion;
  surveyQuestionId: Scalars['Int'];
};

export type SurveySubmissionAnswerFilterInput = {
  and?: InputMaybe<Array<SurveySubmissionAnswerFilterInput>>;
  answer?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<SurveySubmissionAnswerFilterInput>>;
  surveyQuestion?: InputMaybe<SurveySubmissionQuestionFilterInput>;
  surveyQuestionId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type SurveySubmissionHeader = {
  __typename?: 'SurveySubmissionHeader';
  businessLevel: BusinessLevel;
  businessLevelId: Scalars['Int'];
  businesslevelIdlist: Scalars['String'];
  businesslevelNameList: Scalars['String'];
  created: Scalars['DateTime'];
  customer: Customer;
  customerId: Scalars['Int'];
  id: Scalars['Int'];
  surveyDescriptor: SurveyDescriptor;
  surveyDescriptorId: Scalars['Int'];
  surveySubmissionQuestions: Array<SurveySubmissionQuestion>;
  totalNumberOfQuestions: Scalars['Int'];
  userCreatedId: Scalars['Int'];
};

export type SurveySubmissionHeaderFilterInput = {
  and?: InputMaybe<Array<SurveySubmissionHeaderFilterInput>>;
  businessLevel?: InputMaybe<BusinessLevelFilterInput>;
  businessLevelId?: InputMaybe<ComparableInt32OperationFilterInput>;
  businesslevelIdlist?: InputMaybe<StringOperationFilterInput>;
  businesslevelNameList?: InputMaybe<StringOperationFilterInput>;
  created?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  customer?: InputMaybe<CustomerFilterInput>;
  customerId?: InputMaybe<ComparableInt32OperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<SurveySubmissionHeaderFilterInput>>;
  surveyDescriptor?: InputMaybe<SurveyDescriptorFilterInput>;
  surveyDescriptorId?: InputMaybe<ComparableInt32OperationFilterInput>;
  surveySubmissionQuestions?: InputMaybe<ListFilterInputTypeOfSurveySubmissionQuestionFilterInput>;
  totalNumberOfQuestions?: InputMaybe<ComparableInt32OperationFilterInput>;
  userCreatedId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type SurveySubmissionQuestion = {
  __typename?: 'SurveySubmissionQuestion';
  created: Scalars['DateTime'];
  id: Scalars['Int'];
  metaName: Scalars['String'];
  questionHtml: Scalars['String'];
  surveySubmissionAnswers: Array<SurveySubmissionAnswer>;
  surveySubmissionHeader: SurveySubmissionHeader;
  surveySubmissionHeaderId: Scalars['Int'];
  userCreatedId: Scalars['Int'];
};

export type SurveySubmissionQuestionFilterInput = {
  and?: InputMaybe<Array<SurveySubmissionQuestionFilterInput>>;
  created?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  metaName?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<SurveySubmissionQuestionFilterInput>>;
  questionHtml?: InputMaybe<StringOperationFilterInput>;
  surveySubmissionAnswers?: InputMaybe<ListFilterInputTypeOfSurveySubmissionAnswerFilterInput>;
  surveySubmissionHeader?: InputMaybe<SurveySubmissionHeaderFilterInput>;
  surveySubmissionHeaderId?: InputMaybe<ComparableInt32OperationFilterInput>;
  userCreatedId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type Team = {
  __typename?: 'Team';
  active: Scalars['Boolean'];
  created: Scalars['DateTime'];
  modified: Scalars['DateTime'];
  name: Scalars['String'];
  purgeDate?: Maybe<Scalars['DateTime']>;
  recordTimestamp: Array<Scalars['ByteArray']>;
  removed: Scalars['Boolean'];
  teamCustomers: Array<TeamCustomer>;
  teamId: Scalars['Int'];
  userCreatedId: Scalars['Int'];
  userDetails: Array<UserType>;
  userModifiedId: Scalars['Int'];
};

export type TeamCustomer = {
  __typename?: 'TeamCustomer';
  created: Scalars['DateTime'];
  customer: Customer;
  customerId: Scalars['Int'];
  modified: Scalars['DateTime'];
  team: Team;
  teamCustomerId: Scalars['Int'];
  teamId: Scalars['Int'];
  userCreatedId: Scalars['Int'];
  userModifiedId: Scalars['Int'];
};

export type TeamCustomerFilterInput = {
  and?: InputMaybe<Array<TeamCustomerFilterInput>>;
  created?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  customer?: InputMaybe<CustomerFilterInput>;
  customerId?: InputMaybe<ComparableInt32OperationFilterInput>;
  modified?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<TeamCustomerFilterInput>>;
  team?: InputMaybe<TeamFilterInput>;
  teamCustomerId?: InputMaybe<ComparableInt32OperationFilterInput>;
  teamId?: InputMaybe<ComparableInt32OperationFilterInput>;
  userCreatedId?: InputMaybe<ComparableInt32OperationFilterInput>;
  userModifiedId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type TeamFilterInput = {
  active?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<TeamFilterInput>>;
  created?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  modified?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TeamFilterInput>>;
  purgeDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  recordTimestamp?: InputMaybe<ListComparableByteOperationFilterInput>;
  removed?: InputMaybe<BooleanOperationFilterInput>;
  teamCustomers?: InputMaybe<ListFilterInputTypeOfTeamCustomerFilterInput>;
  teamId?: InputMaybe<ComparableInt32OperationFilterInput>;
  userCreatedId?: InputMaybe<ComparableInt32OperationFilterInput>;
  userDetails?: InputMaybe<ListFilterInputTypeOfUserDetailFilterInput>;
  userModifiedId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type TeamSortInput = {
  active?: InputMaybe<SortEnumType>;
  created?: InputMaybe<SortEnumType>;
  modified?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  purgeDate?: InputMaybe<SortEnumType>;
  removed?: InputMaybe<SortEnumType>;
  teamId?: InputMaybe<SortEnumType>;
  userCreatedId?: InputMaybe<SortEnumType>;
  userModifiedId?: InputMaybe<SortEnumType>;
};

export type Theme = {
  __typename?: 'Theme';
  backgroundDefault: Scalars['String'];
  backgroundLayout: Scalars['String'];
  backgroundLayoutDark: Scalars['String'];
  backgroundPaper: Scalars['String'];
  border: Scalars['String'];
  customer?: Maybe<Customer>;
  customerId?: Maybe<Scalars['Int']>;
  logo?: Maybe<Scalars['String']>;
  primaryContrastText: Scalars['String'];
  primaryDark: Scalars['String'];
  primaryLight: Scalars['String'];
  primaryMain: Scalars['String'];
  secondaryContrastText: Scalars['String'];
  secondaryDark: Scalars['String'];
  secondaryLight: Scalars['String'];
  secondaryMain: Scalars['String'];
  textDisabled: Scalars['String'];
  textPrimary: Scalars['String'];
  textSecondary: Scalars['String'];
  themeId: Scalars['Int'];
  typographyBody: Scalars['String'];
  typographyHeader: Scalars['String'];
};

export type ThemeFilterInput = {
  and?: InputMaybe<Array<ThemeFilterInput>>;
  backgroundDefault?: InputMaybe<StringOperationFilterInput>;
  backgroundLayout?: InputMaybe<StringOperationFilterInput>;
  backgroundLayoutDark?: InputMaybe<StringOperationFilterInput>;
  backgroundPaper?: InputMaybe<StringOperationFilterInput>;
  border?: InputMaybe<StringOperationFilterInput>;
  customer?: InputMaybe<CustomerFilterInput>;
  customerId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  logo?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ThemeFilterInput>>;
  primaryContrastText?: InputMaybe<StringOperationFilterInput>;
  primaryDark?: InputMaybe<StringOperationFilterInput>;
  primaryLight?: InputMaybe<StringOperationFilterInput>;
  primaryMain?: InputMaybe<StringOperationFilterInput>;
  secondaryContrastText?: InputMaybe<StringOperationFilterInput>;
  secondaryDark?: InputMaybe<StringOperationFilterInput>;
  secondaryLight?: InputMaybe<StringOperationFilterInput>;
  secondaryMain?: InputMaybe<StringOperationFilterInput>;
  textDisabled?: InputMaybe<StringOperationFilterInput>;
  textPrimary?: InputMaybe<StringOperationFilterInput>;
  textSecondary?: InputMaybe<StringOperationFilterInput>;
  themeId?: InputMaybe<ComparableInt32OperationFilterInput>;
  typographyBody?: InputMaybe<StringOperationFilterInput>;
  typographyHeader?: InputMaybe<StringOperationFilterInput>;
};

export type ThemeSortInput = {
  backgroundDefault?: InputMaybe<SortEnumType>;
  backgroundLayout?: InputMaybe<SortEnumType>;
  backgroundLayoutDark?: InputMaybe<SortEnumType>;
  backgroundPaper?: InputMaybe<SortEnumType>;
  border?: InputMaybe<SortEnumType>;
  customer?: InputMaybe<CustomerSortInput>;
  customerId?: InputMaybe<SortEnumType>;
  logo?: InputMaybe<SortEnumType>;
  primaryContrastText?: InputMaybe<SortEnumType>;
  primaryDark?: InputMaybe<SortEnumType>;
  primaryLight?: InputMaybe<SortEnumType>;
  primaryMain?: InputMaybe<SortEnumType>;
  secondaryContrastText?: InputMaybe<SortEnumType>;
  secondaryDark?: InputMaybe<SortEnumType>;
  secondaryLight?: InputMaybe<SortEnumType>;
  secondaryMain?: InputMaybe<SortEnumType>;
  textDisabled?: InputMaybe<SortEnumType>;
  textPrimary?: InputMaybe<SortEnumType>;
  textSecondary?: InputMaybe<SortEnumType>;
  themeId?: InputMaybe<SortEnumType>;
  typographyBody?: InputMaybe<SortEnumType>;
  typographyHeader?: InputMaybe<SortEnumType>;
};

export type TopOrderedProduct = {
  __typename?: 'TopOrderedProduct';
  productCode: Scalars['String'];
  productName: Scalars['String'];
  productsSold: Scalars['Int'];
  totalQuantity: Scalars['Int'];
};

export type TopOrderedProductCollectionSegment = {
  __typename?: 'TopOrderedProductCollectionSegment';
  items?: Maybe<Array<TopOrderedProduct>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int'];
};

export type TopOrderedProductFilterInput = {
  and?: InputMaybe<Array<TopOrderedProductFilterInput>>;
  or?: InputMaybe<Array<TopOrderedProductFilterInput>>;
  productCode?: InputMaybe<StringOperationFilterInput>;
  productName?: InputMaybe<StringOperationFilterInput>;
  productsSold?: InputMaybe<ComparableInt32OperationFilterInput>;
  totalQuantity?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type TopOrderedProductSortInput = {
  productCode?: InputMaybe<SortEnumType>;
  productName?: InputMaybe<SortEnumType>;
  productsSold?: InputMaybe<SortEnumType>;
  totalQuantity?: InputMaybe<SortEnumType>;
};

export type Translation = {
  __typename?: 'Translation';
  active: Scalars['Boolean'];
  created: Scalars['DateTime'];
  customer: Customer;
  customerId: Scalars['Int'];
  defaultText: Scalars['String'];
  english?: Maybe<Scalars['String']>;
  modified: Scalars['DateTime'];
  purgeDate?: Maybe<Scalars['DateTime']>;
  removed: Scalars['Boolean'];
  rowVersion: Array<Scalars['ByteArray']>;
  translationId: Scalars['Int'];
  userCreatedId: Scalars['Int'];
  userModifiedId: Scalars['Int'];
};

export type TranslationFilterInput = {
  active?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<TranslationFilterInput>>;
  created?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  customer?: InputMaybe<CustomerFilterInput>;
  customerId?: InputMaybe<ComparableInt32OperationFilterInput>;
  defaultText?: InputMaybe<StringOperationFilterInput>;
  english?: InputMaybe<StringOperationFilterInput>;
  modified?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<TranslationFilterInput>>;
  purgeDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  removed?: InputMaybe<BooleanOperationFilterInput>;
  rowVersion?: InputMaybe<ListComparableByteOperationFilterInput>;
  translationId?: InputMaybe<ComparableInt32OperationFilterInput>;
  userCreatedId?: InputMaybe<ComparableInt32OperationFilterInput>;
  userModifiedId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type TsuCustomerFeature = {
  __typename?: 'TsuCustomerFeature';
  access: Scalars['Boolean'];
  customer: Customer;
  customerId: Scalars['Int'];
  tsuCustomerFeatureId: Scalars['Int'];
  tsuFeature: TsuFeature;
  tsuFeatureId: Scalars['Int'];
};

export type TsuCustomerFeatureFilterInput = {
  access?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<TsuCustomerFeatureFilterInput>>;
  customer?: InputMaybe<CustomerFilterInput>;
  customerId?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<TsuCustomerFeatureFilterInput>>;
  tsuCustomerFeatureId?: InputMaybe<ComparableInt32OperationFilterInput>;
  tsuFeature?: InputMaybe<TsuFeatureFilterInput>;
  tsuFeatureId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type TsuFeature = {
  __typename?: 'TsuFeature';
  active: Scalars['Boolean'];
  description: Scalars['String'];
  name: Scalars['String'];
  removed: Scalars['Boolean'];
  tsuCustomerFeatures: Array<TsuCustomerFeature>;
  tsuFeatureId: Scalars['Int'];
};

export type TsuFeatureFilterInput = {
  active?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<TsuFeatureFilterInput>>;
  description?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<TsuFeatureFilterInput>>;
  removed?: InputMaybe<BooleanOperationFilterInput>;
  tsuCustomerFeatures?: InputMaybe<ListFilterInputTypeOfTsuCustomerFeatureFilterInput>;
  tsuFeatureId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type TsunamiTheme = {
  __typename?: 'TsunamiTheme';
  background: Color;
  banners: Array<BannerItem>;
  customerId: Scalars['String'];
  fonts: Fonts;
  footer: Footer;
  logo?: Maybe<Scalars['String']>;
  navigationBar: NavigationBar;
  pageHeader: PageHeader;
  primary: Color;
  secondary: Color;
  themeId: Scalars['String'];
};

export type Uomdescription = {
  __typename?: 'Uomdescription';
  descriptorId: Scalars['Int'];
  name: Scalars['String'];
  productUoms: Array<ProductUom>;
};

export type UomdescriptionFilterInput = {
  and?: InputMaybe<Array<UomdescriptionFilterInput>>;
  descriptorId?: InputMaybe<ComparableInt32OperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<UomdescriptionFilterInput>>;
  productUoms?: InputMaybe<ListFilterInputTypeOfProductUomFilterInput>;
};

export type UpdateCrossUpSalesPayloadInput = {
  items: Array<CrossUpSaleItemInput>;
  productId: Scalars['Int'];
};

export type UpdateCustomerFeatureInput = {
  access: Scalars['Boolean'];
  custFeatureId: Scalars['Int'];
};

/** Represents the input to update user details. */
export type UpdateDetailsInputType = {
  /** Represents the user's contact number */
  contactNumber: Scalars['String'];
  /** Represents the user's unique email */
  email: Scalars['String'];
  /** Represents the user's first name */
  firstName: Scalars['String'];
  /** Represents the user's last name */
  lastName: Scalars['String'];
};

export type UpdateDetailsPayload = {
  __typename?: 'UpdateDetailsPayload';
  success: Scalars['Boolean'];
};

/** Represents the payload returned for updating user details. */
export type UpdateDetailsPayloadType = {
  /** Represents if the reset was successful. */
  success: Scalars['Boolean'];
};

export type UpdateMultipleCustomerFeaturesInput = {
  updates: Array<UpdateCustomerFeatureInput>;
};

/** Represents the input for updating an OrderLine quantity. */
export type UpdateOrderLineQuantityInput = {
  /** orderline active or not */
  active: Scalars['Boolean'];
  /** The Order Line ID */
  orderLineId: Scalars['Int'];
  /** Product quantity */
  quantity: Scalars['Int'];
};

/** Represents the input for changing the status of an OrderShipping. */
export type UpdateOrderShippingStatusInput = {
  /** The Order Shipping ID */
  orderShippingId: Scalars['Int'];
  /** The Order Status ID */
  statusId: Scalars['Int'];
};

/** Represents the input for changing the status of an OrderShipping. */
export type UpdateOrderSavedInput = {
  /** The Order ID */
  orderId: Scalars['Int'];
  /** The Boolean value of Saved */
  saved: Scalars['Boolean'];
};

/** Represents the input for updating cart using csv upload*/
export type BulkCartCsvUploadInput = {
  /** The Csv file */
  file: Scalars['Upload'];
  /** The cart ID */
  cartId: Scalars['String'];
};

/** Represents the input for bulk ordering using csv upload*/
export type BulkOrderCsvUploadInput = {
  /** The Csv file */
  file: Scalars['Upload'];
};

/** Represents the input for loading saved order into user cart*/
export type LoadSavedOrderInput = {
  /** The Order Shipping ID */
  orderShipId: Scalars['Int'];
  /** The cart ID */
  cartId: Scalars['String'];
};

export type UpdateProductCategoryPayloadInput = {
  categoryIds: Array<Scalars['Int']>;
};

export type UpdateRoleDetailsInput = {
  role: UpdateRoleInput;
  roleId: Scalars['Int'];
  selectedFreightSettingIds: Array<Scalars['Int']>;
  selectedOrderTypeIds: Array<Scalars['Int']>;
  selectedUserActionIds: Array<Scalars['Int']>;
};

export type UpdateRoleInput = {
  defaultWarehouse?: InputMaybe<Scalars['String']>;
  discount?: InputMaybe<Scalars['Decimal']>;
  discountUom?: InputMaybe<Scalars['String']>;
  maxOrderQuantity?: InputMaybe<Scalars['Int']>;
  minOrderTotal?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  spendLimitDays?: InputMaybe<Scalars['Int']>;
  spendLimitPerDay?: InputMaybe<Scalars['Decimal']>;
  zeroFreightOrderAmount?: InputMaybe<Scalars['Decimal']>;
};

export type UpdateThemeRequestInput = {
  background?: InputMaybe<ColorUpdatesInput>;
  banners?: InputMaybe<Array<InputMaybe<BannerUpdateInput>>> | InputMaybe<Array<InputMaybe<ExistingBannerInput>>>;
  fonts?: InputMaybe<FontsUpdatesInput>;
  footer?: InputMaybe<FooterUpdatesInput>;
  logo?: InputMaybe<Scalars['Upload']>;
  navigationBar?: InputMaybe<NavigationBarUpdatesInput>;
  pageHeader?: InputMaybe<PageHeaderUpdatesInput>;
  primary?: InputMaybe<ColorUpdatesInput>;
  secondary?: InputMaybe<ColorUpdatesInput>;
  themeId: Scalars['String'];
};

export type BannerUpdateInput = {
  file? : InputMaybe<Scalars['Upload']>;
  href? : InputMaybe<Scalars['String']>;
}

export type ExistingBannerInput = {
  fileName? : InputMaybe<Scalars['String']>;
  href? : InputMaybe<Scalars['String']>;
}

export type BannerItem = {
  fileName: Scalars['String'];
  href: Scalars['String'];
}

export type UploadedFile = {
  __typename?: 'UploadedFile';
  active: Scalars['Boolean'];
  campaigns: Array<Campaign>;
  created: Scalars['DateTime'];
  downloadable: Scalars['Boolean'];
  emailAttachedFiles: Array<EmailAttachedFile>;
  emailImageLinks: Array<EmailImageLink>;
  emailTemplates: Array<EmailTemplate>;
  etemplateData: Array<EtemplateDatum>;
  fileData: Array<Scalars['ByteArray']>;
  height?: Maybe<Scalars['Int']>;
  imageThumb: Array<Scalars['ByteArray']>;
  mimeType: Scalars['String'];
  modified: Scalars['DateTime'];
  name: Scalars['String'];
  productMedia: Array<ProductMediumType>;
  purgeDate?: Maybe<Scalars['DateTime']>;
  removed: Scalars['Boolean'];
  uploadedFileId: Scalars['Int'];
  userCreatedId: Scalars['Int'];
  userModifiedId: Scalars['Int'];
  width?: Maybe<Scalars['Int']>;
  wmsRgas: Array<WmsRga>;
};

export type UploadedFileFilterInput = {
  active?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<UploadedFileFilterInput>>;
  campaigns?: InputMaybe<ListFilterInputTypeOfCampaignFilterInput>;
  created?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  downloadable?: InputMaybe<BooleanOperationFilterInput>;
  emailAttachedFiles?: InputMaybe<ListFilterInputTypeOfEmailAttachedFileFilterInput>;
  emailImageLinks?: InputMaybe<ListFilterInputTypeOfEmailImageLinkFilterInput>;
  emailTemplates?: InputMaybe<ListFilterInputTypeOfEmailTemplateFilterInput>;
  etemplateData?: InputMaybe<ListFilterInputTypeOfEtemplateDatumFilterInput>;
  fileData?: InputMaybe<ListComparableByteOperationFilterInput>;
  height?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  imageThumb?: InputMaybe<ListComparableByteOperationFilterInput>;
  mimeType?: InputMaybe<StringOperationFilterInput>;
  modified?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<UploadedFileFilterInput>>;
  productMedia?: InputMaybe<ListFilterInputTypeOfProductMediumFilterInput>;
  purgeDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  removed?: InputMaybe<BooleanOperationFilterInput>;
  uploadedFileId?: InputMaybe<ComparableInt32OperationFilterInput>;
  userCreatedId?: InputMaybe<ComparableInt32OperationFilterInput>;
  userModifiedId?: InputMaybe<ComparableInt32OperationFilterInput>;
  width?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  wmsRgas?: InputMaybe<ListFilterInputTypeOfWmsRgaFilterInput>;
};

export type UserActionCategoryFilterInput = {
  actionCategoryId?: InputMaybe<ComparableInt32OperationFilterInput>;
  and?: InputMaybe<Array<UserActionCategoryFilterInput>>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<UserActionCategoryFilterInput>>;
  userActions?: InputMaybe<ListFilterInputTypeOfUserActionFilterInput>;
};

export type UserActionCategoryType = {
  __typename?: 'UserActionCategoryType';
  /** Represents the name of the User Action Category */
  name: Scalars['String'];
  /** Represents the User Actions under this User Action Category */
  userActions: Array<UserActionType>;
};

export type UserActionFilterInput = {
  actionCategory?: InputMaybe<UserActionCategoryFilterInput>;
  actionCategoryId?: InputMaybe<ComparableInt32OperationFilterInput>;
  actionId?: InputMaybe<ComparableInt32OperationFilterInput>;
  and?: InputMaybe<Array<UserActionFilterInput>>;
  created?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  customerPermissions?: InputMaybe<ListFilterInputTypeOfCustomerPermissionFilterInput>;
  defaultLevel?: InputMaybe<ComparableInt32OperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  isField?: InputMaybe<BooleanOperationFilterInput>;
  modified?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<UserActionFilterInput>>;
  rolePermissions?: InputMaybe<ListFilterInputTypeOfRolePermissionFilterInput>;
  rowVersion?: InputMaybe<ListComparableByteOperationFilterInput>;
  userModifiedId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type UserActionType = {
  __typename?: 'UserActionType';
  actionCategory: UserActionCategoryType;
  actionCategoryId: Scalars['Int'];
  actionId: Scalars['Int'];
  created: Scalars['DateTime'];
  customerPermissions: Array<CustomerPermission>;
  defaultLevel: Scalars['Int'];
  description: Scalars['String'];
  /** Descibes if this User Action is active based on elements in RolePermissions. This field is only relevant when the UserActionCategories & UserActions are filtered by role. */
  isActive?: Maybe<Scalars['Boolean']>;
  isField?: Maybe<Scalars['Boolean']>;
  modified: Scalars['DateTime'];
  name: Scalars['String'];
  rolePermissions: Array<RolePermission>;
  rowVersion: Array<Scalars['ByteArray']>;
  userModifiedId: Scalars['Int'];
};

export type UserCreditByCategory = {
  __typename?: 'UserCreditByCategory';
  category: Category;
  categoryCredit: Scalars['Decimal'];
  categoryCreditId: Scalars['Int'];
  categoryId: Scalars['Int'];
  rowVersion: Array<Scalars['ByteArray']>;
  user: UserType;
  userId: Scalars['Int'];
};

export type UserCreditByCategoryFilterInput = {
  and?: InputMaybe<Array<UserCreditByCategoryFilterInput>>;
  category?: InputMaybe<CategoryFilterInput>;
  categoryCredit?: InputMaybe<ComparableDecimalOperationFilterInput>;
  categoryCreditId?: InputMaybe<ComparableInt32OperationFilterInput>;
  categoryId?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<UserCreditByCategoryFilterInput>>;
  rowVersion?: InputMaybe<ListComparableByteOperationFilterInput>;
  user?: InputMaybe<UserDetailFilterInput>;
  userId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type UserDetailFilterInput = {
  active?: InputMaybe<BooleanOperationFilterInput>;
  activities?: InputMaybe<ListFilterInputTypeOfActivityFilterInput>;
  activityAttendees?: InputMaybe<ListFilterInputTypeOfActivityAttendeeFilterInput>;
  additionalInfo?: InputMaybe<StringOperationFilterInput>;
  advertisementMasterPageUserCreateds?: InputMaybe<ListFilterInputTypeOfAdvertisementMasterPageFilterInput>;
  advertisementMasterPageUserModifieds?: InputMaybe<ListFilterInputTypeOfAdvertisementMasterPageFilterInput>;
  advertisementPageUserCreateds?: InputMaybe<ListFilterInputTypeOfAdvertisementPageFilterInput>;
  advertisementPageUserModifieds?: InputMaybe<ListFilterInputTypeOfAdvertisementPageFilterInput>;
  and?: InputMaybe<Array<UserDetailFilterInput>>;
  awaitingApproval?: InputMaybe<BooleanOperationFilterInput>;
  billingAddress?: InputMaybe<AddressFilterInput>;
  billingAddressId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  bmwcampaignSubmissions?: InputMaybe<ListFilterInputTypeOfBmwcampaignSubmissionFilterInput>;
  bmwcommunicationBriefs?: InputMaybe<ListFilterInputTypeOfBmwcommunicationBriefFilterInput>;
  businessLevel?: InputMaybe<BusinessLevelFilterInput>;
  businessLevelId?: InputMaybe<ComparableInt32OperationFilterInput>;
  businessLevelOptHeads?: InputMaybe<ListFilterInputTypeOfBusinessLevelOptHeadFilterInput>;
  businessLevelResponsiblePerson1Navigations?: InputMaybe<ListFilterInputTypeOfBusinessLevelFilterInput>;
  businessLevelResponsiblePerson2Navigations?: InputMaybe<ListFilterInputTypeOfBusinessLevelFilterInput>;
  campaignUserCreateds?: InputMaybe<ListFilterInputTypeOfCampaignFilterInput>;
  campaignUserModifieds?: InputMaybe<ListFilterInputTypeOfCampaignFilterInput>;
  companyName?: InputMaybe<StringOperationFilterInput>;
  created?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  creationDate?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  crmcontactLoginUsers?: InputMaybe<ListFilterInputTypeOfCrmcontactFilterInput>;
  crmcontactUserCreateds?: InputMaybe<ListFilterInputTypeOfCrmcontactFilterInput>;
  crmguid?: InputMaybe<ComparableNullableOfGuidOperationFilterInput>;
  defaultUser?: InputMaybe<BooleanOperationFilterInput>;
  deliveryAddress?: InputMaybe<AddressFilterInput>;
  deliveryAddressId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  documentCategories?: InputMaybe<ListFilterInputTypeOfDocumentCategoryFilterInput>;
  documentCategoryCustomVisibilities?: InputMaybe<ListFilterInputTypeOfDocumentCategoryCustomVisibilityFilterInput>;
  documentCategoryUserFavouriteMaps?: InputMaybe<ListFilterInputTypeOfDocumentCategoryUserFavouriteMapFilterInput>;
  documentCustomVisibilities?: InputMaybe<ListFilterInputTypeOfDocumentCustomVisibilityFilterInput>;
  documentLinks?: InputMaybe<ListFilterInputTypeOfDocumentLinkFilterInput>;
  documentMetadata?: InputMaybe<ListFilterInputTypeOfDocumentMetadataFilterInput>;
  documentUserFavouriteMaps?: InputMaybe<ListFilterInputTypeOfDocumentUserFavouriteMapFilterInput>;
  documents?: InputMaybe<ListFilterInputTypeOfDocumentFilterInput>;
  email?: InputMaybe<StringOperationFilterInput>;
  emailAdBlockData?: InputMaybe<ListFilterInputTypeOfEmailAdBlockDatumFilterInput>;
  emailAdPages?: InputMaybe<ListFilterInputTypeOfEmailAdPageFilterInput>;
  emailAlertDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  emailTemplateUserCreateds?: InputMaybe<ListFilterInputTypeOfEmailTemplateFilterInput>;
  emailTemplateUserModifieds?: InputMaybe<ListFilterInputTypeOfEmailTemplateFilterInput>;
  etemplateRestApirequests?: InputMaybe<ListFilterInputTypeOfEtemplateRestApirequestFilterInput>;
  firstName?: InputMaybe<StringOperationFilterInput>;
  hash?: InputMaybe<StringOperationFilterInput>;
  hashedPassword?: InputMaybe<ListComparableByteOperationFilterInput>;
  hideFromDelivery?: InputMaybe<BooleanOperationFilterInput>;
  jobTitle?: InputMaybe<StringOperationFilterInput>;
  lastActivityDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  lastCustomerId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  lastLockedOutDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  lastLoginDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  lastName?: InputMaybe<StringOperationFilterInput>;
  maxSpendByDays?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  maxSpendDays?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  mobile?: InputMaybe<StringOperationFilterInput>;
  modified?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<UserDetailFilterInput>>;
  orderCredit?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  pageSize?: InputMaybe<ComparableInt32OperationFilterInput>;
  password?: InputMaybe<StringOperationFilterInput>;
  passwordAnswer?: InputMaybe<StringOperationFilterInput>;
  phone?: InputMaybe<StringOperationFilterInput>;
  products?: InputMaybe<ListFilterInputTypeOfProductFilterInput>;
  projectStageAttendees?: InputMaybe<ListFilterInputTypeOfProjectStageAttendeeFilterInput>;
  projectStages?: InputMaybe<ListFilterInputTypeOfProjectStageFilterInput>;
  projectVisibilities?: InputMaybe<ListFilterInputTypeOfProjectVisibilityFilterInput>;
  purgeDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  recipientData?: InputMaybe<ListFilterInputTypeOfRecipientDataFilterInput>;
  recordTimestamp?: InputMaybe<ListComparableByteOperationFilterInput>;
  removed?: InputMaybe<BooleanOperationFilterInput>;
  reportSchedules?: InputMaybe<ListFilterInputTypeOfReportScheduleFilterInput>;
  resetExpiry?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  resetToken?: InputMaybe<ListComparableByteOperationFilterInput>;
  role?: InputMaybe<RoleFilterInput>;
  roleId?: InputMaybe<ComparableInt32OperationFilterInput>;
  sQuestionId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  salesForceId?: InputMaybe<StringOperationFilterInput>;
  sapContactId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  siteMapOverrides?: InputMaybe<ListFilterInputTypeOfSiteMapOverrideFilterInput>;
  skin?: InputMaybe<SkinFilterInput>;
  skinId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  skinMobileId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  smsDetails?: InputMaybe<ListFilterInputTypeOfSmsDetailFilterInput>;
  smsRequestApproverSecondUsers?: InputMaybe<ListFilterInputTypeOfSmsRequestFilterInput>;
  smsRequestApproverUsers?: InputMaybe<ListFilterInputTypeOfSmsRequestFilterInput>;
  smsRequestUserCreateds?: InputMaybe<ListFilterInputTypeOfSmsRequestFilterInput>;
  smsTemplateUserCreateds?: InputMaybe<ListFilterInputTypeOfSmsTemplateFilterInput>;
  smsTemplateUserModifieds?: InputMaybe<ListFilterInputTypeOfSmsTemplateFilterInput>;
  storedCookie?: InputMaybe<ComparableNullableOfGuidOperationFilterInput>;
  storedCookieExpirydate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  team?: InputMaybe<TeamFilterInput>;
  teamId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  type?: InputMaybe<UserTypeFilterInput>;
  typeId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  userCreatedId?: InputMaybe<ComparableInt32OperationFilterInput>;
  userCreditByCategories?: InputMaybe<ListFilterInputTypeOfUserCreditByCategoryFilterInput>;
  userId?: InputMaybe<ComparableInt32OperationFilterInput>;
  userModifiedId?: InputMaybe<ComparableInt32OperationFilterInput>;
  userProfiles?: InputMaybe<ListFilterInputTypeOfUserProfileFilterInput>;
  userSpendByCategories?: InputMaybe<ListFilterInputTypeOfUserSpendByCategoryFilterInput>;
  userTheme?: InputMaybe<StringOperationFilterInput>;
  username?: InputMaybe<StringOperationFilterInput>;
  zeescapeJobDetails?: InputMaybe<ListFilterInputTypeOfZeescapeJobDetailFilterInput>;
};

export type UserDetailSortInput = {
  active?: InputMaybe<SortEnumType>;
  additionalInfo?: InputMaybe<SortEnumType>;
  awaitingApproval?: InputMaybe<SortEnumType>;
  billingAddress?: InputMaybe<AddressSortInput>;
  billingAddressId?: InputMaybe<SortEnumType>;
  businessLevel?: InputMaybe<BusinessLevelSortInput>;
  businessLevelId?: InputMaybe<SortEnumType>;
  companyName?: InputMaybe<SortEnumType>;
  created?: InputMaybe<SortEnumType>;
  creationDate?: InputMaybe<SortEnumType>;
  crmguid?: InputMaybe<SortEnumType>;
  defaultUser?: InputMaybe<SortEnumType>;
  deliveryAddress?: InputMaybe<AddressSortInput>;
  deliveryAddressId?: InputMaybe<SortEnumType>;
  email?: InputMaybe<SortEnumType>;
  emailAlertDate?: InputMaybe<SortEnumType>;
  firstName?: InputMaybe<SortEnumType>;
  hash?: InputMaybe<SortEnumType>;
  hideFromDelivery?: InputMaybe<SortEnumType>;
  jobTitle?: InputMaybe<SortEnumType>;
  lastActivityDate?: InputMaybe<SortEnumType>;
  lastCustomerId?: InputMaybe<SortEnumType>;
  lastLockedOutDate?: InputMaybe<SortEnumType>;
  lastLoginDate?: InputMaybe<SortEnumType>;
  lastName?: InputMaybe<SortEnumType>;
  maxSpendByDays?: InputMaybe<SortEnumType>;
  maxSpendDays?: InputMaybe<SortEnumType>;
  mobile?: InputMaybe<SortEnumType>;
  modified?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  orderCredit?: InputMaybe<SortEnumType>;
  pageSize?: InputMaybe<SortEnumType>;
  password?: InputMaybe<SortEnumType>;
  passwordAnswer?: InputMaybe<SortEnumType>;
  phone?: InputMaybe<SortEnumType>;
  purgeDate?: InputMaybe<SortEnumType>;
  removed?: InputMaybe<SortEnumType>;
  resetExpiry?: InputMaybe<SortEnumType>;
  role?: InputMaybe<RoleSortInput>;
  roleId?: InputMaybe<SortEnumType>;
  sQuestionId?: InputMaybe<SortEnumType>;
  salesForceId?: InputMaybe<SortEnumType>;
  sapContactId?: InputMaybe<SortEnumType>;
  skin?: InputMaybe<SkinSortInput>;
  skinId?: InputMaybe<SortEnumType>;
  skinMobileId?: InputMaybe<SortEnumType>;
  storedCookie?: InputMaybe<SortEnumType>;
  storedCookieExpirydate?: InputMaybe<SortEnumType>;
  team?: InputMaybe<TeamSortInput>;
  teamId?: InputMaybe<SortEnumType>;
  type?: InputMaybe<UserTypeSortInput>;
  typeId?: InputMaybe<SortEnumType>;
  userCreatedId?: InputMaybe<SortEnumType>;
  userId?: InputMaybe<SortEnumType>;
  userModifiedId?: InputMaybe<SortEnumType>;
  userTheme?: InputMaybe<SortEnumType>;
  username?: InputMaybe<SortEnumType>;
};

export type UserProfileFilterInput = {
  and?: InputMaybe<Array<UserProfileFilterInput>>;
  categoryDockState?: InputMaybe<StringOperationFilterInput>;
  cultureName?: InputMaybe<StringOperationFilterInput>;
  defaultSort?: InputMaybe<StringOperationFilterInput>;
  lastSelectedCategory?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  lastSelectedOrderType?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  optionsDockState?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<UserProfileFilterInput>>;
  orderDockState?: InputMaybe<StringOperationFilterInput>;
  pageSize?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  productsDisplayMode?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  rowVersion?: InputMaybe<ListComparableByteOperationFilterInput>;
  searchDockState?: InputMaybe<StringOperationFilterInput>;
  user?: InputMaybe<UserDetailFilterInput>;
  userId?: InputMaybe<ComparableInt32OperationFilterInput>;
  userProfileId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type UserSecurityQuestion = {
  __typename?: 'UserSecurityQuestion';
  sQuestion: Scalars['String'];
  sQuestionId: Scalars['Int'];
};

export type UserSpendByCategory = {
  __typename?: 'UserSpendByCategory';
  catSpendLimitId: Scalars['Int'];
  category: Category;
  categoryId: Scalars['Int'];
  maxLimitQuantityForDays: Scalars['Int'];
  maxSpendForDays: Scalars['Decimal'];
  numberOfDays: Scalars['Int'];
  rowVersion: Array<Scalars['ByteArray']>;
  user: UserType;
  userId: Scalars['Int'];
};

export type UserSpendByCategoryFilterInput = {
  and?: InputMaybe<Array<UserSpendByCategoryFilterInput>>;
  catSpendLimitId?: InputMaybe<ComparableInt32OperationFilterInput>;
  category?: InputMaybe<CategoryFilterInput>;
  categoryId?: InputMaybe<ComparableInt32OperationFilterInput>;
  maxLimitQuantityForDays?: InputMaybe<ComparableInt32OperationFilterInput>;
  maxSpendForDays?: InputMaybe<ComparableDecimalOperationFilterInput>;
  numberOfDays?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<UserSpendByCategoryFilterInput>>;
  rowVersion?: InputMaybe<ListComparableByteOperationFilterInput>;
  user?: InputMaybe<UserDetailFilterInput>;
  userId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

/** Represents a WaiveNET user. */
export type UserType = {
  __typename?: 'UserType';
  /** This is the business level to which the user belongs to. */
  businessLevel?: Maybe<BusinessLevel>;
  /** Represents the unique ID of the business level which the user belongs to. */
  businessLevelId: Scalars['Int'];
  /** Represents the user's Customer */
  customer?: Maybe<Customer>;
  /** Represents the allowed features of the user's Customer */
  customerFeatures?: Maybe<Array<TsuCustomerFeature>>;
  /** Represents the theme of the user's Customer */
  customerTheme: TsunamiTheme;
  /** Represents the user's email. */
  email?: Maybe<Scalars['String']>;
  /** Represents the user's favorite products */
  favorites?: Maybe<Favorite>;
  /** Represents the first name of the user. */
  firstName: Scalars['String'];
  /** Represents the last name of the user. */
  lastName: Scalars['String'];
  /** Represents the user's mobile number. */
  mobile?: Maybe<Scalars['String']>;
  /** Represents the full name of the user. */
  name?: Maybe<Scalars['String']>;
  /** Represents the user's current credit. */
  orderCredit?: Maybe<Scalars['Decimal']>;
  /** Represents the user's phone number. */
  phone?: Maybe<Scalars['String']>;
  /** This is the role to which the user belongs to. */
  role?: Maybe<RoleType>;
  /** Represents the unique ID of the role which the user belongs to. */
  roleId: Scalars['Int'];
  /** Represents the user's shopping cart */
  shoppingCart?: Maybe<ShoppingCartType>;
  /** This is the list of sitemaps which the user has access to. */
  sitemaps?: Maybe<Array<SiteMap>>;
  /** Represents the unique ID for the user. */
  userId: Scalars['Int'];
  /** Represents the user's specified username. */
  username: Scalars['String'];
};

export type UserTypeFilterInput = {
  and?: InputMaybe<Array<UserTypeFilterInput>>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<UserTypeFilterInput>>;
  userDetails?: InputMaybe<ListFilterInputTypeOfUserDetailFilterInput>;
};

export type UserTypeSortInput = {
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
};

/** Represents the input to punchout the page to leagcy waivenet. */
export type WaivenetPunchoutInput = {
  /** Represnets where it goes. */
  destination: Scalars['String'];
  /** set where it should go back when punchout is done. */
  returnURL: Scalars['String'];
};

export type WaivenetPunchoutPayload = {
  __typename?: 'WaivenetPunchoutPayload';
  link: Scalars['String'];
  success: Scalars['Boolean'];
};

export type Warehouse = {
  __typename?: 'Warehouse';
  name: Scalars['String'];
  warehouseId: Scalars['Int'];
  wmsLocations: Array<WmsLocation>;
};

export type WarehouseFilterInput = {
  and?: InputMaybe<Array<WarehouseFilterInput>>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<WarehouseFilterInput>>;
  warehouseId?: InputMaybe<ComparableInt32OperationFilterInput>;
  wmsLocations?: InputMaybe<ListFilterInputTypeOfWmsLocationFilterInput>;
};

export type WmsAssignedNumber = {
  __typename?: 'WmsAssignedNumber';
  active: Scalars['Boolean'];
  assignedId: Scalars['Int'];
  created: Scalars['DateTime'];
  modified: Scalars['DateTime'];
  numberFinish?: Maybe<Scalars['Long']>;
  numberStart: Scalars['Long'];
  orderLine: OrderLineType;
  orderLineId: Scalars['Int'];
  purgeDate?: Maybe<Scalars['DateTime']>;
  quantity: Scalars['Int'];
  removed: Scalars['Boolean'];
  userModifiedId: Scalars['Int'];
};

export type WmsAssignedNumberFilterInput = {
  active?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<WmsAssignedNumberFilterInput>>;
  assignedId?: InputMaybe<ComparableInt32OperationFilterInput>;
  created?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  modified?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  numberFinish?: InputMaybe<ComparableNullableOfInt64OperationFilterInput>;
  numberStart?: InputMaybe<ComparableInt64OperationFilterInput>;
  or?: InputMaybe<Array<WmsAssignedNumberFilterInput>>;
  orderLine?: InputMaybe<OrderLineFilterInput>;
  orderLineId?: InputMaybe<ComparableInt32OperationFilterInput>;
  purgeDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  quantity?: InputMaybe<ComparableInt32OperationFilterInput>;
  removed?: InputMaybe<BooleanOperationFilterInput>;
  userModifiedId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type WmsCyclicProduct = {
  __typename?: 'WmsCyclicProduct';
  created: Scalars['DateTime'];
  cyclicProductId: Scalars['Int'];
  failedCountEmailNotify?: Maybe<Scalars['String']>;
  modified: Scalars['DateTime'];
  product: ProductType;
  productId: Scalars['Int'];
  rowVersion: Array<Scalars['ByteArray']>;
  stocktakeStatus: WmsStocktakeStatus;
  stocktakeStatusId: Scalars['Int'];
  wmsCyclicStockCounts: Array<WmsCyclicStockCount>;
};

export type WmsCyclicProductFilterInput = {
  and?: InputMaybe<Array<WmsCyclicProductFilterInput>>;
  created?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  cyclicProductId?: InputMaybe<ComparableInt32OperationFilterInput>;
  failedCountEmailNotify?: InputMaybe<StringOperationFilterInput>;
  modified?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<WmsCyclicProductFilterInput>>;
  product?: InputMaybe<ProductFilterInput>;
  productId?: InputMaybe<ComparableInt32OperationFilterInput>;
  rowVersion?: InputMaybe<ListComparableByteOperationFilterInput>;
  stocktakeStatus?: InputMaybe<WmsStocktakeStatusFilterInput>;
  stocktakeStatusId?: InputMaybe<ComparableInt32OperationFilterInput>;
  wmsCyclicStockCounts?: InputMaybe<ListFilterInputTypeOfWmsCyclicStockCountFilterInput>;
};

export type WmsCyclicStockCount = {
  __typename?: 'WmsCyclicStockCount';
  active: Scalars['Boolean'];
  created: Scalars['DateTime'];
  cyclicCountId: Scalars['Int'];
  cyclicProduct: WmsCyclicProduct;
  cyclicProductId: Scalars['Int'];
  modified: Scalars['DateTime'];
  newQuantity?: Maybe<Scalars['Int']>;
  oldQuantity: Scalars['Int'];
  reCount2Quantity?: Maybe<Scalars['Int']>;
  reCount2Variance?: Maybe<Scalars['Int']>;
  reCountQuantity?: Maybe<Scalars['Int']>;
  reCountVariance?: Maybe<Scalars['Int']>;
  rowVersion: Array<Scalars['ByteArray']>;
  stockQuantity: WmsStockQuantity;
  stockQuantityId: Scalars['Int'];
  stocktakeStatus: WmsStocktakeStatus;
  stocktakeStatusId: Scalars['Int'];
  userCreatedId: Scalars['Int'];
  userModifiedId: Scalars['Int'];
  variance?: Maybe<Scalars['Int']>;
};

export type WmsCyclicStockCountFilterInput = {
  active?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<WmsCyclicStockCountFilterInput>>;
  created?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  cyclicCountId?: InputMaybe<ComparableInt32OperationFilterInput>;
  cyclicProduct?: InputMaybe<WmsCyclicProductFilterInput>;
  cyclicProductId?: InputMaybe<ComparableInt32OperationFilterInput>;
  modified?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  newQuantity?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  oldQuantity?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<WmsCyclicStockCountFilterInput>>;
  reCount2Quantity?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  reCount2Variance?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  reCountQuantity?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  reCountVariance?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  rowVersion?: InputMaybe<ListComparableByteOperationFilterInput>;
  stockQuantity?: InputMaybe<WmsStockQuantityFilterInput>;
  stockQuantityId?: InputMaybe<ComparableInt32OperationFilterInput>;
  stocktakeStatus?: InputMaybe<WmsStocktakeStatusFilterInput>;
  stocktakeStatusId?: InputMaybe<ComparableInt32OperationFilterInput>;
  userCreatedId?: InputMaybe<ComparableInt32OperationFilterInput>;
  userModifiedId?: InputMaybe<ComparableInt32OperationFilterInput>;
  variance?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
};

export type WmsLocation = {
  __typename?: 'WmsLocation';
  active: Scalars['Boolean'];
  aisle: Scalars['String'];
  col: Scalars['Int'];
  created: Scalars['DateTime'];
  height: Scalars['Decimal'];
  length: Scalars['Decimal'];
  locationId: Scalars['Int'];
  modified: Scalars['DateTime'];
  name: Scalars['String'];
  pickface: Scalars['Int'];
  purgeDate?: Maybe<Scalars['DateTime']>;
  removed: Scalars['Boolean'];
  row: Scalars['String'];
  slot: Scalars['Int'];
  userCreatedId: Scalars['Int'];
  userModifiedId: Scalars['Int'];
  volumn: Scalars['Decimal'];
  warehouse: Warehouse;
  warehouseId: Scalars['Int'];
  width: Scalars['Decimal'];
  wmsPickedStocks: Array<WmsPickedStock>;
  wmsRgareceiveds: Array<WmsRgareceived>;
  wmsStockQuantities: Array<WmsStockQuantity>;
  zone: Scalars['Int'];
};

export type WmsLocationFilterInput = {
  active?: InputMaybe<BooleanOperationFilterInput>;
  aisle?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<WmsLocationFilterInput>>;
  col?: InputMaybe<ComparableInt32OperationFilterInput>;
  created?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  height?: InputMaybe<ComparableDecimalOperationFilterInput>;
  length?: InputMaybe<ComparableDecimalOperationFilterInput>;
  locationId?: InputMaybe<ComparableInt32OperationFilterInput>;
  modified?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<WmsLocationFilterInput>>;
  pickface?: InputMaybe<ComparableInt32OperationFilterInput>;
  purgeDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  removed?: InputMaybe<BooleanOperationFilterInput>;
  row?: InputMaybe<StringOperationFilterInput>;
  slot?: InputMaybe<ComparableInt32OperationFilterInput>;
  userCreatedId?: InputMaybe<ComparableInt32OperationFilterInput>;
  userModifiedId?: InputMaybe<ComparableInt32OperationFilterInput>;
  volumn?: InputMaybe<ComparableDecimalOperationFilterInput>;
  warehouse?: InputMaybe<WarehouseFilterInput>;
  warehouseId?: InputMaybe<ComparableInt32OperationFilterInput>;
  width?: InputMaybe<ComparableDecimalOperationFilterInput>;
  wmsPickedStocks?: InputMaybe<ListFilterInputTypeOfWmsPickedStockFilterInput>;
  wmsRgareceiveds?: InputMaybe<ListFilterInputTypeOfWmsRgareceivedFilterInput>;
  wmsStockQuantities?: InputMaybe<ListFilterInputTypeOfWmsStockQuantityFilterInput>;
  zone?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type WmsPickDetail = {
  __typename?: 'WmsPickDetail';
  lastPrintDatetTime?: Maybe<Scalars['DateTime']>;
  orderShip: OrderShippingType;
  orderShipId: Scalars['Int'];
  pickDetailId: Scalars['Int'];
  pickList: WmsPickList;
  pickListId: Scalars['Int'];
  pickMethod: Scalars['String'];
  printed: Scalars['Boolean'];
  wmsPickPdftype: WmsPickPdftype;
  wmsPickPdftypeId: Scalars['Int'];
};

export type WmsPickDetailFilterInput = {
  and?: InputMaybe<Array<WmsPickDetailFilterInput>>;
  lastPrintDatetTime?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<WmsPickDetailFilterInput>>;
  orderShip?: InputMaybe<OrderShippingFilterInput>;
  orderShipId?: InputMaybe<ComparableInt32OperationFilterInput>;
  pickDetailId?: InputMaybe<ComparableInt32OperationFilterInput>;
  pickList?: InputMaybe<WmsPickListFilterInput>;
  pickListId?: InputMaybe<ComparableInt32OperationFilterInput>;
  pickMethod?: InputMaybe<StringOperationFilterInput>;
  printed?: InputMaybe<BooleanOperationFilterInput>;
  wmsPickPdftype?: InputMaybe<WmsPickPdftypeFilterInput>;
  wmsPickPdftypeId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type WmsPickList = {
  __typename?: 'WmsPickList';
  bulkPick: Scalars['Boolean'];
  created: Scalars['DateTime'];
  externalId?: Maybe<Scalars['String']>;
  pickListId: Scalars['Int'];
  printType: Scalars['Int'];
  reprint: Scalars['Boolean'];
  userModifiedId: Scalars['Int'];
  wmsPickDetails: Array<WmsPickDetail>;
};

export type WmsPickListFilterInput = {
  and?: InputMaybe<Array<WmsPickListFilterInput>>;
  bulkPick?: InputMaybe<BooleanOperationFilterInput>;
  created?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  externalId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<WmsPickListFilterInput>>;
  pickListId?: InputMaybe<ComparableInt32OperationFilterInput>;
  printType?: InputMaybe<ComparableInt32OperationFilterInput>;
  reprint?: InputMaybe<BooleanOperationFilterInput>;
  userModifiedId?: InputMaybe<ComparableInt32OperationFilterInput>;
  wmsPickDetails?: InputMaybe<ListFilterInputTypeOfWmsPickDetailFilterInput>;
};

export type WmsPickPdftype = {
  __typename?: 'WmsPickPdftype';
  categories: Array<Category>;
  letterhead: Scalars['Boolean'];
  letterheadType?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  wmsPickDetails: Array<WmsPickDetail>;
  wmsPickPdftypeId: Scalars['Int'];
};

export type WmsPickPdftypeFilterInput = {
  and?: InputMaybe<Array<WmsPickPdftypeFilterInput>>;
  categories?: InputMaybe<ListFilterInputTypeOfCategoryFilterInput>;
  letterhead?: InputMaybe<BooleanOperationFilterInput>;
  letterheadType?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<WmsPickPdftypeFilterInput>>;
  wmsPickDetails?: InputMaybe<ListFilterInputTypeOfWmsPickDetailFilterInput>;
  wmsPickPdftypeId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type WmsPickPdftypeSortInput = {
  letterhead?: InputMaybe<SortEnumType>;
  letterheadType?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  wmsPickPdftypeId?: InputMaybe<SortEnumType>;
};

export type WmsPickedStock = {
  __typename?: 'WmsPickedStock';
  created: Scalars['DateTime'];
  despatched?: Maybe<Scalars['Boolean']>;
  location: WmsLocation;
  locationId: Scalars['Int'];
  locationName: Scalars['String'];
  orderLine: OrderLineType;
  orderLineId: Scalars['Int'];
  pickedStockId: Scalars['Int'];
  picklistId?: Maybe<Scalars['Int']>;
  quantity: Scalars['Int'];
  userCreatedId: Scalars['Int'];
};

export type WmsPickedStockFilterInput = {
  and?: InputMaybe<Array<WmsPickedStockFilterInput>>;
  created?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  despatched?: InputMaybe<BooleanOperationFilterInput>;
  location?: InputMaybe<WmsLocationFilterInput>;
  locationId?: InputMaybe<ComparableInt32OperationFilterInput>;
  locationName?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<WmsPickedStockFilterInput>>;
  orderLine?: InputMaybe<OrderLineFilterInput>;
  orderLineId?: InputMaybe<ComparableInt32OperationFilterInput>;
  pickedStockId?: InputMaybe<ComparableInt32OperationFilterInput>;
  picklistId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  quantity?: InputMaybe<ComparableInt32OperationFilterInput>;
  userCreatedId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type WmsRga = {
  __typename?: 'WmsRga';
  category?: Maybe<Scalars['String']>;
  categoryId: Scalars['Int'];
  closedOffFromAddingQtyto: Scalars['Boolean'];
  created: Scalars['DateTime'];
  crmjobNo?: Maybe<Scalars['Int']>;
  crmsyncMessage?: Maybe<Scalars['String']>;
  customer?: Maybe<Customer>;
  customerId?: Maybe<Scalars['Int']>;
  customerName: Scalars['String'];
  customerReferenceNumber?: Maybe<Scalars['String']>;
  dateArrived?: Maybe<Scalars['DateTime']>;
  destructionDate?: Maybe<Scalars['DateTime']>;
  emailNotify?: Maybe<Scalars['String']>;
  eta: Scalars['DateTime'];
  expectedQuantity: Scalars['Int'];
  holdingLocations?: Maybe<Scalars['String']>;
  imageUpload?: Maybe<UploadedFile>;
  imageUploadId?: Maybe<Scalars['Int']>;
  modified: Scalars['DateTime'];
  notes?: Maybe<Scalars['String']>;
  orderLines: Array<OrderLineType>;
  procured: Scalars['Boolean'];
  product?: Maybe<ProductType>;
  productCode?: Maybe<Scalars['String']>;
  productDescription?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['Int']>;
  productName: Scalars['String'];
  productSellTotal?: Maybe<Scalars['Decimal']>;
  reOrderLevel: Scalars['Int'];
  receivedQuantity?: Maybe<Scalars['Int']>;
  removed: Scalars['Boolean'];
  rgaId: Scalars['Int'];
  rgaStatus: WmsRgastatus;
  rgaStatusId: Scalars['Int'];
  rgaType: WmsRgatype;
  rgaTypeId: Scalars['Int'];
  rowVersion: Array<Scalars['ByteArray']>;
  sendToCrm: Scalars['Boolean'];
  subCategory?: Maybe<Scalars['String']>;
  supplierAddress?: Maybe<Address>;
  supplierAddressId?: Maybe<Scalars['Int']>;
  supplierName?: Maybe<Scalars['String']>;
  unitSell?: Maybe<Scalars['Decimal']>;
  uomdesc: Scalars['String'];
  uomid?: Maybe<Scalars['Int']>;
  userCreatedId: Scalars['Int'];
  userModifiedId: Scalars['Int'];
  version?: Maybe<Scalars['String']>;
  wmsRgareceiveds: Array<WmsRgareceived>;
};

export type WmsRgaFilterInput = {
  and?: InputMaybe<Array<WmsRgaFilterInput>>;
  category?: InputMaybe<StringOperationFilterInput>;
  categoryId?: InputMaybe<ComparableInt32OperationFilterInput>;
  closedOffFromAddingQtyto?: InputMaybe<BooleanOperationFilterInput>;
  created?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  crmjobNo?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  crmsyncMessage?: InputMaybe<StringOperationFilterInput>;
  customer?: InputMaybe<CustomerFilterInput>;
  customerId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  customerName?: InputMaybe<StringOperationFilterInput>;
  customerReferenceNumber?: InputMaybe<StringOperationFilterInput>;
  dateArrived?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  destructionDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  emailNotify?: InputMaybe<StringOperationFilterInput>;
  eta?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  expectedQuantity?: InputMaybe<ComparableInt32OperationFilterInput>;
  holdingLocations?: InputMaybe<StringOperationFilterInput>;
  imageUpload?: InputMaybe<UploadedFileFilterInput>;
  imageUploadId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  modified?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  notes?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<WmsRgaFilterInput>>;
  orderLines?: InputMaybe<ListFilterInputTypeOfOrderLineFilterInput>;
  procured?: InputMaybe<BooleanOperationFilterInput>;
  product?: InputMaybe<ProductFilterInput>;
  productCode?: InputMaybe<StringOperationFilterInput>;
  productDescription?: InputMaybe<StringOperationFilterInput>;
  productId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  productName?: InputMaybe<StringOperationFilterInput>;
  productSellTotal?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  reOrderLevel?: InputMaybe<ComparableInt32OperationFilterInput>;
  receivedQuantity?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  removed?: InputMaybe<BooleanOperationFilterInput>;
  rgaId?: InputMaybe<ComparableInt32OperationFilterInput>;
  rgaStatus?: InputMaybe<WmsRgastatusFilterInput>;
  rgaStatusId?: InputMaybe<ComparableInt32OperationFilterInput>;
  rgaType?: InputMaybe<WmsRgatypeFilterInput>;
  rgaTypeId?: InputMaybe<ComparableInt32OperationFilterInput>;
  rowVersion?: InputMaybe<ListComparableByteOperationFilterInput>;
  sendToCrm?: InputMaybe<BooleanOperationFilterInput>;
  subCategory?: InputMaybe<StringOperationFilterInput>;
  supplierAddress?: InputMaybe<AddressFilterInput>;
  supplierAddressId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  supplierName?: InputMaybe<StringOperationFilterInput>;
  unitSell?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  uomdesc?: InputMaybe<StringOperationFilterInput>;
  uomid?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  userCreatedId?: InputMaybe<ComparableInt32OperationFilterInput>;
  userModifiedId?: InputMaybe<ComparableInt32OperationFilterInput>;
  version?: InputMaybe<StringOperationFilterInput>;
  wmsRgareceiveds?: InputMaybe<ListFilterInputTypeOfWmsRgareceivedFilterInput>;
};

export type WmsRgareceived = {
  __typename?: 'WmsRgareceived';
  created: Scalars['DateTime'];
  expectedQuantity: Scalars['Int'];
  location?: Maybe<WmsLocation>;
  locationId?: Maybe<Scalars['Int']>;
  receiveId: Scalars['Int'];
  receivedQuantity: Scalars['Int'];
  rga: WmsRga;
  rgaid: Scalars['Int'];
  userModifiedId: Scalars['Int'];
};

export type WmsRgareceivedFilterInput = {
  and?: InputMaybe<Array<WmsRgareceivedFilterInput>>;
  created?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  expectedQuantity?: InputMaybe<ComparableInt32OperationFilterInput>;
  location?: InputMaybe<WmsLocationFilterInput>;
  locationId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  or?: InputMaybe<Array<WmsRgareceivedFilterInput>>;
  receiveId?: InputMaybe<ComparableInt32OperationFilterInput>;
  receivedQuantity?: InputMaybe<ComparableInt32OperationFilterInput>;
  rga?: InputMaybe<WmsRgaFilterInput>;
  rgaid?: InputMaybe<ComparableInt32OperationFilterInput>;
  userModifiedId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type WmsRgastatus = {
  __typename?: 'WmsRgastatus';
  name: Scalars['String'];
  rgaStatusId: Scalars['Int'];
  sortOrder: Scalars['Int'];
  wmsRgas: Array<WmsRga>;
};

export type WmsRgastatusFilterInput = {
  and?: InputMaybe<Array<WmsRgastatusFilterInput>>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<WmsRgastatusFilterInput>>;
  rgaStatusId?: InputMaybe<ComparableInt32OperationFilterInput>;
  sortOrder?: InputMaybe<ComparableInt32OperationFilterInput>;
  wmsRgas?: InputMaybe<ListFilterInputTypeOfWmsRgaFilterInput>;
};

export type WmsRgatype = {
  __typename?: 'WmsRgatype';
  name: Scalars['String'];
  rgaTypeId: Scalars['Int'];
  wmsRgas: Array<WmsRga>;
};

export type WmsRgatypeFilterInput = {
  and?: InputMaybe<Array<WmsRgatypeFilterInput>>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<WmsRgatypeFilterInput>>;
  rgaTypeId?: InputMaybe<ComparableInt32OperationFilterInput>;
  wmsRgas?: InputMaybe<ListFilterInputTypeOfWmsRgaFilterInput>;
};

export type WmsSerialNumberFilterInput = {
  active?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<WmsSerialNumberFilterInput>>;
  created?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  modified?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  numberFinish?: InputMaybe<ComparableNullableOfInt64OperationFilterInput>;
  numberStart?: InputMaybe<ComparableInt64OperationFilterInput>;
  or?: InputMaybe<Array<WmsSerialNumberFilterInput>>;
  product?: InputMaybe<ProductFilterInput>;
  productId?: InputMaybe<ComparableInt32OperationFilterInput>;
  purgeDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  quantity?: InputMaybe<ComparableInt32OperationFilterInput>;
  removed?: InputMaybe<BooleanOperationFilterInput>;
  serialId?: InputMaybe<ComparableInt32OperationFilterInput>;
  userModifiedId?: InputMaybe<ComparableInt32OperationFilterInput>;
};

export type WmsStockQuantity = {
  __typename?: 'WmsStockQuantity';
  active: Scalars['Boolean'];
  created: Scalars['DateTime'];
  emptyDate?: Maybe<Scalars['DateTime']>;
  location: WmsLocation;
  locationId: Scalars['Int'];
  modified: Scalars['DateTime'];
  product: ProductType;
  productId: Scalars['Int'];
  quantity: Scalars['Int'];
  rowVersion: Array<Scalars['ByteArray']>;
  stockQuantityId: Scalars['Int'];
  userModifiedId: Scalars['Int'];
  wmsCyclicStockCounts: Array<WmsCyclicStockCount>;
};

export type WmsStockQuantityFilterInput = {
  active?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<WmsStockQuantityFilterInput>>;
  created?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  emptyDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  location?: InputMaybe<WmsLocationFilterInput>;
  locationId?: InputMaybe<ComparableInt32OperationFilterInput>;
  modified?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  or?: InputMaybe<Array<WmsStockQuantityFilterInput>>;
  product?: InputMaybe<ProductFilterInput>;
  productId?: InputMaybe<ComparableInt32OperationFilterInput>;
  quantity?: InputMaybe<ComparableInt32OperationFilterInput>;
  rowVersion?: InputMaybe<ListComparableByteOperationFilterInput>;
  stockQuantityId?: InputMaybe<ComparableInt32OperationFilterInput>;
  userModifiedId?: InputMaybe<ComparableInt32OperationFilterInput>;
  wmsCyclicStockCounts?: InputMaybe<ListFilterInputTypeOfWmsCyclicStockCountFilterInput>;
};

export type WmsStocktakeStatus = {
  __typename?: 'WmsStocktakeStatus';
  name: Scalars['String'];
  stocktakeStatusId: Scalars['Int'];
  wmsCyclicProducts: Array<WmsCyclicProduct>;
  wmsCyclicStockCounts: Array<WmsCyclicStockCount>;
};

export type WmsStocktakeStatusFilterInput = {
  and?: InputMaybe<Array<WmsStocktakeStatusFilterInput>>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<WmsStocktakeStatusFilterInput>>;
  stocktakeStatusId?: InputMaybe<ComparableInt32OperationFilterInput>;
  wmsCyclicProducts?: InputMaybe<ListFilterInputTypeOfWmsCyclicProductFilterInput>;
  wmsCyclicStockCounts?: InputMaybe<ListFilterInputTypeOfWmsCyclicStockCountFilterInput>;
};

export type ZeecapeJobDetailsv2 = {
  __typename?: 'ZeecapeJobDetailsv2';
  activity?: Maybe<Activity>;
  activityId?: Maybe<Scalars['Int']>;
  addedManually: Scalars['Boolean'];
  additionalFee?: Maybe<Scalars['Decimal']>;
  anyObstacles?: Maybe<Scalars['String']>;
  ceilingHeight?: Maybe<Scalars['Decimal']>;
  contitionOfSurfaceToBePrintedOn?: Maybe<Scalars['String']>;
  created: Scalars['DateTime'];
  dateAccepted?: Maybe<Scalars['DateTime']>;
  dateApplied?: Maybe<Scalars['DateTime']>;
  dimensionX: Scalars['Decimal'];
  dimensionY: Scalars['Decimal'];
  gpslat?: Maybe<Scalars['Float']>;
  gpslong?: Maybe<Scalars['Float']>;
  id: Scalars['Int'];
  imageAccessInfo?: Maybe<Scalars['String']>;
  imageSizeRequiredSquareMetre?: Maybe<Scalars['Decimal']>;
  imageToApplyDocumentId?: Maybe<Scalars['Int']>;
  jobApplicationSellPrice?: Maybe<Scalars['Decimal']>;
  jobDetailId: Scalars['Int'];
  keyAccessRequirement?: Maybe<Scalars['String']>;
  machineCount?: Maybe<Scalars['Int']>;
  operatorCost?: Maybe<Scalars['Decimal']>;
  orderLineId?: Maybe<Scalars['Int']>;
  penaltyFeeGlassPreperation?: Maybe<Scalars['Decimal']>;
  perSquareMetrePrice?: Maybe<Scalars['Decimal']>;
  photoOfSurfaceAfterApplicationDocumentId?: Maybe<Scalars['Int']>;
  photoOfSurfaceBeforeApplicationDocumentId?: Maybe<Scalars['Int']>;
  rowVersion: Array<Scalars['ByteArray']>;
  setupFee?: Maybe<Scalars['Decimal']>;
  signature?: Maybe<Scalars['String']>;
  signedBy?: Maybe<Scalars['String']>;
  siteAfterHoursFee?: Maybe<Scalars['Decimal']>;
  siteAfterHoursRequirement?: Maybe<Scalars['String']>;
  surfaceToBePrintedOn?: Maybe<Scalars['String']>;
};

export type ZeecapeJobDetailsv2FilterInput = {
  activity?: InputMaybe<ActivityFilterInput>;
  activityId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  addedManually?: InputMaybe<BooleanOperationFilterInput>;
  additionalFee?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  and?: InputMaybe<Array<ZeecapeJobDetailsv2FilterInput>>;
  anyObstacles?: InputMaybe<StringOperationFilterInput>;
  ceilingHeight?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  contitionOfSurfaceToBePrintedOn?: InputMaybe<StringOperationFilterInput>;
  created?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  dateAccepted?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  dateApplied?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  dimensionX?: InputMaybe<ComparableDecimalOperationFilterInput>;
  dimensionY?: InputMaybe<ComparableDecimalOperationFilterInput>;
  gpslat?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  gpslong?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  imageAccessInfo?: InputMaybe<StringOperationFilterInput>;
  imageSizeRequiredSquareMetre?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  imageToApplyDocumentId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  jobApplicationSellPrice?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  jobDetailId?: InputMaybe<ComparableInt32OperationFilterInput>;
  keyAccessRequirement?: InputMaybe<StringOperationFilterInput>;
  machineCount?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  operatorCost?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  or?: InputMaybe<Array<ZeecapeJobDetailsv2FilterInput>>;
  orderLineId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  penaltyFeeGlassPreperation?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  perSquareMetrePrice?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  photoOfSurfaceAfterApplicationDocumentId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  photoOfSurfaceBeforeApplicationDocumentId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  rowVersion?: InputMaybe<ListComparableByteOperationFilterInput>;
  setupFee?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  signature?: InputMaybe<StringOperationFilterInput>;
  signedBy?: InputMaybe<StringOperationFilterInput>;
  siteAfterHoursFee?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  siteAfterHoursRequirement?: InputMaybe<StringOperationFilterInput>;
  surfaceToBePrintedOn?: InputMaybe<StringOperationFilterInput>;
};

export type ZeescapeJob = {
  __typename?: 'ZeescapeJob';
  address1: Scalars['String'];
  address2?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  complete: Scalars['Boolean'];
  contactPerson: Scalars['String'];
  country: Scalars['String'];
  created: Scalars['DateTime'];
  customer: Customer;
  customerId: Scalars['Int'];
  email: Scalars['String'];
  fax?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  order?: Maybe<Order>;
  orderId?: Maybe<Scalars['Int']>;
  postcode: Scalars['String'];
  removed: Scalars['Boolean'];
  rowVersion: Array<Scalars['ByteArray']>;
  sellPrice?: Maybe<Scalars['Decimal']>;
  state: Scalars['String'];
  suburb: Scalars['String'];
  telephone?: Maybe<Scalars['String']>;
  userCreatedId: Scalars['Int'];
  zeescapeJobDetails: Array<ZeescapeJobDetail>;
};

export type ZeescapeJobApplication = {
  __typename?: 'ZeescapeJobApplication';
  addedManually: Scalars['Boolean'];
  additionalFee?: Maybe<Scalars['Decimal']>;
  anyObstacles?: Maybe<Scalars['String']>;
  ceilingHeight?: Maybe<Scalars['Decimal']>;
  contitionOfSurfaceToBePrintedOn?: Maybe<Scalars['String']>;
  created: Scalars['DateTime'];
  dateAccepted?: Maybe<Scalars['DateTime']>;
  dateApplied?: Maybe<Scalars['DateTime']>;
  dimensionX: Scalars['Decimal'];
  dimensionY: Scalars['Decimal'];
  gpslat?: Maybe<Scalars['Float']>;
  gpslong?: Maybe<Scalars['Float']>;
  id: Scalars['Int'];
  imageAccessInfo?: Maybe<Scalars['String']>;
  imageSizeRequiredSquareMetre?: Maybe<Scalars['Decimal']>;
  imageToApplyDocumentId?: Maybe<Scalars['Int']>;
  jobApplicationSellPrice?: Maybe<Scalars['Decimal']>;
  jobDetail: ZeescapeJobDetail;
  jobDetailId: Scalars['Int'];
  keyAccessRequirement?: Maybe<Scalars['String']>;
  machineCount?: Maybe<Scalars['Int']>;
  operatorCost?: Maybe<Scalars['Decimal']>;
  orderLine?: Maybe<OrderLineType>;
  orderLineId?: Maybe<Scalars['Int']>;
  penaltyFeeGlassPreperation?: Maybe<Scalars['Decimal']>;
  photoOfSurfaceAfterApplicationDocumentId?: Maybe<Scalars['Int']>;
  photoOfSurfaceBeforeApplicationDocumentId?: Maybe<Scalars['Int']>;
  photoOfWall?: Maybe<Array<Scalars['ByteArray']>>;
  rowVersion: Array<Scalars['ByteArray']>;
  siteAfterHoursFee?: Maybe<Scalars['Decimal']>;
  siteAfterHoursRequirement?: Maybe<Scalars['String']>;
  surfaceToBePrintedOn?: Maybe<Scalars['String']>;
};

export type ZeescapeJobApplicationFilterInput = {
  addedManually?: InputMaybe<BooleanOperationFilterInput>;
  additionalFee?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  and?: InputMaybe<Array<ZeescapeJobApplicationFilterInput>>;
  anyObstacles?: InputMaybe<StringOperationFilterInput>;
  ceilingHeight?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  contitionOfSurfaceToBePrintedOn?: InputMaybe<StringOperationFilterInput>;
  created?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  dateAccepted?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  dateApplied?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  dimensionX?: InputMaybe<ComparableDecimalOperationFilterInput>;
  dimensionY?: InputMaybe<ComparableDecimalOperationFilterInput>;
  gpslat?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  gpslong?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  imageAccessInfo?: InputMaybe<StringOperationFilterInput>;
  imageSizeRequiredSquareMetre?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  imageToApplyDocumentId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  jobApplicationSellPrice?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  jobDetail?: InputMaybe<ZeescapeJobDetailFilterInput>;
  jobDetailId?: InputMaybe<ComparableInt32OperationFilterInput>;
  keyAccessRequirement?: InputMaybe<StringOperationFilterInput>;
  machineCount?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  operatorCost?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  or?: InputMaybe<Array<ZeescapeJobApplicationFilterInput>>;
  orderLine?: InputMaybe<OrderLineFilterInput>;
  orderLineId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  penaltyFeeGlassPreperation?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  photoOfSurfaceAfterApplicationDocumentId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  photoOfSurfaceBeforeApplicationDocumentId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  photoOfWall?: InputMaybe<ListComparableByteOperationFilterInput>;
  rowVersion?: InputMaybe<ListComparableByteOperationFilterInput>;
  siteAfterHoursFee?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  siteAfterHoursRequirement?: InputMaybe<StringOperationFilterInput>;
  surfaceToBePrintedOn?: InputMaybe<StringOperationFilterInput>;
};

export type ZeescapeJobDetail = {
  __typename?: 'ZeescapeJobDetail';
  address1: Scalars['String'];
  address2?: Maybe<Scalars['String']>;
  completionDate?: Maybe<Scalars['DateTime']>;
  contactPersonIfDifferent?: Maybe<Scalars['String']>;
  country: Scalars['String'];
  dateAccepted?: Maybe<Scalars['DateTime']>;
  dateBooked?: Maybe<Scalars['DateTime']>;
  datePreferred: Scalars['DateTime'];
  email?: Maybe<Scalars['String']>;
  fax?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  job: ZeescapeJob;
  jobAcceptance: Scalars['Boolean'];
  jobId: Scalars['Int'];
  operator: UserType;
  operatorBusinessLevelId?: Maybe<Scalars['Int']>;
  operatorBusinessLevelNameList?: Maybe<Scalars['String']>;
  operatorEmailSent: Scalars['Boolean'];
  operatorId: Scalars['Int'];
  operatorNotes?: Maybe<Scalars['String']>;
  orderShip?: Maybe<OrderShippingType>;
  orderShipId?: Maybe<Scalars['Int']>;
  penaltyRatePerSquareMetre?: Maybe<Scalars['Decimal']>;
  postcode: Scalars['String'];
  preInspectionRequired: Scalars['Boolean'];
  remarks?: Maybe<Scalars['String']>;
  removed: Scalars['Boolean'];
  rowVersion: Array<Scalars['ByteArray']>;
  salesNotes?: Maybe<Scalars['String']>;
  sellPrice?: Maybe<Scalars['Decimal']>;
  setupFee?: Maybe<Scalars['Decimal']>;
  signedBy?: Maybe<Scalars['String']>;
  signiture?: Maybe<Array<Scalars['ByteArray']>>;
  siteAfterHoursRequirement?: Maybe<Scalars['String']>;
  siteGpslat?: Maybe<Scalars['Float']>;
  siteGpslong?: Maybe<Scalars['Float']>;
  state: Scalars['String'];
  status: ZeescapeJobStatus;
  statusId: Scalars['Int'];
  suburb: Scalars['String'];
  telephone?: Maybe<Scalars['String']>;
  zeescapeJobApplications: Array<ZeescapeJobApplication>;
};

export type ZeescapeJobDetailFilterInput = {
  address1?: InputMaybe<StringOperationFilterInput>;
  address2?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<ZeescapeJobDetailFilterInput>>;
  completionDate?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  contactPersonIfDifferent?: InputMaybe<StringOperationFilterInput>;
  country?: InputMaybe<StringOperationFilterInput>;
  dateAccepted?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  dateBooked?: InputMaybe<ComparableNullableOfDateTimeOperationFilterInput>;
  datePreferred?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  email?: InputMaybe<StringOperationFilterInput>;
  fax?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  job?: InputMaybe<ZeescapeJobFilterInput>;
  jobAcceptance?: InputMaybe<BooleanOperationFilterInput>;
  jobId?: InputMaybe<ComparableInt32OperationFilterInput>;
  operator?: InputMaybe<UserDetailFilterInput>;
  operatorBusinessLevelId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  operatorBusinessLevelNameList?: InputMaybe<StringOperationFilterInput>;
  operatorEmailSent?: InputMaybe<BooleanOperationFilterInput>;
  operatorId?: InputMaybe<ComparableInt32OperationFilterInput>;
  operatorNotes?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ZeescapeJobDetailFilterInput>>;
  orderShip?: InputMaybe<OrderShippingFilterInput>;
  orderShipId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  penaltyRatePerSquareMetre?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  postcode?: InputMaybe<StringOperationFilterInput>;
  preInspectionRequired?: InputMaybe<BooleanOperationFilterInput>;
  remarks?: InputMaybe<StringOperationFilterInput>;
  removed?: InputMaybe<BooleanOperationFilterInput>;
  rowVersion?: InputMaybe<ListComparableByteOperationFilterInput>;
  salesNotes?: InputMaybe<StringOperationFilterInput>;
  sellPrice?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  setupFee?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  signedBy?: InputMaybe<StringOperationFilterInput>;
  signiture?: InputMaybe<ListComparableByteOperationFilterInput>;
  siteAfterHoursRequirement?: InputMaybe<StringOperationFilterInput>;
  siteGpslat?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  siteGpslong?: InputMaybe<ComparableNullableOfDoubleOperationFilterInput>;
  state?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<ZeescapeJobStatusFilterInput>;
  statusId?: InputMaybe<ComparableInt32OperationFilterInput>;
  suburb?: InputMaybe<StringOperationFilterInput>;
  telephone?: InputMaybe<StringOperationFilterInput>;
  zeescapeJobApplications?: InputMaybe<ListFilterInputTypeOfZeescapeJobApplicationFilterInput>;
};

export type ZeescapeJobFilterInput = {
  address1?: InputMaybe<StringOperationFilterInput>;
  address2?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<ZeescapeJobFilterInput>>;
  companyName?: InputMaybe<StringOperationFilterInput>;
  complete?: InputMaybe<BooleanOperationFilterInput>;
  contactPerson?: InputMaybe<StringOperationFilterInput>;
  country?: InputMaybe<StringOperationFilterInput>;
  created?: InputMaybe<ComparableDateTimeOperationFilterInput>;
  customer?: InputMaybe<CustomerFilterInput>;
  customerId?: InputMaybe<ComparableInt32OperationFilterInput>;
  email?: InputMaybe<StringOperationFilterInput>;
  fax?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  or?: InputMaybe<Array<ZeescapeJobFilterInput>>;
  order?: InputMaybe<OrderFilterInput>;
  orderId?: InputMaybe<ComparableNullableOfInt32OperationFilterInput>;
  postcode?: InputMaybe<StringOperationFilterInput>;
  removed?: InputMaybe<BooleanOperationFilterInput>;
  rowVersion?: InputMaybe<ListComparableByteOperationFilterInput>;
  sellPrice?: InputMaybe<ComparableNullableOfDecimalOperationFilterInput>;
  state?: InputMaybe<StringOperationFilterInput>;
  suburb?: InputMaybe<StringOperationFilterInput>;
  telephone?: InputMaybe<StringOperationFilterInput>;
  userCreatedId?: InputMaybe<ComparableInt32OperationFilterInput>;
  zeescapeJobDetails?: InputMaybe<ListFilterInputTypeOfZeescapeJobDetailFilterInput>;
};

export type ZeescapeJobStatus = {
  __typename?: 'ZeescapeJobStatus';
  id: Scalars['Int'];
  name: Scalars['String'];
  zeescapeJobDetails: Array<ZeescapeJobDetail>;
};

export type ZeescapeJobStatusFilterInput = {
  and?: InputMaybe<Array<ZeescapeJobStatusFilterInput>>;
  id?: InputMaybe<ComparableInt32OperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ZeescapeJobStatusFilterInput>>;
  zeescapeJobDetails?: InputMaybe<ListFilterInputTypeOfZeescapeJobDetailFilterInput>;
};

export type GetCurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentUserQuery = { __typename?: 'Query', currentUser?: { __typename?: 'UserType', firstName: string, lastName: string, email?: string | null | undefined, username: string, mobile?: string | null | undefined, phone?: string | null | undefined, sitemaps?: Array<{ __typename?: 'SiteMap', name: string, pagePath?: string | null | undefined, seqNo: number }> | null | undefined, businessLevel?: { __typename?: 'BusinessLevel', name: string, bankDetailsId: number, crmid: string, deliveryAddress?: { __typename?: 'Address', companyName?: string | null | undefined } | null | undefined } | null | undefined, shoppingCart?: { __typename?: 'ShoppingCartType', id?: string | null | undefined, userId?: number | null | undefined, customerId?: number | null | undefined, cartItems: Array<{ __typename?: 'ShoppingCartItem', productId?: number | null | undefined, productCode: string, quantity: number, isSelected: boolean, eTemplateId?: number | null | undefined, product?: { __typename?: 'ProductType', productId: number, name: string, code: string, description?: string | null | undefined, priceType: string, orderTypeId: number, priceSummary: string, status: string, statusId: number, stockOnHand: number, stockAvailable: number, defaultQuantity: number, minOrderQuantity?: number | null | undefined, dateCreated: string, unitOfMeasurement?: string | null | undefined, unitOfMeasurementAmount?: string | null | undefined, hasPriceBreaks: boolean, prices: Array<{ __typename?: 'ProductPriceBreakType', quantity: number, price: number }>, orderType: { __typename?: 'OrderTypeGQLType', name?: string | null | undefined } } | null | undefined }> } | null | undefined, customer?: { __typename?: 'Customer', customerId: number, name?: string | null | undefined } | null | undefined, customerTheme: { __typename?: 'TsunamiTheme', themeId: string, customerId: string, banners: Array<{ __typename?: 'BannerItem', fileName?: string | null | undefined, href?: string | null | undefined }>, logo?: string | null | undefined, primary: { __typename?: 'Color', main: string, dark: string, light: string, contrastText: string }, secondary: { __typename?: 'Color', main: string, dark: string, light: string, contrastText: string }, background: { __typename?: 'Color', main: string, dark: string, light: string, contrastText: string }, navigationBar: { __typename?: 'NavigationBar', background: string, buttonActive: string, textActive: string, text: string }, footer: { __typename?: 'Footer', background: string, button: string, text: string }, pageHeader: { __typename?: 'PageHeader', background: string, cart: string, text: string }, fonts: { __typename?: 'Fonts', body: string, navigationAndHeading: string }}, customerFeatures?: Array<{ __typename?: 'TsuCustomerFeature', tsuCustomerFeatureId: number, customerId: number, access: boolean, tsuFeatureId: number, tsuFeature: { __typename?: 'TsuFeature', name: string, description: string, active: boolean } }> | null | undefined, role?: { __typename?: 'RoleType', roleId: number, adminRole: boolean, discount: number } | null | undefined } | null | undefined };

export type GetCurrentCustomerQueryVariables = Exact<{ [key: string]: never; }>;

export type GetCurrentCustomerQuery = { __typename?: 'Query', currentCustomer?: { __typename?: 'Customer', customerId: number, name?: string | null | undefined } | null | undefined };



export type LoginMutationVariables = Exact<{
  email: Scalars['String'];
  password: Scalars['String'];
}>;

export type AddUserMutationVariables = Exact<{
  input: CreateUserInputType;
}>;

export type LoginMutation = { __typename?: 'Mutation', userLogin: { __typename?: 'LoginPayloadType', token: string, expires: number, refreshToken: string, refreshTokenExpires: number } };

export type AddUserMutation = { __typename?: 'Mutation', addUser: { __typename?: 'UserType', userId: number, username: string, email: string } };

export type RefreshAccessTokenMutationVariables = Exact<{
  refreshToken: Scalars['String'];
}>;


export type RefreshAccessTokenMutation = { __typename?: 'Mutation', refreshAccessToken: { __typename?: 'LoginPayloadType', token: string, expires: number, refreshToken: string, refreshTokenExpires: number } };

export type ResetPasswordMutationVariables = Exact<{
  resetToken: Scalars['String'];
  password: Scalars['String'];
}>;


export type ResetPasswordMutation = { __typename?: 'Mutation', resetPassword: { __typename?: 'ResetPasswordPayloadType', success: boolean } };

export type SecurityQuestionsQueryVariables = Exact<{ [key: string]: never; }>;


export type SecurityQuestionsQuery = { __typename?: 'Query', securityQuestions?: Array<{ __typename?: 'UserSecurityQuestion', sQuestionId: number, sQuestion: string }> | null | undefined };

export type SendResetPasswordEmailMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type SendResetPasswordEmailMutation = { __typename?: 'Mutation', resetEmail: { __typename?: 'ResetEmailPayload', success: boolean } };

export type UpdateUserDetailsMutationVariables = Exact<{
  contactNumber: Scalars['String'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
}>;


export type UpdateUserDetailsMutation = { __typename?: 'Mutation', updateDetails: { __typename?: 'UpdateDetailsPayload', success: boolean } };

export type CreateUserCartMutationVariables = Exact<{
  freightSettingId: Scalars['Int'];
  serviceCode?: InputMaybe<Scalars['String']>;
  chargeProcessingFee: Scalars['Boolean'];
  isUrgentOrder: Scalars['Boolean'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  company: Scalars['String'];
  street1: Scalars['String'];
  suburb: Scalars['String'];
  postcode: Scalars['String'];
  state: Scalars['String'];
  country: Scalars['String'];
  phone: Scalars['String'];
  mobile?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  cartLines: Array<CartLineInput> | CartLineInput;
  destructionMode?: InputMaybe<Scalars['Boolean']>;
}>;


export type CreateUserCartMutation = { __typename?: 'Mutation', createCart?: { __typename?: 'Cart', id?: string | null | undefined, userId?: number | null | undefined, orderCosts?: { __typename?: 'OrderCosts', gst: number, grandTotal: number } | null | undefined } | null | undefined };

export type GetShoppingCartQueryVariables = Exact<{ [key: string]: never; }>;


export type GetShoppingCartQuery = { __typename?: 'Query', shoppingCart?: { __typename?: 'ShoppingCartType', id?: string | null | undefined, userId?: number | null | undefined, customerId?: number | null | undefined, cartItems: Array<{ __typename?: 'ShoppingCartItem', productId?: number | null | undefined, productCode: string, quantity: number, isSelected: boolean, eTemplateId?: number | null | undefined, product?: { __typename?: 'ProductType', productId: number, name: string, code: string, description?: string | null | undefined, priceType: string, orderTypeId: number, priceSummary: string, status: string, statusId: number, stockOnHand: number, stockAvailable: number, defaultQuantity: number, minOrderQuantity?: number | null | undefined, dateCreated: string, unitOfMeasurement?: string | null | undefined, unitOfMeasurementAmount?: string | null | undefined, hasPriceBreaks: boolean, prices: Array<{ __typename?: 'ProductPriceBreakType', quantity: number, price: number }>, orderType: { __typename?: 'OrderTypeGQLType', name?: string | null | undefined } } | null | undefined }> } | null | undefined };

export type GetUserCartQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserCartQuery = { __typename?: 'Query', userCart?: { __typename?: 'Cart', id?: string | null | undefined, created?: string | null | undefined, cartInformation: { __typename?: 'CartInformation', billingAddress?: { __typename?: 'CartAddress', company: string, country?: string | null | undefined, email: string, mobile?: string | null | undefined, phone: string, postcode: string, state: string, street1: string, street2?: string | null | undefined, street3?: string | null | undefined, street4?: string | null | undefined, suburb: string } | null | undefined, deliveryAddress?: { __typename?: 'CartAddress', company: string, country?: string | null | undefined, email: string, mobile?: string | null | undefined, phone: string, postcode: string, state: string, street1: string, street2?: string | null | undefined, street3?: string | null | undefined, street4?: string | null | undefined, suburb: string } | null | undefined, clientOrderReference?: string | null | undefined, firstName: string, lastName: string, manualOrder: boolean, urgentPick: boolean, deliveryMethodId: number, deliveryInstructions: string, cartLines: Array<{ __typename?: 'CartLine', productId?: number | null | undefined, productCode: string, quantity: number, eTemplateId: number}> }, orderCosts?: { __typename?: 'OrderCosts', itemCost: number, grandTotal: number, subTotal: number, gst: number, fees: { __typename?: 'OrderFees', pickFee: { __typename?: 'OrderFee', fee: number, gst: number, paysFor: boolean }, urgentPickFee: { __typename?: 'OrderFee', fee: number, gst: number, paysFor: boolean }, shippingFee: { __typename?: 'OrderFee', fee: number, gst: number, paysFor: boolean }, collectFee: { __typename?: 'OrderFee', fee: number, gst: number, paysFor: boolean }, manualOrderFee: { __typename?: 'OrderFee', fee: number, gst: number, paysFor: boolean }, fuelLevyFee: { __typename?: 'OrderFee', fee: number, gst: number, paysFor: boolean } } } | null | undefined } | null | undefined };

export type OrderCostsPartsFragment = { __typename?: 'OrderCosts', itemCost: number, grandTotal: number, subTotal: number, gst: number, fees: { __typename?: 'OrderFees', pickFee: { __typename?: 'OrderFee', fee: number, gst: number, paysFor: boolean }, urgentPickFee: { __typename?: 'OrderFee', fee: number, gst: number, paysFor: boolean }, shippingFee: { __typename?: 'OrderFee', fee: number, gst: number, paysFor: boolean }, collectFee: { __typename?: 'OrderFee', fee: number, gst: number, paysFor: boolean }, manualOrderFee: { __typename?: 'OrderFee', fee: number, gst: number, paysFor: boolean }, fuelLevyFee: { __typename?: 'OrderFee', fee: number, gst: number, paysFor: boolean }} };

export type ProductsTotalPriceQueryVariables = Exact<{
  products: Array<ProductsTotalPriceItemInput> | ProductsTotalPriceItemInput;
}>;


export type ProductsTotalPriceQuery = { __typename?: 'Query', productsTotalPrice: { __typename?: 'GetProductsTotalPriceOutput', total: number } };

export type ShoppingCartPartsFragment = { __typename?: 'ShoppingCartType', id?: string | null | undefined, userId?: number | null | undefined, customerId?: number | null | undefined, cartItems: Array<{ __typename?: 'ShoppingCartItem', productId?: number | null | undefined, productCode: string, quantity: number, isSelected: boolean, eTemplateId?: number | null | undefined, product?: { __typename?: 'ProductType', productId: number, name: string, code: string, description?: string | null | undefined, priceType: string, orderTypeId: number, priceSummary: string, status: string, statusId: number, stockOnHand: number, stockAvailable: number, defaultQuantity: number, minOrderQuantity?: number | null | undefined, dateCreated: string, unitOfMeasurement?: string | null | undefined, unitOfMeasurementAmount?: string | null | undefined, hasPriceBreaks: boolean, prices: Array<{ __typename?: 'ProductPriceBreakType', quantity: number, price: number }>, orderType: { __typename?: 'OrderTypeGQLType', name?: string | null | undefined } } | null | undefined }> };

export type UpdateShoppingCartMutationVariables = Exact<{
  id?: InputMaybe<Scalars['String']>;
  cartItems: Array<ShoppingCartItemInput> | ShoppingCartItemInput;
}>;


export type UpdateShoppingCartMutation = { __typename?: 'Mutation', updateShoppingCart?: { __typename?: 'ShoppingCartType', id?: string | null | undefined, userId?: number | null | undefined, customerId?: number | null | undefined, cartItems: Array<{ __typename?: 'ShoppingCartItem', productId?: number | null | undefined, productCode: string, quantity: number, isSelected: boolean, eTemplateId?: number | null | undefined, product?: { __typename?: 'ProductType', productId: number, name: string, code: string, description?: string | null | undefined, priceType: string, orderTypeId: number, priceSummary: string, status: string, statusId: number, stockOnHand: number, stockAvailable: number, defaultQuantity: number, minOrderQuantity?: number | null | undefined, dateCreated: string, unitOfMeasurement?: string | null | undefined, unitOfMeasurementAmount?: string | null | undefined, hasPriceBreaks: boolean, prices: Array<{ __typename?: 'ProductPriceBreakType', quantity: number, price: number }>, orderType: { __typename?: 'OrderTypeGQLType', name?: string | null | undefined } } | null | undefined }> } | null | undefined };

export type UpdateUserCartMutationVariables = Exact<{
  cartId: Scalars['String'];
  freightSettingId: Scalars['Int'];
  serviceCode?: InputMaybe<Scalars['String']>;
  chargeProcessingFee: Scalars['Boolean'];
  isUrgentOrder: Scalars['Boolean'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  company: Scalars['String'];
  street1: Scalars['String'];
  suburb: Scalars['String'];
  postcode: Scalars['String'];
  state: Scalars['String'];
  country: Scalars['String'];
  phone: Scalars['String'];
  mobile?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  cartLines: Array<CartLineInput> | CartLineInput;
}>;


export type UpdateUserCartMutation = { __typename?: 'Mutation', updateCart?: { __typename?: 'Cart', id?: string | null | undefined, userId?: number | null | undefined, orderCosts?: { __typename?: 'OrderCosts', itemCost: number, grandTotal: number, subTotal: number, gst: number, fees: { __typename?: 'OrderFees', pickFee: { __typename?: 'OrderFee', fee: number, gst: number, paysFor: boolean }, urgentPickFee: { __typename?: 'OrderFee', fee: number, gst: number, paysFor: boolean }, shippingFee: { __typename?: 'OrderFee', fee: number, gst: number, paysFor: boolean }, collectFee: { __typename?: 'OrderFee', fee: number, gst: number, paysFor: boolean }, manualOrderFee: { __typename?: 'OrderFee', fee: number, gst: number, paysFor: boolean }, fuelLevyFee: { __typename?: 'OrderFee', fee: number, gst: number, paysFor: boolean } } } | null | undefined } | null | undefined };

export type ContactUsMutationVariables = Exact<{
  name: Scalars['String'];
  email: Scalars['String'];
  message: Scalars['String'];
}>;


export type ContactUsMutation = { __typename?: 'Mutation', contactUs?: { __typename?: 'ContactUsResponse', message: string } | null | undefined };

export type AutoPopulateCustomerFeaturesMutationVariables = Exact<{ [key: string]: never; }>;


export type AutoPopulateCustomerFeaturesMutation = { __typename?: 'Mutation', autoPopulateCustomerFeatures: { __typename?: 'AutoPopulateCustomerFeaturesPayload', success: boolean } };

export type ChangeCustomerMutationVariables = Exact<{
  customerId: Scalars['Int'];
}>;


export type ChangeCustomerMutation = { __typename?: 'Mutation', changeCustomer: { __typename?: 'LoginPayloadType', token: string, refreshToken: string, expires: number, refreshTokenExpires: number } };

export type GetCustomerFeaturesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCustomerFeaturesQuery = { __typename?: 'Query', customerFeatures?: Array<{ __typename?: 'TsuCustomerFeature', tsuCustomerFeatureId: number, customerId: number, access: boolean, tsuFeatureId: number, tsuFeature: { __typename?: 'TsuFeature', name: string, description: string, active: boolean } }> | null | undefined };

export type GetCustomersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCustomersQuery = { __typename?: 'Query', customers?: Array<{ __typename?: 'Customer', customerId: number, name?: string | null | undefined }> | null | undefined };

export type GetCustomerBusinessLevelsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCustomerBusinessLevelsQuery = { __typename?: 'Query', customerBusinessLevels?: Array<{ __typename?: 'BusinessLevel', customerId: number, name?: string | null | undefined, active: boolean | null | undefined, billingAddress?: { __typename?: 'Address', street1: string, street2?: string | null | undefined, street3?: string | null | undefined, street4?: string | null | undefined, country?: string | null | undefined, postcode: string, email?: string | null | undefined, firstName?: string | null | undefined, lastName?: string | null | undefined, mobile?: string | null | undefined, phone?: string | null | undefined, state?: string | null | undefined, suburb?: string | null | undefined, cityId?: number | null | undefined, companyName?: string | null | undefined, notes?: string | null | undefined } | null | undefined, deliveryAddress?: { __typename?: 'Address', street1: string, street2?: string | null | undefined, street3?: string | null | undefined, street4?: string | null | undefined, country?: string | null | undefined, postcode: string, email?: string | null | undefined, firstName?: string | null | undefined, lastName?: string | null | undefined, mobile?: string | null | undefined, phone?: string | null | undefined, state?: string | null | undefined, suburb?: string | null | undefined, cityId?: number | null | undefined, companyName?: string | null | undefined, notes?: string | null | undefined } | null | undefined }> | null | undefined };


export type UpdateCustomerFeaturesMutationVariables = Exact<{
  tsuCustomerFeatureId: Scalars['Int'];
  access: Scalars['Boolean'];
}>;


export type UpdateCustomerFeaturesMutation = { __typename?: 'Mutation', updateCustomerFeature?: { __typename?: 'TsuCustomerFeature', tsuFeatureId: number, tsuCustomerFeatureId: number, access: boolean } | null | undefined };

export type UpdateMultipleCustomerFeaturesMutationVariables = Exact<{
  updates: Array<UpdateCustomerFeatureInput> | UpdateCustomerFeatureInput;
}>;


export type UpdateMultipleCustomerFeaturesMutation = { __typename?: 'Mutation', updateMultipleCustomerFeatures?: Array<{ __typename?: 'TsuCustomerFeature', tsuFeatureId: number, tsuCustomerFeatureId: number, access: boolean }> | null | undefined };

export type TopOrderedProductsQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
}>;


export type TopOrderedProductsQuery = { __typename?: 'Query', topOrderedProducts?: { __typename?: 'TopOrderedProductCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'TopOrderedProduct', productCode: string, productName: string, productsSold: number, totalQuantity: number }> | null | undefined } | null | undefined };

export type FaqsQueryVariables = Exact<{ [key: string]: never; }>;


export type FaqsQuery = { __typename?: 'Query', faqs?: Array<{ __typename?: 'FaqType', fQuestion: string, fAnswer: string }> | null | undefined };

export type FavoritePartsFragment = { __typename?: 'Favorite', id?: string | null | undefined, userId: number, customerId: number, products: Array<{ __typename?: 'FavoriteProductEntry', productId: number, product?: { __typename?: 'ProductType', productId: number, name: string, code: string, description?: string | null | undefined, priceType: string, orderTypeId: number, priceSummary: string, status: string, statusId: number, stockOnHand: number, stockAvailable: number, defaultQuantity: number, minOrderQuantity?: number | null | undefined, dateCreated: string, unitOfMeasurement?: string | null | undefined, unitOfMeasurementAmount?: string | null | undefined, hasPriceBreaks: boolean, prices: Array<{ __typename?: 'ProductPriceBreakType', quantity: number, price: number }>, orderType: { __typename?: 'OrderTypeGQLType', name?: string | null | undefined } } | null | undefined }> };

export type GetFavoritesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFavoritesQuery = { __typename?: 'Query', favorites?: { __typename?: 'Favorite', id?: string | null | undefined, userId: number, customerId: number, products: Array<{ __typename?: 'FavoriteProductEntry', productId: number, product?: { __typename?: 'ProductType', productId: number, name: string, code: string, description?: string | null | undefined, priceType: string, orderTypeId: number, priceSummary: string, status: string, statusId: number, stockOnHand: number, stockAvailable: number, defaultQuantity: number, minOrderQuantity?: number | null | undefined, dateCreated: string, unitOfMeasurement?: string | null | undefined, unitOfMeasurementAmount?: string | null | undefined, hasPriceBreaks: boolean, prices: Array<{ __typename?: 'ProductPriceBreakType', quantity: number, price: number }>, orderType: { __typename?: 'OrderTypeGQLType', name?: string | null | undefined } } | null | undefined }> } | null | undefined };

export type UpdateFavoritesMutationVariables = Exact<{
  favoriteId?: InputMaybe<Scalars['String']>;
  input: Array<FavoriteProductEntryInput> | FavoriteProductEntryInput;
}>;


export type UpdateFavoritesMutation = { __typename?: 'Mutation', updateFavorites?: { __typename?: 'Favorite', id?: string | null | undefined } | null | undefined };

export type ApproveMultipleOrderShippingsMutationVariables = Exact<{
  input: ApproveMultipleOrderShippingsInput;
}>;


export type ApproveMultipleOrderShippingsMutation = { __typename?: 'Mutation', approveMultipleOrderShippings?: Array<{ __typename?: 'OrderShippingType', orderId: number, orderShipId: number, status: { __typename?: 'OrderStatus', statusId: number, name: string } }> | null | undefined };

export type ApproveOrderShippingMutationVariables = Exact<{
  input: ApproveOrderShippingInput;
}>;


export type ApproveOrderShippingMutation = { __typename?: 'Mutation', approveOrderShipping?: { __typename?: 'OrderShippingType', orderId: number, orderShipId: number, status: { __typename?: 'OrderStatus', statusId: number, name: string } } | null | undefined };

export type UpdateOrderLineQuantityMutationVariables = Exact<{
  input: UpdateOrderLineQuantityInput;
}>;

export type UpdateOrderShippingStatusMutationVariables = Exact<{
  input: UpdateOrderShippingStatusInput;
}>;

export type UpdateOrderSavedMutationVariables = Exact<{
  input: UpdateOrderSavedInput;
}>;

export type UpdateOrderShippingStatusMutation = { __typename?: 'Mutation', updateOrderShippingStatus?: { __typename?: 'OrderShippingType', orderId: number, orderShipId: number, status: { __typename?: 'OrderStatus', statusId: number, name: string } } | null | undefined };

export type UpdateOrderSavedMutation = { __typename?: 'Mutation', updateOrderSaved?: { __typename?: 'Order', orderId: number } | null | undefined };


export type UpdateOrderLineQuantityMutation = { __typename?: 'Mutation', updateOrderLineQuantity?: { __typename?: 'OrderLineType', quantity: number, active: boolean, orderLineId: number } | null | undefined };


export type CancelOrderShippingMutationVariables = Exact<{
  input: ApproveOrderShippingInput;
}>;


export type CancelOrderShippingMutation = { __typename?: 'Mutation', cancelOrderShipping?: { __typename?: 'OrderShippingType', orderId: number, orderShipId: number, status: { __typename?: 'OrderStatus', statusId: number, name: string } } | null | undefined };


export type UpdateOrderShippingFeeMutationVariables = Exact<{
  input: UpdateOrderShippingFeeInput;
}>;


export type UpdateOrderShippingFeeMutation = { __typename?: 'Mutation', updateOrderShippingFee?: { __typename?: 'OrderShippingType', orderId: number, orderShipId: number, status: { __typename?: 'OrderStatus', statusId: number, name: string } } | null | undefined };


export type GetOrderShippingsForApprovalQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<OrderShippingFilterInput>;
}>;


export type GetOrderShippingsForApprovalQuery = { __typename?: 'Query', orderShippingsForApproval?: { __typename?: 'OrderShippingTypeCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'OrderShippingType', orderShipId: number, created: string, deliveryUserFirstName?: string | null | undefined, deliveryUserLastName?: string | null | undefined, order: { __typename?: 'Order', orderId: number }, orderedByUser?: { __typename?: 'UserType', userId: number, firstName: string, lastName: string } | null | undefined }> | null | undefined } | null | undefined };

export type GetOrderDetailQueryVariables = Exact<{
  orderId: Scalars['Int'];
}>;


export type GetOrderDetailQuery = { __typename?: 'Query', orderDetail?: { __typename?: 'Order', orderId: number, customerId: number, orderShippings: Array<{ __typename?: 'OrderShippingType', orderShipId: number, deliveryMethod?: string | null | undefined, grandTotal?: number | null | undefined, deliveryUserFirstName?: string | null | undefined, deliveryUserLastName?: string | null | undefined, deliveryEmail?: string | null | undefined, deliveryPhone?: string | null | undefined, deliveryMobile?: string | null | undefined, deliveryCompanyName?: string | null | undefined, created: string, orderedByUser?: { __typename?: 'UserType', firstName: string, lastName: string } | null | undefined, orderLines: Array<{ __typename?: 'OrderLineType', quantity: number, unitSell?: number | null | undefined }> }> } | null | undefined };

export type GetOrdersInProgressQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
}>;


export type GetOrdersInProgressQuery = { __typename?: 'Query', ordersInProgress?: { __typename?: 'OrderCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'Order', orderId: number, despatchDate?: string | null | undefined, created: string, userCreatedFirstName: string, userCreatedLastName: string, orderShippings: Array<{ __typename?: 'OrderShippingType', deliveryUserLastName?: string | null | undefined, status: {__typename?: 'OrderStatus', statusId: number, name: string} }> }> | null | undefined } | null | undefined };


export type GetSavedOrdersQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
}>;


export type GetSavedOrdersQuery = { __typename?: 'Query', savedOrders?: { __typename?: 'OrderCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'Order', orderId: number, despatchDate?: string | null | undefined, created: string, orderShippings: Array<{ __typename?: 'OrderShippingType', orderShipId: number, orderLines: Array<{ __typename?: 'OrderLineType', productId: number, quantity: number }> }> }> | null | undefined } | null | undefined };

export type GetSharedPaymentUrlQueryVariables = Exact<{
  input: EWayTransactionInput;
}>;

export type GetSharedPaymentUrlQuery = { __typename?: 'Query', sharedPaymentUrl?: { __typename?: 'String' } | null | undefined };

export type EWayDirectPaymentQueryVariables = Exact<{
  input: PaymentCardInput;
}>;

export type EWayDirectPaymentQuery = { __typename?: 'Query', eWayDirectPayment?: { __typename?: 'Boolean' } | null | undefined };


export type GetCategoriesQueryVariables = Exact<{
  catId?: InputMaybe<Scalars['Int']>;
}>;


export type GetCategoriesQuery = { __typename?: 'Query', childCategories?: Array<{ __typename?: 'CategoryType', name?: string | null | undefined, categoryId: number, orderTypeId: number, childCategoriesCount: number }> | null | undefined };

export type GetCategoryQueryVariables = Exact<{
  catId: Scalars['Int'];
}>;


export type GetCategoryQuery = { __typename?: 'Query', category?: { __typename?: 'CategoryType', name?: string | null | undefined, categoryId: number, orderTypeId: number, parentId?: number | null | undefined, childCategoriesCount: number } | null | undefined };

export type GetProductCategoriesQueryVariables = Exact<{
  productId: Scalars['Int'];
}>;


export type GetProductCategoriesQuery = { __typename?: 'Query', productCategories?: Array<{ __typename?: 'ProductCategory', categoryId: number, name: string }> | null | undefined };

export type UpdateProductCategoriesMutationVariables = Exact<{
  productId: Scalars['Int'];
  categoryIds: Array<Scalars['Int']> | Scalars['Int'];
}>;


export type UpdateProductCategoriesMutation = { __typename?: 'Mutation', updateProductCategories?: { __typename?: 'SimpleMessageResponse', message: string } | null | undefined };

export type AttributeSetsQueryVariables = Exact<{ [key: string]: never; }>;


export type AttributeSetsQuery = { __typename?: 'Query', attributeSets?: Array<{ __typename?: 'AttributeSetRecord', attributeSetId: number, name: string, attributes: Array<{ __typename?: 'AttributeRecord', attributeId: number, name: string, attributeData: Array<{ __typename?: 'AttributeDataRecord', attribDataId: number, name?: string | null | undefined, abbreviation?: string | null | undefined }> }> }> | null | undefined };

export type ChildProductsQueryVariables = Exact<{
  productId: Scalars['Int'];
}>;


export type ChildProductsQuery = { __typename?: 'Query', childProducts?: Array<{ __typename?: 'ProductType', productId: number, name: string, code: string, stockAvailable: number, parentId?: number | null | undefined }> | null | undefined };

export type CreateChildProductMutationVariables = Exact<{
  productId: Scalars['Int'];
  attribDataId: Scalars['Int'];
}>;


export type CreateChildProductMutation = { __typename?: 'Mutation', createChildProduct?: { __typename?: 'ProductType', productId: number, parentId?: number | null | undefined, name: string } | null | undefined };

export type GetProductDetailsQueryVariables = Exact<{
  productId: Scalars['Int'];
}>;


export type GetProductDetailsQuery = { __typename?: 'Query', productDetails?: { __typename?: 'ProductDetailsPayload', productName: string, productDescription: string, statusId?: number | null | undefined, itemGroupId?: number | null | undefined, productCode: string, externalProductId?: string | null | undefined, isHidden: boolean, isWBSOwnedStock: boolean, isEmbroidery: boolean, isScreenPrintItem: boolean, isOverPrintItem: boolean, isWBSJobItem: boolean, orderTypeId?: number | null | undefined, approverId?: number | null | undefined, crmSupplier: string, supplierLeadTime?: number | null | undefined, crmSpecification: string, reOrderLevel?: number | null | undefined, maxStockLevel: number, enableSerialNumberTracking: boolean, serialNumberBookSize?: number | null | undefined, gst: number, processDays: number, minQuantityPerOrder?: number | null | undefined, maxOrderQuantityLimit?: number | null | undefined, maxOrderQuantityLimitDays?: number | null | undefined, isSpecialDelivery: boolean, quantityTypeId?: number | null | undefined, maxQuantityPerOrder?: number | null | undefined, forceRGA: boolean, sortOrder?: number | null | undefined, isRemoved: boolean } | null | undefined };

export type GetProductManagementQueryVariables = Exact<{
  orderTypeId?: InputMaybe<Scalars['Int']>;
  catId?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
}>;


export type GetProductManagementQuery = { __typename?: 'Query', productManagement?: { __typename?: 'ProductTypeCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'ProductType', productId: number, code: string, name: string, image?: number[] | null | undefined, priceSummary: string, categories: string, unitOfMeasurement?: string | null | undefined, stockCommitted: number, stockOnHand: number, stockAvailable: number, status: string }> | null | undefined } | null | undefined };

export type ItemGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type ItemGroupsQuery = { __typename?: 'Query', itemGroups: Array<{ __typename?: 'ProductItemGroupType', productItemGroupId: number, name: string }> };

export type OrderStatusesQueryVariables = Exact<{ [key: string]: never; }>;


export type OrderStatusesQuery = { __typename?: 'Query', orderStatuses?: Array<{ __typename?: 'OrderStatus', statusId: number, name: string }> | null | undefined };

export type OrderTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type OrderTypesQuery = { __typename?: 'Query', orderTypes: Array<{ __typename?: 'OrderTypeGQLType', orderTypeId: number, name?: string | null | undefined }> };

export type ProductApproversQueryVariables = Exact<{ [key: string]: never; }>;


export type ProductApproversQuery = { __typename?: 'Query', productApprovers: Array<{ __typename?: 'ProductApprover', userId: number, name: string }> };

export type ProductStatusesQueryVariables = Exact<{ [key: string]: never; }>;


export type ProductStatusesQuery = { __typename?: 'Query', productStatuses: Array<{ __typename?: 'ProductStatus', statusId: number, name: string }> };

export type UpdateProductParentMutationVariables = Exact<{
  productId: Scalars['Int'];
  childProductId: Scalars['Int'];
  link?: InputMaybe<Scalars['Boolean']>;
}>;


export type UpdateProductParentMutation = { __typename?: 'Mutation', updateProductParent?: { __typename?: 'ProductType', productId: number, parentId?: number | null | undefined, name: string } | null | undefined };

export type ProductPartsFragment = { __typename?: 'ProductType', productId: number, name: string, code: string, description?: string | null | undefined, priceType: string, orderTypeId: number, priceSummary: string, status: string, statusId: number, stockOnHand: number, stockAvailable: number, defaultQuantity: number, minOrderQuantity?: number | null | undefined, dateCreated: string, unitOfMeasurement?: string | null | undefined, unitOfMeasurementAmount?: string | null | undefined, hasPriceBreaks: boolean, prices: Array<{ __typename?: 'ProductPriceBreakType', quantity: number, price: number }>, orderType: { __typename?: 'OrderTypeGQLType', name?: string | null | undefined } };

export type FreightSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type FreightSettingsQuery = { __typename?: 'Query', freightSettings?: Array<{ __typename?: 'CustomerFreightSettingType', freightSettingId: number, name: string }> | null | undefined };

export type ProductAttributesQueryVariables = Exact<{
  productId: Scalars['Int'];
}>;


export type ProductAttributesQuery = { __typename?: 'Query', productAttributes?: { __typename?: 'ProductAttributesViewModel', name: string, attributes: Array<{ __typename?: 'AttributeViewModel', productId: number, productCode: string, attributeName: string, stockAvailable: number }> } | null | undefined };

export type GetProductQueryVariables = Exact<{
  productId: Scalars['Int'];
}>;

export type GetProductByCodeQueryVariables = Exact<{
  productCode: Scalars['String'];
}>;

export type GetProductQuery = { __typename?: 'Query', product?: { __typename?: 'ProductType', productId: number, name: string, code: string, description?: string | null | undefined, priceType: string, orderTypeId: number, priceSummary: string, status: string, statusId: number, stockOnHand: number, stockAvailable: number, defaultQuantity: number, minOrderQuantity?: number | null | undefined, dateCreated: string, unitOfMeasurement?: string | null | undefined, unitOfMeasurementAmount?: string | null | undefined, hasPriceBreaks: boolean, prices: Array<{ __typename?: 'ProductPriceBreakType', quantity: number, price: number }>, orderType: { __typename?: 'OrderTypeGQLType', name?: string | null | undefined } } | null | undefined };

export type GetProductByCodeQuery = { __typename?: 'Query', productByCode?: { __typename?: 'ProductType', productId: number, name: string, code: string, description?: string | null | undefined, priceType: string, orderTypeId: number, priceSummary: string, status: string, statusId: number, stockOnHand: number, stockAvailable: number, defaultQuantity: number, minOrderQuantity?: number | null | undefined, dateCreated: string, unitOfMeasurement?: string | null | undefined, unitOfMeasurementAmount?: string | null | undefined, hasPriceBreaks: boolean, prices: Array<{ __typename?: 'ProductPriceBreakType', quantity: number, price: number }>, orderType: { __typename?: 'OrderTypeGQLType', name?: string | null | undefined } } | null | undefined };


export type ProductsQueryVariables = Exact<{
  where?: InputMaybe<ProductFilterInput>;
  categoryId?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type ProductsQuery = { __typename?: 'Query', products?: { __typename?: 'ProductTypeCollectionSegment', totalCount: number, items?: Array<{
  parentId: null; __typename?: 'ProductType', productId: number, name: string, code: string, description?: string | null | undefined, hidden?: Boolean | null | undefined, priceType: string, orderTypeId: number, priceSummary: string, status: string, statusId: number, stockOnHand: number, stockAvailable: number, defaultQuantity: number, minOrderQuantity?: number | null | undefined, dateCreated: string, unitOfMeasurement?: string | null | undefined, unitOfMeasurementAmount?: string | null | undefined, hasPriceBreaks: boolean, prices: Array<{ __typename?: 'ProductPriceBreakType', quantity: number, price: number }>, orderType: { __typename?: 'OrderTypeGQLType', name?: string | null | undefined } 
}> | null | undefined } | null | undefined };

export type AddressPartsFragment = { __typename?: 'Address', street1: string, street2?: string | null | undefined, street3?: string | null | undefined, street4?: string | null | undefined, country?: string | null | undefined, postcode: string, email?: string | null | undefined, firstName?: string | null | undefined, lastName?: string | null | undefined, mobile?: string | null | undefined, phone?: string | null | undefined, state?: string | null | undefined, suburb?: string | null | undefined, cityId?: number | null | undefined, companyName?: string | null | undefined, notes?: string | null | undefined };

export type SavedAddressQueryVariables = Exact<{ [key: string]: never; }>;


export type SavedAddressQuery = { __typename?: 'Query', savedAddress?: { __typename?: 'SavedAddressResponse', billingAddress?: { __typename?: 'Address', street1: string, street2?: string | null | undefined, street3?: string | null | undefined, street4?: string | null | undefined, country?: string | null | undefined, postcode: string, email?: string | null | undefined, firstName?: string | null | undefined, lastName?: string | null | undefined, mobile?: string | null | undefined, phone?: string | null | undefined, state?: string | null | undefined, suburb?: string | null | undefined, cityId?: number | null | undefined, companyName?: string | null | undefined, notes?: string | null | undefined } | null | undefined, deliveryAddress?: { __typename?: 'Address', street1: string, street2?: string | null | undefined, street3?: string | null | undefined, street4?: string | null | undefined, country?: string | null | undefined, postcode: string, email?: string | null | undefined, firstName?: string | null | undefined, lastName?: string | null | undefined, mobile?: string | null | undefined, phone?: string | null | undefined, state?: string | null | undefined, suburb?: string | null | undefined, cityId?: number | null | undefined, companyName?: string | null | undefined, notes?: string | null | undefined } | null | undefined } | null | undefined };

export type ShippingEstimateQueryVariables = Exact<{
  freightSettingId: Scalars['Int'];
  deliveryAddress: CartAddressInput;
  cartLines: Array<CartLineInput> | CartLineInput;
}>;


export type ShippingEstimateQuery = { __typename?: 'Query', shippingEstimate?: { __typename?: 'ShippingEstimatePayloadType', services: Array<{ __typename?: 'ShippingEstimateServicePayloadType', service: string, serviceCode: string, description: string, tax: number, net: number }> } | null | undefined };

export type SubmitOrderMutationVariables = Exact<{
  cartId: Scalars['String'];
}>;

export type BulkCartCsvUploadMutationVariables = Exact<{
  input: BulkCartCsvUploadInput;
}>;

export type BulkOrderCsvUploadMutationVariables = Exact<{
  input: BulkOrderCsvUploadInput;
}>;

export type LoadSavedOrderMutationVariables = Exact<{
  input: LoadSavedOrderInput;
}>;

export type SubmitOrderMutation = { __typename?: 'Mutation', submitOrder: { __typename?: 'SubmitOrderPayloadType', orderReference: string } };

export type SubmitOrderWithoutEmailMutation = { __typename?: 'Mutation', submitOrderWithoutEmail: { __typename?: 'SubmitOrderPayloadType', orderReference: string } };

export type BulkCartCsvUploadMutation = { __typename?: 'Mutation', bulkCartCsvUpload: { __typename?: 'string'} };

export type BulkOrderCsvUploadMutation = { __typename?: 'Mutation', bulkOrderCsvUpload: { __typename?: 'string'} };

export type LoadSavedOrderMutation = { __typename?: 'Mutation', loadSavedOrder: { __typename?: 'string'} };

export type GetThemeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetThemeQuery = { __typename?: 'Query', customerTheme?: { __typename?: 'TsunamiTheme', themeId: string, customerId: string, banners: Array<{ __typename?: 'BannerItem', fileName?: string | null | undefined, href?: string | null | undefined }>, logo?: string | null | undefined, primary: { __typename?: 'Color', main: string, dark: string, light: string, contrastText: string }, secondary: { __typename?: 'Color', main: string, dark: string, light: string, contrastText: string }, background: { __typename?: 'Color', main: string, dark: string, light: string, contrastText: string }, navigationBar: { __typename?: 'NavigationBar', background: string, buttonActive: string, textActive: string, text: string }, footer: { __typename?: 'Footer', background: string, button: string, text: string }, pageHeader: { __typename?: 'PageHeader', background: string, cart: string, text: string }, fonts: { __typename?: 'Fonts', body: string, navigationAndHeading: string } } | null | undefined };

export type ThemePartsFragment = { __typename?: 'TsunamiTheme', themeId: string, customerId: string, banners: Array<{ __typename?: 'BannerItem', fileName?: string | null | undefined, href?: string | null | undefined }>, logo?: string | null | undefined, primary: { __typename?: 'Color', main: string, dark: string, light: string, contrastText: string }, secondary: { __typename?: 'Color', main: string, dark: string, light: string, contrastText: string }, background: { __typename?: 'Color', main: string, dark: string, light: string, contrastText: string }, navigationBar: { __typename?: 'NavigationBar', background: string, buttonActive: string, textActive: string, text: string }, footer: { __typename?: 'Footer', background: string, button: string, text: string }, pageHeader: { __typename?: 'PageHeader', background: string, cart: string, text: string }, fonts: { __typename?: 'Fonts', body: string, navigationAndHeading: string } };

export type ColorPartsFragment = { __typename?: 'Color', main: string, dark: string, light: string, contrastText: string };

export type UpdateThemeMutationVariables = Exact<{
  input: UpdateThemeRequestInput;
}>;


export type UpdateThemeMutation = { __typename?: 'Mutation', updateTheme?: { __typename?: 'TsunamiTheme', themeId: string, customerId: string, banners: Array<{ __typename?: 'BannerItem', fileName?: string | null | undefined, href?: string | null | undefined }>, logo?: string | null | undefined, primary: { __typename?: 'Color', main: string, dark: string, light: string, contrastText: string }, secondary: { __typename?: 'Color', main: string, dark: string, light: string, contrastText: string }, background: { __typename?: 'Color', main: string, dark: string, light: string, contrastText: string }, navigationBar: { __typename?: 'NavigationBar', background: string, buttonActive: string, textActive: string, text: string }, footer: { __typename?: 'Footer', background: string, button: string, text: string }, pageHeader: { __typename?: 'PageHeader', background: string, cart: string, text: string }, fonts: { __typename?: 'Fonts', body: string, navigationAndHeading: string } } | null | undefined };

export const OrderCostsPartsFragmentDoc = gql`
    fragment OrderCostsParts on OrderCosts {
  fees {
    pickFee {
      fee
      gst
      paysFor
    }
    urgentPickFee {
      fee
      gst
      paysFor
    }
    shippingFee {
      fee
      gst
      paysFor
    }
    collectFee {
      fee
      gst
      paysFor
    }
    manualOrderFee {
      fee
      gst
      paysFor
    }
    fuelLevyFee {
      fee
      gst
      paysFor
    }
  }
  itemCost
  grandTotal
  subTotal
  gst
}
    `;
export const ProductPartsFragmentDoc = gql`
    fragment ProductParts on ProductType {
  productId
  name
  code
  description
  hidden
  parentId
  priceType
  prices {
    quantity
    price
  }
  orderTypeId
  orderType {
    name
  }
  priceSummary
  status
  statusId
  stockOnHand
  stockAvailable
  defaultQuantity
  minOrderQuantity
  dateCreated
  unitOfMeasurement
  unitOfMeasurementAmount
  defaultQuantity
  minOrderQuantity
  dateCreated
  hasPriceBreaks
}
    `;
export const ShoppingCartPartsFragmentDoc = gql`
    fragment ShoppingCartParts on ShoppingCartType {
  id
  userId
  customerId
  cartItems {
    productId
    productCode
    quantity
    isSelected
    eTemplateId
    product {
      ...ProductParts
    }
  }
}
    ${ProductPartsFragmentDoc}`;
export const FavoritePartsFragmentDoc = gql`
    fragment FavoriteParts on Favorite {
  id
  userId
  customerId
  products {
    productId
    product {
      ...ProductParts
    }
  }
}
    ${ProductPartsFragmentDoc}`;
export const AddressPartsFragmentDoc = gql`
    fragment AddressParts on Address {
  street1
  street2
  street3
  street4
  country
  postcode
  email
  firstName
  lastName
  mobile
  phone
  state
  suburb
  cityId
  country
  companyName
  notes
}
    `;
export const ColorPartsFragmentDoc = gql`
    fragment ColorParts on Color {
  main
  dark
  light
  contrastText
}
    `;
export const ThemePartsFragmentDoc = gql`
    fragment ThemeParts on TsunamiTheme {
  themeId
  customerId
  primary {
    ...ColorParts
  }
  secondary {
    ...ColorParts
  }
  background {
    ...ColorParts
  }
  navigationBar {
    background
    buttonActive
    textActive
    text
  }
  footer {
    background
    button
    text
  }
  pageHeader {
    background
    cart
    text
  }
  fonts {
    body
    navigationAndHeading
  }
  banners {
    fileName
    href
  }
  logo
}
    ${ColorPartsFragmentDoc}`;
export const GetCurrentUserDocument = gql`
    query GetCurrentUser {
  currentUser {
    firstName
    lastName
    email
    username
    mobile
    phone
    sitemaps {
      name
      pagePath
      seqNo
    }
    businessLevel {
      name
      crmid
    }
    shoppingCart {
      ...ShoppingCartParts
    }
    customer {
      customerId
      name
    }
    customerTheme {
      ...ThemeParts
    }
    customerFeatures {
      tsuCustomerFeatureId
      customerId
      access
      tsuFeatureId
      tsuFeature {
        name
        description
        active
      }
    }
    role {
      roleId
      adminRole
      discount
    }
  }
}
    ${ShoppingCartPartsFragmentDoc}
${ThemePartsFragmentDoc}`;

/**
 * __useGetCurrentUserQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<GetCurrentUserQuery, GetCurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentUserQuery, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
      }
export function useGetCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentUserQuery, GetCurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentUserQuery, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
        }
export type GetCurrentUserQueryHookResult = ReturnType<typeof useGetCurrentUserQuery>;
export type GetCurrentUserLazyQueryHookResult = ReturnType<typeof useGetCurrentUserLazyQuery>;
export type GetCurrentUserQueryResult = Apollo.QueryResult<GetCurrentUserQuery, GetCurrentUserQueryVariables>;
export const GetCurrentCustomerDocument = gql`
  query GetCurrentCustomer {
    currentCustomer {
      customerId
      name
    }
  }
`;

/**
 * __useGetCurrentCustomerQuery__
 *
 * To run a query within a React component, call `useGetCurrentCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentCustomerQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentCustomerQuery(baseOptions?: Apollo.QueryHookOptions<GetCurrentCustomerQuery, GetCurrentCustomerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentCustomerQuery, GetCurrentCustomerQueryVariables>(GetCurrentCustomerDocument, options);
      }
export function useGetCurrentCustomerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentCustomerQuery, GetCurrentCustomerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentCustomerQuery, GetCurrentCustomerQueryVariables>(GetCurrentCustomerDocument, options);
        }
export type GetCurrentCustomerQueryHookResult = ReturnType<typeof useGetCurrentCustomerQuery>;
export type GetCurrentCustomerLazyQueryHookResult = ReturnType<typeof useGetCurrentCustomerLazyQuery>;
export type GetCurrentCustomerQueryResult = Apollo.QueryResult<GetCurrentCustomerQuery, GetCurrentCustomerQueryVariables>;
export const LoginDocument = gql`
    mutation Login($email: String!, $password: String!) {
  userLogin(input: {email: $email, password: $password}) {
    token
    expires
    refreshToken
    refreshTokenExpires
  }
}
    `;
export type LoginMutationFn = Apollo.MutationFunction<LoginMutation, LoginMutationVariables>;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useLoginMutation(baseOptions?: Apollo.MutationHookOptions<LoginMutation, LoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument, options);
      }
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = Apollo.MutationResult<LoginMutation>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<LoginMutation, LoginMutationVariables>;
export const AddUserDocument = gql`
    mutation AddUser($input: CreateUserInputType!) {
  addUser(input: $input) {
    userId
    username
    email
  }
}
    `;
export type AddUserMutationFn = Apollo.MutationFunction<AddUserMutation, AddUserMutationVariables>;

/**
 * __useAddUserMutation__
 *
 * To run a mutation, you first call `useAddUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUserMutation, { data, loading, error }] = useAddUserMutation({
 *   variables: {
 *   },
 * });
 */
export function useAddUserMutation(baseOptions?: Apollo.MutationHookOptions<AddUserMutation, AddUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUserMutation, AddUserMutationVariables>(AddUserDocument, options);
      }
export type AddUserMutationHookResult = ReturnType<typeof useAddUserMutation>;
export type AddUserMutationResult = Apollo.MutationResult<AddUserMutation>;
export type AddUserMutationOptions = Apollo.BaseMutationOptions<AddUserMutation, AddUserMutationVariables>;
export const RefreshAccessTokenDocument = gql`
    mutation RefreshAccessToken($refreshToken: String!) {
  refreshAccessToken(refreshToken: $refreshToken) {
    token
    expires
    refreshToken
    refreshTokenExpires
  }
}
    `;
export type RefreshAccessTokenMutationFn = Apollo.MutationFunction<RefreshAccessTokenMutation, RefreshAccessTokenMutationVariables>;

/**
 * __useRefreshAccessTokenMutation__
 *
 * To run a mutation, you first call `useRefreshAccessTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshAccessTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshAccessTokenMutation, { data, loading, error }] = useRefreshAccessTokenMutation({
 *   variables: {
 *      refreshToken: // value for 'refreshToken'
 *   },
 * });
 */
export function useRefreshAccessTokenMutation(baseOptions?: Apollo.MutationHookOptions<RefreshAccessTokenMutation, RefreshAccessTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefreshAccessTokenMutation, RefreshAccessTokenMutationVariables>(RefreshAccessTokenDocument, options);
      }
export type RefreshAccessTokenMutationHookResult = ReturnType<typeof useRefreshAccessTokenMutation>;
export type RefreshAccessTokenMutationResult = Apollo.MutationResult<RefreshAccessTokenMutation>;
export type RefreshAccessTokenMutationOptions = Apollo.BaseMutationOptions<RefreshAccessTokenMutation, RefreshAccessTokenMutationVariables>;
export const ResetPasswordDocument = gql`
    mutation ResetPassword($resetToken: String!, $password: String!) {
  resetPassword(input: {resetToken: $resetToken, password: $password}) {
    success
  }
}
    `;
export type ResetPasswordMutationFn = Apollo.MutationFunction<ResetPasswordMutation, ResetPasswordMutationVariables>;

/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordMutation, { data, loading, error }] = useResetPasswordMutation({
 *   variables: {
 *      resetToken: // value for 'resetToken'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useResetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ResetPasswordMutation, ResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument, options);
      }
export type ResetPasswordMutationHookResult = ReturnType<typeof useResetPasswordMutation>;
export type ResetPasswordMutationResult = Apollo.MutationResult<ResetPasswordMutation>;
export type ResetPasswordMutationOptions = Apollo.BaseMutationOptions<ResetPasswordMutation, ResetPasswordMutationVariables>;
export const SecurityQuestionsDocument = gql`
    query SecurityQuestions {
  securityQuestions {
    sQuestionId
    sQuestion
  }
}
    `;

/**
 * __useSecurityQuestionsQuery__
 *
 * To run a query within a React component, call `useSecurityQuestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSecurityQuestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSecurityQuestionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSecurityQuestionsQuery(baseOptions?: Apollo.QueryHookOptions<SecurityQuestionsQuery, SecurityQuestionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SecurityQuestionsQuery, SecurityQuestionsQueryVariables>(SecurityQuestionsDocument, options);
      }
export function useSecurityQuestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SecurityQuestionsQuery, SecurityQuestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SecurityQuestionsQuery, SecurityQuestionsQueryVariables>(SecurityQuestionsDocument, options);
        }
export type SecurityQuestionsQueryHookResult = ReturnType<typeof useSecurityQuestionsQuery>;
export type SecurityQuestionsLazyQueryHookResult = ReturnType<typeof useSecurityQuestionsLazyQuery>;
export type SecurityQuestionsQueryResult = Apollo.QueryResult<SecurityQuestionsQuery, SecurityQuestionsQueryVariables>;
export const SendResetPasswordEmailDocument = gql`
    mutation SendResetPasswordEmail($email: String!) {
  resetEmail(input: {email: $email}) {
    success
  }
}
    `;
export type SendResetPasswordEmailMutationFn = Apollo.MutationFunction<SendResetPasswordEmailMutation, SendResetPasswordEmailMutationVariables>;

/**
 * __useSendResetPasswordEmailMutation__
 *
 * To run a mutation, you first call `useSendResetPasswordEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendResetPasswordEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendResetPasswordEmailMutation, { data, loading, error }] = useSendResetPasswordEmailMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useSendResetPasswordEmailMutation(baseOptions?: Apollo.MutationHookOptions<SendResetPasswordEmailMutation, SendResetPasswordEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendResetPasswordEmailMutation, SendResetPasswordEmailMutationVariables>(SendResetPasswordEmailDocument, options);
      }
export type SendResetPasswordEmailMutationHookResult = ReturnType<typeof useSendResetPasswordEmailMutation>;
export type SendResetPasswordEmailMutationResult = Apollo.MutationResult<SendResetPasswordEmailMutation>;
export type SendResetPasswordEmailMutationOptions = Apollo.BaseMutationOptions<SendResetPasswordEmailMutation, SendResetPasswordEmailMutationVariables>;
export const UpdateUserDetailsDocument = gql`
    mutation UpdateUserDetails($contactNumber: String!, $email: String!, $firstName: String!, $lastName: String!) {
  updateDetails(
    input: {contactNumber: $contactNumber, email: $email, firstName: $firstName, lastName: $lastName}
  ) {
    success
  }
}
    `;
export type UpdateUserDetailsMutationFn = Apollo.MutationFunction<UpdateUserDetailsMutation, UpdateUserDetailsMutationVariables>;

/**
 * __useUpdateUserDetailsMutation__
 *
 * To run a mutation, you first call `useUpdateUserDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserDetailsMutation, { data, loading, error }] = useUpdateUserDetailsMutation({
 *   variables: {
 *      contactNumber: // value for 'contactNumber'
 *      email: // value for 'email'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *   },
 * });
 */
export function useUpdateUserDetailsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserDetailsMutation, UpdateUserDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserDetailsMutation, UpdateUserDetailsMutationVariables>(UpdateUserDetailsDocument, options);
      }
export type UpdateUserDetailsMutationHookResult = ReturnType<typeof useUpdateUserDetailsMutation>;
export type UpdateUserDetailsMutationResult = Apollo.MutationResult<UpdateUserDetailsMutation>;
export type UpdateUserDetailsMutationOptions = Apollo.BaseMutationOptions<UpdateUserDetailsMutation, UpdateUserDetailsMutationVariables>;
export const CreateUserCartDocument = gql`
    mutation CreateUserCart($freightSettingId: Int!, $serviceCode: String, $chargeProcessingFee: Boolean!, $isUrgentOrder: Boolean!, $firstName: String!, $lastName: String!, $notes: String, $company: String!, $street1: String!, $suburb: String!, $postcode: String!, $state: String!, $country: String!, $phone: String!, $mobile: String, $email: String!, $cartLines: [CartLineInput!]!, $destructionMode: Boolean!) {
  createCart(
    input: {deliveryMethodId: $freightSettingId, deliveryServiceCode: $serviceCode, collect: false, manualOrder: $chargeProcessingFee, urgentPick: $isUrgentOrder, firstName: $firstName, lastName: $lastName, deliveryInstructions: $notes, deliveryAddress: {company: $company, street1: $street1, suburb: $suburb, postcode: $postcode, state: $state, country: $country, phone: $phone, mobile: $mobile, email: $email}, cartLines: $cartLines, destructionMode: $destructionMode}
  ) {
    id
    orderCosts {
      gst
      grandTotal
    }
    userId
  }
}
    `;
export type CreateUserCartMutationFn = Apollo.MutationFunction<CreateUserCartMutation, CreateUserCartMutationVariables>;

/**
 * __useCreateUserCartMutation__
 *
 * To run a mutation, you first call `useCreateUserCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserCartMutation, { data, loading, error }] = useCreateUserCartMutation({
 *   variables: {
 *      freightSettingId: // value for 'freightSettingId'
 *      serviceCode: // value for 'serviceCode'
 *      chargeProcessingFee: // value for 'chargeProcessingFee'
 *      isUrgentOrder: // value for 'isUrgentOrder'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      notes: // value for 'notes'
 *      company: // value for 'company'
 *      street1: // value for 'street1'
 *      suburb: // value for 'suburb'
 *      postcode: // value for 'postcode'
 *      state: // value for 'state'
 *      country: // value for 'country'
 *      phone: // value for 'phone'
 *      mobile: // value for 'mobile'
 *      email: // value for 'email'
 *      cartLines: // value for 'cartLines'
 *   },
 * });
 */
export function useCreateUserCartMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserCartMutation, CreateUserCartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserCartMutation, CreateUserCartMutationVariables>(CreateUserCartDocument, options);
      }
export type CreateUserCartMutationHookResult = ReturnType<typeof useCreateUserCartMutation>;
export type CreateUserCartMutationResult = Apollo.MutationResult<CreateUserCartMutation>;
export type CreateUserCartMutationOptions = Apollo.BaseMutationOptions<CreateUserCartMutation, CreateUserCartMutationVariables>;
export const GetShoppingCartDocument = gql`
    query GetShoppingCart {
  shoppingCart {
    ...ShoppingCartParts
  }
}
    ${ShoppingCartPartsFragmentDoc}`;

/**
 * __useGetShoppingCartQuery__
 *
 * To run a query within a React component, call `useGetShoppingCartQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShoppingCartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShoppingCartQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetShoppingCartQuery(baseOptions?: Apollo.QueryHookOptions<GetShoppingCartQuery, GetShoppingCartQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetShoppingCartQuery, GetShoppingCartQueryVariables>(GetShoppingCartDocument, options);
      }
export function useGetShoppingCartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetShoppingCartQuery, GetShoppingCartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetShoppingCartQuery, GetShoppingCartQueryVariables>(GetShoppingCartDocument, options);
        }
export type GetShoppingCartQueryHookResult = ReturnType<typeof useGetShoppingCartQuery>;
export type GetShoppingCartLazyQueryHookResult = ReturnType<typeof useGetShoppingCartLazyQuery>;
export type GetShoppingCartQueryResult = Apollo.QueryResult<GetShoppingCartQuery, GetShoppingCartQueryVariables>;
export const GetUserCartDocument = gql`
    query GetUserCart {
  userCart {
    id
    created
    cartInformation {
      billingAddress {
        company
        country
        email
        mobile
        phone
        postcode
        state
        street1
        street2
        suburb
      }
      deliveryAddress {
        company
        country
        email
        mobile
        phone
        postcode
        state
        street1
        street2
        suburb
      }
      cartLines {
        productId
        quantity
        productCode
        eTemplateId
      }
      clientOrderReference
      firstName
      lastName
      manualOrder
      urgentPick
      deliveryMethodId
      deliveryInstructions
    }
    orderCosts {
      ...OrderCostsParts
    }
  }
}
    ${OrderCostsPartsFragmentDoc}`;

/**
 * __useGetUserCartQuery__
 *
 * To run a query within a React component, call `useGetUserCartQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserCartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserCartQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserCartQuery(baseOptions?: Apollo.QueryHookOptions<GetUserCartQuery, GetUserCartQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserCartQuery, GetUserCartQueryVariables>(GetUserCartDocument, options);
      }
export function useGetUserCartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserCartQuery, GetUserCartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserCartQuery, GetUserCartQueryVariables>(GetUserCartDocument, options);
        }
export type GetUserCartQueryHookResult = ReturnType<typeof useGetUserCartQuery>;
export type GetUserCartLazyQueryHookResult = ReturnType<typeof useGetUserCartLazyQuery>;
export type GetUserCartQueryResult = Apollo.QueryResult<GetUserCartQuery, GetUserCartQueryVariables>;
export const ProductsTotalPriceDocument = gql`
    query ProductsTotalPrice($products: [ProductsTotalPriceItemInput!]!) {
  productsTotalPrice(input: {products: $products}) {
    total
  }
}
    `;

/**
 * __useProductsTotalPriceQuery__
 *
 * To run a query within a React component, call `useProductsTotalPriceQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductsTotalPriceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductsTotalPriceQuery({
 *   variables: {
 *      products: // value for 'products'
 *   },
 * });
 */
export function useProductsTotalPriceQuery(baseOptions: Apollo.QueryHookOptions<ProductsTotalPriceQuery, ProductsTotalPriceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductsTotalPriceQuery, ProductsTotalPriceQueryVariables>(ProductsTotalPriceDocument, options);
      }
export function useProductsTotalPriceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductsTotalPriceQuery, ProductsTotalPriceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductsTotalPriceQuery, ProductsTotalPriceQueryVariables>(ProductsTotalPriceDocument, options);
        }
export type ProductsTotalPriceQueryHookResult = ReturnType<typeof useProductsTotalPriceQuery>;
export type ProductsTotalPriceLazyQueryHookResult = ReturnType<typeof useProductsTotalPriceLazyQuery>;
export type ProductsTotalPriceQueryResult = Apollo.QueryResult<ProductsTotalPriceQuery, ProductsTotalPriceQueryVariables>;
export const UpdateShoppingCartDocument = gql`
    mutation UpdateShoppingCart($id: String, $cartItems: [ShoppingCartItemInput!]!) {
  updateShoppingCart(shoppingCartId: $id, cartItems: $cartItems) {
    ...ShoppingCartParts
  }
}
    ${ShoppingCartPartsFragmentDoc}`;
export type UpdateShoppingCartMutationFn = Apollo.MutationFunction<UpdateShoppingCartMutation, UpdateShoppingCartMutationVariables>;

/**
 * __useUpdateShoppingCartMutation__
 *
 * To run a mutation, you first call `useUpdateShoppingCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateShoppingCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateShoppingCartMutation, { data, loading, error }] = useUpdateShoppingCartMutation({
 *   variables: {
 *      id: // value for 'id'
 *      cartItems: // value for 'cartItems'
 *   },
 * });
 */
export function useUpdateShoppingCartMutation(baseOptions?: Apollo.MutationHookOptions<UpdateShoppingCartMutation, UpdateShoppingCartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateShoppingCartMutation, UpdateShoppingCartMutationVariables>(UpdateShoppingCartDocument, options);
      }
export type UpdateShoppingCartMutationHookResult = ReturnType<typeof useUpdateShoppingCartMutation>;
export type UpdateShoppingCartMutationResult = Apollo.MutationResult<UpdateShoppingCartMutation>;
export type UpdateShoppingCartMutationOptions = Apollo.BaseMutationOptions<UpdateShoppingCartMutation, UpdateShoppingCartMutationVariables>;
export const UpdateUserCartDocument = gql`
    mutation UpdateUserCart($cartId: String!, $freightSettingId: Int!, $serviceCode: String, $chargeProcessingFee: Boolean!, $isUrgentOrder: Boolean!, $firstName: String!, $lastName: String!, $notes: String, $company: String!, $street1: String!, $suburb: String!, $postcode: String!, $state: String!, $country: String!, $phone: String!, $mobile: String, $email: String!, $cartLines: [CartLineInput!]!) {
  updateCart(
    cartId: $cartId
    input: {deliveryMethodId: $freightSettingId, deliveryServiceCode: $serviceCode, collect: false, manualOrder: $chargeProcessingFee, urgentPick: $isUrgentOrder, firstName: $firstName, lastName: $lastName, deliveryInstructions: $notes, deliveryAddress: {company: $company, street1: $street1, suburb: $suburb, postcode: $postcode, state: $state, country: $country, phone: $phone, mobile: $mobile, email: $email}, cartLines: $cartLines}
  ) {
    id
    orderCosts {
      ...OrderCostsParts
    }
    userId
  }
}
    ${OrderCostsPartsFragmentDoc}`;
export type UpdateUserCartMutationFn = Apollo.MutationFunction<UpdateUserCartMutation, UpdateUserCartMutationVariables>;

/**
 * __useUpdateUserCartMutation__
 *
 * To run a mutation, you first call `useUpdateUserCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserCartMutation, { data, loading, error }] = useUpdateUserCartMutation({
 *   variables: {
 *      cartId: // value for 'cartId'
 *      freightSettingId: // value for 'freightSettingId'
 *      serviceCode: // value for 'serviceCode'
 *      chargeProcessingFee: // value for 'chargeProcessingFee'
 *      isUrgentOrder: // value for 'isUrgentOrder'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      notes: // value for 'notes'
 *      company: // value for 'company'
 *      street1: // value for 'street1'
 *      suburb: // value for 'suburb'
 *      postcode: // value for 'postcode'
 *      state: // value for 'state'
 *      country: // value for 'country'
 *      phone: // value for 'phone'
 *      mobile: // value for 'mobile'
 *      email: // value for 'email'
 *      cartLines: // value for 'cartLines'
 *   },
 * });
 */
export function useUpdateUserCartMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserCartMutation, UpdateUserCartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserCartMutation, UpdateUserCartMutationVariables>(UpdateUserCartDocument, options);
      }
export type UpdateUserCartMutationHookResult = ReturnType<typeof useUpdateUserCartMutation>;
export type UpdateUserCartMutationResult = Apollo.MutationResult<UpdateUserCartMutation>;
export type UpdateUserCartMutationOptions = Apollo.BaseMutationOptions<UpdateUserCartMutation, UpdateUserCartMutationVariables>;
export const ContactUsDocument = gql`
    mutation ContactUs($name: String!, $email: String!, $message: String!) {
  contactUs(input: {name: $name, email: $email, message: $message}) {
    message
  }
}
    `;
export type ContactUsMutationFn = Apollo.MutationFunction<ContactUsMutation, ContactUsMutationVariables>;

/**
 * __useContactUsMutation__
 *
 * To run a mutation, you first call `useContactUsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContactUsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contactUsMutation, { data, loading, error }] = useContactUsMutation({
 *   variables: {
 *      name: // value for 'name'
 *      email: // value for 'email'
 *      message: // value for 'message'
 *   },
 * });
 */
export function useContactUsMutation(baseOptions?: Apollo.MutationHookOptions<ContactUsMutation, ContactUsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ContactUsMutation, ContactUsMutationVariables>(ContactUsDocument, options);
      }
export type ContactUsMutationHookResult = ReturnType<typeof useContactUsMutation>;
export type ContactUsMutationResult = Apollo.MutationResult<ContactUsMutation>;
export type ContactUsMutationOptions = Apollo.BaseMutationOptions<ContactUsMutation, ContactUsMutationVariables>;
export const AutoPopulateCustomerFeaturesDocument = gql`
    mutation AutoPopulateCustomerFeatures {
  autoPopulateCustomerFeatures {
    success
  }
}
    `;
export type AutoPopulateCustomerFeaturesMutationFn = Apollo.MutationFunction<AutoPopulateCustomerFeaturesMutation, AutoPopulateCustomerFeaturesMutationVariables>;

/**
 * __useAutoPopulateCustomerFeaturesMutation__
 *
 * To run a mutation, you first call `useAutoPopulateCustomerFeaturesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAutoPopulateCustomerFeaturesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [autoPopulateCustomerFeaturesMutation, { data, loading, error }] = useAutoPopulateCustomerFeaturesMutation({
 *   variables: {
 *   },
 * });
 */
export function useAutoPopulateCustomerFeaturesMutation(baseOptions?: Apollo.MutationHookOptions<AutoPopulateCustomerFeaturesMutation, AutoPopulateCustomerFeaturesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AutoPopulateCustomerFeaturesMutation, AutoPopulateCustomerFeaturesMutationVariables>(AutoPopulateCustomerFeaturesDocument, options);
      }
export type AutoPopulateCustomerFeaturesMutationHookResult = ReturnType<typeof useAutoPopulateCustomerFeaturesMutation>;
export type AutoPopulateCustomerFeaturesMutationResult = Apollo.MutationResult<AutoPopulateCustomerFeaturesMutation>;
export type AutoPopulateCustomerFeaturesMutationOptions = Apollo.BaseMutationOptions<AutoPopulateCustomerFeaturesMutation, AutoPopulateCustomerFeaturesMutationVariables>;
export const ChangeCustomerDocument = gql`
    mutation ChangeCustomer($customerId: Int!) {
  changeCustomer(input: {custId: $customerId}) {
    token
    refreshToken
    expires
    refreshTokenExpires
  }
}
    `;
export type ChangeCustomerMutationFn = Apollo.MutationFunction<ChangeCustomerMutation, ChangeCustomerMutationVariables>;

/**
 * __useChangeCustomerMutation__
 *
 * To run a mutation, you first call `useChangeCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeCustomerMutation, { data, loading, error }] = useChangeCustomerMutation({
 *   variables: {
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useChangeCustomerMutation(baseOptions?: Apollo.MutationHookOptions<ChangeCustomerMutation, ChangeCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeCustomerMutation, ChangeCustomerMutationVariables>(ChangeCustomerDocument, options);
      }
export type ChangeCustomerMutationHookResult = ReturnType<typeof useChangeCustomerMutation>;
export type ChangeCustomerMutationResult = Apollo.MutationResult<ChangeCustomerMutation>;
export type ChangeCustomerMutationOptions = Apollo.BaseMutationOptions<ChangeCustomerMutation, ChangeCustomerMutationVariables>;
export const GetCustomerFeaturesDocument = gql`
    query GetCustomerFeatures {
  customerFeatures {
    tsuCustomerFeatureId
    customerId
    access
    tsuFeatureId
    tsuFeature {
      name
      description
      active
    }
  }
}
    `;

/**
 * __useGetCustomerFeaturesQuery__
 *
 * To run a query within a React component, call `useGetCustomerFeaturesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerFeaturesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerFeaturesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCustomerFeaturesQuery(baseOptions?: Apollo.QueryHookOptions<GetCustomerFeaturesQuery, GetCustomerFeaturesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomerFeaturesQuery, GetCustomerFeaturesQueryVariables>(GetCustomerFeaturesDocument, options);
      }
export function useGetCustomerFeaturesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomerFeaturesQuery, GetCustomerFeaturesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomerFeaturesQuery, GetCustomerFeaturesQueryVariables>(GetCustomerFeaturesDocument, options);
        }
export type GetCustomerFeaturesQueryHookResult = ReturnType<typeof useGetCustomerFeaturesQuery>;
export type GetCustomerFeaturesLazyQueryHookResult = ReturnType<typeof useGetCustomerFeaturesLazyQuery>;
export type GetCustomerFeaturesQueryResult = Apollo.QueryResult<GetCustomerFeaturesQuery, GetCustomerFeaturesQueryVariables>;
export const GetCustomersDocument = gql`
    query GetCustomers {
  customers {
    customerId
    name
  }
}
    `;

/**
 * __useGetCustomersQuery__
 *
 * To run a query within a React component, call `useGetCustomersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCustomersQuery(baseOptions?: Apollo.QueryHookOptions<GetCustomersQuery, GetCustomersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomersQuery, GetCustomersQueryVariables>(GetCustomersDocument, options);
      }
export function useGetCustomersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomersQuery, GetCustomersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomersQuery, GetCustomersQueryVariables>(GetCustomersDocument, options);
        }
export type GetCustomersQueryHookResult = ReturnType<typeof useGetCustomersQuery>;
export type GetCustomersLazyQueryHookResult = ReturnType<typeof useGetCustomersLazyQuery>;
export type GetCustomersQueryResult = Apollo.QueryResult<GetCustomersQuery, GetCustomersQueryVariables>;
export const GetCustomerBusinessLevelsDocument = gql`
    query GetCustomerBusinessLevels {
  customerBusinessLevels {
    businessLevelId
    accpacAccount
    approverFirstOrderValue
    approverSecondOrderValue
    active
    customerId
    customerBlid
    name
    abn
    orderNotifyEmail
    primaryApproverId
    secondaryApproverId
    webAddress
    deliveryAddress {
      active
      street1
      suburb
      state
      name
      email
      country
      notes
      postcode
      companyName
    }
    billingAddress {
      active
      street1
      suburb
      state
      name
      email
      country
      notes
      postcode
      companyName
    }
  }
}`;

/**
 * __useGetCustomerBusinessLevelsQuery__
 *
 * To run a query within a React component, call `useGetCustomerBusinessLevelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerBusinessLevelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerBusinessLevelsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCustomerBusinessLevelsQuery(baseOptions?: Apollo.QueryHookOptions<GetCustomerBusinessLevelsQuery, GetCustomerBusinessLevelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomerBusinessLevelsQuery, GetCustomerBusinessLevelsQueryVariables>(GetCustomerBusinessLevelsDocument, options);
      }
export function useGetCustomerBusinessLevelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomerBusinessLevelsQuery, GetCustomerBusinessLevelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomerBusinessLevelsQuery, GetCustomerBusinessLevelsQueryVariables>(GetCustomerBusinessLevelsDocument, options);
        }
export type GetCustomerBusinessLevelsQueryHookResult = ReturnType<typeof useGetCustomerBusinessLevelsQuery>;
export type GetCustomerBusinessLevelsLazyQueryHookResult = ReturnType<typeof useGetCustomerBusinessLevelsLazyQuery>;
export type GetCustomerBusinessLevelsQueryResult = Apollo.QueryResult<GetCustomerBusinessLevelsQuery, GetCustomerBusinessLevelsQueryVariables>;
export const UpdateCustomerFeaturesDocument = gql`
    mutation UpdateCustomerFeatures($tsuCustomerFeatureId: Int!, $access: Boolean!) {
  updateCustomerFeature(
    input: {custFeatureId: $tsuCustomerFeatureId, access: $access}
  ) {
    tsuFeatureId
    tsuCustomerFeatureId
    access
  }
}
    `;
export type UpdateCustomerFeaturesMutationFn = Apollo.MutationFunction<UpdateCustomerFeaturesMutation, UpdateCustomerFeaturesMutationVariables>;

/**
 * __useUpdateCustomerFeaturesMutation__
 *
 * To run a mutation, you first call `useUpdateCustomerFeaturesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomerFeaturesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomerFeaturesMutation, { data, loading, error }] = useUpdateCustomerFeaturesMutation({
 *   variables: {
 *      tsuCustomerFeatureId: // value for 'tsuCustomerFeatureId'
 *      access: // value for 'access'
 *   },
 * });
 */
export function useUpdateCustomerFeaturesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCustomerFeaturesMutation, UpdateCustomerFeaturesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCustomerFeaturesMutation, UpdateCustomerFeaturesMutationVariables>(UpdateCustomerFeaturesDocument, options);
      }
export type UpdateCustomerFeaturesMutationHookResult = ReturnType<typeof useUpdateCustomerFeaturesMutation>;
export type UpdateCustomerFeaturesMutationResult = Apollo.MutationResult<UpdateCustomerFeaturesMutation>;
export type UpdateCustomerFeaturesMutationOptions = Apollo.BaseMutationOptions<UpdateCustomerFeaturesMutation, UpdateCustomerFeaturesMutationVariables>;
export const UpdateMultipleCustomerFeaturesDocument = gql`
    mutation UpdateMultipleCustomerFeatures($updates: [UpdateCustomerFeatureInput!]!) {
  updateMultipleCustomerFeatures(input: {updates: $updates}) {
    tsuFeatureId
    tsuCustomerFeatureId
    access
  }
}
    `;
export type UpdateMultipleCustomerFeaturesMutationFn = Apollo.MutationFunction<UpdateMultipleCustomerFeaturesMutation, UpdateMultipleCustomerFeaturesMutationVariables>;

/**
 * __useUpdateMultipleCustomerFeaturesMutation__
 *
 * To run a mutation, you first call `useUpdateMultipleCustomerFeaturesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMultipleCustomerFeaturesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMultipleCustomerFeaturesMutation, { data, loading, error }] = useUpdateMultipleCustomerFeaturesMutation({
 *   variables: {
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdateMultipleCustomerFeaturesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMultipleCustomerFeaturesMutation, UpdateMultipleCustomerFeaturesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMultipleCustomerFeaturesMutation, UpdateMultipleCustomerFeaturesMutationVariables>(UpdateMultipleCustomerFeaturesDocument, options);
      }
export type UpdateMultipleCustomerFeaturesMutationHookResult = ReturnType<typeof useUpdateMultipleCustomerFeaturesMutation>;
export type UpdateMultipleCustomerFeaturesMutationResult = Apollo.MutationResult<UpdateMultipleCustomerFeaturesMutation>;
export type UpdateMultipleCustomerFeaturesMutationOptions = Apollo.BaseMutationOptions<UpdateMultipleCustomerFeaturesMutation, UpdateMultipleCustomerFeaturesMutationVariables>;
export const TopOrderedProductsDocument = gql`
    query TopOrderedProducts($skip: Int, $take: Int) {
  topOrderedProducts(monthsTrailing: 1, skip: $skip, take: $take) {
    totalCount
    items {
      productCode
      productName
      productsSold
      totalQuantity
    }
  }
}
    `;

/**
 * __useTopOrderedProductsQuery__
 *
 * To run a query within a React component, call `useTopOrderedProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTopOrderedProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTopOrderedProductsQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useTopOrderedProductsQuery(baseOptions?: Apollo.QueryHookOptions<TopOrderedProductsQuery, TopOrderedProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TopOrderedProductsQuery, TopOrderedProductsQueryVariables>(TopOrderedProductsDocument, options);
      }
export function useTopOrderedProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TopOrderedProductsQuery, TopOrderedProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TopOrderedProductsQuery, TopOrderedProductsQueryVariables>(TopOrderedProductsDocument, options);
        }
export type TopOrderedProductsQueryHookResult = ReturnType<typeof useTopOrderedProductsQuery>;
export type TopOrderedProductsLazyQueryHookResult = ReturnType<typeof useTopOrderedProductsLazyQuery>;
export type TopOrderedProductsQueryResult = Apollo.QueryResult<TopOrderedProductsQuery, TopOrderedProductsQueryVariables>;
export const FaqsDocument = gql`
    query Faqs {
  faqs {
    fQuestion
    fAnswer
  }
}
    `;

/**
 * __useFaqsQuery__
 *
 * To run a query within a React component, call `useFaqsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFaqsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFaqsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFaqsQuery(baseOptions?: Apollo.QueryHookOptions<FaqsQuery, FaqsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FaqsQuery, FaqsQueryVariables>(FaqsDocument, options);
      }
export function useFaqsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FaqsQuery, FaqsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FaqsQuery, FaqsQueryVariables>(FaqsDocument, options);
        }
export type FaqsQueryHookResult = ReturnType<typeof useFaqsQuery>;
export type FaqsLazyQueryHookResult = ReturnType<typeof useFaqsLazyQuery>;
export type FaqsQueryResult = Apollo.QueryResult<FaqsQuery, FaqsQueryVariables>;
export const GetFavoritesDocument = gql`
    query GetFavorites {
  favorites {
    ...FavoriteParts
  }
}
    ${FavoritePartsFragmentDoc}`;

/**
 * __useGetFavoritesQuery__
 *
 * To run a query within a React component, call `useGetFavoritesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFavoritesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFavoritesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFavoritesQuery(baseOptions?: Apollo.QueryHookOptions<GetFavoritesQuery, GetFavoritesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFavoritesQuery, GetFavoritesQueryVariables>(GetFavoritesDocument, options);
      }
export function useGetFavoritesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFavoritesQuery, GetFavoritesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFavoritesQuery, GetFavoritesQueryVariables>(GetFavoritesDocument, options);
        }
export type GetFavoritesQueryHookResult = ReturnType<typeof useGetFavoritesQuery>;
export type GetFavoritesLazyQueryHookResult = ReturnType<typeof useGetFavoritesLazyQuery>;
export type GetFavoritesQueryResult = Apollo.QueryResult<GetFavoritesQuery, GetFavoritesQueryVariables>;
export const UpdateFavoritesDocument = gql`
    mutation UpdateFavorites($favoriteId: String, $input: [FavoriteProductEntryInput!]!) {
  updateFavorites(favoriteId: $favoriteId, input: $input) {
    id
  }
}
    `;
export type UpdateFavoritesMutationFn = Apollo.MutationFunction<UpdateFavoritesMutation, UpdateFavoritesMutationVariables>;

/**
 * __useUpdateFavoritesMutation__
 *
 * To run a mutation, you first call `useUpdateFavoritesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFavoritesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFavoritesMutation, { data, loading, error }] = useUpdateFavoritesMutation({
 *   variables: {
 *      favoriteId: // value for 'favoriteId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFavoritesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFavoritesMutation, UpdateFavoritesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFavoritesMutation, UpdateFavoritesMutationVariables>(UpdateFavoritesDocument, options);
      }
export type UpdateFavoritesMutationHookResult = ReturnType<typeof useUpdateFavoritesMutation>;
export type UpdateFavoritesMutationResult = Apollo.MutationResult<UpdateFavoritesMutation>;
export type UpdateFavoritesMutationOptions = Apollo.BaseMutationOptions<UpdateFavoritesMutation, UpdateFavoritesMutationVariables>;
export const ApproveMultipleOrderShippingsDocument = gql`
    mutation ApproveMultipleOrderShippings($input: ApproveMultipleOrderShippingsInput!) {
  approveMultipleOrderShippings(input: $input) {
    orderId
    orderShipId
    status {
      statusId
      name
    }
  }
}
    `;
export type ApproveMultipleOrderShippingsMutationFn = Apollo.MutationFunction<ApproveMultipleOrderShippingsMutation, ApproveMultipleOrderShippingsMutationVariables>;

/**
 * __useApproveMultipleOrderShippingsMutation__
 *
 * To run a mutation, you first call `useApproveMultipleOrderShippingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveMultipleOrderShippingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveMultipleOrderShippingsMutation, { data, loading, error }] = useApproveMultipleOrderShippingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApproveMultipleOrderShippingsMutation(baseOptions?: Apollo.MutationHookOptions<ApproveMultipleOrderShippingsMutation, ApproveMultipleOrderShippingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveMultipleOrderShippingsMutation, ApproveMultipleOrderShippingsMutationVariables>(ApproveMultipleOrderShippingsDocument, options);
      }
export type ApproveMultipleOrderShippingsMutationHookResult = ReturnType<typeof useApproveMultipleOrderShippingsMutation>;
export type ApproveMultipleOrderShippingsMutationResult = Apollo.MutationResult<ApproveMultipleOrderShippingsMutation>;
export type ApproveMultipleOrderShippingsMutationOptions = Apollo.BaseMutationOptions<ApproveMultipleOrderShippingsMutation, ApproveMultipleOrderShippingsMutationVariables>;
export const ApproveOrderShippingDocument = gql`
    mutation ApproveOrderShipping($input: ApproveOrderShippingInput!) {
  approveOrderShipping(input: $input) {
    orderId
    orderShipId
    status {
      statusId
      name
    }
  }
}
    `;
export type ApproveOrderShippingMutationFn = Apollo.MutationFunction<ApproveOrderShippingMutation, ApproveOrderShippingMutationVariables>;

/**
 * __useApproveOrderShippingMutation__
 *
 * To run a mutation, you first call `useApproveOrderShippingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveOrderShippingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveOrderShippingMutation, { data, loading, error }] = useApproveOrderShippingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApproveOrderShippingMutation(baseOptions?: Apollo.MutationHookOptions<ApproveOrderShippingMutation, ApproveOrderShippingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveOrderShippingMutation, ApproveOrderShippingMutationVariables>(ApproveOrderShippingDocument, options);
      }
export type ApproveOrderShippingMutationHookResult = ReturnType<typeof useApproveOrderShippingMutation>;
export type ApproveOrderShippingMutationResult = Apollo.MutationResult<ApproveOrderShippingMutation>;
export type ApproveOrderShippingMutationOptions = Apollo.BaseMutationOptions<ApproveOrderShippingMutation, ApproveOrderShippingMutationVariables>;
export const CancelOrderShippingDocument = gql`
    mutation CancelOrderShipping($input: ApproveOrderShippingInput!) {
  cancelOrderShipping(input: $input) {
    orderId
    orderShipId
    status {
      statusId
      name
    }
  }
}
    `;
export type CancelOrderShippingMutationFn = Apollo.MutationFunction<CancelOrderShippingMutation, CancelOrderShippingMutationVariables>;

/**
 * __useCancelOrderShippingMutation__
 *
 * To run a mutation, you first call `useCancelOrderShippingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelOrderShippingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelOrderShippingMutation, { data, loading, error }] = useCancelOrderShippingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCancelOrderShippingMutation(baseOptions?: Apollo.MutationHookOptions<CancelOrderShippingMutation, CancelOrderShippingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelOrderShippingMutation, CancelOrderShippingMutationVariables>(CancelOrderShippingDocument, options);
      }
export type CancelOrderShippingMutationHookResult = ReturnType<typeof useCancelOrderShippingMutation>;
export type CancelOrderShippingMutationResult = Apollo.MutationResult<CancelOrderShippingMutation>;
export type CancelOrderShippingMutationOptions = Apollo.BaseMutationOptions<CancelOrderShippingMutation, CancelOrderShippingMutationVariables>;
export const UpdateOrderShippingFeeDocument = gql`
    mutation UpdateOrderShippingFee($input: UpdateOrderShippingFeeInput!) {
  updateOrderShippingFee(input: $input) {
    orderId
    orderShipId
    status {
      statusId
      name
    }
  }
}
    `;
export type UpdateOrderShippingFeeMutationFn = Apollo.MutationFunction<UpdateOrderShippingFeeMutation, UpdateOrderShippingFeeMutationVariables>;

/**
 * __useUpdateOrderShippingFeeMutation__
 *
 * To run a mutation, you first call `useUpdateOrderShippingFeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrderShippingFeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrderShippingFeeMutation, { data, loading, error }] = useUpdateOrderShippingFeeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrderShippingFeeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrderShippingFeeMutation, UpdateOrderShippingFeeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrderShippingFeeMutation, UpdateOrderShippingFeeMutationVariables>(UpdateOrderShippingFeeDocument, options);
      }
export type UpdateOrderShippingFeeMutationHookResult = ReturnType<typeof useUpdateOrderShippingFeeMutation>;
export type UpdateOrderShippingFeeMutationResult = Apollo.MutationResult<UpdateOrderShippingFeeMutation>;
export type UpdateOrderShippingFeeMutationOptions = Apollo.BaseMutationOptions<UpdateOrderShippingFeeMutation, UpdateOrderShippingFeeMutationVariables>;
export const UpdateOrderLineQuantityDocument = gql`
  mutation UpdateOrderLineQuantity ($input: UpdateOrderLineQuantityInput!){
    updateOrderLineQuantity(input: $input)
    {
        orderLineId
        quantity
        active
    }
  }
    `;
export type UpdateOrderLineQuantityMutationFn = Apollo.MutationFunction<UpdateOrderLineQuantityMutation, UpdateOrderLineQuantityMutationVariables>;

/**
 * __useUpdateOrderLineQuantityMutation__
 *
 * To run a mutation, you first call `useUpdateOrderLineQuantityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrderLineQuantityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrderLineQuantityMutation, { data, loading, error }] = useUpdateOrderLineQuantityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrderLineQuantityMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrderLineQuantityMutation, UpdateOrderLineQuantityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrderLineQuantityMutation, UpdateOrderLineQuantityMutationVariables>(UpdateOrderLineQuantityDocument, options);
      }
export type UpdateOrderLineQuantityMutationHookResult = ReturnType<typeof useUpdateOrderLineQuantityMutation>;
export type UpdateOrderLineQuantityMutationResult = Apollo.MutationResult<UpdateOrderLineQuantityMutation>;
export type UpdateOrderLineQuantityMutationOptions = Apollo.BaseMutationOptions<UpdateOrderLineQuantityMutation, UpdateOrderLineQuantityMutationVariables>;
export const UpdateOrderShippingStatusDocument = gql`
    mutation UpdateOrderShippingStatus($input: UpdateOrderShippingStatusInput!) {
  updateOrderShippingStatus(input: $input) {
    orderId
    orderShipId
    status {
      statusId
      name
    }
  }
}
    `;
export type UpdateOrderShippingStatusMutationFn = Apollo.MutationFunction<UpdateOrderShippingStatusMutation, UpdateOrderShippingStatusMutationVariables>;

/**
 * __useUpdateOrderShippingStatusMutation__
 *
 * To run a mutation, you first call `useUpdateOrderShippingStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrderShippingStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrderShippingStatusMutation, { data, loading, error }] = useUpdateOrderShippingStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrderShippingStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrderShippingStatusMutation, UpdateOrderShippingStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrderShippingStatusMutation, UpdateOrderShippingStatusMutationVariables>(UpdateOrderShippingStatusDocument, options);
      }
export type UpdateOrderShippingStatusMutationHookResult = ReturnType<typeof useUpdateOrderShippingStatusMutation>;
export type UpdateOrderShippingStatusMutationResult = Apollo.MutationResult<UpdateOrderShippingStatusMutation>;
export type UpdateOrderShippingStatusMutationOptions = Apollo.BaseMutationOptions<UpdateOrderShippingStatusMutation, UpdateOrderShippingStatusMutationVariables>;
export const UpdateOrderSavedDocument = gql`
    mutation UpdateOrderSaved($input: UpdateOrderSavedInput!) {
  updateOrderSaved(input: $input) {
    orderId
  }
}
    `;
export type UpdateOrderSavedMutationFn = Apollo.MutationFunction<UpdateOrderSavedMutation, UpdateOrderSavedMutationVariables>;

/**
 * __useUpdateOrderSavedMutation__
 *
 * To run a mutation, you first call `useUpdateOrderSavedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrderSavedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrderSavedMutation, { data, loading, error }] = useUpdateOrderSavedMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrderSavedMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrderSavedMutation, UpdateOrderSavedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrderSavedMutation, UpdateOrderSavedMutationVariables>(UpdateOrderSavedDocument, options);
      }
export type UpdateOrderSavedMutationHookResult = ReturnType<typeof useUpdateOrderSavedMutation>;
export type UpdateOrderSavedMutationResult = Apollo.MutationResult<UpdateOrderSavedMutation>;
export type UpdateOrderSavedMutationOptions = Apollo.BaseMutationOptions<UpdateOrderSavedMutation, UpdateOrderSavedMutationVariables>;
export const GetOrderShippingsForApprovalDocument = gql`
    query GetOrderShippingsForApproval($skip: Int, $take: Int, $where: OrderShippingFilterInput) {
  orderShippingsForApproval(
    skip: $skip
    take: $take
    where: $where
    order: {created: DESC}
  ) {
    totalCount
    items {
      billingCompanyName
      billingMobile
      orderShipId
      order {
        orderId
      }
      created
      deliveryUserFirstName
      deliveryUserLastName
      deliveryCompanyName
      deliveryMobile
      deliveryEmail
      deliveryMethod
      deliveryPhone
      deliveryStreet1
      deliverySuburb
      deliveryState
      deliveryPostcode
      despatchedDate
      orderedByUser {
        userId
        firstName
        lastName
      }
      orderLines {
        orderLineId
        productId
        productCode
        active
        quantity
        unitSell
        feeLine
        product {
          productId
          stockAvailable
          name
          code
          prices {
            price
          }
        }
      }
      minimumDespatchDate
      status {
        name
      }
    }
  }
}
    `;

/**
 * __useGetOrderShippingsForApprovalQuery__
 *
 * To run a query within a React component, call `useGetOrderShippingsForApprovalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderShippingsForApprovalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderShippingsForApprovalQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetOrderShippingsForApprovalQuery(baseOptions?: Apollo.QueryHookOptions<GetOrderShippingsForApprovalQuery, GetOrderShippingsForApprovalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrderShippingsForApprovalQuery, GetOrderShippingsForApprovalQueryVariables>(GetOrderShippingsForApprovalDocument, options);
      }
export function useGetOrderShippingsForApprovalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrderShippingsForApprovalQuery, GetOrderShippingsForApprovalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrderShippingsForApprovalQuery, GetOrderShippingsForApprovalQueryVariables>(GetOrderShippingsForApprovalDocument, options);
        }
export type GetOrderShippingsForApprovalQueryHookResult = ReturnType<typeof useGetOrderShippingsForApprovalQuery>;
export type GetOrderShippingsForApprovalLazyQueryHookResult = ReturnType<typeof useGetOrderShippingsForApprovalLazyQuery>;
export type GetOrderShippingsForApprovalQueryResult = Apollo.QueryResult<GetOrderShippingsForApprovalQuery, GetOrderShippingsForApprovalQueryVariables>;
export const GetOrderDetailDocument = gql`
    query GetOrderDetail($orderId: Int!) {
  orderDetail(orderId: $orderId) {
    orderId
    customerId
    orderShippings {
      orderShipId
      deliveryMethod
      grandTotal
      orderedByUser {
        firstName
        lastName
      }
      deliveryUserFirstName
      deliveryUserLastName
      deliveryEmail
      deliveryPhone
      deliveryMobile
      deliveryCompanyName
      grandTotal
      orderLines {
        quantity
        unitSell
      }
      created
    }
  }
}
    `;

/**
 * __useGetOrderDetailQuery__
 *
 * To run a query within a React component, call `useGetOrderDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderDetailQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useGetOrderDetailQuery(baseOptions: Apollo.QueryHookOptions<GetOrderDetailQuery, GetOrderDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrderDetailQuery, GetOrderDetailQueryVariables>(GetOrderDetailDocument, options);
      }
export function useGetOrderDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrderDetailQuery, GetOrderDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrderDetailQuery, GetOrderDetailQueryVariables>(GetOrderDetailDocument, options);
        }
export type GetOrderDetailQueryHookResult = ReturnType<typeof useGetOrderDetailQuery>;
export type GetOrderDetailLazyQueryHookResult = ReturnType<typeof useGetOrderDetailLazyQuery>;
export type GetOrderDetailQueryResult = Apollo.QueryResult<GetOrderDetailQuery, GetOrderDetailQueryVariables>;
export const GetOrdersInProgressDocument = gql`
    query GetOrdersInProgress($skip: Int, $take: Int) {
  ordersInProgress(skip: $skip, take: $take) {
    totalCount
    items {
      orderId
      created
      userCreatedFirstName
      userCreatedLastName
      orderShippings {
        orderShipId
        deliveryCompanyName
        deliveryMobile
        deliveryEmail
        deliveryMethod
        deliveryPhone
        deliveryStreet1
        deliverySuburb
        deliveryState
        deliveryPostcode
        orderLines {
          quantity
          unitSell
          feeLine
          product {
            productId
            name
            code
            prices {
              price
            }
          }
        }
        status {
          name
        }
      }
    }
  }
}
    `;

/**
 * __useOrdersInProgressQuery__
 *
 * To run a query within a React component, call `useGetOrdersInProgressQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrdersInProgressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrdersInProgressQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useGetOrdersInProgressQuery(baseOptions?: Apollo.QueryHookOptions<GetOrdersInProgressQuery, GetOrdersInProgressQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrdersInProgressQuery, GetOrdersInProgressQueryVariables>(GetOrdersInProgressDocument, options);
      }
export function useGetOrdersInProgressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrdersInProgressQuery, GetOrdersInProgressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrdersInProgressQuery, GetOrdersInProgressQueryVariables>(GetOrdersInProgressDocument, options);
        }
export type GetOrdersInProgressQueryHookResult = ReturnType<typeof useGetOrdersInProgressQuery>;
export type GetOrdersInProgressLazyQueryHookResult = ReturnType<typeof useGetOrdersInProgressLazyQuery>;
export type GetOrdersInProgressQueryResult = Apollo.QueryResult<GetOrdersInProgressQuery, GetOrdersInProgressQueryVariables>;
export const GetSavedOrdersDocument = gql`
    query GetSavedOrders($skip: Int, $take: Int) {
  savedOrders(skip: $skip, take: $take) {
    totalCount
    items {
      orderId
      despatchDate
      created
      orderShippings {
        orderShipId
        orderLines {
          productId
          quantity
        }
      }
    }
  }
}
    `;

/**
 * __useGetSavedOrdersQuery__
 *
 * To run a query within a React component, call `useGetSavedOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSavedOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSavedOrdersQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useGetSavedOrdersQuery(baseOptions?: Apollo.QueryHookOptions<GetSavedOrdersQuery, GetSavedOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSavedOrdersQuery, GetSavedOrdersQueryVariables>(GetSavedOrdersDocument, options);
      }
export function useGetSavedOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSavedOrdersQuery, GetSavedOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSavedOrdersQuery, GetSavedOrdersQueryVariables>(GetSavedOrdersDocument, options);
        }
export type GetSavedOrdersQueryHookResult = ReturnType<typeof useGetSavedOrdersQuery>;
export type GetSavedOrdersLazyQueryHookResult = ReturnType<typeof useGetSavedOrdersLazyQuery>;
export type GetSavedOrdersQueryResult = Apollo.QueryResult<GetSavedOrdersQuery, GetSavedOrdersQueryVariables>;
export const GetSharedPaymentUrlDocument = gql`
    query GetSharedPaymentUrl($input: EWayTransactionInput!) {
  sharedPaymentUrl(input: $input)
}
    `;

/**
 * __useSharedPaymentUrlQuery__
 *
 * To run a query within a React component, call `useGetSharedPaymentUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSharedPaymentUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSharedPaymentUrlQuery({
 *   variables: {
 *      totalAmount: // value for 'totalAmount'
 *   },
 * });
 */
export function useGetSharedPaymentUrlQuery(baseOptions?: Apollo.QueryHookOptions<GetSharedPaymentUrlQuery, GetSharedPaymentUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSharedPaymentUrlQuery, GetSharedPaymentUrlQueryVariables>(GetSharedPaymentUrlDocument, options);
      }
export function useGetSharedPaymentUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSharedPaymentUrlQuery, GetSharedPaymentUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSharedPaymentUrlQuery, GetSharedPaymentUrlQueryVariables>(GetSharedPaymentUrlDocument, options);
        }
export type GetSharedPaymentUrlQueryHookResult = ReturnType<typeof useGetSharedPaymentUrlQuery>;
export type GetSharedPaymentUrlLazyQueryHookResult = ReturnType<typeof useGetSharedPaymentUrlLazyQuery>;
export type GetSharedPaymentUrlQueryResult = Apollo.QueryResult<GetSharedPaymentUrlQuery, GetSharedPaymentUrlQueryVariables>;
export const EWayDirectPaymentDocument = gql`
    query EWayDirectPayment($input: PaymentCardInput!) {
  eWayDirectPayment(input: $input)
}
    `;

/**
 * __useEWayDirectPaymentQuery__
 *
 * To run a query within a React component, call `useEWayDirectPaymentQuery` and pass it any options that fit your needs.
 * When your component renders, `useEWayDirectPaymentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEWayDirectPaymentQuery({
 *   variables: {
 *      input: // value for 'totalAmount'
 *   },
 * });
 */
export function useEWayDirectPaymentQuery(baseOptions?: Apollo.QueryHookOptions<EWayDirectPaymentQuery, EWayDirectPaymentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EWayDirectPaymentQuery, EWayDirectPaymentQueryVariables>(EWayDirectPaymentDocument, options);
      }
export function useEWayDirectPaymentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EWayDirectPaymentQuery, EWayDirectPaymentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EWayDirectPaymentQuery, EWayDirectPaymentQueryVariables>(EWayDirectPaymentDocument, options);
        }
export type EWayDirectPaymentQueryHookResult = ReturnType<typeof useEWayDirectPaymentQuery>;
export type EWayDirectPaymentLazyQueryHookResult = ReturnType<typeof useEWayDirectPaymentLazyQuery>;
export type EWayDirectPaymentQueryResult = Apollo.QueryResult<EWayDirectPaymentQuery, EWayDirectPaymentQueryVariables>;
export const GetCategoriesDocument = gql`
    query GetCategories($catId: Int) {
  childCategories(order: {name: ASC}, catId: $catId) {
    name
    categoryId
    orderTypeId
    childCategoriesCount
  }
}
    `;

/**
 * __useGetCategoriesQuery__
 *
 * To run a query within a React component, call `useGetCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCategoriesQuery({
 *   variables: {
 *      catId: // value for 'catId'
 *   },
 * });
 */
export function useGetCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<GetCategoriesQuery, GetCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCategoriesQuery, GetCategoriesQueryVariables>(GetCategoriesDocument, options);
      }
export function useGetCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCategoriesQuery, GetCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCategoriesQuery, GetCategoriesQueryVariables>(GetCategoriesDocument, options);
        }
export type GetCategoriesQueryHookResult = ReturnType<typeof useGetCategoriesQuery>;
export type GetCategoriesLazyQueryHookResult = ReturnType<typeof useGetCategoriesLazyQuery>;
export type GetCategoriesQueryResult = Apollo.QueryResult<GetCategoriesQuery, GetCategoriesQueryVariables>;
export const GetCategoryDocument = gql`
    query GetCategory($catId: Int!) {
  category(catId: $catId) {
    name
    categoryId
    orderTypeId
    parentId
    childCategoriesCount
  }
}
    `;

/**
 * __useGetCategoryQuery__
 *
 * To run a query within a React component, call `useGetCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCategoryQuery({
 *   variables: {
 *      catId: // value for 'catId'
 *   },
 * });
 */
export function useGetCategoryQuery(baseOptions: Apollo.QueryHookOptions<GetCategoryQuery, GetCategoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCategoryQuery, GetCategoryQueryVariables>(GetCategoryDocument, options);
      }
export function useGetCategoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCategoryQuery, GetCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCategoryQuery, GetCategoryQueryVariables>(GetCategoryDocument, options);
        }
export type GetCategoryQueryHookResult = ReturnType<typeof useGetCategoryQuery>;
export type GetCategoryLazyQueryHookResult = ReturnType<typeof useGetCategoryLazyQuery>;
export type GetCategoryQueryResult = Apollo.QueryResult<GetCategoryQuery, GetCategoryQueryVariables>;
export const GetProductCategoriesDocument = gql`
    query GetProductCategories($productId: Int!) {
  productCategories(productId: $productId) {
    categoryId
    name
  }
}
    `;

/**
 * __useGetProductCategoriesQuery__
 *
 * To run a query within a React component, call `useGetProductCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductCategoriesQuery({
 *   variables: {
 *      productId: // value for 'productId'
 *   },
 * });
 */
export function useGetProductCategoriesQuery(baseOptions: Apollo.QueryHookOptions<GetProductCategoriesQuery, GetProductCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductCategoriesQuery, GetProductCategoriesQueryVariables>(GetProductCategoriesDocument, options);
      }
export function useGetProductCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductCategoriesQuery, GetProductCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductCategoriesQuery, GetProductCategoriesQueryVariables>(GetProductCategoriesDocument, options);
        }
export type GetProductCategoriesQueryHookResult = ReturnType<typeof useGetProductCategoriesQuery>;
export type GetProductCategoriesLazyQueryHookResult = ReturnType<typeof useGetProductCategoriesLazyQuery>;
export type GetProductCategoriesQueryResult = Apollo.QueryResult<GetProductCategoriesQuery, GetProductCategoriesQueryVariables>;
export const UpdateProductCategoriesDocument = gql`
    mutation UpdateProductCategories($productId: Int!, $categoryIds: [Int!]!) {
  updateProductCategories(
    productId: $productId
    payload: {categoryIds: $categoryIds}
  ) {
    message
  }
}
    `;
export type UpdateProductCategoriesMutationFn = Apollo.MutationFunction<UpdateProductCategoriesMutation, UpdateProductCategoriesMutationVariables>;

/**
 * __useUpdateProductCategoriesMutation__
 *
 * To run a mutation, you first call `useUpdateProductCategoriesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductCategoriesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductCategoriesMutation, { data, loading, error }] = useUpdateProductCategoriesMutation({
 *   variables: {
 *      productId: // value for 'productId'
 *      categoryIds: // value for 'categoryIds'
 *   },
 * });
 */
export function useUpdateProductCategoriesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProductCategoriesMutation, UpdateProductCategoriesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProductCategoriesMutation, UpdateProductCategoriesMutationVariables>(UpdateProductCategoriesDocument, options);
      }
export type UpdateProductCategoriesMutationHookResult = ReturnType<typeof useUpdateProductCategoriesMutation>;
export type UpdateProductCategoriesMutationResult = Apollo.MutationResult<UpdateProductCategoriesMutation>;
export type UpdateProductCategoriesMutationOptions = Apollo.BaseMutationOptions<UpdateProductCategoriesMutation, UpdateProductCategoriesMutationVariables>;
export const AttributeSetsDocument = gql`
    query AttributeSets {
  attributeSets {
    attributeSetId
    name
    attributes {
      attributeId
      name
      attributeData {
        attribDataId
        name
        abbreviation
      }
    }
  }
}
    `;

/**
 * __useAttributeSetsQuery__
 *
 * To run a query within a React component, call `useAttributeSetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAttributeSetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAttributeSetsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAttributeSetsQuery(baseOptions?: Apollo.QueryHookOptions<AttributeSetsQuery, AttributeSetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AttributeSetsQuery, AttributeSetsQueryVariables>(AttributeSetsDocument, options);
      }
export function useAttributeSetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AttributeSetsQuery, AttributeSetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AttributeSetsQuery, AttributeSetsQueryVariables>(AttributeSetsDocument, options);
        }
export type AttributeSetsQueryHookResult = ReturnType<typeof useAttributeSetsQuery>;
export type AttributeSetsLazyQueryHookResult = ReturnType<typeof useAttributeSetsLazyQuery>;
export type AttributeSetsQueryResult = Apollo.QueryResult<AttributeSetsQuery, AttributeSetsQueryVariables>;
export const ChildProductsDocument = gql`
    query ChildProducts($productId: Int!) {
  childProducts(productId: $productId) {
    productId
    name
    code
    stockAvailable
    parentId
  }
}
    `;

/**
 * __useChildProductsQuery__
 *
 * To run a query within a React component, call `useChildProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useChildProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChildProductsQuery({
 *   variables: {
 *      productId: // value for 'productId'
 *   },
 * });
 */
export function useChildProductsQuery(baseOptions: Apollo.QueryHookOptions<ChildProductsQuery, ChildProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChildProductsQuery, ChildProductsQueryVariables>(ChildProductsDocument, options);
      }
export function useChildProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChildProductsQuery, ChildProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChildProductsQuery, ChildProductsQueryVariables>(ChildProductsDocument, options);
        }
export type ChildProductsQueryHookResult = ReturnType<typeof useChildProductsQuery>;
export type ChildProductsLazyQueryHookResult = ReturnType<typeof useChildProductsLazyQuery>;
export type ChildProductsQueryResult = Apollo.QueryResult<ChildProductsQuery, ChildProductsQueryVariables>;
export const CreateChildProductDocument = gql`
    mutation CreateChildProduct($productId: Int!, $attribDataId: Int!) {
  createChildProduct(productId: $productId, attribDataId: $attribDataId) {
    productId
    parentId
    name
  }
}
    `;
export type CreateChildProductMutationFn = Apollo.MutationFunction<CreateChildProductMutation, CreateChildProductMutationVariables>;

/**
 * __useCreateChildProductMutation__
 *
 * To run a mutation, you first call `useCreateChildProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateChildProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createChildProductMutation, { data, loading, error }] = useCreateChildProductMutation({
 *   variables: {
 *      productId: // value for 'productId'
 *      attribDataId: // value for 'attribDataId'
 *   },
 * });
 */
export function useCreateChildProductMutation(baseOptions?: Apollo.MutationHookOptions<CreateChildProductMutation, CreateChildProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateChildProductMutation, CreateChildProductMutationVariables>(CreateChildProductDocument, options);
      }
export type CreateChildProductMutationHookResult = ReturnType<typeof useCreateChildProductMutation>;
export type CreateChildProductMutationResult = Apollo.MutationResult<CreateChildProductMutation>;
export type CreateChildProductMutationOptions = Apollo.BaseMutationOptions<CreateChildProductMutation, CreateChildProductMutationVariables>;
export const GetProductDetailsDocument = gql`
    query GetProductDetails($productId: Int!) {
  productDetails(productId: $productId) {
    productName
    productDescription
    statusId
    itemGroupId
    productCode
    externalProductId
    isHidden
    isWBSOwnedStock
    isEmbroidery
    isScreenPrintItem
    isOverPrintItem
    isWBSJobItem
    orderTypeId
    approverId
    crmSupplier
    supplierLeadTime
    crmSpecification
    reOrderLevel
    maxStockLevel
    enableSerialNumberTracking
    serialNumberBookSize
    gst
    processDays
    minQuantityPerOrder
    maxOrderQuantityLimit
    maxOrderQuantityLimitDays
    isSpecialDelivery
    quantityTypeId
    maxQuantityPerOrder
    forceRGA
    sortOrder
    isRemoved
  }
}
    `;

/**
 * __useGetProductDetailsQuery__
 *
 * To run a query within a React component, call `useGetProductDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductDetailsQuery({
 *   variables: {
 *      productId: // value for 'productId'
 *   },
 * });
 */
export function useGetProductDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetProductDetailsQuery, GetProductDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductDetailsQuery, GetProductDetailsQueryVariables>(GetProductDetailsDocument, options);
      }
export function useGetProductDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductDetailsQuery, GetProductDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductDetailsQuery, GetProductDetailsQueryVariables>(GetProductDetailsDocument, options);
        }
export type GetProductDetailsQueryHookResult = ReturnType<typeof useGetProductDetailsQuery>;
export type GetProductDetailsLazyQueryHookResult = ReturnType<typeof useGetProductDetailsLazyQuery>;
export type GetProductDetailsQueryResult = Apollo.QueryResult<GetProductDetailsQuery, GetProductDetailsQueryVariables>;
export const GetProductManagementDocument = gql`
    query GetProductManagement($orderTypeId: Int, $catId: Int, $search: String, $skip: Int, $take: Int) {
  productManagement(
    skip: $skip
    take: $take
    input: {orderTypeId: $orderTypeId, catId: $catId, search: $search}
  ) {
    totalCount
    items {
      productId
      code
      name
      image
      priceSummary
      categories
      unitOfMeasurement
      stockCommitted
      stockOnHand
      stockAvailable
      status
    }
  }
}
    `;

/**
 * __useGetProductManagementQuery__
 *
 * To run a query within a React component, call `useGetProductManagementQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductManagementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductManagementQuery({
 *   variables: {
 *      orderTypeId: // value for 'orderTypeId'
 *      catId: // value for 'catId'
 *      search: // value for 'search'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useGetProductManagementQuery(baseOptions?: Apollo.QueryHookOptions<GetProductManagementQuery, GetProductManagementQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductManagementQuery, GetProductManagementQueryVariables>(GetProductManagementDocument, options);
      }
export function useGetProductManagementLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductManagementQuery, GetProductManagementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductManagementQuery, GetProductManagementQueryVariables>(GetProductManagementDocument, options);
        }
export type GetProductManagementQueryHookResult = ReturnType<typeof useGetProductManagementQuery>;
export type GetProductManagementLazyQueryHookResult = ReturnType<typeof useGetProductManagementLazyQuery>;
export type GetProductManagementQueryResult = Apollo.QueryResult<GetProductManagementQuery, GetProductManagementQueryVariables>;
export const ItemGroupsDocument = gql`
    query ItemGroups {
  itemGroups {
    productItemGroupId
    name
  }
}
    `;

/**
 * __useItemGroupsQuery__
 *
 * To run a query within a React component, call `useItemGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useItemGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useItemGroupsQuery({
 *   variables: {
 *   },
 * });
 */
export function useItemGroupsQuery(baseOptions?: Apollo.QueryHookOptions<ItemGroupsQuery, ItemGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ItemGroupsQuery, ItemGroupsQueryVariables>(ItemGroupsDocument, options);
      }
export function useItemGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ItemGroupsQuery, ItemGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ItemGroupsQuery, ItemGroupsQueryVariables>(ItemGroupsDocument, options);
        }
export type ItemGroupsQueryHookResult = ReturnType<typeof useItemGroupsQuery>;
export type ItemGroupsLazyQueryHookResult = ReturnType<typeof useItemGroupsLazyQuery>;
export type ItemGroupsQueryResult = Apollo.QueryResult<ItemGroupsQuery, ItemGroupsQueryVariables>;
export const OrderStatusesDocument = gql`
    query OrderStatuses {
  orderStatuses {
    statusId
    name
  }
}
    `;

/**
 * __useOrderStatusesQuery__
 *
 * To run a query within a React component, call `useOrderStatusesQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderStatusesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderStatusesQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrderStatusesQuery(baseOptions?: Apollo.QueryHookOptions<OrderStatusesQuery, OrderStatusesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderStatusesQuery, OrderStatusesQueryVariables>(OrderStatusesDocument, options);
      }
export function useOrderStatusesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderStatusesQuery, OrderStatusesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderStatusesQuery, OrderStatusesQueryVariables>(OrderStatusesDocument, options);
        }
export type OrderStatusesQueryHookResult = ReturnType<typeof useOrderStatusesQuery>;
export type OrderStatusesLazyQueryHookResult = ReturnType<typeof useOrderStatusesLazyQuery>;
export type OrderStatusesQueryResult = Apollo.QueryResult<OrderStatusesQuery, OrderStatusesQueryVariables>;
export const OrderTypesDocument = gql`
    query OrderTypes {
  orderTypes {
    orderTypeId
    name
  }
}
    `;

/**
 * __useOrderTypesQuery__
 *
 * To run a query within a React component, call `useOrderTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrderTypesQuery(baseOptions?: Apollo.QueryHookOptions<OrderTypesQuery, OrderTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderTypesQuery, OrderTypesQueryVariables>(OrderTypesDocument, options);
      }
export function useOrderTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderTypesQuery, OrderTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderTypesQuery, OrderTypesQueryVariables>(OrderTypesDocument, options);
        }
export type OrderTypesQueryHookResult = ReturnType<typeof useOrderTypesQuery>;
export type OrderTypesLazyQueryHookResult = ReturnType<typeof useOrderTypesLazyQuery>;
export type OrderTypesQueryResult = Apollo.QueryResult<OrderTypesQuery, OrderTypesQueryVariables>;
export const ProductApproversDocument = gql`
    query ProductApprovers {
  productApprovers {
    userId
    name
  }
}
    `;

/**
 * __useProductApproversQuery__
 *
 * To run a query within a React component, call `useProductApproversQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductApproversQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductApproversQuery({
 *   variables: {
 *   },
 * });
 */
export function useProductApproversQuery(baseOptions?: Apollo.QueryHookOptions<ProductApproversQuery, ProductApproversQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductApproversQuery, ProductApproversQueryVariables>(ProductApproversDocument, options);
      }
export function useProductApproversLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductApproversQuery, ProductApproversQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductApproversQuery, ProductApproversQueryVariables>(ProductApproversDocument, options);
        }
export type ProductApproversQueryHookResult = ReturnType<typeof useProductApproversQuery>;
export type ProductApproversLazyQueryHookResult = ReturnType<typeof useProductApproversLazyQuery>;
export type ProductApproversQueryResult = Apollo.QueryResult<ProductApproversQuery, ProductApproversQueryVariables>;
export const ProductStatusesDocument = gql`
    query ProductStatuses {
  productStatuses {
    statusId
    name
  }
}
    `;

/**
 * __useProductStatusesQuery__
 *
 * To run a query within a React component, call `useProductStatusesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductStatusesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductStatusesQuery({
 *   variables: {
 *   },
 * });
 */
export function useProductStatusesQuery(baseOptions?: Apollo.QueryHookOptions<ProductStatusesQuery, ProductStatusesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductStatusesQuery, ProductStatusesQueryVariables>(ProductStatusesDocument, options);
      }
export function useProductStatusesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductStatusesQuery, ProductStatusesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductStatusesQuery, ProductStatusesQueryVariables>(ProductStatusesDocument, options);
        }
export type ProductStatusesQueryHookResult = ReturnType<typeof useProductStatusesQuery>;
export type ProductStatusesLazyQueryHookResult = ReturnType<typeof useProductStatusesLazyQuery>;
export type ProductStatusesQueryResult = Apollo.QueryResult<ProductStatusesQuery, ProductStatusesQueryVariables>;
export const UpdateProductParentDocument = gql`
    mutation UpdateProductParent($productId: Int!, $childProductId: Int!, $link: Boolean) {
  updateProductParent(
    productId: $productId
    childProductId: $childProductId
    link: $link
  ) {
    productId
    parentId
    name
  }
}
    `;
export type UpdateProductParentMutationFn = Apollo.MutationFunction<UpdateProductParentMutation, UpdateProductParentMutationVariables>;

/**
 * __useUpdateProductParentMutation__
 *
 * To run a mutation, you first call `useUpdateProductParentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductParentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductParentMutation, { data, loading, error }] = useUpdateProductParentMutation({
 *   variables: {
 *      productId: // value for 'productId'
 *      childProductId: // value for 'childProductId'
 *      link: // value for 'link'
 *   },
 * });
 */
export function useUpdateProductParentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProductParentMutation, UpdateProductParentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProductParentMutation, UpdateProductParentMutationVariables>(UpdateProductParentDocument, options);
      }
export type UpdateProductParentMutationHookResult = ReturnType<typeof useUpdateProductParentMutation>;
export type UpdateProductParentMutationResult = Apollo.MutationResult<UpdateProductParentMutation>;
export type UpdateProductParentMutationOptions = Apollo.BaseMutationOptions<UpdateProductParentMutation, UpdateProductParentMutationVariables>;
export const FreightSettingsDocument = gql`
    query FreightSettings {
  freightSettings(input: {weight: 0}) {
    freightSettingId
    name
  }
}
    `;

/**
 * __useFreightSettingsQuery__
 *
 * To run a query within a React component, call `useFreightSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFreightSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFreightSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFreightSettingsQuery(baseOptions?: Apollo.QueryHookOptions<FreightSettingsQuery, FreightSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FreightSettingsQuery, FreightSettingsQueryVariables>(FreightSettingsDocument, options);
      }
export function useFreightSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FreightSettingsQuery, FreightSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FreightSettingsQuery, FreightSettingsQueryVariables>(FreightSettingsDocument, options);
        }
export type FreightSettingsQueryHookResult = ReturnType<typeof useFreightSettingsQuery>;
export type FreightSettingsLazyQueryHookResult = ReturnType<typeof useFreightSettingsLazyQuery>;
export type FreightSettingsQueryResult = Apollo.QueryResult<FreightSettingsQuery, FreightSettingsQueryVariables>;
export const ProductAttributesDocument = gql`
    query ProductAttributes($productId: Int!) {
  productAttributes(productId: $productId) {
    name
    attributes {
      productId
      productCode
      attributeName
      stockAvailable
    }
  }
}
    `;

/**
 * __useProductAttributesQuery__
 *
 * To run a query within a React component, call `useProductAttributesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductAttributesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductAttributesQuery({
 *   variables: {
 *      productId: // value for 'productId'
 *   },
 * });
 */
export function useProductAttributesQuery(baseOptions: Apollo.QueryHookOptions<ProductAttributesQuery, ProductAttributesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductAttributesQuery, ProductAttributesQueryVariables>(ProductAttributesDocument, options);
      }
export function useProductAttributesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductAttributesQuery, ProductAttributesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductAttributesQuery, ProductAttributesQueryVariables>(ProductAttributesDocument, options);
        }
export type ProductAttributesQueryHookResult = ReturnType<typeof useProductAttributesQuery>;
export type ProductAttributesLazyQueryHookResult = ReturnType<typeof useProductAttributesLazyQuery>;
export type ProductAttributesQueryResult = Apollo.QueryResult<ProductAttributesQuery, ProductAttributesQueryVariables>;
export const GetProductDocument = gql`
    query GetProduct($productId: Int!) {
  product(productId: $productId) {
    ...ProductParts
  }
}
    ${ProductPartsFragmentDoc}`;

/**
 * __useGetProductQuery__
 *
 * To run a query within a React component, call `useGetProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductQuery({
 *   variables: {
 *      productId: // value for 'productId'
 *   },
 * });
 */
export function useGetProductQuery(baseOptions: Apollo.QueryHookOptions<GetProductQuery, GetProductQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductQuery, GetProductQueryVariables>(GetProductDocument, options);
      }
export function useGetProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductQuery, GetProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductQuery, GetProductQueryVariables>(GetProductDocument, options);
        }
export type GetProductQueryHookResult = ReturnType<typeof useGetProductQuery>;
export type GetProductLazyQueryHookResult = ReturnType<typeof useGetProductLazyQuery>;
export type GetProductQueryResult = Apollo.QueryResult<GetProductQuery, GetProductQueryVariables>;
export const GetProductByCodeDocument = gql`
    query GetProductByCode($productCode: String!) {
  productByCode(productCode: $productCode) {
    ...ProductParts
  }
}
    ${ProductPartsFragmentDoc}`;

/**
 * __useGetProductByCodeQuery__
 *
 * To run a query within a React component, call `useGetProductByCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductByCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductByCodeQuery({
 *   variables: {
 *      productCode: // value for 'productCode'
 *   },
 * });
 */
export function useGetProductByCodeQuery(baseOptions: Apollo.QueryHookOptions<GetProductByCodeQuery, GetProductByCodeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductByCodeQuery, GetProductByCodeQueryVariables>(GetProductByCodeDocument, options);
      }
export function useGetProductByCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductByCodeQuery, GetProductByCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductByCodeQuery, GetProductByCodeQueryVariables>(GetProductByCodeDocument, options);
        }
export type GetProductByCodeQueryHookResult = ReturnType<typeof useGetProductByCodeQuery>;
export type GetProductByCodeLazyQueryHookResult = ReturnType<typeof useGetProductByCodeLazyQuery>;
export type GetProductByCodeQueryResult = Apollo.QueryResult<GetProductByCodeQuery, GetProductByCodeQueryVariables>;
export const ProductsDocument = gql`
    query Products($where: ProductFilterInput, $categoryId: Int, $take: Int, $skip: Int) {
  products(take: $take, skip: $skip, where: $where, input: {catId: $categoryId}) {
    totalCount
    items {
      ...ProductParts
    }
  }
}
    ${ProductPartsFragmentDoc}`;

/**
 * __useProductsQuery__
 *
 * To run a query within a React component, call `useProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      categoryId: // value for 'categoryId'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useProductsQuery(baseOptions?: Apollo.QueryHookOptions<ProductsQuery, ProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductsQuery, ProductsQueryVariables>(ProductsDocument, options);
      }
export function useProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductsQuery, ProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductsQuery, ProductsQueryVariables>(ProductsDocument, options);
        }
export type ProductsQueryHookResult = ReturnType<typeof useProductsQuery>;
export type ProductsLazyQueryHookResult = ReturnType<typeof useProductsLazyQuery>;
export type ProductsQueryResult = Apollo.QueryResult<ProductsQuery, ProductsQueryVariables>;
export const SavedAddressDocument = gql`
    query SavedAddress {
  savedAddress {
    billingAddress {
      ...AddressParts
    }
    deliveryAddress {
      ...AddressParts
    }
  }
}
    ${AddressPartsFragmentDoc}`;

/**
 * __useSavedAddressQuery__
 *
 * To run a query within a React component, call `useSavedAddressQuery` and pass it any options that fit your needs.
 * When your component renders, `useSavedAddressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSavedAddressQuery({
 *   variables: {
 *   },
 * });
 */
export function useSavedAddressQuery(baseOptions?: Apollo.QueryHookOptions<SavedAddressQuery, SavedAddressQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SavedAddressQuery, SavedAddressQueryVariables>(SavedAddressDocument, options);
      }
export function useSavedAddressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SavedAddressQuery, SavedAddressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SavedAddressQuery, SavedAddressQueryVariables>(SavedAddressDocument, options);
        }
export type SavedAddressQueryHookResult = ReturnType<typeof useSavedAddressQuery>;
export type SavedAddressLazyQueryHookResult = ReturnType<typeof useSavedAddressLazyQuery>;
export type SavedAddressQueryResult = Apollo.QueryResult<SavedAddressQuery, SavedAddressQueryVariables>;
export const ShippingEstimateDocument = gql`
    query ShippingEstimate($freightSettingId: Int!, $deliveryAddress: CartAddressInput!, $cartLines: [CartLineInput!]!) {
  shippingEstimate(
    input: {freightSettingId: $freightSettingId, deliveryAddress: $deliveryAddress, cartLines: $cartLines}
  ) {
    services {
      service
      serviceCode
      description
      tax
      net
    }
  }
}
    `;

/**
 * __useShippingEstimateQuery__
 *
 * To run a query within a React component, call `useShippingEstimateQuery` and pass it any options that fit your needs.
 * When your component renders, `useShippingEstimateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShippingEstimateQuery({
 *   variables: {
 *      freightSettingId: // value for 'freightSettingId'
 *      deliveryAddress: // value for 'deliveryAddress'
 *      cartLines: // value for 'cartLines'
 *   },
 * });
 */
export function useShippingEstimateQuery(baseOptions: Apollo.QueryHookOptions<ShippingEstimateQuery, ShippingEstimateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShippingEstimateQuery, ShippingEstimateQueryVariables>(ShippingEstimateDocument, options);
      }
export function useShippingEstimateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShippingEstimateQuery, ShippingEstimateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShippingEstimateQuery, ShippingEstimateQueryVariables>(ShippingEstimateDocument, options);
        }
export type ShippingEstimateQueryHookResult = ReturnType<typeof useShippingEstimateQuery>;
export type ShippingEstimateLazyQueryHookResult = ReturnType<typeof useShippingEstimateLazyQuery>;
export type ShippingEstimateQueryResult = Apollo.QueryResult<ShippingEstimateQuery, ShippingEstimateQueryVariables>;
export const SubmitOrderDocument = gql`
    mutation SubmitOrder($cartId: String!) {
  submitOrder(cartId: $cartId) {
    orderReference
  }
}
    `;
export type SubmitOrderMutationFn = Apollo.MutationFunction<SubmitOrderMutation, SubmitOrderMutationVariables>;

/**
 * __useSubmitOrderMutation__
 *
 * To run a mutation, you first call `useSubmitOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitOrderMutation, { data, loading, error }] = useSubmitOrderMutation({
 *   variables: {
 *      cartId: // value for 'cartId'
 *   },
 * });
 */
export function useSubmitOrderMutation(baseOptions?: Apollo.MutationHookOptions<SubmitOrderMutation, SubmitOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitOrderMutation, SubmitOrderMutationVariables>(SubmitOrderDocument, options);
      }
export type SubmitOrderMutationHookResult = ReturnType<typeof useSubmitOrderMutation>;
export type SubmitOrderMutationResult = Apollo.MutationResult<SubmitOrderMutation>;
export type SubmitOrderMutationOptions = Apollo.BaseMutationOptions<SubmitOrderMutation, SubmitOrderMutationVariables>;
export const SubmitOrderWithoutEmailDocument = gql`
    mutation SubmitOrderWithoutEmail($cartId: String!) {
  submitOrderWithoutEmail(cartId: $cartId) {
    orderReference
  }
}
    `;
export type SubmitOrderWithoutEmailMutationFn = Apollo.MutationFunction<SubmitOrderWithoutEmailMutation, SubmitOrderMutationVariables>;

/**
 * __useSubmitOrderWithoutEmailMutation__
 *
 * To run a mutation, you first call `useSubmitOrderWithoutEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitOrderWithoutEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitOrderWithoutEmailMutation, { data, loading, error }] = useSubmitOrderWithoutEmailMutation({
 *   variables: {
 *      cartId: // value for 'cartId'
 *   },
 * });
 */
export function useSubmitOrderWithoutEmailMutation(baseOptions?: Apollo.MutationHookOptions<SubmitOrderWithoutEmailMutation, SubmitOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitOrderWithoutEmailMutation, SubmitOrderMutationVariables>(SubmitOrderWithoutEmailDocument, options);
      }
export type SubmitOrderWithoutEmailMutationHookResult = ReturnType<typeof useSubmitOrderWithoutEmailMutation>;
export type SubmitOrderWithoutEmailMutationResult = Apollo.MutationResult<SubmitOrderWithoutEmailMutation>;
export type SubmitOrderWithoutEmailMutationOptions = Apollo.BaseMutationOptions<SubmitOrderWithoutEmailMutation, SubmitOrderMutationVariables>;
export const BulkCartCsvUploadDocument = gql`
    mutation BulkCartCsvUpload($input: BulkCartCsvUploadInput!) {
  bulkCartCsvUpload(input: $input)
}
    `;
export type BulkCartCsvUploadMutationFn = Apollo.MutationFunction<BulkCartCsvUploadMutation, BulkCartCsvUploadMutationVariables>;

/**
 * __useBulkCartCsvUploadMutation__
 *
 * To run a mutation, you first call `useBulkCartCsvUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkCartCsvUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkCartCsvUploadMutation, { data, loading, error }] = useBulkCartCsvUploadMutation({
 *   variables: {
 *      file: // value for 'file'
 *   },
 * });
 */
export function useBulkCartCsvUploadMutation(baseOptions?: Apollo.MutationHookOptions<BulkCartCsvUploadMutation, BulkCartCsvUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkCartCsvUploadMutation, BulkCartCsvUploadMutationVariables>(BulkCartCsvUploadDocument, options);
      }
export type BulkCartCsvUploadMutationHookResult = ReturnType<typeof useBulkCartCsvUploadMutation>;
export type BulkCartCsvUploadMutationResult = Apollo.MutationResult<BulkCartCsvUploadMutation>;
export type BulkCartCsvUploadMutationOptions = Apollo.BaseMutationOptions<BulkCartCsvUploadMutation, BulkCartCsvUploadMutationVariables>;
export const BulkOrderCsvUploadDocument = gql`
    mutation BulkOrderCsvUpload($input: BulkOrderCsvUploadInput!) {
  bulkOrderCsvUpload(input: $input)
}
    `;
export type BulkOrderCsvUploadMutationFn = Apollo.MutationFunction<BulkOrderCsvUploadMutation, BulkOrderCsvUploadMutationVariables>;

/**
 * __useBulkOrderCsvUploadMutation__
 *
 * To run a mutation, you first call `useBulkOrderCsvUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkOrderCsvUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkOrderCsvUploadMutation, { data, loading, error }] = useBulkOrderCsvUploadMutation({
 *   variables: {
 *      file: // value for 'file'
 *   },
 * });
 */
export function useBulkOrderCsvUploadMutation(baseOptions?: Apollo.MutationHookOptions<BulkOrderCsvUploadMutation, BulkOrderCsvUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkOrderCsvUploadMutation, BulkOrderCsvUploadMutationVariables>(BulkOrderCsvUploadDocument, options);
      }
export type BulkOrderCsvUploadMutationHookResult = ReturnType<typeof useBulkOrderCsvUploadMutation>;
export type BulkOrderCsvUploadMutationResult = Apollo.MutationResult<BulkOrderCsvUploadMutation>;
export type BulkOrderCsvUploadMutationOptions = Apollo.BaseMutationOptions<BulkOrderCsvUploadMutation, BulkOrderCsvUploadMutationVariables>;
export const LoadSavedOrderDocument = gql`
    mutation LoadSavedOrder($input: LoadSavedOrderInput!) {
  loadSavedOrder(input: $input)
}
    `;
export type LoadSavedOrderMutationFn = Apollo.MutationFunction<LoadSavedOrderMutation, LoadSavedOrderMutationVariables>;

/**
 * __useLoadSavedOrderMutation__
 *
 * To run a mutation, you first call `useLoadSavedOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoadSavedOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loadSavedOrderMutation, { data, loading, error }] = useLoadSavedOrderMutation({
 *   variables: {
 *      orderShipId: // value for 'file'
 *   },
 * });
 */
export function useLoadSavedOrderMutation(baseOptions?: Apollo.MutationHookOptions<LoadSavedOrderMutation, LoadSavedOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoadSavedOrderMutation, LoadSavedOrderMutationVariables>(LoadSavedOrderDocument, options);
      }
export type LoadSavedOrderMutationHookResult = ReturnType<typeof useLoadSavedOrderMutation>;
export type LoadSavedOrderMutationResult = Apollo.MutationResult<LoadSavedOrderMutation>;
export type LoadSavedOrderMutationOptions = Apollo.BaseMutationOptions<LoadSavedOrderMutation, LoadSavedOrderMutationVariables>;
export const GetThemeDocument = gql`
    query GetTheme {
  customerTheme {
    ...ThemeParts
  }
}
    ${ThemePartsFragmentDoc}`;

/**
 * __useGetThemeQuery__
 *
 * To run a query within a React component, call `useGetThemeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetThemeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetThemeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetThemeQuery(baseOptions?: Apollo.QueryHookOptions<GetThemeQuery, GetThemeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetThemeQuery, GetThemeQueryVariables>(GetThemeDocument, options);
      }
export function useGetThemeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetThemeQuery, GetThemeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetThemeQuery, GetThemeQueryVariables>(GetThemeDocument, options);
        }
export type GetThemeQueryHookResult = ReturnType<typeof useGetThemeQuery>;
export type GetThemeLazyQueryHookResult = ReturnType<typeof useGetThemeLazyQuery>;
export type GetThemeQueryResult = Apollo.QueryResult<GetThemeQuery, GetThemeQueryVariables>;
export const UpdateThemeDocument = gql`
    mutation UpdateTheme($input: UpdateThemeRequestInput!) {
  updateTheme(input: $input) {
    ...ThemeParts
  }
}
    ${ThemePartsFragmentDoc}`;
export type UpdateThemeMutationFn = Apollo.MutationFunction<UpdateThemeMutation, UpdateThemeMutationVariables>;

/**
 * __useUpdateThemeMutation__
 *
 * To run a mutation, you first call `useUpdateThemeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateThemeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateThemeMutation, { data, loading, error }] = useUpdateThemeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateThemeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateThemeMutation, UpdateThemeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateThemeMutation, UpdateThemeMutationVariables>(UpdateThemeDocument, options);
      }
export type UpdateThemeMutationHookResult = ReturnType<typeof useUpdateThemeMutation>;
export type UpdateThemeMutationResult = Apollo.MutationResult<UpdateThemeMutation>;
export type UpdateThemeMutationOptions = Apollo.BaseMutationOptions<UpdateThemeMutation, UpdateThemeMutationVariables>;

      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {}
};
      export default result;
    